"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var a = {};
a['ABevelCircleBottomFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M509.95 64c-247.3 0-448 200.7-448 448s200.7 448 448 448 448-200.7 448-448-200.7-448-448-448zm209.41 381.44L537.6 670.72a32.37 32.37 0 01-45.06 5.12 24.27 24.27 0 01-5.12-5.12L305.66 445.44c-7.16-9.22-5.63-22.53 3.08-29.7l32.25-26.62c9.22-7.68 22.53-6.66 30.21 2.56 0 .51.51.51.51 1.02L511.5 566.78l139.26-173.56c7.17-9.73 20.48-11.78 29.7-4.61.51.51 1.02 1.02 1.53 1.02l33.28 26.63c9.73 6.65 11.27 19.96 4.1 29.18z"
      }
    }]
  },
  "name": "a-bevel-circle-bottom-fill"
};
a['ABevelCircleTopFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M509.95 64c-247.3 0-448 200.7-448 448s200.7 448 448 448 448-200.7 448-448-200.7-448-448-448zm205.31 545.28l-32.76 27.14c-9.22 7.68-22.53 6.65-30.21-2.56 0-.52-.51-.52-.51-1.03L512 458.75 372.74 632.32c-7.17 9.22-21 10.75-30.21 3.07l-33.28-26.62a20.65 20.65 0 01-3.07-29.7L486.4 353.8a32.37 32.37 0 0145.06-5.12 24.27 24.27 0 015.12 5.12l181.76 225.28c7.16 9.73 6.14 23.04-3.08 30.21z"
      }
    }]
  },
  "name": "a-bevel-circle-top-fill"
};
a['ACloudUploadfailedStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M819.41 378.67a315.95 315.95 0 00-308.69-263.04 316.59 316.59 0 00-309.55 264.96 273.92 273.92 0 00-50.77 436.69 270.3 270.3 0 0059.73 42.67 354.99 354.99 0 0049.07 21.33 184.1 184.1 0 0023.68 5.76A31.79 31.79 0 00320 854.83v-21.34a32 32 0 00-25.17-30.93 189.65 189.65 0 01-143.58-213.33 196.05 196.05 0 0197.71-137.82l29.44-17.06 6.4-39.9a227.63 227.63 0 01449.7-1.7l6.83 40.53 35.84 20.05a189.01 189.01 0 01-49.06 348.8A31.79 31.79 0 00704 833.07v21.33a31.79 31.79 0 0038.19 31.36 268.37 268.37 0 0029.65-7.04 274.35 274.35 0 0048.21-499.84z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M663.47 817.5l-95.79-96 99.63-99.63c15.36-15.36 6.4-31.36-9.39-47.15s-31.36-24.96-47.36-9.39L512 665.4l-100.27-99.63c-15.36-15.57-31.14-6.19-47.14 9.39s-24.75 31.36-9.39 47.14l100.05 99.2-95.78 96a39.68 39.68 0 0056.1 57.18l96-96 95.79 96a39.9 39.9 0 0059.52-52.91c-1.07 0-2.35-1.92-3.41-3.2z"
      }
    }]
  },
  "name": "a-cloud-Uploadfailed-stroke"
};
a['ACommonlyUsedStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M927.36 510.72a106.67 106.67 0 0027.3-110.93A108.37 108.37 0 00867 325.76l-152.96-21.33a49.28 49.28 0 01-36.06-27.1l-68.26-138.66a108.8 108.8 0 00-194.78 0l-68.26 138.66a48.21 48.21 0 01-36.06 26.46l-152.96 21.33a108.37 108.37 0 00-87.68 74.03 106.67 106.67 0 0027.31 110.93l110.5 108.59a47.57 47.57 0 0113.66 42.66L194.99 812.8A108.16 108.16 0 00352.2 926.72l136.75-71.9a49.7 49.7 0 0144.59 0l136.96 71.9a105.39 105.39 0 0050.56 12.8 103.25 103.25 0 0064-21.33 106.67 106.67 0 0042.66-106.67l-26.02-150.19a48.43 48.43 0 0113.65-42.66zm-250.24-15.79l-6.61-1.49a252.16 252.16 0 01-175.36-135.25 30.3 30.3 0 1154.61-26.24 192 192 0 00132.9 102.82l6.62 1.5a30.08 30.08 0 0123.68 36.05 30.93 30.93 0 01-30.3 23.25 18.99 18.99 0 01-5.54-.64z"
      }
    }]
  },
  "name": "a-Commonly-used-stroke"
};
a['ATableSubEditStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M874.67 75.1H149.33a64 64 0 00-64 64v725.33a64 64 0 0064 64h341.34a32 32 0 0032-32v-21.76a32 32 0 00-32-32h-64V674.13h64a32 32 0 0032-32V620.8a32 32 0 00-32-32h-64V418.13h480a32 32 0 0032-32V139.1a64 64 0 00-64-64zm-533.34 768H170.67V674.55h170.66zm0-253.87H170.67V418.56h170.66zm-170.66-256v-172.8h682.66v172.8z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M913.5 551.9l-110.94-64a42.67 42.67 0 00-58.24 15.57L605.65 743.68a42.67 42.67 0 00-4.69 12.59 32.43 32.43 0 00-3.63 14.5v145.07a32 32 0 0048 27.73L771 871.04a34.13 34.13 0 0010.88-10.45 49.5 49.5 0 008.53-10.24l138.67-240.22a42.67 42.67 0 00-15.58-58.24zM746.66 799.78l-10.03 17.49-42.67 24.53-25.38 14.72-5.34 2.99V774.4l9.6-16.43L691 726.4l98.34-171.73 73.82 42.66z"
      }
    }]
  },
  "name": "a-table-sub-edit-stroke"
};
a['AddFavoritesStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M923.95 497.07a109.65 109.65 0 0021.33-126.51 113.28 113.28 0 00-87.25-61.65l-156.59-23.04a24.32 24.32 0 01-18.56-13.44l-70.4-142.94a113.92 113.92 0 00-85.33-64 109.65 109.65 0 00-113.5 60.38l-72.32 146.56a24.32 24.32 0 01-18.56 13.44L164.91 308.9a113.28 113.28 0 00-87.26 61.65 109.65 109.65 0 0022.4 126.5L216.96 611a25.17 25.17 0 017.04 21.33l-26.88 157.01a113.5 113.5 0 0031.79 102.19 109.87 109.87 0 00128 17.7s96.21-49.91 136.74-70.18a32 32 0 0016.86-28.37v-25.6a32 32 0 00-45.23-29.23l-4.48 2.13-144.43 76.16a24.75 24.75 0 01-35.84-26.02l27.52-160.86a110.5 110.5 0 00-30.72-97.49l-117.76-113.7a24.32 24.32 0 01-6.18-25.4 23.9 23.9 0 0119.84-16.85l161.49-23.46a110.08 110.08 0 0082.99-60.16l72.96-146.35a24.75 24.75 0 0144.37 0l72.1 146.35a110.08 110.08 0 0082.78 60.16l161.7 23.46a23.9 23.9 0 0119.85 16.86 24.32 24.32 0 01-6.19 25.38L746.67 549.76a112 112 0 00-13.02 15.57 32 32 0 0026.03 50.78h29.65a32.43 32.43 0 0022.62-9.39c28.58-27.95 112-109.65 112-109.65z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M834.13 760.32h-72.96v-75.95a35.2 35.2 0 00-32-37.54h-21.33a35.2 35.2 0 00-32 37.54v75.95h-72.75a34.56 34.56 0 00-36.48 32v21.33a34.35 34.35 0 0036.48 32h72.75v76.16a35.2 35.2 0 0032 38.19h21.33a35.2 35.2 0 0032-37.55v-76.8h72.96a34.56 34.56 0 0036.48-32v-21.33a34.56 34.56 0 00-36.48-32z"
      }
    }]
  },
  "name": "Add-Favorites-stroke"
};
a['AddressBookFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M610.13 418.13c0-55.46-42.66-98.13-98.13-98.13s-98.13 42.67-98.13 98.13c0 55.47 42.66 98.14 98.13 98.14s98.13-42.67 98.13-98.14z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M785.07 93.87H238.93c-76.8 0-140.8 55.46-140.8 123.73v588.8c0 68.27 64 123.73 140.8 123.73h550.4c76.8 0 140.8-55.46 140.8-123.73V217.6c0-68.27-64-123.73-145.06-123.73zm-51.2 682.66c-17.07 4.27-34.14-4.26-38.4-21.33-25.6-81.07-98.14-136.53-183.47-136.53S354.13 674.13 328.53 755.2c-4.26 12.8-17.06 21.33-29.86 21.33h-8.54c-17.06-4.26-25.6-21.33-21.33-38.4C294.4 652.8 362.67 588.8 448 567.47c-55.47-25.6-93.87-81.07-93.87-145.07C349.87 328.53 422.4 256 512 256s162.13 72.53 162.13 162.13c0 64-38.4 119.47-93.86 145.07 81.06 21.33 153.6 85.33 179.2 170.67 0 17.06-8.54 38.4-25.6 42.66z"
      }
    }]
  },
  "name": "address-book-fill"
};
a['AddressBookStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M268.8 733.87c-4.27 17.06 4.27 34.13 21.33 38.4h8.54c12.8 0 25.6-8.54 29.86-21.34C354.13 669.87 426.67 614.4 512 614.4s157.87 55.47 183.47 136.53c4.26 17.07 21.33 25.6 38.4 21.34 17.06-4.27 25.6-21.34 21.33-38.4-25.6-85.34-93.87-149.34-179.2-170.67 55.47-25.6 93.87-81.07 93.87-145.07C674.13 328.53 601.6 256 512 256s-162.13 72.53-162.13 162.13c0 64 38.4 119.47 93.86 145.07-81.06 25.6-149.33 89.6-174.93 170.67zm145.07-315.74c0-55.46 42.66-98.13 98.13-98.13s98.13 42.67 98.13 98.13c0 55.47-42.66 98.14-98.13 98.14s-98.13-46.94-98.13-98.14z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M896 226.13c-17.07 0-34.13 12.8-34.13 34.14V806.4c-4.27 38.4-38.4 64-76.8 59.73h-550.4c-38.4 4.27-72.54-25.6-76.8-59.73V221.87c4.26-38.4 38.4-64 76.8-59.74h529.06c17.07 0 34.14-12.8 34.14-34.13s-12.8-34.13-34.14-34.13h-524.8C166.4 89.6 102.4 145.07 93.87 217.6v593.07c8.53 68.26 64 119.46 132.26 119.46h558.94C857.6 934.4 921.6 883.2 930.13 806.4V256c0-17.07-17.06-29.87-34.13-29.87z"
      }
    }]
  },
  "name": "address-book-stroke"
};
a['AddressFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M837.35 288.14a344.57 344.57 0 00-76-110 352.64 352.64 0 00-112.37-74 358.18 358.18 0 00-387.11 73.87 345.56 345.56 0 00-76 110A337.58 337.58 0 00158 423c0 67.12 16.07 134 47.63 198.41 25.38 51.81 60.84 102.29 105.52 150.3 76.34 82 156.39 132 179.11 145.45a42 42 0 0042.59 0c22.72-13.4 102.77-63.5 179.1-145.45 44.69-47.92 80.15-98.49 105.53-150.3 31.75-64.36 47.82-131.1 47.82-198.31a337.63 337.63 0 00-27.95-134.96zM511.65 598A167.32 167.32 0 11679 430.65 167.32 167.32 0 01511.65 598z"
      }
    }]
  },
  "name": "address-fill"
};
a['AddressStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512.48 615.77c-94.51 0-171.4-76.89-171.4-171.4S418 273 512.48 273s171.4 76.89 171.4 171.39S607 615.77 512.48 615.77zm0-278.79a107.4 107.4 0 10107.4 107.39A107.51 107.51 0 00512.48 337zm5.59 597.65a40.25 40.25 0 01-19.65-5.1c-23.4-13-105.85-61.79-184.31-140.86-45.91-46.27-82.41-95-108.5-144.74C173 581.77 156.5 517.54 156.5 453c0-97.44 36.33-188.63 102.31-256.79 66.72-68.89 156.81-106.86 253.67-106.86s186.77 38 253.24 106.94C831.35 264.38 867.5 355.56 867.5 453c0 62.48-15.86 125.36-47.15 186.89-25 49.23-60.07 97.87-104.14 144.57-75.39 79.9-154.7 130.65-177.21 144.3a40.33 40.33 0 01-20.93 5.87zm-5.59-781.28c-79.37 0-153.13 31-207.69 87.41C250.44 296.91 220.5 372.3 220.5 453c0 221.94 234.9 376.61 297.08 413.66C577.75 827.87 803.5 667.89 803.5 453c0-80.82-29.78-156.22-83.86-212.32-54.3-56.3-127.87-87.33-207.16-87.33z"
      }
    }]
  },
  "name": "address-stroke"
};
a['AggregateFunctionStoke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M143.36 328.75l-29.44-13.66a21.33 21.33 0 01-10.24-28.8A431.57 431.57 0 01646.4 85.33a21.33 21.33 0 0111.1 28.59l-13.45 29.01a21.33 21.33 0 01-27.73 10.67A356.9 356.9 0 00170.67 320a21.33 21.33 0 01-27.31 8.75z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M94.93 338.99L64 197.76a21.33 21.33 0 0116-25.39l21.33-4.9a21.33 21.33 0 0125.6 16.21l17.92 79.15a21.33 21.33 0 0025.39 16l89.17-19.63a21.33 21.33 0 0125.39 16.21l4.7 21.34a21.33 21.33 0 01-16.22 25.6L120.53 355.2a21.33 21.33 0 01-25.6-16.21zM531 968.96a429.65 429.65 0 01-160.22-30.3 21.33 21.33 0 01-11.09-28.8l13.44-29a21.33 21.33 0 0127.73-10.67A356.9 356.9 0 00846.3 704a21.33 21.33 0 0128.38-8.96l29.44 13.65a21.33 21.33 0 0110.24 28.8A429.01 429.01 0 01681.6 942.08a434.35 434.35 0 01-150.61 26.88z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M891.73 840.1l-17.06-79.14a21.33 21.33 0 00-25.39-16l-89.17 19.63a21.33 21.33 0 01-25.39-16.22l-4.7-21.33a21.33 21.33 0 0116.22-25.6L896 668.59a21.33 21.33 0 0125.39 16.21l32 141.23a21.33 21.33 0 01-16.22 25.6l-21.33 4.69a21.33 21.33 0 01-24.1-16.21zM721.92 391.9h-35.63a21.33 21.33 0 00-16.21 8.1l-71.47 90.67a1239.93 1239.93 0 00-18.34-40.54l-22.4-46.93a21.33 21.33 0 00-18.78-11.95H427.95l4.05-18.98a73.6 73.6 0 0110.24-29.66c5.76-8.53 33.92-3.41 51.63 0a14.72 14.72 0 0017.92-11.52l7.46-35.2a14.93 14.93 0 00-11.94-17.7 533.33 533.33 0 00-53.55-7.68 98.56 98.56 0 00-49.07 10.45 65.7 65.7 0 00-27.52 27.52 212.05 212.05 0 00-14.5 49.7l-6.83 33.71h-33.07a15.15 15.15 0 00-14.72 12.38l-5.12 29.44a14.93 14.93 0 0015.15 17.49h26.88l-52.27 241.07a14.93 14.93 0 0014.72 18.13h42.67a15.36 15.36 0 0014.72-11.95l51.41-245.97h87.26l48.21 95.36-110.3 128a21.33 21.33 0 0015.8 34.35h36.9a21.33 21.33 0 0016-7.68l74.24-90.88a732.35 732.35 0 0014.72 32l26.88 54.82a21.33 21.33 0 0018.77 11.74h33.28a21.33 21.33 0 0018.35-30.3l-64-125.86 106.67-128a21.33 21.33 0 00-17.07-34.14z"
      }
    }]
  },
  "name": "aggregate-function-stoke"
};
a['ApiStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M950.19 90.03l-15.15-14.94a32 32 0 00-45.23 0l-71.25 71.04a243.2 243.2 0 00-312.32 26.67L448 230.19a64 64 0 000 89.81l256 254.72a64 64 0 0090.45 0l57.39-57.39a243.41 243.41 0 0026.88-310.61l71.47-71.25a32.43 32.43 0 000-45.44zM790.4 457.17l-42.67 42.67-223.36-224.43 42.67-42.66a158.3 158.3 0 01223.79 0 158.72 158.72 0 01-.43 224.42zM597.33 560.64a31.79 31.79 0 00-22.61-9.39 32.21 32.21 0 00-22.61 9.39l-58.88 59.1-91.31-90.67 58.88-59.74a31.79 31.79 0 000-45.22l-14.93-15.15a32.21 32.21 0 00-22.62-9.39 31.79 31.79 0 00-22.61 9.39l-59.3 60.37L320 448a64 64 0 00-90.45 0l-61.02 61.87a244.05 244.05 0 00-27.73 311.89l-66.99 66.77a32.43 32.43 0 000 45.44l15.15 14.94a32 32 0 0045.23 0l66.77-66.78a243.84 243.84 0 00312.96-26.88l61.87-61.86a64 64 0 000-90.67l-22.83-22.83 58.88-58.88a31.79 31.79 0 000-45.22zM454.2 795.31A158.93 158.93 0 11228.9 570.24l46.72-46.93 224.64 224.85z"
      }
    }]
  },
  "name": "api-stroke"
};
a['AppStoreFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M276.9 535.04a212.05 212.05 0 00-150.6 62.3A210.7 210.7 0 0064 747.51c0 56.75 22.19 110.08 62.5 150.4 40.11 39.9 93.66 62.08 150.4 62.08s110.3-22.19 150.62-62.3a210.54 210.54 0 0062.5-150.4c0-56.74-22.18-110.07-62.5-150.18a211.86 211.86 0 00-150.61-62.08zm608.86 20.48H587.09a42.8 42.8 0 00-42.66 42.67v298.66a42.8 42.8 0 0042.66 42.67h298.67a42.8 42.8 0 0042.67-42.67V598.2a42.67 42.67 0 00-42.67-42.67zm-758.19-75.73h298.67a42.8 42.8 0 0042.67-42.67V138.45a42.8 42.8 0 00-42.67-42.66H127.57a42.8 42.8 0 00-42.66 42.66v298.67a42.8 42.8 0 0042.66 42.67zm819.84-222.3L766.51 76.6C758.19 68.27 747.3 64 736.43 64s-21.76 4.27-30.08 12.59l-180.91 180.9a42.75 42.75 0 000 60.38l180.9 180.9c8.33 8.32 19.2 12.59 30.09 12.59s21.76-4.27 30.08-12.59l23.89-23.89 157.23-157.23c16.64-16.42 16.64-43.52-.22-60.16zM736.43 408.32L615.89 287.79l120.54-120.54L856.96 287.8 736.43 408.32z"
      }
    }]
  },
  "name": "app-store-fill"
};
a['AppStoreStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M276.9 535.04a212.05 212.05 0 00-150.6 62.3A210.7 210.7 0 0064 747.51c0 56.75 22.19 110.08 62.5 150.4 40.11 39.9 93.66 62.08 150.4 62.08s110.3-22.19 150.62-62.3a210.54 210.54 0 0062.5-150.4c0-56.74-22.18-110.07-62.5-150.18a211.86 211.86 0 00-150.61-62.08zm90.25 302.3c-24.11 24.1-56.11 37.33-90.24 37.33s-66.14-13.23-90.24-37.34c-24.11-24.1-37.34-55.89-37.34-89.81s13.23-65.92 37.34-89.81c24.1-24.11 56.1-37.34 90.24-37.34s66.13 13.23 90.24 37.34a126.04 126.04 0 0137.33 89.81c0 33.92-13.23 65.7-37.33 89.81zm518.61-281.82H587.09a42.8 42.8 0 00-42.66 42.67v298.66a42.8 42.8 0 0042.66 42.67h298.67a42.8 42.8 0 0042.67-42.67V598.2a42.67 42.67 0 00-42.67-42.67zm-42.67 298.03v.64H629.76V640.85h213.33v212.7zM127.57 479.79h298.67a42.8 42.8 0 0042.67-42.67V138.45a42.8 42.8 0 00-42.67-42.66H127.57a42.8 42.8 0 00-42.66 42.66v298.67a42.8 42.8 0 0042.66 42.67zm42.67-298.67h213.33v213.33H170.24V181.12zm777.17 76.37L766.51 76.6C758.19 68.27 747.3 64 736.43 64s-21.76 4.27-30.08 12.59l-180.91 180.9a42.75 42.75 0 000 60.38l180.9 180.9c8.33 8.32 19.2 12.59 30.09 12.59s21.76-4.27 30.08-12.59l23.89-23.89 157.23-157.23c16.64-16.42 16.64-43.52-.22-60.16zM736.43 408.32L615.89 287.79l120.54-120.54L856.96 287.8 736.43 408.32z"
      }
    }]
  },
  "name": "app-store-stroke"
};
a['ArrowBackCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M387.2 111.27c205.89-63.43 426.34 39.46 509.94 238.01A416.62 416.62 0 01930 512c0 215.43-163.25 395.81-377.61 417.24C338.02 950.67 142.3 806.17 99.66 595 57 383.83 181.32 174.7 387.2 111.27zm19.36 225.69L362 371.25l-46.88 36.08a4 4 0 000 6.34L362 449.75 406.56 484a4 4 0 006.44-3.17V443.5h236v179H326a8 8 0 00-8 8v48a8 8 0 008 8h379a8 8 0 008-8v-291a8 8 0 00-8-8H413v-39.37a4 4 0 00-6.44-3.17z"
      }
    }]
  },
  "name": "arrow-back-circle-fill"
};
a['ArrowBackCircleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64C264.53 64 64 264.53 64 512s200.53 448 448 448 448-200.53 448-448S759.47 64 512 64zm0 810.67c-199.9 0-362.67-162.78-362.67-362.67S312.11 149.33 512 149.33 874.67 312.11 874.67 512 711.89 874.67 512 874.67zm157.23-535.9H474.45v-66.56c0-14.29-17.06-21.33-27.3-11.3L345.6 361.6c-12.59 12.59-12.59 33.07 0 45.44l101.55 100.27c10.02 10.02 27.3 2.77 27.3-11.31v-71.68h186.88v194.35H320c-23.47 0-42.67 19.2-42.67 42.66S296.53 704 320 704h349.23c42.66 0 77.44-36.48 77.44-81.5V420.28c0-45.02-34.78-81.5-77.44-81.5z"
      }
    }]
  },
  "name": "arrow-back-circle-stroke"
};
a['ArrowBackStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M608.64 254.08L221.65 256 320 157.01a31.79 31.79 0 000-45.22l-15.15-15.15a32 32 0 00-45.22 0L83.4 273.49a32.21 32.21 0 000 45.23l176 176.85a32 32 0 0045.23 0l15.15-15.14a31.79 31.79 0 000-45.23l-93.66-93.87 382.51-1.7a256 256 0 010 512H280.96a32 32 0 00-32 32v21.33a31.79 31.79 0 0031.79 32h327.89a341.33 341.33 0 00341.33-341.33 341.33 341.33 0 00-341.33-341.55z"
      }
    }]
  },
  "name": "arrow-back-stroke"
};
a['ArrowBottomStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M179.84 504.32L508.8 833.49l331.73-328.96a32 32 0 0145.23 0l14.93 15.15a32 32 0 010 45.23L554.67 909a64 64 0 01-90.24 0L119.47 564.7a31.79 31.79 0 010-45.22l15.14-15.15a32.21 32.21 0 0145.23 0zM499.41 90.88h21.34a32 32 0 0132 32v743.9H467.4v-743.9a32 32 0 0132-32z"
      }
    }]
  },
  "name": "arrow-bottom-stroke"
};
a['ArrowCircleBottomStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 96c229.75 0 416 186.25 416 416S741.75 928 512 928 96 741.75 96 512 282.25 96 512 96zm0 64c-194.4 0-352 157.6-352 352s157.6 352 352 352 352-157.6 352-352-157.6-352-352-352zm33.23 73.72a8 8 0 018 8v376h102.8a7.25 7.25 0 015.7 11.7l-134.4 155.3a16 16 0 01-1.63 1.62 16 16 0 01-22.57-1.63L368.83 629.5a7.23 7.23 0 015.7-11.7h102.7V241.72a8 8 0 018-8z"
      }
    }]
  },
  "name": "arrow-circle-bottom-stroke"
};
a['ArrowCircleLeftStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 96c229.75 0 416 186.25 416 416S741.75 928 512 928 96 741.75 96 512 282.25 96 512 96zm0 64c-194.4 0-352 157.6-352 352s157.6 352 352 352 352-157.6 352-352-157.6-352-352-352zM405.45 364.73a7.25 7.25 0 014.07 6.49v102.8h376a8 8 0 018 8v60a8 8 0 01-8 8H409.45v102.7a7.23 7.23 0 01-11.7 5.7l-155.22-134.3a16 16 0 01-1.63-22.57 16 16 0 011.63-1.63l155.3-134.4a7.25 7.25 0 017.62-.79z"
      }
    }]
  },
  "name": "arrow-circle-left-stroke"
};
a['ArrowCircleTopStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 96c229.75 0 416 186.25 416 416S741.75 928 512 928 96 741.75 96 512 282.25 96 512 96zm0 64c-194.4 0-352 157.6-352 352s157.6 352 352 352 352-157.6 352-352-157.6-352-352-352zm-7.17 77.62a16 16 0 0122.57 1.63l134.3 155.22a7.23 7.23 0 01-5.7 11.7H553.3v376.07a8 8 0 01-8 8h-60a8 8 0 01-8-8v-376H374.5a7.25 7.25 0 01-5.7-11.69l134.4-155.3a16 16 0 011.63-1.63z"
      }
    }]
  },
  "name": "arrow-circle-top-stroke"
};
a['ArrowLeftStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M514.99 178.99L185.8 507.95l328.96 331.73a32 32 0 010 45.23l-15.14 14.93a31.79 31.79 0 01-45.23 0L110.3 552.96a64 64 0 010-90.24l344.31-344.1a31.79 31.79 0 0145.23 0l15.15 15.14a32.21 32.21 0 010 45.23zm413.44 319.57v21.33a32 32 0 01-32 32h-743.9v-85.33H896a32 32 0 0132.43 32z"
      }
    }]
  },
  "name": "arrow-left-stroke"
};
a['ArrowReloadStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M175.94 267.84l4.1-5.57a415.62 415.62 0 01576.63-85.95 415.36 415.36 0 01171.07 318.4l.2 3.84.12 5 69.12-2.38a3.33 3.33 0 013.01 5.12l-.13.13-104 141.76a3.26 3.26 0 01-5.12.32l-.12-.19-113.86-134.14a3.33 3.33 0 012.3-5.5h.2l74.62-2.57-.2-5.12a342.27 342.27 0 00-618.87-189.5 342.14 342.14 0 00330.69 539 338.35 338.35 0 0033.02-6.9 3.26 3.26 0 013.97 2.17v.2l18.69 64.76a3.46 3.46 0 01-2.37 4.29 416 416 0 01-447.04-641.54l3.97-5.63z"
      }
    }]
  },
  "name": "arrow-reload-stroke"
};
a['ArrowRightStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M505.17 839.47L834.35 510.5 505.39 178.77a32 32 0 010-45.22l15.14-15.15a32 32 0 0145.23 0l344.1 347.1a64 64 0 010 90.23L565.56 899.84a32.21 32.21 0 01-45.23 0l-15.15-15.15a32.21 32.21 0 010-45.22zM91.73 519.89v-21.33a32 32 0 0132-32h743.9v85.33h-743.9a32 32 0 01-32-32z"
      }
    }]
  },
  "name": "arrow-right-stroke"
};
a['ArrowShuffleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M568.84 128H455.16c-4.06 0-7.94.92-10.79 2.56-2.85 1.65-4.42 3.87-4.37 6.18v750.52c-.05 2.31 1.52 4.53 4.37 6.17 2.85 1.65 6.74 2.57 10.79 2.57h113.68c4.05 0 7.94-.92 10.79-2.56 2.84-1.65 4.42-3.87 4.37-6.18V136.74c.05-2.31-1.53-4.53-4.37-6.18-2.85-1.64-6.74-2.56-10.79-2.56zm230.78 237.5a7.25 7.25 0 00-11.69 5.7V474h-156a8 8 0 00-8 8v60a8 8 0 008 8H788v102.7a7.23 7.23 0 0011.7 5.7l155.22-134.3a16 16 0 001.63-22.57 16 16 0 00-1.63-1.63l-155.3-134.4zm-574.4 0a7.25 7.25 0 0111.68 5.7V474h156a8 8 0 018 8v60a8 8 0 01-8 8H236.83v102.7a7.23 7.23 0 01-11.7 5.7L69.91 524.1a16 16 0 01-1.63-22.57 16 16 0 011.63-1.63l155.3-134.4z"
      }
    }]
  },
  "name": "arrow-shuffle-fill"
};
a['ArrowShuffleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M542.38 128h-60c-2.14 0-4.19.92-5.69 2.56a9 9 0 00-2.3 6.18v750.52a9 9 0 002.3 6.17 7.72 7.72 0 005.7 2.57h59.99c2.14 0 4.19-.92 5.7-2.56a9 9 0 002.3-6.18V136.74a9 9 0 00-2.3-6.18 7.72 7.72 0 00-5.7-2.56zm257.24 237.5a7.25 7.25 0 00-11.69 5.7V474h-156a8 8 0 00-8 8v60a8 8 0 008 8H788v102.7a7.23 7.23 0 0011.7 5.7l155.22-134.3a16 16 0 001.63-22.57 16 16 0 00-1.63-1.63l-155.3-134.4zm-574.4 0a7.25 7.25 0 0111.68 5.7V474h156a8 8 0 018 8v60a8 8 0 01-8 8H236.83v102.7a7.23 7.23 0 01-11.7 5.7L69.91 524.1a16 16 0 01-1.63-22.57 16 16 0 011.63-1.63l155.3-134.4z"
      }
    }]
  },
  "name": "arrow-shuffle-stroke"
};
a['ArrowSortLeftStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M614.91 64h-21.5a31.58 31.58 0 00-31.75 31.74v728.58l-115.2-115.2a32.14 32.14 0 00-45.05-.51l-.51.51-15.36 15.36a32.14 32.14 0 00-.52 45.06l.52.5L566.78 951.3c8.2 8.19 19.46 10.24 29.7 8.19h18.43a31.58 31.58 0 0031.75-31.75v-832c.5-17.4-13.83-31.74-31.75-31.74z"
      }
    }]
  },
  "name": "arrow-sort-left-stroke"
};
a['ArrowSortRightStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M637.95 254.98L456.7 73.73a36.27 36.27 0 00-18.43-8.7l-3.07-.52h-1.54c-1.02 0-2.04-.51-3.58-.51h-21.5a31.58 31.58 0 00-31.75 31.74v832a31.58 31.58 0 0031.75 31.75h21.5a31.58 31.58 0 0031.74-31.75V200.2l115.2 115.2c12.8 12.8 32.77 12.8 45.06 0l15.36-15.36a31.68 31.68 0 00.51-45.05z"
      }
    }]
  },
  "name": "arrow-sort-right-stroke"
};
a['ArrowSortStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M373.33 64.43H352c-17.7 0-32 14.29-32 32v728.74L205.01 710.2a31.79 31.79 0 00-45.22 0l-15.15 15.14a31.79 31.79 0 000 45.23l181.12 181.12c8.1 8.1 19.2 10.24 29.44 8.1h18.35c17.7 0 32-14.29 32-32V96.44c-.22-17.71-14.51-32-32.22-32zm513.28 190.5L705.5 73.81a31.15 31.15 0 00-18.56-8.53l-2.98-.64c-.43 0-.86-.21-1.5-.21-1.06-.22-2.13-.43-3.41-.43h-21.33c-17.71 0-32 14.3-32 32v832c0 17.7 14.29 32 32 32h21.33c17.7 0 32-14.3 32-32V200.1l114.99 115c12.58 12.58 32.85 12.58 45.22 0l15.15-15.15a31.37 31.37 0 00.21-45.02z"
      }
    }]
  },
  "name": "arrow-sort-stroke"
};
a['ArrowSyncAngleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M147.72 550.09h61.58a7.76 7.76 0 007.74-7.74V295.17h511.79v70.29a8.08 8.08 0 0013.07 6.39l138.74-108.92c4.16-4.84 3.48-10 0-12.78L741.9 141.32a8 8 0 00-5-1.74 8.18 8.18 0 00-8.13 8.13V218H209.39A69.56 69.56 0 00140 287.52v254.83a7.77 7.77 0 007.75 7.74zm728.08-77.45h-61.58a7.76 7.76 0 00-7.74 7.75v247.17H294.69v-70.29a8 8 0 00-1.74-5 8 8 0 00-11.33-1.36L142.88 759.8c-4.16 4.84-3.49 10 0 12.78l138.74 108.83a8 8 0 005 1.74 8.18 8.18 0 008.14-8.13v-70.29h519.56a69.57 69.57 0 0069.42-69.52V480.39a8.07 8.07 0 00-7.94-7.75zm0 0"
      }
    }]
  },
  "name": "arrow-sync-angle-stroke"
};
a['ArrowSyncFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M293.55 582.83L276.48 573a31.85 31.85 0 00-24.53-3.2c-8.32 2.14-15.15 7.47-19.63 14.94l-14.93 25.81c.21-6.4-.64-13.01-2.99-19.41-38.61-106.88-11.73-228.06 68.7-308.48 80.42-80.43 201.6-107.31 308.47-68.48 24.96 9.17 52.06-2.35 63.36-26.24l8.32-17.92c5.98-12.8 6.4-27.95.86-40.96-5.34-13.02-16-23.47-29.23-28.16-151.68-56.11-323.41-18.35-437.76 96C86.4 307.63 48 472.1 96.42 620.16c-15.14-7.47-33.7-2.13-42.23 12.59l-9.82 17.06c-4.26 7.47-5.33 16.22-3.2 24.54s7.47 15.36 14.94 19.62l130.13 75.1a32.38 32.38 0 0043.95-11.74l75.09-130.13a32.54 32.54 0 00-11.73-44.37zm689.28-232.96a31.52 31.52 0 00-14.94-19.63l-130.13-75.1a32.09 32.09 0 00-43.95 11.74l-75.09 130.13a32.09 32.09 0 0011.73 43.95l17.07 9.81a32.66 32.66 0 0016 4.27c2.77 0 5.55-.43 8.32-1.07a31.52 31.52 0 0019.63-14.93l14.93-25.81c-.21 6.4.64 13.01 2.99 19.41 38.82 106.88 11.94 228.05-68.48 308.48-80.43 80.43-201.6 107.3-308.48 68.48a50.82 50.82 0 00-63.36 26.24l-8.32 17.92c-5.98 12.8-6.4 27.95-.86 40.96 5.34 13.01 16 23.47 29.23 28.16a415.13 415.13 0 00143.15 25.39c108.58 0 215.25-42.46 294.4-121.6C937.39 715.95 976 551.47 927.36 403.4c7.04 3.42 14.93 4.48 22.61 2.35a31.52 31.52 0 0019.63-14.93l9.81-17.07c4.48-6.83 5.76-15.57 3.42-23.9zM512 685.23c95.57 0 173.23-77.66 173.23-173.23S607.57 338.77 512 338.77 338.77 416.43 338.77 512 416.43 685.23 512 685.23zm0-218.46a45.25 45.25 0 010 90.46 45.25 45.25 0 010-90.46z"
      }
    }]
  },
  "name": "arrow-sync-fill"
};
a['ArrowSyncStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 660.05c81.7 0 148.05-66.34 148.05-148.05 0-81.7-66.34-148.05-148.05-148.05-81.7 0-148.05 66.34-148.05 148.05 0 81.7 66.34 148.05 148.05 148.05zm0-210.77A62.82 62.82 0 01574.72 512 62.82 62.82 0 01512 574.72 62.82 62.82 0 01449.28 512 62.82 62.82 0 01512 449.28zM293.55 582.83L276.48 573a31.85 31.85 0 00-24.53-3.2 31.52 31.52 0 00-19.63 14.94l-20.48 35.62c-8.1-11.3-14.5-23.89-19.41-36.48-34.14-110.29-4.7-232.32 77.44-314.45 85.54-85.55 214.18-114.13 328.1-72.75a31.73 31.73 0 0039.9-16.64l8.32-17.92c3.84-8.1 4.05-17.7.64-26.02s-10.24-14.72-18.56-17.92c-144.86-53.34-308.7-17.28-417.92 91.73C101.33 318.93 65.28 482.99 118.6 627.84c.86 2.35 2.14 4.7 3.63 6.83l-24.1-13.87a31.85 31.85 0 00-24.54-3.2 31.52 31.52 0 00-19.63 14.93l-9.81 17.07a32.09 32.09 0 0011.73 43.95l130.14 75.09a32.38 32.38 0 0043.94-11.73l75.1-130.14c9.17-15.36 3.84-34.98-11.52-43.94zm674.34-252.59l-130.13-75.1a32.09 32.09 0 00-43.95 11.74l-75.09 130.13a32.09 32.09 0 0011.73 43.95l17.07 9.81a32.66 32.66 0 0016 4.27c2.77 0 5.55-.43 8.32-1.07a31.52 31.52 0 0019.63-14.93l22.4-38.83c5.12 8.54 9.6 17.5 13.22 26.67a306.28 306.28 0 0117.92 87.68v-.21c5.12 87.89-26.88 176-90.88 240-85.54 85.54-214.4 114.13-328.1 72.74a31.73 31.73 0 00-39.9 16.64l-8.32 17.92c-3.84 8.11-4.05 17.71-.64 26.03s10.24 14.72 18.56 17.92a393.16 393.16 0 00136.54 24.32c103.68 0 205.65-40.53 281.17-116.05 109.01-109.02 145.07-273.07 91.73-417.92a30.06 30.06 0 00-3.62-6.83l24.1 13.87a32.81 32.81 0 0024.54 3.2 31.52 31.52 0 0019.62-14.94l9.82-17.06c8.96-15.36 3.62-34.99-11.74-43.95z"
      }
    }]
  },
  "name": "arrow-sync-stroke"
};
a['ArrowTopStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M840.32 514.13L512 184.96 179.63 513.92a32 32 0 01-45.23 0l-14.93-15.15a32 32 0 010-45.22l346.88-344.11a64 64 0 0190.24 0l344.1 344.32a31.79 31.79 0 010 45.23l-15.14 15.14a32.21 32.21 0 01-45.23 0zM520.75 927.57H499.4a32 32 0 01-32-32V151.68h85.34V896a32 32 0 01-32 31.57z"
      }
    }]
  },
  "name": "arrow-top-stroke"
};
a['ArrowsShrinkStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M151.04 887.3c12.8 12.28 36.35 8.7 53.76-8.2l187.4-187.9 49.66 49.66c10.24 10.24 27.13 3.08 27.64-11.26l.52-143.36a32.12 32.12 0 00-32.26-32.26l-142.85 1.03c-14.33 0-21.5 17.4-11.26 27.13l48.13 48.13-187.4 187.4c-16.9 16.89-20.99 40.95-8.19 53.75l14.85 15.88zm435.2-417.8l142.85-1.02c14.33 0 21.5-17.4 11.26-27.14l-48.64-48.64 187.4-187.9c16.89-16.9 20.47-40.96 8.19-53.76l-15.36-15.36c-12.8-12.8-36.36-8.7-53.76 8.2l-187.9 187.9-48.65-48.64c-10.24-10.24-27.13-3.08-27.13 11.26l-.52 143.36c0 17.4 14.85 31.74 32.26 31.74z"
      }
    }]
  },
  "name": "arrows-shrink-stroke"
};
a['ArrowsSpreadStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M258.77 826.03l-60.37-60.38 195.41-195.41c17.07-17.07 40.96-20.7 53.55-8.32l15.15 15.15c12.58 12.58 8.74 36.48-8.32 53.54L258.77 826.03zM156.8 708.05l158.08 158.08c10.03 10.03 2.99 27.31-11.3 27.31l-142.73 1.07c-17.7.21-32.21-14.3-32.21-32.22l.64-143.14c.21-14.08 17.5-21.12 27.52-11.1zm706.13-579.62l-142.72 1.06c-14.29 0-21.33 17.28-11.3 27.31l48.85 48.85L570.03 393.4c-17.07 17.06-20.7 40.96-8.32 53.54l15.14 15.15c12.59 12.59 36.48 8.75 53.55-8.32l187.73-187.73L867 314.88c10.02 10.03 27.3 2.99 27.3-11.3l.64-143.15c.22-17.71-14.29-32-32-32z"
      }
    }]
  },
  "name": "arrows-spread-stroke"
};
a['AssetAccountFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 64H234.67c-36.27 0-64 27.73-64 64v192H96c-17.07 0-32 14.93-32 32v21.33c0 19.2 14.93 32 32 32h74.67v256H96c-17.07 0-32 14.94-32 32v21.34c0 19.2 14.93 32 32 32h74.67V896c0 36.27 27.73 64 64 64H896c36.27 0 64-27.73 64-64V128c0-36.27-27.73-64-64-64zM693.33 558.93c17.07 0 32 14.94 32 32v21.34c0 17.06-14.93 32-32 32h-96v74.66c0 17.07-14.93 32-32 32H544c-17.07 0-32-14.93-32-32v-74.66h-96c-17.07 0-32-14.94-32-32v-21.34c0-17.06 14.93-32 32-32h96v-42.66h-96c-17.07 0-32-14.94-32-32v-21.34c0-17.06 14.93-32 32-32h57.6l-81.07-138.66c-8.53-14.94-4.26-34.14 10.67-42.67l19.2-10.67c14.93-8.53 34.13-4.26 42.67 10.67l85.33 149.33 85.33-149.33c8.54-14.93 27.74-21.33 42.67-10.67l19.2 10.67c14.93 8.53 21.33 27.73 12.8 42.67l-81.07 138.66h61.87c17.07 0 32 14.94 32 32v21.34c0 17.06-14.93 32-32 32h-93.87v42.66h96z"
      }
    }]
  },
  "name": "asset-account-fill"
};
a['AssociateStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M899.84 341.33H682.67V124.37A61.01 61.01 0 00622.5 64H124.16A61.01 61.01 0 0064 124.37v498.35a61.01 61.01 0 0060.16 59.95h217.17v216.96A61.01 61.01 0 00401.5 960h498.35A61.01 61.01 0 00960 899.63V401.28a61.01 61.01 0 00-60.16-59.95zm-750.5 256v-448h448v192H401.48a61.01 61.01 0 00-60.16 59.95v196.05zm448-170.66v170.66H426.66V426.67zm277.33 448h-448v-192h196.48a61.01 61.01 0 0059.52-59.95V426.67h192z"
      }
    }]
  },
  "name": "associate-stroke"
};
a['At'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M509.87 936.53c-235.27 0-426.67-191.4-426.67-426.66S274.6 83.2 509.87 83.2s426.66 191.4 426.66 426.67a424.74 424.74 0 01-31.31 160.74 42.69 42.69 0 01-79.07-32.17 339.26 339.26 0 0025.05-128.57c0-188.2-153.13-341.34-341.33-341.34S168.53 321.66 168.53 509.87 321.66 851.2 509.87 851.2c53.33 0 104.38-11.95 151.74-35.48a42.67 42.67 0 1138 76.42 422.7 422.7 0 01-189.74 44.4"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M509.87 367.64a142.38 142.38 0 00-142.23 142.23A142.38 142.38 0 00509.87 652.1 142.23 142.23 0 00652.1 509.87a142.38 142.38 0 00-142.23-142.23m0 369.79c-125.46 0-227.57-102.1-227.57-227.56S384.43 282.3 509.87 282.3s227.56 102.13 227.56 227.57a227.5 227.5 0 01-227.56 227.56"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M763.24 780.67c-7.83 0-15.44-.77-22.76-2.28-52.86-10.92-88.38-58.03-88.38-117.18V324.99a42.67 42.67 0 0185.33 0v336.22c0 10.98 2.62 29.97 20.33 33.64 19.56 3.97 49.32-12.2 68.76-57.24a42.67 42.67 0 0178.35 33.81C871.5 748.74 813.31 780.7 763.22 780.7"
      }
    }]
  },
  "name": "at"
};
a['BankStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M877.5 838H827V454h56c29.85 0 43.45-37.26 20.61-56.48L532.6 85.29a32 32 0 00-41.2 0l-371 312.23C97.54 416.74 111.14 454 141 454h55v384h-49.5a32 32 0 00-32 32v24a8 8 0 008 8h779a8 8 0 008-8v-24a32 32 0 00-32-32zM763 838H638V454h125zM574 454v384H449V454zm-62-301.95L791.13 390H232.87zM260 454h125v384H260z"
      }
    }]
  },
  "name": "bank-stroke"
};
a['BarCodeStoke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M99.41 465.28h827.31q32 0 32 32v21.33q0 32-32 32H99.42q-32 0-32-32v-21.33q0-32 32-32zM161.7 152.1h21.34q32 0 32 32v195.85q0 32-32 32h-21.33q-32 0-32-32V184.1q0-32 32-32zM298.03 152.1h21.33q32 0 32 32v195.85q0 32-32 32h-21.33q-32 0-32-32V184.1q0-32 32-32zM434.35 152.1h21.33q32 0 32 32v195.85q0 32-32 32h-21.33q-32 0-32-32V184.1q0-32 32-32zM570.88 152.1h21.33q32 0 32 32v195.85q0 32-32 32h-21.33q-32 0-32-32V184.1q0-32 32-32zM707.2 152.1h21.33q32 0 32 32v195.85q0 32-32 32H707.2q-32 0-32-32V184.1q0-32 32-32zM843.52 152.1h21.33q32 0 32 32v195.85q0 32-32 32h-21.33q-32 0-32-32V184.1q0-32 32-32zM161.7 593.7h21.34q32 0 32 32v232.54q0 32-32 32h-21.33q-32 0-32-32V625.71q0-32 32-32zM298.03 593.7h21.33q32 0 32 32v195.85q0 32-32 32h-21.33q-32 0-32-32V625.7q0-32 32-32zM434.35 593.7h21.33q32 0 32 32v304.86q0 32-32 32h-21.33q-32 0-32-32V625.71q0-32 32-32zM570.88 593.7h21.33q32 0 32 32v195.85q0 32-32 32h-21.33q-32 0-32-32V625.7q0-32 32-32zM707.2 593.7h21.33q32 0 32 32v195.85q0 32-32 32H707.2q-32 0-32-32V625.7q0-32 32-32zM843.52 593.7h21.33q32 0 32 32v232.54q0 32-32 32h-21.33q-32 0-32-32V625.71q0-32 32-32z"
      }
    }]
  },
  "name": "bar-code-stoke"
};
a['BarcodeStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M442.81 791h-46.45a7.77 7.77 0 00-7.74 7.74v46.46a7.77 7.77 0 007.74 7.74h46.45a7.76 7.76 0 007.74-7.74v-46.45a7.77 7.77 0 00-7.74-7.75zm372.55 0H643.12a7.77 7.77 0 00-7.74 7.74v46.46a7.76 7.76 0 007.74 7.74h172.24a7.77 7.77 0 007.75-7.74v-46.45a7.77 7.77 0 00-7.75-7.75zm-247.72 0h-46.45a7.77 7.77 0 00-7.74 7.74v46.46a7.77 7.77 0 007.74 7.74h46.45a7.76 7.76 0 007.74-7.74v-46.45a7.77 7.77 0 00-7.74-7.75zM319 791H210.57a7.77 7.77 0 00-7.74 7.74v46.46a7.76 7.76 0 007.74 7.74H319a7.76 7.76 0 007.74-7.74v-46.45A7.77 7.77 0 00319 791zm76.45-61.93h46.44a7.77 7.77 0 007.75-7.74V178.8a7.77 7.77 0 00-7.75-7.74H395.4a7.77 7.77 0 00-7.75 7.74v542.54a7.77 7.77 0 007.75 7.74zm246.75 0h172.2a7.77 7.77 0 007.74-7.74V178.8a7.77 7.77 0 00-7.74-7.74H642.15a7.76 7.76 0 00-7.74 7.74v542.54a7.76 7.76 0 007.74 7.74zm-121.92 0h46.44a7.76 7.76 0 007.74-7.74V178.8a7.76 7.76 0 00-7.74-7.74h-46.49a7.77 7.77 0 00-7.75 7.74v542.54a7.77 7.77 0 007.75 7.74zm-310.63 0H318a7.76 7.76 0 007.74-7.74V178.8a7.76 7.76 0 00-7.74-7.74H209.6a7.77 7.77 0 00-7.74 7.74v542.54a7.77 7.77 0 007.74 7.74zm704.4-558h-22.24a7.76 7.76 0 00-7.74 7.74V845.2a7.76 7.76 0 007.74 7.74H914a32.09 32.09 0 0032-32V203.06a32.09 32.09 0 00-32-32zm-781.81 0H110a32.09 32.09 0 00-32 32v617.87a32.09 32.09 0 0032 32h22.19a7.76 7.76 0 007.74-7.74V178.8a7.76 7.76 0 00-7.74-7.74z"
      }
    }]
  },
  "name": "barcode-stroke"
};
a['BatchExportStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M577.34 289.74l-100.8 127.6a7.26 7.26 0 005.7 11.7H545V585a8 8 0 008 8h60a8 8 0 008-8V428.94h62.7a7.23 7.23 0 005.7-11.7l-100.8-127.5a7.14 7.14 0 00-11.26 0zM758 823.83H199.91V266.41a8 8 0 00-8-8H136a8 8 0 00-8 8v621.36a8 8 0 008 8h622.3a8 8 0 008-8v-55.95a8.24 8.24 0 00-8.25-8zm104.5-72.33h-559a32 32 0 01-32-32v-559a32 32 0 0132-32h559a32 32 0 0132 32v559a32 32 0 01-32 32zm-520.3-70.7h481.6V199.2H342.2z"
      }
    }]
  },
  "name": "batch-export-stroke"
};
a['BatchImportStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M759 823.83H200.91V266.41a8 8 0 00-8-8H137a8 8 0 00-8 8v621.36a8 8 0 008 8h622.3a8 8 0 008-8v-55.95a8.24 8.24 0 00-8.25-8zm103.5-71.33h-559a32 32 0 01-32-32v-559a32 32 0 0132-32h559a32 32 0 0132 32v559a32 32 0 01-32 32zm-520.3-70.7h481.6V200.2H342.2zm246.46-90.54l100.8-127.6a7.26 7.26 0 00-5.7-11.7H621V296a8 8 0 00-8-8h-60a8 8 0 00-8 8v156.1h-62.7a7.23 7.23 0 00-5.7 11.7l100.8 127.5a7.14 7.14 0 0011.26-.04z"
      }
    }]
  },
  "name": "batch-import-stroke"
};
a['BatchRemoveStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M310 540h286v64H310zm570-428H274a8 8 0 00-8 8v56a8 8 0 008 8h566v556a8 8 0 008 8h56a8 8 0 008-8V144a32 32 0 00-32-32zM712 820H194V312h518zm40-580H154a32 32 0 00-32 32v588a32 32 0 0032 32h598a32 32 0 0032-32V272a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "batch-remove-stroke"
};
a['BellFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M836.27 548.27a10.58 10.58 0 01-5.34-7.68l-18.56-203.74c-13.44-144-128-258.13-272.64-271.36A249.05 249.05 0 00511.57 64a302.5 302.5 0 00-192.42 69.33c-61.87 51.2-100.27 123.52-107.52 203.31l-18.56 203.73a9.81 9.81 0 01-5.55 7.9 146.43 146.43 0 00-82.35 132.69v15.57c0 74.46 61.02 135.26 135.9 135.26h134.4c4.48 71.25 64 128 136.53 128s132.27-56.75 136.75-128h134.18c74.88-.22 135.9-60.8 135.9-135.26v-15.78c.21-56.54-31.58-107.31-82.56-132.48zM562.77 832a51.62 51.62 0 01-50.98 42.67A51.56 51.56 0 01461 832h101.76zM732.8 339.84c0 17.7-14.3 32-32 32s-32-14.3-32-32a116.27 116.27 0 00-116.27-116.27c-17.7 0-32-14.29-32-32s14.3-32 32-32c99.63 0 180.27 80.64 180.27 180.27z"
      }
    }]
  },
  "name": "bell-fill"
};
a['BellStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M836.27 548.27a10.58 10.58 0 01-5.34-7.68l-18.56-203.74c-13.44-144-128-258.13-272.64-271.36A249.05 249.05 0 00511.57 64a302.5 302.5 0 00-192.42 69.33c-61.87 51.2-100.27 123.52-107.52 203.31l-18.56 203.73a9.81 9.81 0 01-5.55 7.9 146.43 146.43 0 00-82.35 132.69v15.57c0 74.46 61.02 135.26 135.9 135.26h134.4c4.48 71.25 64 128 136.53 128s132.27-56.75 136.75-128h134.18c74.88-.22 135.9-60.8 135.9-135.26v-15.78c.21-56.54-31.58-107.31-82.56-132.48zM562.77 832a51.62 51.62 0 01-50.98 42.67A51.56 51.56 0 01461 832h101.76zM833.5 680.75v15.78c0 27.74-22.82 50.35-50.56 50.35H241.07c-27.95 0-50.56-22.61-50.56-50.35v-16c0-24.1 13.22-45.65 34.98-56.32a95.49 95.49 0 0052.7-76.37l18.56-203.73a213.03 213.03 0 0177.22-145.71c39.26-32.43 87.47-49.7 137.82-49.7 6.82 0 13.44.2 20.26.85 103.68 9.6 186.03 91.3 195.42 194.56l18.56 203.52A95.26 95.26 0 00798.5 624a63.57 63.57 0 0134.98 56.75z"
      }
    }]
  },
  "name": "bell-stroke"
};
a['BevelBackwardStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M472.53 886.83L145.5 557a64 64 0 010-90.24l327.47-327.25a31.79 31.79 0 0145.23 0l14.93 15.15a31.79 31.79 0 010 45.22L221.02 512l312.31 314.67a32.21 32.21 0 010 45.22l-15.14 15.15a32 32 0 01-45.66-.21zm322.35 0L468.05 557a64 64 0 010-90.24l327.26-327.25a32 32 0 0145.44 0l14.93 15.15a31.79 31.79 0 010 45.22L543.58 512l311.89 314.67a31.79 31.79 0 010 45.22l-15.15 15.15a32 32 0 01-45.44-.21z"
      }
    }]
  },
  "name": "bevel-backward-stroke"
};
a['BevelBottomSquareFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M898.05 63.49h-768c-35.33 0-64 28.67-64 64v768c0 35.33 28.67 64 64 64h768c35.33 0 64-28.67 64-64v-768c0-35.33-28.67-64-64-64zM720.38 423.42L539.65 648.7a32.37 32.37 0 01-45.06 5.12 24.27 24.27 0 01-5.12-5.12L307.71 423.42c-7.68-9.21-6.14-22.52 3.07-30.2l33.28-26.63c9.22-7.17 23.04-5.63 30.21 3.59l140.29 174.08 139.26-174.08c7.17-9.22 21-10.76 30.21-3.08l33.28 26.63a20.65 20.65 0 013.07 29.7z"
      }
    }]
  },
  "name": "bevel-bottom-square-fill"
};
a['BevelBottomStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M455.9 699.52L138.88 368.86a33.06 33.06 0 010-45.24l14.3-15.14a29.66 29.66 0 0141.88-2.01q.4.36.78.73l1.5 1.28L513.7 640 832 308.48a29.66 29.66 0 0141.89-2.01q.4.36.77.73l1.28 1.28 14.52 15.14a33.06 33.06 0 010 45.24L571.74 699.74a79.36 79.36 0 01-112.18 3.43l-.26-.23z"
      }
    }]
  },
  "name": "bevel-bottom-stroke"
};
a['BevelCircleBottomFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896.21 349.67A418.21 418.21 0 10929 512a415.32 415.32 0 00-32.79-162.33zm-214.37 86L518.49 662.54a8 8 0 01-13 0L342.16 435.67a8 8 0 016.49-12.67h55.05a16 16 0 0113 6.65L512 562l95.31-132.38a16 16 0 0113-6.65h55.05a8 8 0 016.48 12.7z"
      }
    }]
  },
  "name": "bevel-circle-bottom-fill"
};
a['BevelCircleBottomStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M510.08 149.33A362.67 362.67 0 11147.41 512a362.67 362.67 0 01362.67-362.67m0-85.33a448 448 0 10448 448 448 448 0 00-448-448zM372.05 391.68L512 565.55l139.3-173.66a21.33 21.33 0 0131.37-3.41l33.28 26.88a21.33 21.33 0 013.2 29.87L537.39 670.72a32 32 0 01-49.92 0L305.7 445.22a21.33 21.33 0 013.2-29.86l32.42-26.88a21.33 21.33 0 0130.72 3.2z"
      }
    }]
  },
  "name": "bevel-circle-bottom-stroke"
};
a['BevelCircleLeftFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M509.95 64c-247.3 0-448 200.7-448 448s200.7 448 448 448 448-200.7 448-448-200.7-448-448-448zm123.4 617.47l-26.63 33.28a21.16 21.16 0 01-29.7 3.59L351.74 538.1a32.37 32.37 0 01-5.12-45.05 24.27 24.27 0 015.12-5.12l224.77-181.76c9.22-7.68 22.53-6.15 30.21 3.07l26.62 33.28c7.68 9.21 6.66 22.53-2.56 30.2L456.7 512l173.57 139.26c9.22 7.68 10.24 21 3.07 30.21z"
      }
    }]
  },
  "name": "bevel-circle-left-fill"
};
a['BevelCircleLeftStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M510.08 149.33A362.67 362.67 0 11147.41 512a362.67 362.67 0 01362.67-362.67m0-85.33a448 448 0 10448 448 448 448 0 00-448-448zM630.4 372.48L456.53 512 630.2 651.52a21.33 21.33 0 013.2 29.87l-26.67 33.28a21.33 21.33 0 01-29.87 3.41L351.36 537.81a32 32 0 010-49.92L576 305.92a21.33 21.33 0 0130.08 3.2l26.88 33.28a21.33 21.33 0 01-2.56 30.08z"
      }
    }]
  },
  "name": "bevel-circle-left-stroke"
};
a['BevelCircleRightFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M509.95 960c247.3 0 448-200.7 448-448s-200.7-448-448-448-448 200.7-448 448 200.7 448 448 448zM386.56 342.53l26.62-33.28a21.16 21.16 0 0129.7-3.59L668.16 485.9a32.37 32.37 0 015.12 45.05 24.27 24.27 0 01-5.12 5.12L443.39 717.82c-9.21 7.68-22.53 6.15-30.2-3.07l-26.63-33.28c-7.68-9.21-6.66-22.53 2.56-30.2L563.2 512 390.14 372.74c-9.21-7.68-10.75-21-3.58-30.21z"
      }
    }]
  },
  "name": "bevel-circle-right-fill"
};
a['BevelCircleRightStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M510.08 149.33A362.67 362.67 0 11147.41 512a362.67 362.67 0 01362.67-362.67m0-85.33a448 448 0 10448 448 448 448 0 00-448-448zM389.76 652.16L563.63 512 389.76 372.48a21.33 21.33 0 01-3.2-29.87l26.67-33.28a21.33 21.33 0 0130.08-3.41l225.49 180.9a32.21 32.21 0 010 49.93L443.3 718.72a21.33 21.33 0 01-30.07-3.2l-26.67-32.85a21.33 21.33 0 013.2-30.51z"
      }
    }]
  },
  "name": "bevel-circle-right-stroke"
};
a['BevelCircleTopFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896.21 349.67A418.21 418.21 0 10929 512a415.32 415.32 0 00-32.79-162.33zM675.35 600H620.3a16 16 0 01-13-6.65L512 461l-95.31 132.35a16 16 0 01-13 6.65h-55.04a8 8 0 01-6.49-12.67l163.35-226.87a8 8 0 0113 0l163.33 226.87a8 8 0 01-6.49 12.67z"
      }
    }]
  },
  "name": "bevel-circle-top-fill"
};
a['BevelCircleTopStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M651.95 633.17L512 459.31 372.7 632.96a21.33 21.33 0 01-30.09 3.2l-33.28-26.67a21.33 21.33 0 01-3.2-29.86l180.27-225.5a32 32 0 0149.92 0l181.97 225.28a21.33 21.33 0 01-3.2 30.08l-32.42 26.88a21.33 21.33 0 01-30.72-3.2zM510.08 149.33A362.67 362.67 0 11147.41 512a362.67 362.67 0 01362.67-362.67m0-85.33a448 448 0 10448 448 448 448 0 00-448-448z"
      }
    }]
  },
  "name": "bevel-circle-top-stroke"
};
a['BevelDownSquareStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M872.75 149.33v725.34H147.4V149.33h725.34M126.08 64a64 64 0 00-64 64v768a64 64 0 0064 64h768a64 64 0 0064-64V128a64 64 0 00-64-64zm244.05 332.37l140.38 173.87 139.3-173.87a21.33 21.33 0 0130.08-3.2l33.28 26.67a21.33 21.33 0 013.2 29.87L535.47 675.2a32 32 0 01-49.92 0L303.79 449.92a21.33 21.33 0 013.2-30.08l33.06-26.88a21.33 21.33 0 0130.08 3.41z"
      }
    }]
  },
  "name": "bevel-down-square-stroke"
};
a['BevelFastLeftStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M645.67 192.39a7.22 7.22 0 00-7.14 7.26v623.91a7.22 7.22 0 007.14 7.26h57.19a7.23 7.23 0 007.14-7.26V199.65a7.23 7.23 0 00-7.14-7.26zM249 265.61a28.78 28.78 0 0010.18 21.88L526.5 511.82 259.19 736.16A28.78 28.78 0 00249 758v64.69a7.1 7.1 0 0011.7 5.44l376.93-316.31-376.92-316.34a7.1 7.1 0 00-11.7 5.44v64.69z"
      }
    }]
  },
  "name": "bevel-fast-left-stroke"
};
a['BevelFastRightStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M384.33 192.39h-57.19a7.23 7.23 0 00-7.14 7.26v623.91a7.23 7.23 0 007.14 7.26h57.19a7.22 7.22 0 007.14-7.26V199.65a7.22 7.22 0 00-7.14-7.26zM781 265.61v-64.69a7.1 7.1 0 00-11.7-5.44L392.37 511.82l376.92 316.35a7.1 7.1 0 0011.7-5.44V758a28.78 28.78 0 00-10.18-21.88L503.5 511.82l267.31-224.33A28.78 28.78 0 00781 265.61z"
      }
    }]
  },
  "name": "bevel-fast-right-stroke"
};
a['BevelForwardStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M547.63 139.52l327.04 329.81a64 64 0 010 90.24L547.2 886.83a31.79 31.79 0 01-45.23 0l-15.14-14.94a32 32 0 010-45.44l312.32-312.1-312.11-314.67a32 32 0 010-45.23l15.15-15.14a32.21 32.21 0 0145.44.21zm-322.56 0L552.1 469.33a64 64 0 010 90.24L224.64 886.83a31.79 31.79 0 01-45.23 0l-15.14-14.94a32.43 32.43 0 010-45.44l312.32-312.1-312.11-314.67a32 32 0 010-45.23l15.15-15.14a32.21 32.21 0 0145.44.21z"
      }
    }]
  },
  "name": "bevel-forward-stroke"
};
a['BevelLeftSquareStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M872.75 149.33v725.34H147.4V149.33h725.34M126.08 64a64 64 0 00-64 64v768a64 64 0 0064 64h768a64 64 0 0064-64V128a64 64 0 00-64-64zM630.4 372.48L456.53 512 630.2 651.3a21.33 21.33 0 013.2 31.37l-26.67 33.28a21.33 21.33 0 01-29.87 3.2L351.36 537.8a32 32 0 010-49.92L576 306.13a21.33 21.33 0 0130.08 3.2l26.88 33.07a21.33 21.33 0 01-2.56 30.08z"
      }
    }]
  },
  "name": "bevel-left-square-stroke"
};
a['BevelLeftStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M733.7 901.18l-14.73 15.36a32 32 0 01-45.22.64L301.48 556.86l-3.41-3.41a59.94 59.94 0 011.53-84.77l.6-.56.21-.22.22-.21 372.9-360.96a32 32 0 0145.23.85l14.93 15.15a32.07 32.07 0 01-.75 45.34l-.1.1-355.2 343.68 355.41 344.1a32 32 0 01.64 45.23z"
      }
    }]
  },
  "name": "bevel-left-stroke"
};
a['BevelRightSquareStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M872.75 149.33v725.34H147.4V149.33h725.34M126.08 64a64 64 0 00-64 64v768a64 64 0 0064 64h768a64 64 0 0064-64V128a64 64 0 00-64-64zm263.68 588.37L563.63 512 389.76 372.7a21.33 21.33 0 01-3.2-30.09l26.67-33.28a21.33 21.33 0 0130.08-3.41l225.49 180.9a32.21 32.21 0 010 49.93L443.3 718.72a21.33 21.33 0 01-30.07-3.2l-26.67-32.85a21.33 21.33 0 013.2-30.3z"
      }
    }]
  },
  "name": "bevel-right-square-stroke"
};
a['BevelRightStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M290.3 122.83l14.73-15.36a32 32 0 0145.22-.64l372.27 360.32 3.41 3.41a59.94 59.94 0 01-1.53 84.77l-.6.56-.21.22-.22.21-372.9 360.96a32 32 0 01-45.23-.85l-14.93-15.15a32.07 32.07 0 01.75-45.34l.1-.1 355.2-343.68-355.41-344.1a32 32 0 01-.64-45.23z"
      }
    }]
  },
  "name": "bevel-right-stroke"
};
a['BevelTopSquareFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M898.05 63.49h-768c-35.33 0-64 28.67-64 64v768c0 35.33 28.67 64 64 64h768c35.33 0 64-28.67 64-64v-768c0-35.33-28.67-64-64-64zM717.82 629.76l-33.28 27.14c-9.72 6.65-23.04 5.12-30.2-4.1l-140.3-174.08L374.79 652.8c-7.16 9.22-20.99 10.75-30.2 3.07l-33.28-26.62a20.65 20.65 0 01-3.08-29.7l180.74-225.28a32.37 32.37 0 0145.06-5.12 24.27 24.27 0 015.12 5.12L720.9 599.55c7.68 9.22 6.14 22.53-3.08 30.21z"
      }
    }]
  },
  "name": "bevel-top-square-fill"
};
a['BevelTopSquareStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M872.75 149.33v725.34H147.4V149.33h725.34M126.08 64a64 64 0 00-64 64v768a64 64 0 0064 64h768a64 64 0 0064-64V128a64 64 0 00-64-64zm523.73 568.32L509.65 458.45 370.13 632.11a21.33 21.33 0 01-29.86 3.41l-33.28-26.88a21.33 21.33 0 01-3.42-29.87l180.91-225.49a32 32 0 0149.92 0l181.97 225.5a21.33 21.33 0 01-3.2 29.86l-33.28 26.88a21.33 21.33 0 01-30.08-3.2z"
      }
    }]
  },
  "name": "bevel-top-square-stroke"
};
a['BevelTopStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M573.44 323.96l317.02 330.67a33.06 33.06 0 010 45.23L876.16 715a29.66 29.66 0 01-41.89 2.02q-.4-.36-.77-.74L832 715 515.62 383.48 197.34 715a29.66 29.66 0 01-41.9 2.02q-.4-.36-.78-.74l-1.28-1.28-14.5-15.14a33.06 33.06 0 010-45.23L457.6 323.75a79.36 79.36 0 01112.18-3.43l.24.23z"
      }
    }]
  },
  "name": "bevel-top-stroke"
};
a['BoardListFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M0 0h1024v1024H0zm865 125H577c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32V157c0-17.7-14.3-32-32-32zm-40 376H617V197h208v304zM448 125H160c-17.7 0-32 14.3-32 32v707c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32V157c0-17.7-14.3-32-32-32zm-40 699H200V197h208v627z"
      }
    }]
  },
  "name": "board-list-fill"
};
a['BoardListStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M584 896.5H440a32 32 0 01-32-32v-705a32 32 0 0132-32h144a32 32 0 0132 32v705a32 32 0 01-32 32zm-104-72h64v-625h-64v625zm383-41H719a32 32 0 01-32-32v-592a32 32 0 0132-32h144a32 32 0 0132 32v592a32 32 0 01-32 32zm-104-72h64v-512h-64v512zm-454-16H161a32 32 0 01-32-32v-504a32 32 0 0132-32h144a32 32 0 0132 32v504a32 32 0 01-32 32zm-104-72h64v-424h-64v424z"
      }
    }]
  },
  "name": "board-list-stroke"
};
a['BoardSimpleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M258.85 692a8 8 0 0011.3 0l151.29-151.26 107.32 107.42a8 8 0 0011.3 0l275.79-276a8 8 0 000-11.3l-36.8-36.8a8 8 0 00-11.3 0l-233.29 233.4L427.14 450a8 8 0 00-11.3 0L222.15 643.82a8 8 0 000 11.3zM914 171H110a32 32 0 00-32 32v618a32 32 0 0032 32h804a32 32 0 0032-32V203a32 32 0 00-32-32zm-40 610H150V243h724z"
      }
    }]
  },
  "name": "board-simple-stroke"
};
a['BoardStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M865.28 128A30.69 30.69 0 01896 158.72v706.56A30.69 30.69 0 01865.28 896H158.72A30.69 30.69 0 01128 865.28V158.72A30.69 30.69 0 01158.72 128zM476 256H198v568h278V256zm348 0H548v568h276V256z"
      }
    }]
  },
  "name": "board-stroke"
};
a['BoltStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M528.33 81.7L867 282.7a32 32 0 0115.67 27.52v403.56a32 32 0 01-15.67 27.52l-338.66 201a32 32 0 01-32.66 0L157 741.3a32 32 0 01-15.67-27.52V310.22a32 32 0 0115.67-27.52l338.66-201a32 32 0 0132.66 0zM512 155.72L213.34 332.99v358.02L512 868.27l298.66-177.26V332.99L512 155.73zM512 362c82.84 0 150 67.16 150 150s-67.16 150-150 150-150-67.16-150-150 67.16-150 150-150zm0 64a86 86 0 100 172 86 86 0 000-172z"
      }
    }]
  },
  "name": "bolt-stroke"
};
a['BookmarkStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M810.67 149.33v688.64L573 709.97l-4.69-2.56-4.05-3.41a149.33 149.33 0 00-107.74 0l-5.12 1.92-4.9 2.77-234.67 128V149.33h598.83M832 64H192a64 64 0 00-64 64v799.36A32.21 32.21 0 00159.15 960a31.36 31.36 0 0011.52-2.13l316.8-173.44a64 64 0 0145.86 0l320 173.44a31.36 31.36 0 0011.52 2.13A32.21 32.21 0 00896 927.36v-798.3a64 64 0 00-64-64z"
      }
    }]
  },
  "name": "bookmark-stroke"
};
a['BournStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M928 468.05h-56.32a362.67 362.67 0 00-317.01-317.22V96.2a32 32 0 00-32-32.21h-21.34a32 32 0 00-32 32.21v54.62A362.67 362.67 0 00151.9 468.05H96a32 32 0 00-32 32v21.34a32 32 0 0032 32h55.9A362.67 362.67 0 00469.32 870.6v57.6a32 32 0 0032 31.79h21.34a32 32 0 0032-32v-57.6a362.67 362.67 0 00317.01-317.01H928a32 32 0 0032-32v-21.34a32 32 0 00-32-32zm-416 320a277.33 277.33 0 11277.33-277.33A277.33 277.33 0 01512 788.05z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M323.44 541.2099999999999a190.72 190.72 0 10376.51-61.11 190.72 190.72 0 10-376.5 61.11z"
      }
    }]
  },
  "name": "bourn-stroke"
};
a['BugFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M328.81 309.3h366.38a7.07 7.07 0 007-7.05c0-35.23-7.75-67.55-22.81-95.2a162.29 162.29 0 00-65.18-65.18c-27.65-15.06-60-22.81-95.2-22.81h-14c-35.23 0-67.55 7.75-95.2 22.81a162.29 162.29 0 00-65.18 65.18c-15.06 27.65-22.81 60-22.81 95.2a7.07 7.07 0 007 7.05zM889 513.63H758.61v-88.07A122.39 122.39 0 00881 303.13a7.07 7.07 0 00-7-7h-52.86a7.07 7.07 0 00-7 7 55.48 55.48 0 01-55.48 55.49H265.39a55.48 55.48 0 01-55.48-55.49 7.07 7.07 0 00-7-7H150a7.07 7.07 0 00-7.05 7 122.39 122.39 0 00122.44 122.43v88.07H135.05a7.07 7.07 0 00-7.05 7V570a7.07 7.07 0 007.05 7h130.34v84.55c0 5.73.18 11.45.62 17a169.22 169.22 0 00-102.78 155.67 7.07 7.07 0 007.05 7h49.32a7.06 7.06 0 007-7 105.59 105.59 0 0152.49-91.34 240.38 240.38 0 0020 43.16 246.93 246.93 0 00172.44 118.9 7.07 7.07 0 007.05-7.05V489a7.07 7.07 0 017.05-7.05h52.84a7.07 7.07 0 017 7.05v408.81a7.06 7.06 0 007 7A247.42 247.42 0 00745 742.8a106 106 0 0152.32 91.42 7.06 7.06 0 007 7h49.32a7.07 7.07 0 007-7A169.22 169.22 0 00758 678.59c.35-5.64.62-11.27.62-17V577H889a7.07 7.07 0 007-7v-49.32a7.07 7.07 0 00-7-7.05z"
      }
    }]
  },
  "name": "bug-fill"
};
a['BulbFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M607.15 874.67h-192a32 32 0 00-32 32V928a32 32 0 0032 32h192a32 32 0 0032-32v-21.33a32 32 0 00-32-32zm232.53-483.63A327.68 327.68 0 10384 692.48v99.84a32 32 0 0032 32h192a32 32 0 0032-32v-99.2a328.1 328.1 0 00199.68-302.08z"
      }
    }]
  },
  "name": "bulb-fill"
};
a['BulbStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64a327.47 327.47 0 00-163.84 610.99v105.6a42.67 42.67 0 0042.67 42.66h242.34a42.67 42.67 0 0042.67-42.66V674.77A327.47 327.47 0 00512 64zm163.84 505.39a241.28 241.28 0 01-85.33 51.2v117.33H433.49V620.59a245.97 245.97 0 01-85.33-50.99 242.56 242.56 0 11327.68 0zM416 874.88h192q32 0 32 32v21.33q0 32-32 32H416q-32 0-32-32v-21.33q0-32 32-32z"
      }
    }]
  },
  "name": "bulb-stroke"
};
a['CalculateStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M917.33 64H106.67A42.67 42.67 0 0064 106.67v810.66A42.67 42.67 0 00106.67 960h810.66A42.67 42.67 0 00960 917.33V106.67A42.67 42.67 0 00917.33 64zm-42.66 810.67H149.33V149.33h725.34z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M245.55 378.67h58.66v59.3a32 32 0 0032 32h10.67a32 32 0 0032-32v-59.3h58.67a32 32 0 0032-32V336a32 32 0 00-32-32h-58.67v-58.03a32 32 0 00-32-32h-10.67a32 32 0 00-32 32V304h-58.66a32 32 0 00-32 32v10.67a32 32 0 0032 32zm149.12 304l40.96-40.96a32 32 0 000-45.44l-7.47-7.47a32 32 0 00-45.23 0l-41.6 40.53-42.66-41.38a31.79 31.79 0 00-21.34-9.39 32.21 32.21 0 00-22.61 9.39l-7.47 7.46a31.79 31.79 0 000 45.23l41.82 42.03-42.67 42.66a32 32 0 000 45.44l7.47 7.47a32 32 0 0045.22 0l42.67-42.67L384 776.53a32.64 32.64 0 0022.61 9.39 31.79 31.79 0 0022.62-9.39l7.68-7.68a32.21 32.21 0 000-45.22zM587.3 304h192q32 0 32 32v10.67q0 32-32 32h-192q-32 0-32-32V336q0-32 32-32zM587.3 644.48h192q32 0 32 32v10.67q0 32-32 32h-192q-32 0-32-32v-10.67q0-32 32-32zM645.3299999999999 774.19a37.33 37.33 0 1074.67 0 37.33 37.33 0 10-74.67 0zM645.3299999999999 590.5a37.33 37.33 0 1074.67 0 37.33 37.33 0 10-74.67 0z"
      }
    }]
  },
  "name": "calculate-stroke"
};
a['CalendarDayStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M832 302.93H192c-46.93 0-85.33 38.4-85.33 85.34V633.6c0 46.93 38.4 85.33 85.33 85.33h640c46.93 0 85.33-38.4 85.33-85.33V388.27c0-46.94-38.4-85.34-85.33-85.34zm0 332.8H192V388.27h640v247.46zm53.33-486.4H138.67c-17.07 0-32 14.94-32 32v21.34c0 17.06 14.93 32 32 32h746.66c17.07 0 32-14.94 32-32v-21.34c0-17.06-14.93-32-32-32zm0 640H138.67c-17.07 0-32 14.94-32 32v21.34c0 17.06 14.93 32 32 32h746.66c17.07 0 32-14.94 32-32v-21.34c0-17.06-14.93-32-32-32z"
      }
    }]
  },
  "name": "calendar-day-stroke"
};
a['CalendarFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 128a128 128 0 01128 128v512a128 128 0 01-128 128H256a128 128 0 01-128-128V256a128 128 0 01128-128zM288 672h-64a32 32 0 00-32 32v64a32 32 0 0032 32h64a32 32 0 0032-32v-64a32 32 0 00-32-32zm384 0H416a32 32 0 00-32 32v64a32 32 0 0032 32h256a32 32 0 0032-32v-64a32 32 0 00-32-32zm128-224H224a32 32 0 00-32 32v64a32 32 0 0032 32h576a32 32 0 0032-32v-64a32 32 0 00-32-32zm0-192h-64a32 32 0 00-32 32v64a32 32 0 0032 32h64a32 32 0 0032-32v-64a32 32 0 00-32-32zm-192 0H352a32 32 0 00-32 32v64a32 32 0 0032 32h256a32 32 0 0032-32v-64a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "calendar-fill"
};
a['CalendarMonthStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M832 149.33H192c-46.93 0-85.33 38.4-85.33 85.34v554.66c0 46.94 38.4 85.34 85.33 85.34h640c46.93 0 85.33-38.4 85.33-85.34V234.67c0-46.94-38.4-85.34-85.33-85.34zm0 322.14H704v-236.8h128v236.8zm-384 0v-236.8h170.67v236.8H448zm170.67 85.33v232.53H448V556.8h170.67zm-256-322.13v236.8H192v-236.8h170.67zM192 556.8h170.67v232.53H192V556.8zm512 232.53V556.8h128v232.53H704z"
      }
    }]
  },
  "name": "calendar-month-stroke"
};
a['CalendarThreeDayStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M917.33 219.73c0-8.53-2.13-14.93-6.4-19.2-14.93-29.86-44.8-51.2-78.93-51.2H192c-34.13 0-64 21.34-78.93 51.2-4.27 6.4-6.4 12.8-6.4 19.2v576c4.26 44.8 40.53 78.94 85.33 78.94h640c44.8 0 81.07-34.14 85.33-78.94v-576zM192 234.67h155.73v554.66H192V234.67zm241.07 0H588.8v554.66H433.07V234.67zM832 789.33H676.27V234.67H832v554.66z"
      }
    }]
  },
  "name": "calendar-three-day-stroke"
};
a['CameraFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M426.67 554.67a85.33 85.33 0 10170.66 0 85.33 85.33 0 10-170.66 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M896 256H746.67L736 187.73l-2.13-12.8c-8.54-25.6-32-44.8-57.6-46.93h-326.4c-27.74 2.13-51.2 21.33-59.74 49.07v6.4L277.33 256H128c-36.27 0-64 27.73-64 64v512c0 36.27 27.73 64 64 64h768c36.27 0 64-27.73 64-64V320c0-36.27-27.73-64-64-64zM512 725.33c-93.87 0-170.67-76.8-170.67-170.66S418.13 384 512 384s170.67 76.8 170.67 170.67S605.87 725.33 512 725.33z"
      }
    }]
  },
  "name": "camera-fill"
};
a['CameraStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M675.41 128H349.87a64 64 0 00-58.88 48.85v5.98l-13.66 71.46H128a64 64 0 00-64 64v512a64 64 0 0064 64h768a64 64 0 0064-64v-512a64 64 0 00-64-64H746.67l-11.31-67.62-2.13-12.8A64 64 0 00675.4 128zM357.33 298.67l6.62-38.83V256l7.46-42.67h282.24l7.68 40.32 7.26 42.67 7.04 42.67h199.04v469.33H149.33V338.99h201.18l6.82-42.67z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M512 469.33a85.33 85.33 0 11-85.33 85.34A85.33 85.33 0 01512 469.33m0-85.33a170.67 170.67 0 10170.67 170.67A170.67 170.67 0 00512 384z"
      }
    }]
  },
  "name": "camera-stroke"
};
a['CarStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M746.67 87.68H276.69a64 64 0 00-52.9 36.05l-4.27 12.16-57.17 159.36-39.9-23.04a31.57 31.57 0 00-16-4.26 32 32 0 00-27.73 16l-10.67 18.34a32 32 0 0011.74 42.67l53.12 30.72L106.67 448a75.73 75.73 0 000 12.16v330.67a64 64 0 0064 64h42.66v49.92a32 32 0 0032 32h18.99a32 32 0 0032-32V854.4h429.01v49.92a32 32 0 0032 32h19.2a32 32 0 0032-32V854.4h44.8a64 64 0 0064-64V459.73a75.73 75.73 0 000-11.73l-23.46-68.9 50.34-29.23a32 32 0 0011.74-42.67l-10.67-18.35a32 32 0 00-27.73-16 31.57 31.57 0 00-16 4.27l-36.7 21.33L807.9 135.9l-4.05-11.3a64 64 0 00-53.12-36.48h-4.7zM224.2 362.67l53.12-147.42 16.64-46.08h439.68l16.22 46.08 52.05 147.42zM192 769.07V448h640v321.07z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M341.33 546.99a48 48 0 1048 48 48 48 0 00-48-48zm341.34 0a48 48 0 1048 48 48 48 0 00-48-48z"
      }
    }]
  },
  "name": "car-stroke"
};
a['ChartAreaStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M134.4 130.13h-17.07c-17.06 0-32 14.94-32 32v699.74c0 17.06 14.94 32 32 32h789.34c17.06 0 32-14.94 32-32v-8.54c0-17.06-14.94-32-32-32H166.4v-659.2c0-17.06-12.8-32-32-32z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M861.87 563.2V288c0-14.93-12.8-27.73-27.74-27.73-6.4 0-12.8 2.13-17.06 6.4l-243.2 230.4-134.4-123.74c-8.54-8.53-21.34-8.53-29.87 0L213.33 563.2V704c0 23.47 19.2 44.8 44.8 44.8H819.2c19.2 0 36.27-12.8 40.53-29.87 2.14-4.26 2.14-8.53 2.14-10.66V563.2zm-230.4-2.13l2.13 2.13-2.13-2.13c-2.14 2.13-2.14 0 0 0z"
      }
    }]
  },
  "name": "chart-area-stroke"
};
a['ChartBarStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M245.12 740.7h21.33a30.5 30.5 0 0032.22-28.6V597.34a30.5 30.5 0 00-32-28.58h-21.34a30.5 30.5 0 00-32 28.58v114.35a30.5 30.5 0 0031.79 29.01zm170.24 0h21.33a30.5 30.5 0 0032.64-28.6V388.06a30.5 30.5 0 00-32-28.58H416a30.5 30.5 0 00-32 28.58v324.06a30.5 30.5 0 0031.36 28.58zm170.67 0h21.33A30.5 30.5 0 00640 712.1V483.42a30.5 30.5 0 00-32-28.58h-21.33a30.5 30.5 0 00-32 28.58v228.7a30.5 30.5 0 0031.36 28.58zm170.66 0h21.34a30.5 30.5 0 0032.64-28.6V311.9a30.5 30.5 0 00-32-28.6h-21.34a30.5 30.5 0 00-32 28.6v400.2a30.5 30.5 0 0031.36 28.6z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M906.24 820.7H166.61V159.35a30.5 30.5 0 00-32-28.59h-17.06a30.5 30.5 0 00-32.22 28.59v685.01a19.41 19.41 0 000 4.91v15.36a30.5 30.5 0 0032 28.59h789.34a30.5 30.5 0 0032-28.59v-15.36a30.5 30.5 0 00-32.43-28.59z"
      }
    }]
  },
  "name": "chart-bar-stroke"
};
a['ChartDotStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M903.47 820.7H164.05V159.35a30.5 30.5 0 00-32-28.59h-17.28a30.5 30.5 0 00-32 28.59v685.01a19.41 19.41 0 000 4.91v15.36a30.5 30.5 0 0032 28.59h789.34a30.5 30.5 0 0032-28.59v-15.36a30.5 30.5 0 00-32.64-28.59z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M210.13 615.68a74.67 74.67 0 10149.34 0 74.67 74.67 0 10-149.34 0zM523.52 607.57a117.33 117.33 0 10234.67 0 117.33 117.33 0 10-234.67 0zM341.76 351.36a53.33 53.33 0 10106.67 0 53.33 53.33 0 10-106.67 0zM679.68 280.75a64 64 0 10128 0 64 64 0 10-128 0z"
      }
    }]
  },
  "name": "chart-dot-stroke"
};
a['ChartFunnelStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M898.56 130.77H126.51A58.88 58.88 0 0064 186.24a51.84 51.84 0 004.7 21.33l3.62 5.98 269.01 450.77v170.67a60.8 60.8 0 0064 57.17h213.34a60.8 60.8 0 0064-57.17V664.32l266.88-448 5.97-10.24a49.28 49.28 0 004.7-21.33 58.88 58.88 0 00-61.66-53.98zm-301.23 686.3H426.67V664.53h170.66zm34.14-229.12H392.96l-90.88-152.32h420.9zm219.3-366.51L768 359.47H256l-81.92-138.03-8.53-14.5h693.97z"
      }
    }]
  },
  "name": "chart-funnel-stroke"
};
a['ChartLineStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M253.01 648.32a32.21 32.21 0 0022.62 9.39 31.79 31.79 0 0023.04-9.39l142.08-142.08 109.44 109.23 15.14 14.93a31.36 31.36 0 0022.62 9.39 31.36 31.36 0 0022.61-9.39l15.15-14.93 257.7-257.28a31.79 31.79 0 000-45.23l-15.14-14.3a31.79 31.79 0 00-22.62-9.38 32.21 32.21 0 00-22.61 9.39L588.37 533.33 478.72 423.9l-14.93-15.14a32.64 32.64 0 00-22.62-9.39 32.21 32.21 0 00-22.61 9.39l-15.15 15.14-164.69 164.48a32.21 32.21 0 000 45.23z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M906.67 820.7H167.04V159.35a30.5 30.5 0 00-32-28.59h-17.07a30.5 30.5 0 00-32.64 28.59v685.01a19.41 19.41 0 000 4.91v15.36a30.5 30.5 0 0032 28.59h789.34a30.5 30.5 0 0032-28.59v-15.36a30.5 30.5 0 00-32-28.59z"
      }
    }]
  },
  "name": "chart-line-stroke"
};
a['ChartPieFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M273.92 939.73H127.57a42.8 42.8 0 01-42.66-42.66V596.69a42.8 42.8 0 0142.66-42.66h146.56a42.8 42.8 0 0142.67 42.66v300.38a42.84 42.84 0 01-42.88 42.66zm311.25 0H438.61a42.8 42.8 0 01-42.66-42.66V379.09a42.8 42.8 0 0142.66-42.66h146.56a42.8 42.8 0 0142.67 42.66v518.19a42.47 42.47 0 01-42.67 42.45zm311.26 0H749.87a42.8 42.8 0 01-42.67-42.66V128a42.8 42.8 0 0142.67-42.67h146.56A42.8 42.8 0 01939.09 128v769.07a42.52 42.52 0 01-42.66 42.66z"
      }
    }]
  },
  "name": "chart-pie-fill"
};
a['ChartPieStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M874.67 128.43H149.33c-35.41 0-64 32.21-64 71.89v623.15c0 39.68 28.59 71.89 64 71.89h725.34c35.41 0 64-32.21 64-71.9V200.33c0-39.68-28.59-71.9-64-71.9zm-21.34 681.81H170.67V213.76h682.66v596.48zM318.51 736h24.74a30.05 30.05 0 0030.08-30.08V394.88a30.05 30.05 0 00-30.08-30.08h-24.74a30.05 30.05 0 00-30.08 30.08v310.83A30.1 30.1 0 00318.5 736zm178.56 0h30.08a27.59 27.59 0 0027.52-27.52V315.52A27.59 27.59 0 00527.15 288h-30.08a27.59 27.59 0 00-27.52 27.52v392.75A27.63 27.63 0 00497.07 736zm182.4 0h27.3c16 0 29.02-13.01 29.02-29.01V517.97c0-16-13.02-29.01-29.02-29.01h-27.3c-16 0-29.02 13.01-29.02 29.01V707c0 16 13.02 29.01 29.02 29.01z"
      }
    }]
  },
  "name": "chart-pie-stroke"
};
a['ChartRadarStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M933.55 373.97l-384-277.33a64 64 0 00-75.1 0l-384 277.33a64 64 0 00-23.25 71.9l146.13 448a64 64 0 0061.23 44.8h474.88a64 64 0 0061.23-44.8l146.56-448a64 64 0 00-23.68-71.9zM842.03 400l-106.67 34.99-184.75-133.55V188.8zM516.27 576l-2.14-1.7h4.48zM512 610.13L570.88 691H453.55zm37.12-114.98V393.17l97.5 70.19zm-74.67 0l-97.49-31.58 97.5-70.4zm-22.82 71.04l-60.16 82.77-37.34-114.35zm-52.48 199.46h226.13l71.04 97.71h-368zm173.22-199.68l97.07-31.36-37.12 113.71zm-97.7-377.17v112.21L289.92 434.56l-106.67-34.99zM153.39 469.33l113.06 36.7 70.4 215.25a7.68 7.68 0 000 1.92l-69.76 96zm602.88 349.44l-69.76-96v-1.28l70.4-215.25 113.7-36.9z"
      }
    }]
  },
  "name": "chart-radar-stroke"
};
a['CloseStoke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M460.59 212.05h470.4q32 0 32 32v21.34q0 32-32 32h-470.4q-32 0-32-32v-21.34q0-32 32-32zM460.59 468.05h470.4q32 0 32 32v21.34q0 32-32 32h-470.4q-32 0-32-32v-21.34q0-32 32-32zM459.95 724.05h470.4q32 0 32 32v21.34q0 32-32 32h-470.4q-32 0-32-32v-21.34q0-32 32-32zM75.73 535.68l213.34 123.3a21.33 21.33 0 0032-18.34V394.03a21.33 21.33 0 00-32-18.56L75.73 498.77a21.33 21.33 0 000 36.91z"
      }
    }]
  },
  "name": "close-stoke"
};
a['CloudDownloadStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M819.41 378.67a315.95 315.95 0 00-308.69-263.04 316.59 316.59 0 00-309.55 264.96 273.92 273.92 0 00-50.77 436.69 270.3 270.3 0 0059.73 42.67 354.99 354.99 0 0049.07 21.33 184.1 184.1 0 0023.68 5.76A31.79 31.79 0 00320 854.83v-21.34a32 32 0 00-25.17-30.93 189.65 189.65 0 01-143.58-213.33 196.05 196.05 0 0197.71-137.82l29.44-17.06 6.4-39.9a227.63 227.63 0 01449.7-1.7l6.83 40.53 35.84 20.05a189.01 189.01 0 01-49.06 348.8A31.79 31.79 0 00704 833.07v21.33a31.79 31.79 0 0038.19 31.36 268.37 268.37 0 0029.65-7.04 274.35 274.35 0 0048.21-499.84z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M663.68 731.95l-13.87-13.87a28.8 28.8 0 00-41.17 0l-57.39 57.39v-251.1a32 32 0 00-32-32H505.4a32 32 0 00-32 32v251.31L416 718.29a29.23 29.23 0 00-41.17 0l-13.87 13.87a29.01 29.01 0 000 41.39l123.73 123.52a39.04 39.04 0 0055.04 0l123.95-123.74a29.65 29.65 0 008.1-17.49v-6.4a28.16 28.16 0 00-7.89-17.28z"
      }
    }]
  },
  "name": "cloud-download-stroke"
};
a['CloudFailStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M518.85 160l4.54.32h6.72c154.24 17.92 233.15 116.8 247.49 217.02A221.57 221.57 0 01960 598.72v2.24c0 157.31-112 213.76-217.09 213.76H280.96C176 814.72 64 758.34 64 599.87a221 221 0 01182.2-221.89c14.22-102.65 93.32-202.88 250.5-217.6h17.54a29.95 29.95 0 019.15 0zm4.93 74.69h-21.83c-135.3 13.5-183.49 103.8-183.49 177.28a37.44 37.44 0 01-37.3 37.63 144.77 144.77 0 00-102.66 45.89A145.6 145.6 0 00138.75 600c0 121.86 89.22 140.16 142.4 140.16H743.1c53.19 0 142.21-18.3 142.21-140.16v-2.24a146.18 146.18 0 00-142.4-148.74 37.44 37.44 0 01-37.31-37.63c0-26.24-8.77-155.84-181.76-176.7zm50.62 200.96c2.11 0 4.1.9 5.57 2.37l33.09 33.08a7.94 7.94 0 010 11.08L556.1 539l56.96 56.7a7.8 7.8 0 010 11.07l-33.1 33.1a7.94 7.94 0 01-11.06 0l-56.96-56.97-56.58 57.28a7.94 7.94 0 01-11.07 0L411.2 607.1a7.94 7.94 0 010-11.07l56.96-56.96-57.28-56.9a7.94 7.94 0 010-11.07l33.09-33.08a7.8 7.8 0 0111.07 0l56.83 56.83 56.96-56.83a7.8 7.8 0 015.57-2.3z"
      }
    }]
  },
  "name": "cloud-fail-stroke"
};
a['CloudFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M819.41 378.67a315.95 315.95 0 00-308.69-263.04 316.59 316.59 0 00-309.55 264.96 273.92 273.92 0 00-50.77 436.69 270.3 270.3 0 0059.73 42.67 354.99 354.99 0 0049.07 21.33 430.93 430.93 0 0061.65 11.52H704a554.67 554.67 0 0067.84-13.65 274.35 274.35 0 0048.21-499.84z"
      }
    }]
  },
  "name": "cloud-fill"
};
a['CloudStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M819.41 378.67a315.95 315.95 0 00-308.69-263.04 316.59 316.59 0 00-309.55 264.96 273.92 273.92 0 00-50.77 436.69 270.3 270.3 0 0059.73 42.67 354.99 354.99 0 0049.07 21.33 430.93 430.93 0 0061.65 11.52H704a554.67 554.67 0 0067.84-13.65 274.35 274.35 0 0048.21-499.84zM872.96 640a189.65 189.65 0 01-170.67 165.55H320A189.44 189.44 0 01151.9 589a196.7 196.7 0 0197.7-137.81l29.44-17.07 6.4-39.89a227.63 227.63 0 01449.7-1.7l6.83 40.53 35.84 20.05A188.16 188.16 0 01872.96 640z"
      }
    }]
  },
  "name": "cloud-stroke"
};
a['CloudSyncStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M819.41 378.67a315.95 315.95 0 00-308.69-263.04 316.59 316.59 0 00-309.55 264.96 273.92 273.92 0 00-50.77 436.69 270.3 270.3 0 0059.73 42.67 354.99 354.99 0 0049.07 21.33 184.1 184.1 0 0023.68 5.76A31.79 31.79 0 00320 854.83v-21.34a32 32 0 00-25.17-30.93 189.65 189.65 0 01-143.58-213.33 196.05 196.05 0 0197.71-137.82l29.44-17.06 6.4-39.9a227.63 227.63 0 01449.7-1.7l6.83 40.53 35.84 20.05a189.01 189.01 0 01-49.06 348.8A31.79 31.79 0 00704 833.07v21.33a31.79 31.79 0 0038.19 31.36 268.37 268.37 0 0029.65-7.04 274.35 274.35 0 0048.21-499.84z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M513.5 830.5a109.65 109.65 0 01-99.42-64h6.19a7.25 7.25 0 007.25-7.46 7.47 7.47 0 00-1.7-5.12l-45.23-52.05a7.47 7.47 0 00-10.67 0h-1.07l-45.22 52.69a7.25 7.25 0 001.06 10.67 6.4 6.4 0 005.12 1.92H339a180.05 180.05 0 00338.34 29.01 21.33 21.33 0 00-19.62-29.44h-26.67a32.21 32.21 0 00-26.88 14.93 108.37 108.37 0 01-90.67 48.86zm180.26-160.2h-7.9a180.27 180.27 0 00-336.85-22.4 21.33 21.33 0 0019.63 29.22h26.67a32 32 0 0026.88-14.72 108.16 108.16 0 01135.46-39.68 110.08 110.08 0 0151.42 47.57h-5.76a7.47 7.47 0 00-7.47 7.26 8.1 8.1 0 001.5 5.12l45.22 52.48a7.25 7.25 0 0010.67 1.06l1.06-1.06 46.08-52.48a7.47 7.47 0 000-10.88 6.19 6.19 0 00-6.61-1.5z"
      }
    }]
  },
  "name": "cloud-sync-stroke"
};
a['CloudUploadStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M819.41 378.67a315.95 315.95 0 00-308.69-263.04 316.59 316.59 0 00-309.55 264.96 273.92 273.92 0 00-50.77 436.69 270.3 270.3 0 0059.73 42.67 354.99 354.99 0 0049.07 21.33 184.1 184.1 0 0023.68 5.76A31.79 31.79 0 00320 854.83v-21.34a32 32 0 00-25.17-30.93 189.65 189.65 0 01-143.58-213.33 196.05 196.05 0 0197.71-137.82l29.44-17.06 6.4-39.9a227.63 227.63 0 01449.7-1.7l6.83 40.53 35.84 20.05a189.01 189.01 0 01-49.06 348.8A31.79 31.79 0 00704 833.07v21.33a31.79 31.79 0 0038.19 31.36 268.37 268.37 0 0029.65-7.04 274.35 274.35 0 0048.21-499.84z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M360.32 669.01l13.87 13.66a28.8 28.8 0 0041.17 0l57.39-57.18v250.88a32 32 0 0032 32h13.86a32 32 0 0032-32V625.28L608 682.67a28.8 28.8 0 0041.17 0L663.04 669a29.01 29.01 0 000-41.38L539.31 504.1a39.04 39.04 0 00-55.04 0L360.32 627.84a29.65 29.65 0 00-8.1 17.5v6.18a27.1 27.1 0 007.89 17.28z"
      }
    }]
  },
  "name": "cloud-upload-stroke"
};
a['CodeSquareFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M864 128H160a32 32 0 00-32 32v704a32 32 0 0032 32h704a32 32 0 0032-32V160a32 32 0 00-32-32zM513.1 518.1l-192 161A8 8 0 01308 673v-62.7a8.09 8.09 0 012.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 01-2.9-6.1V351a8 8 0 0113.1-6.1l192 160.9a8.06 8.06 0 010 12.3zM716 673a7.8 7.8 0 01-7.5 8h-185a7.8 7.8 0 01-7.5-8v-48a7.8 7.8 0 017.5-8h185a7.8 7.8 0 017.5 8z"
      }
    }]
  },
  "name": "code-square-fill"
};
a['CodeSquareStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M824 824H200V200h624zm40-696H160a32 32 0 00-32 32v704a32 32 0 0032 32h704a32 32 0 0032-32V160a32 32 0 00-32-32zM321.1 679.1l192-161a8.06 8.06 0 000-12.3l-192-160.9A8 8 0 00308 351v62.7a7.63 7.63 0 002.9 6.1L420.7 512l-109.8 92.2a8.09 8.09 0 00-2.9 6.1V673a8 8 0 0013.1 6.1zM516 673a7.8 7.8 0 007.5 8h185a7.8 7.8 0 007.5-8v-48a7.8 7.8 0 00-7.5-8h-185a7.8 7.8 0 00-7.5 8z"
      }
    }]
  },
  "name": "code-square-stroke"
};
a['CommonlyUsedFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M798.93 109.23H235.95a64 64 0 00-64 64v701.44a32 32 0 0051.41 25.38l277.33-150.82a21.33 21.33 0 0122.83 0l288.21 151.46a32 32 0 0051.2-25.6V173.23a64 64 0 00-64-64zm-89.81 257.49L528 533.33 516.05 544l-6.18 5.76a32.21 32.21 0 01-45.23-2.35L357.97 432a31.79 31.79 0 012.35-45.23l18.13-16.42a32 32 0 0145.23 2.34L490.67 448 649.6 302.08a32 32 0 0145.01 2.35l16.43 18.13a31.79 31.79 0 01-1.92 44.16z"
      }
    }]
  },
  "name": "Commonly-used-fill"
};
a['CompassCircleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 152.32a362.67 362.67 0 11-362.67 362.67A362.67 362.67 0 01512 152.32m0-85.33a448 448 0 10448 448 448 448 0 00-448-448z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M453.33 501.76L527.57 576l-129.06 54.83 54.82-129.07m234.67-192a31.15 31.15 0 00-12.8 2.56l-245.33 103.9a21.33 21.33 0 00-4.7 2.77 13.23 13.23 0 00-4.9 4.05l-2.78 2.77-1.28 2.14a50.99 50.99 0 00-2.77 4.48l-104.96 246.4a32.21 32.21 0 0029.44 44.58 33.92 33.92 0 0012.59-2.56l246.82-104.32 4.48-2.77 2.14-1.28 2.77-2.77a13.23 13.23 0 004.05-4.91 21.33 21.33 0 002.78-4.7l104.32-245.54a32 32 0 00-29.23-44.59zM572.8 530.99l-74.24-74.46 129.07-54.82-54.83 129.28z"
      }
    }]
  },
  "name": "compass-circle-stroke"
};
a['ConnectStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M958.08 787.41a24.96 24.96 0 00-4.9-27.3L846.5 646.4a25.6 25.6 0 00-44.16 17.5v73.6H748.8a47.36 47.36 0 01-40.53-23.26l-59.74-102.4-196.69-341.33a131.63 131.63 0 00-115.2-66.35h-5.12a136.75 136.75 0 10-1.7 85.33h6.6a46.08 46.08 0 0140.97 23.47l59.52 102.61 197.12 341.34A132.48 132.48 0 00748.8 822.4h53.97v68.7a25.6 25.6 0 0044.16 17.49L953.6 794.88a21.33 21.33 0 004.48-7.04zM200.75 296.75a51.63 51.63 0 1151.41-51.63 51.63 51.63 0 01-51.41 50.56z"
      }
    }]
  },
  "name": "connect-stroke"
};
a['CopyFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M165.55 261.33h533.12q64 0 64 64v533.12q0 64-64 64H165.55q-64 0-64-64V325.33q0-64 64-64z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M890.45 101.55H293.12a32 32 0 00-32 32v31.78a32 32 0 0032 32h502.83a32.21 32.21 0 0132 32v501.34a32 32 0 0032 32h30.5a32 32 0 0032-32V133.33a32 32 0 00-32-31.78z"
      }
    }]
  },
  "name": "copy-fill"
};
a['CopyStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M891.73 66.13H305.07c-36.27 0-66.14 29.87-66.14 66.14v51.2c0 17.06 14.94 32 32 32h19.2c17.07 0 32-14.94 32-32v-34.14h552.54v552.54h-34.14c-17.06 0-32 14.93-32 32v19.2c0 17.06 14.94 32 32 32h53.34c36.26 0 64-29.87 64-66.14V132.27c0-36.27-29.87-66.14-66.14-66.14z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M718.93 238.93H132.27c-36.27 0-66.14 29.87-66.14 66.14v586.66c0 36.27 29.87 66.14 66.14 66.14h586.66c36.27 0 66.14-29.87 66.14-66.14V305.07c0-36.27-29.87-66.14-66.14-66.14zm-17.06 569.6v66.14H149.33V322.13h552.54v486.4z"
      }
    }]
  },
  "name": "copy-stroke"
};
a['CopyrightStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 149.33A362.67 362.67 0 11149.33 512 362.67 362.67 0 01512 149.33M512 64a448 448 0 10448 448A448 448 0 00512 64z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M343.25 449.7h85.34v124.8h-85.34zM594.77 417.7a32 32 0 1064 0 32 32 0 10-64 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M616.75 417.7a32 32 0 1064 0 32 32 0 10-64 0zM594.77 606.3a32 32 0 1064 0 32 32 0 10-64 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M616.75 606.3a32 32 0 1064 0 32 32 0 10-64 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M612.7 417.7h13.86v32h21.33v-32l30.94-7.67A170.67 170.67 0 00342.4 449.7h85.33a85.33 85.33 0 01167.9-23.04zm36.05 188.6v-32H627.4v32l-32-8.97a85.33 85.33 0 01-166.82-23.46h-85.34A170.67 170.67 0 00679.9 612.9z"
      }
    }]
  },
  "name": "copyright-stroke"
};
a['CreateStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M506.45 288.21l189.44 151.9v424.1H200.53v-576h305.92m8.32-85.33H176.64a62.08 62.08 0 00-61.44 62.72v621.01a62.3 62.3 0 0061.44 62.94h543.15a62.3 62.3 0 0061.44-62.94V430.3a64 64 0 00-23.9-50.34L554.67 216.53a61.65 61.65 0 00-38.83-13.65z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M876.8 842.45h-21.33a32.21 32.21 0 01-32-31.78V368.2L553.17 159.8H301.44A32.21 32.21 0 01269.23 128v-21.33a32 32 0 0132-32h259.2a64 64 0 0139.25 13.44l284.37 218.88a64 64 0 0124.75 50.56v453.12a32 32 0 01-32 31.78z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M586.88 544.21h-96.21V448a32 32 0 00-32-32h-21.34a32 32 0 00-32 32v96h-96a32 32 0 00-32 32v21.33a32 32 0 0032 32h96v96a32 32 0 0032 32h21.34a32 32 0 0032-32v-96h96a32 32 0 0032-32V576a32 32 0 00-31.79-31.79z"
      }
    }]
  },
  "name": "create-stroke"
};
a['CreditcardStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M874.67 253.23v512H149.33v-512h725.34M896 167.89H128a64 64 0 00-64 64v554.67a64 64 0 0064 64h768a64 64 0 0064-64V231.89a64 64 0 00-64-64z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M923.52 359.68H85.33v85.33h838.19v-85.33zM784 637.23H624a32 32 0 00-32 32v21.33a32 32 0 0032 32h160a32 32 0 0032-32v-21.33a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "creditcard-stroke"
};
a['CrossCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 95C281.72 95 95 281.72 95 512s186.72 417 417 417 417-186.72 417-417S742.28 95 512 95zm157.54 557.06a7.64 7.64 0 01-5.86 12.58h-56.54a15.64 15.64 0 01-11.81-5.47L512 559.81l-83.33 99.36a15.36 15.36 0 01-11.81 5.47h-56.54a7.64 7.64 0 01-5.86-12.58L471.87 512 354.46 371.94a7.64 7.64 0 015.86-12.58h56.54a15.64 15.64 0 0111.81 5.47L512 464.19l83.33-99.36a15.36 15.36 0 0111.81-5.47h56.54a7.64 7.64 0 015.86 12.58L552.13 512z"
      }
    }]
  },
  "name": "cross-circle-fill"
};
a['CrossCircleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 149.33c199.9 0 362.67 162.78 362.67 362.67S711.89 874.67 512 874.67c-199.9 0-362.67-162.78-362.67-362.67S312.11 149.33 512 149.33M512 64C264.53 64 64 264.53 64 512s200.53 448 448 448 448-200.53 448-448S759.47 64 512 64zm96 282.88L506.24 448.64l-96-96a31.79 31.79 0 00-45.23 0l-15.14 15.15a31.79 31.79 0 000 45.22l96 96L344.1 610.77a31.79 31.79 0 000 45.23l15.14 15.15c12.59 12.58 32.86 12.58 45.23 0l101.76-101.76 107.3 107.3c12.6 12.59 32.86 12.59 45.23 0l15.15-15.14c12.59-12.59 12.59-32.86 0-45.23l-107.3-107.3 101.75-101.77c12.59-12.58 12.59-32.85 0-45.22l-15.14-15.15c-12.59-12.37-32.86-12.37-45.23 0z"
      }
    }]
  },
  "name": "cross-circle-stroke"
};
a['CrossSquareFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 63.57H128c-35.41 0-64 28.59-64 64v768c0 35.42 28.59 64 64 64h768c35.41 0 64-28.58 64-64v-768c0-35.41-28.59-64-64-64zM700.59 640.21c12.58 12.59 12.58 32.86 0 45.23l-15.15 15.15c-12.59 12.58-32.85 12.58-45.23 0L512 572.37 383.79 700.6c-12.59 12.58-32.86 12.58-45.23 0l-15.15-15.15a31.79 31.79 0 010-45.23L451.63 512 323.4 383.79a31.79 31.79 0 010-45.23l15.15-15.15a31.79 31.79 0 0145.23 0L512 451.63 640.21 323.4a31.79 31.79 0 0145.23 0l15.15 15.15c12.58 12.59 12.58 32.85 0 45.23L572.37 512 700.6 640.21z"
      }
    }]
  },
  "name": "cross-square-fill"
};
a['CrossSquareStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M338.56 323.41l-15.15 15.15a31.79 31.79 0 000 45.23L451.63 512 323.4 640.21a31.79 31.79 0 000 45.23l15.15 15.15c12.59 12.58 32.85 12.58 45.23 0L512 572.37 640.21 700.6c12.59 12.58 32.86 12.58 45.23 0l15.15-15.15c12.58-12.59 12.58-32.85 0-45.23L572.37 512 700.6 383.79c12.58-12.59 12.58-32.86 0-45.23l-15.15-15.15a31.79 31.79 0 00-45.23 0L512 451.63 383.79 323.4c-12.59-12.37-32.86-12.37-45.23 0zm536.1-174.5v725.33H149.34V148.91h725.34M896 63.57H128c-35.41 0-64 28.59-64 64v768c0 35.42 28.59 64 64 64h768c35.41 0 64-28.58 64-64v-768c0-35.41-28.59-64-64-64z"
      }
    }]
  },
  "name": "cross-square-stroke"
};
a['CrossStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M776.96 187.73l-264.1 263.9-264.97-264.96a31.79 31.79 0 00-45.22 0l-14.94 15.14a31.79 31.79 0 000 45.23L452.48 512l-263.9 263.9a31.79 31.79 0 000 45.22l15.15 15.15c12.59 12.58 32.86 12.58 45.23 0l264.1-264.11L776.12 835.2c12.58 12.59 32.85 12.59 45.22 0l15.15-15.15c12.59-12.58 12.59-32.85 0-45.22L573.23 512l264.1-264.1c12.59-12.6 12.59-32.86 0-45.23l-15.14-14.94a31.79 31.79 0 00-45.23 0z"
      }
    }]
  },
  "name": "cross-stroke"
};
a['CrownStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 237.44l133.12 193.5 43.73 64 67.63-37.13 80.43-44.37-61.87 411.73H249.81L188.6 414.51l75.09 42.66 67.2 37.55 44.16-64L512 237.44m0-125.23a32.21 32.21 0 00-26.24 13.44l-180.7 256L134.4 286.3a32.64 32.64 0 00-15.57-4.05A32.21 32.21 0 0088.1 320l85.33 563.63a32 32 0 0031.57 27.3h616.11a32 32 0 0032.21-27.73l85.34-564.27a32 32 0 00-31.58-36.69 32.64 32.64 0 00-15.57 4.05L716.8 382.51l-176.64-256A30.93 30.93 0 00512 112.2z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M512 537.39a74.67 74.67 0 11-74.67 74.66A74.67 74.67 0 01512 537.4m0-64a138.67 138.67 0 10138.67 138.66A138.67 138.67 0 00512 473.4z"
      }
    }]
  },
  "name": "crown-stroke"
};
a['CustomerServiceStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M904.53 384C857.6 211.2 701.87 81.07 514.13 81.07c-185.6 0-341.33 125.86-388.26 298.66-36.27 23.47-59.74 64-59.74 108.8v130.14c0 72.53 59.74 132.26 132.27 132.26h34.13c36.27 0 66.14-29.86 66.14-66.13V424.53c0-27.73-19.2-53.33-44.8-61.86-6.4-2.14-17.07-4.27-27.74-4.27 49.07-113.07 160-189.87 290.14-189.87s241.06 78.94 290.13 192c-19.2 0-34.13 2.14-34.13 2.14-27.74 8.53-44.8 34.13-44.8 61.86v262.4c0 23.47 12.8 46.94 36.26 57.6-59.73 76.8-151.46 123.74-249.6 123.74-10.66 0-19.2 0-27.73-2.14-12.8-27.73-46.93-40.53-72.53-25.6s-40.54 46.94-25.6 72.54c6.4 12.8 14.93 21.33 27.73 27.73 4.27 2.13 10.67 2.13 17.07 4.27 27.73 6.4 55.46 8.53 83.2 8.53 145.06 0 279.46-78.93 352-204.8 55.46-17.07 93.86-68.27 93.86-125.87V490.67c-4.26-42.67-25.6-81.07-57.6-106.67zM198.4 665.6c-25.6 0-44.8-21.33-46.93-44.8V490.67c0-25.6 21.33-46.94 46.93-46.94h12.8l2.13 221.87H198.4zm676.27-44.8c0 25.6-21.34 46.93-46.94 46.93H812.8v-224h14.93c25.6 0 46.94 21.34 46.94 46.94V620.8z"
      }
    }]
  },
  "name": "customer-service-stroke"
};
a['DashboardFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M497.02 98.25C682.06 92.02 851.8 200.6 923.86 371.3c76.16 180.93 25.76 390.4-124.32 516.8l-1.7 1.4a32.34 32.34 0 01-20.55 7.5H246.8a32.32 32.32 0 01-20.56-7.5l-1.7-1.4C82.78 768.93 29.07 574.6 89.5 399.43c60.43-175.17 222.48-294.93 407.52-301.17zM608.44 434.9l-81.33 81.34a53.9 53.9 0 1038.12 38.11L646.56 473a7.74 7.74 0 000-10.88l-27.24-27.24v.01a7.74 7.74 0 00-10.88 0zM825.78 539.3h-77a7.72 7.72 0 00-7.7 7.7v42.35a7.72 7.72 0 007.7 7.71h77a7.73 7.73 0 007.7-7.71V547a7.73 7.73 0 00-7.7-7.7zm-554.4-.01h-77a7.72 7.72 0 00-7.7 7.7v42.35a7.72 7.72 0 007.7 7.71h77a7.73 7.73 0 007.7-7.71V547a7.73 7.73 0 00-7.7-7.68v-.03zm29.64-212l-29.93 29.93a7.72 7.72 0 000 10.88l54.47 54.47a7.72 7.72 0 0010.88 0l29.93-29.93a7.72 7.72 0 000-10.88l-54.47-54.47a7.72 7.72 0 00-10.88 0zm411.47-.02L658 381.76a7.74 7.74 0 000 10.88l30 29.93a7.71 7.71 0 0010.87 0l54.43-54.47a7.74 7.74 0 000-10.88v-.02l-29.93-29.93a7.72 7.72 0 00-10.88 0zM533.18 244.8h-42.36a7.72 7.72 0 00-7.69 7.7v77a7.72 7.72 0 007.69 7.7h42.36a7.73 7.73 0 007.7-7.7v-77a7.73 7.73 0 00-7.7-7.7z"
      }
    }]
  },
  "name": "dashboard-fill"
};
a['DashboardStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M595.41 157.87a366.3 366.3 0 01267.31 267.3h-267.3v-267.3M542.28 64a32.21 32.21 0 00-32.21 32v350.5a64 64 0 0064 64H924.8a32.21 32.21 0 0032-34.77A448 448 0 00544.85 64zm292.06 498.35a326.19 326.19 0 11-375.9-371.84 10.67 10.67 0 008.96-10.46v-64a10.88 10.88 0 00-12.16-10.66 411.52 411.52 0 10465.07 459.94 10.67 10.67 0 00-10.67-11.94h-64a10.67 10.67 0 00-11.3 8.96z"
      }
    }]
  },
  "name": "dashboard-stroke"
};
a['DataFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M234.67 85.33a64 64 0 00-64 64v725.34a64 64 0 0064 64h554.66a64 64 0 0064-64V523.52a64 64 0 00-18.77-45.23L459.95 104.11a64 64 0 00-45.23-18.78zm618.66 64a64 64 0 00-64-64H583.04a21.33 21.33 0 00-14.93 36.48l248.32 248.32a21.33 21.33 0 0036.9-15.14z"
      }
    }]
  },
  "name": "data-fill"
};
a['DataStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M405.33 170.67L768 533.33v320H256V170.67h149.33m8.96-85.34H234.67a64 64 0 00-64 64v725.34a64 64 0 0064 64h554.66a64 64 0 0064-64V523.52a64 64 0 00-18.77-45.23L459.95 104.11a64 64 0 00-45.23-18.78zM778.67 160v66.77L711.89 160h66.78m10.66-74.67H583.04a21.33 21.33 0 00-21.33 21.34 21.33 21.33 0 006.4 15.14l248.32 248.32a21.33 21.33 0 0015.57 6.83 21.33 21.33 0 0014.5-5.76 21.33 21.33 0 006.83-16.21V149.33a64 64 0 00-64-64z"
      }
    }]
  },
  "name": "data-stroke"
};
a['DatabaseStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M825.17 601.6H198.83v89.6h626.34v-89.6zm-.21-268.8H198.4v89.6h626.56v-89.6zM417.28 198.4h-88.1a30.5 30.5 0 00-30.51 30.72v28.16a30.5 30.5 0 0030.5 30.72h88.11A30.72 30.72 0 00448 257.28v-28.16a30.72 30.72 0 00-30.72-30.72zm0 268.59h-88.1a30.5 30.5 0 00-30.51 30.72v28.16a30.72 30.72 0 0030.5 30.72h88.11A30.93 30.93 0 00448 525.87V497.7a30.72 30.72 0 00-30.72-30.72zm0 269.01h-88.1a30.5 30.5 0 00-30.51 30.72v28.16a30.5 30.5 0 0030.5 30.72h88.11A30.72 30.72 0 00448 794.88v-28.16A30.72 30.72 0 00417.28 736z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M810.67 149.33v725.34H213.33V149.33h597.34M828.16 64H195.84A67.84 67.84 0 00128 131.84v760.32A67.84 67.84 0 00195.84 960h632.32A67.84 67.84 0 00896 892.16V131.84A67.84 67.84 0 00828.16 64z"
      }
    }]
  },
  "name": "database-stroke"
};
a['DeleteFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M354.3 63.49h320c21.5 0 31.75 10.75 31.75 31.74v21.5c0 21.51-10.75 31.75-31.75 31.75h-320c-21.5 0-31.74-10.24-31.74-31.74v-21.5c0-21 10.24-31.75 31.74-31.75zM930.82 192H97.79a31.58 31.58 0 00-31.74 31.74v21.5c0 17.93 14.33 32.26 31.74 32.26h54.27V896c0 35.33 28.68 64 64 64H810.5c35.32 0 64-28.67 64-64V277.5h55.8a31.58 31.58 0 0031.75-31.74v-21.5A31.27 31.27 0 00930.82 192z"
      }
    }]
  },
  "name": "delete-fill"
};
a['DeleteStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M929.92 192h-832a32 32 0 00-32 32v21.33a32 32 0 0032.64 32h53.76V896a64 64 0 0064 64h594.35a64 64 0 0064-64V277.33h55.89a32 32 0 0032-32V224a32 32 0 00-32.64-32zM789.33 874.67H237.65V277.33h551.68zM354.35 63.36h320q32 0 32 32v21.33q0 32-32 32h-320q-32 0-32-32V95.36q0-32 32-32zm260.26 364.8h21.34q32 0 32 32v251.73q0 32-32 32H614.6q-32 0-32-32V460.16q0-32 32-32zm-222.08 0h21.34q32 0 32 32v251.73q0 32-32 32h-21.34q-32 0-32-32V460.16q0-32 32-32z"
      }
    }]
  },
  "name": "delete-stroke"
};
a['DesktopStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 128H128a64 64 0 00-64 64v426.67a64 64 0 0064 64h341.33v128h-128a42.67 42.67 0 100 85.33h341.34a42.67 42.67 0 000-85.33h-128v-128H896a64 64 0 0064-64V192a64 64 0 00-64-64zm-21.33 469.33H149.33v-384h725.34z"
      }
    }]
  },
  "name": "desktop-stroke"
};
a['DislikeFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M110.72 469.33V128a64 64 0 0164-64h21.33v469.33h-21.33a64 64 0 01-64-64zM934.19 630.2L896 331.3l-16.43-128A170.67 170.67 0 00712.32 64h-448v469.33l91.52 341.34A117.12 117.12 0 00466.56 960h2.77a114.13 114.13 0 0032.22-4.7 117.55 117.55 0 0085.33-106.66V704h256a26.45 26.45 0 005.76 0h21.33a64 64 0 0064.22-73.81zm-583.9-480.86h-4.9z"
      }
    }]
  },
  "name": "dislike-fill"
};
a['DislikeStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M724.7 149.33h-.86.85zM656.63 63.8h23.04-23.04zm235.1 149.54l21.33 168.11-21.34-170.67a7.68 7.68 0 000 2.56zm-275.63-64h107.73-230.4 122.67z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M944.85 630.19L913.07 381l-21.34-170.66A170.67 170.67 0 00722.56 64h-558.5a64 64 0 00-64 64v341.33a64 64 0 0064 64h111.57l91.52 341.34A117.12 117.12 0 00477.87 960h1.92a122.45 122.45 0 0032.21-4.27 117.97 117.97 0 0085.33-106.66V704h283.1a64 64 0 0064.42-73.81zM249.4 448h-64V149.33h64zm607.78 168.96H547A34.99 34.99 0 00512 651.95v193.92a32.21 32.21 0 01-64 5.33l-29.23-109.65-75.94-286.94a34.56 34.56 0 00-8.11-14.5V149.33h390.61a85.33 85.33 0 0182.14 73.39z"
      }
    }]
  },
  "name": "dislike-stroke"
};
a['DisplaySetupFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M0 0h1024v1024H0zm200 568h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm714-397H110c-17.7 0-32 14.3-32 32v618c0 17.7 14.3 32 32 32h804c17.7 0 32-14.3 32-32V203c0-17.7-14.3-32-32-32zm-40 610H150V421h724v360zm0-428H150V243h724v110z"
      }
    }]
  },
  "name": "display-setup-fill"
};
a['DivisionSignStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M891.73 140.8l8.54 8.53c17.06 17.07 17.06 42.67 0 59.74l-712.54 710.4c-17.06 17.06-42.66 17.06-59.73 0l-8.53-8.54c-17.07-17.06-17.07-42.66 0-59.73L832 140.8c17.07-17.07 42.67-17.07 59.73 0z"
      }
    }]
  },
  "name": "division-sign-stroke"
};
a['DotLinkStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M155.11 497.02c-.2 2.35-.42 4.7-.42 7.04a26.2 26.2 0 00.42 5.76l-10.88-6.6z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M752.96 639.9a155.5 155.5 0 00-107.52 42.66l-222.08-135.9a160.83 160.83 0 005.97-43.3 150.49 150.49 0 00-5.12-39.47l218.24-126.08a157.01 157.01 0 00110.51 45.23 158.4 158.4 0 10-158.3-158.5A150.5 150.5 0 00599.8 264L381.33 390.3a156.1 156.1 0 00-110.5-45.23 158.4 158.4 0 000 316.8 156.01 156.01 0 00107.73-42.67l222.08 135.9a158.42 158.42 0 10152.32-115.2zm0-488.33A73.09 73.09 0 11680 224.53c0-2.56.21-4.9.43-7.25a72.79 72.79 0 0172.53-65.7zM270.83 576.53a72.7 72.7 0 01-72.54-67.41 26.2 26.2 0 01-.42-5.76c0-2.35.21-4.7.42-7.04a73.02 73.02 0 11100.91 74.45 69.55 69.55 0 01-28.37 5.76zm482.13 294.83a72.58 72.58 0 01-72.53-67.63h-.22a46.36 46.36 0 01-.21-5.54 72.83 72.83 0 0144.59-67.2h.21a68.52 68.52 0 0128.16-5.76 73.07 73.07 0 110 146.13z"
      }
    }]
  },
  "name": "dot-link-stroke"
};
a['DownloadStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 789.33a32.64 32.64 0 0022.61-9.38l15.15-15.15 271.79-271.15a31.57 31.57 0 000-44.8L806.4 433.5a32 32 0 00-45.23 0L553.4 640V96.43A32 32 0 00521.6 64h-21.33a32 32 0 00-30.94 32.43V640L263.68 434.35a32.43 32.43 0 00-22.61-9.39 32 32 0 00-22.62 9.39l-14.93 15.14a31.57 31.57 0 000 44.8l34.13 34.35 236.59 237.01 15.15 15.15a32 32 0 0022.61 8.53zm384 85.34H128a32 32 0 00-32 32V928a32 32 0 0032 32h768a32 32 0 0032-32v-21.33a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "download-stroke"
};
a['DragStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M645 128a64 64 0 1064 64 64 64 0 00-64-64zm0 320a64 64 0 1064 64 64 64 0 00-64-64zm0 320a64 64 0 1064 64 64 64 0 00-64-64zM379 128a64 64 0 1064 64 64 64 0 00-64-64zm0 320a64 64 0 1064 64 64 64 0 00-64-64zm0 320a64 64 0 1064 64 64 64 0 00-64-64z"
      }
    }]
  },
  "name": "drag-stroke"
};
a['DrinkStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M885.33 220.59h-35.2l-31.57-103.9-4.9-15.57A64 64 0 00759.88 64H264.11a64 64 0 00-54.62 38.61 61.44 61.44 0 00-3.84 12.59l-32 104.96h-34.98a32 32 0 00-32 32.43v21.33a32 32 0 0032 32h32L222.72 896a16.43 16.43 0 000 3.2 64 64 0 0062.93 60.8H739a64 64 0 0061.86-53.12 60.59 60.59 0 001.07-10.88l51.41-590.08h32a32 32 0 0032-32v-21.33a32 32 0 00-32-32zM271.8 192l12.8-42.67H739.2L752 192l8.96 29.01H263.04zm449.7 642.77l-3.41 39.9H306.56l-3.63-40.32L256 305.92h512z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M512 750.72a160 160 0 10-160-160 160 160 0 00160 160zm0-234.67a74.67 74.67 0 11-74.67 74.67A74.67 74.67 0 01512 516.05z"
      }
    }]
  },
  "name": "drink-stroke"
};
a['EarthStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64a448 448 0 10448 448A448 448 0 00512 64zm147.2 465.7A411.73 411.73 0 01641.92 640h-263.9a409.39 409.39 0 01-17.7-112.21A470.83 470.83 0 01381.65 384h256a469.33 469.33 0 0121.55 145.7zm145.7-231.03H696.97a755.63 755.63 0 00-70.19-130.35 363.73 363.73 0 01178.14 130.35zm-201.8 0H415.35a749.01 749.01 0 0193.65-145.71 751.15 751.15 0 0194.08 145.7zm-213.34-128a787.2 787.2 0 00-67.84 128H219.31a365.87 365.87 0 01170.02-128zM173.01 384h119.9a554.67 554.67 0 00-17.92 144.21A503.04 503.04 0 00289.28 640H173.01a357.76 357.76 0 010-256zm46.08 341.33h98.99a605.01 605.01 0 0077.65 129.92A364.8 364.8 0 01219.1 725.33zM510.51 857.4a600.1 600.1 0 01-97.28-132.06h193.92A589.65 589.65 0 01510.5 857.4zm113.49 0a602.67 602.67 0 0078.08-132.06h102.83A362.67 362.67 0 01624 856.75zM850.99 640H730.45a498.13 498.13 0 0014.08-109.65A550.19 550.19 0 00725.33 384h125.02a357.76 357.76 0 010 256z"
      }
    }]
  },
  "name": "earth-stroke"
};
a['EditFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M794.43 356.67L847.14 304a9.57 9.57 0 000-13.54L687.58 130.78a9.74 9.74 0 00-13.63 0l-52.7 52.71zM888 823H136a7.94 7.94 0 00-8 7.89v56.53a7.65 7.65 0 007.68 7.58h752.64a7.65 7.65 0 007.68-7.58v-56.49a7.94 7.94 0 00-8-7.93zm-620.13-80.6a38.59 38.59 0 005.76-.48L435.1 713.6a9.37 9.37 0 005.09-2.69l309-309L576 228.75l-309 309a9.73 9.73 0 00-2.69 5.09L236 704.29a32.2 32.2 0 009 28.61 32.55 32.55 0 0022.87 9.5z"
      }
    }]
  },
  "name": "edit-fill"
};
a['EditStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M818.77 256L646.2 106.67a64 64 0 00-91.52 6.61L78.29 685.87A64 64 0 0064 725.33l-2.56 198.4a32.21 32.21 0 0031.79 32.43l186.45 1.5a64 64 0 0049.28-21.34L825.39 345.6a64 64 0 00-6.62-89.6zM270.08 872.96l-123.1-1.07 2.35-137.17 457.39-549.97 139.95 121.38zm238.08.21H928q32 0 32 32v21.34q0 32-32 32H508.16q-32 0-32-32v-21.34q0-32 32-32z"
      }
    }]
  },
  "name": "edit-stroke"
};
a['EliminateStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M832 261.55l-64-57.39L886.61 73.6a31.79 31.79 0 0145.02-2.13l16 14.29a32.21 32.21 0 012.13 45.23zm-42.67 274.34L484.05 264.11a31.79 31.79 0 01-2.56-45.02l7.04-8.1c72.32-80.86 210.14-76.16 307.2 10.45s117.12 222.93 44.8 304l-7.04 7.9a31.79 31.79 0 01-44.16 2.55zM590.3 243.63l207.58 185.6c10.02-45.23-11.1-102.4-57.82-144.22s-107.09-56.32-150.82-41.38zM415.15 373.76l273.7 247.04a750.72 750.72 0 00-23.25 256c-18.56 1.28-36.7 2.13-54.19 2.13-227.2 0-332.8-122.24-370.98-183.04l19.2-33.06 58.24-100.48-113.28-25.6-37.55-8.54a362.67 362.67 0 01-15.15-106.66c69.98-3.63 181.34-14.72 263.26-47.36m-343.9-10.46a436.7 436.7 0 0027.52 227.2 21.33 21.33 0 0014.94 12.59l66.34 14.93a4.27 4.27 0 012.78 6.4l-33.5 59.31a21.33 21.33 0 000 19.84c21.34 49.92 142.3 260.05 462.08 260.05a824.75 824.75 0 00117.12-8.74 32.21 32.21 0 0026.88-35.2c-19.41-160 9.82-263.68 24.96-304.43a31.36 31.36 0 00-8.53-34.77L445.23 286.08a32.64 32.64 0 00-36.7-4.48c-77.44 38.4-244.26 51.41-307.62 54.83a31.36 31.36 0 00-29.66 27.3z"
      }
    }]
  },
  "name": "eliminate-stroke"
};
a['EnterStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M877.33 193h-56.48a7.55 7.55 0 00-7.53 7.53v487.6H287.84v-68.74a7.55 7.55 0 00-12.23-5.93L142 718.89a7.52 7.52 0 000 11.86l133.61 105.42a7.53 7.53 0 0012.23-5.92v-70.6h536.78a60.31 60.31 0 0060.24-60.25V200.51a7.55 7.55 0 00-7.53-7.53zm0 0"
      }
    }]
  },
  "name": "enter-stroke"
};
a['EqualStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M906.67 589.01H117.33a32 32 0 00-32 32v21.34a32 32 0 0032 32h789.34a32 32 0 0032-32V621a32 32 0 00-32-32zm0-256H117.33a32 32 0 00-32 32v21.34a32 32 0 0032 32h789.34a32 32 0 0032-32V365a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "equal-stroke"
};
a['ExclamationCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64C264.53 64 64 264.53 64 512s200.53 448 448 448 448-200.53 448-448S759.47 64 512 64zm-42.67 203.95c0-17.71 14.3-32 32-32h20.06c17.7 0 32 14.29 32 32V580.9c0 17.7-14.3 32-32 32h-20.06c-17.7 0-32-14.3-32-32V267.95zM569.6 717a52.21 52.21 0 01-52.27 52.27H505.6a52.21 52.21 0 01-52.27-52.27v-11.73a52.21 52.21 0 0152.27-52.27h11.73a52.21 52.21 0 0152.27 52.27v11.73z"
      }
    }]
  },
  "name": "exclamation-circle-fill"
};
a['ExclamationCircleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 149.33c199.9 0 362.67 162.78 362.67 362.67S711.89 874.67 512 874.67c-199.9 0-362.67-162.78-362.67-362.67S312.11 149.33 512 149.33M512 64C264.53 64 64 264.53 64 512s200.53 448 448 448 448-200.53 448-448S759.47 64 512 64zm5.33 705.28H505.6a52.21 52.21 0 01-52.27-52.27v-11.73a52.21 52.21 0 0152.27-52.27h11.73a52.21 52.21 0 0152.27 52.27v11.73a52.21 52.21 0 01-52.27 52.27zm4.06-156.37h-20.06c-17.7 0-32-14.3-32-32V267.95c0-17.71 14.3-32 32-32h20.06c17.7 0 32 14.29 32 32V580.9c0 17.7-14.3 32-32 32z"
      }
    }]
  },
  "name": "exclamation-circle-stroke"
};
a['ExclamationStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M448 776a64 64 0 1064-64 64 64 0 00-64 64zm32-168h64a8 8 0 008-8V136a8 8 0 00-8-8h-64a8 8 0 00-8 8v464a8 8 0 008 8z"
      }
    }]
  },
  "name": "exclamation-stroke"
};
a['EyeDisabledFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M384.85 698.24c-.21 0-.21-.21-.42-.21l71.04-70.19c.21 0 .21.21.42.21l172.38-170.88s0-.21-.22-.21l71.04-70.19.22.22 112.21-110.72.43-.43-.22-.21L918.2 170.45c12.58-12.37 10.88-34.56-3.84-49.28l-17.71-17.92c-14.72-14.72-36.7-16.64-49.28-4.26L726.61 218.45a436.27 436.27 0 00-209.7-49.06c-1.71 0-3.2.21-4.91.21-1.7 0-3.41-.21-5.12-.21a435.63 435.63 0 00-296.1 107.3c-77.23 68.06-116.7 153.18-135.9 203.95 0 .21-.21.43-.21.64-.22.21-.22.43-.43.85a325.51 325.51 0 00-5.33 12.8 64.08 64.08 0 00-4.48 21.98c-.43 1.28-.43 2.98-.43 4.69v1.7c0 1.71.21 3.2.43 4.91a68.1 68.1 0 004.9 22.4c21.55 56.11 53.34 106.88 92.8 151.04 2.35 2.56 4.48 5.12 6.83 7.68 4.48 4.91 8.96 9.6 13.65 14.08.86.86 1.5 1.28 2.14 1.92a310 310 0 0014.93 13.87L80.21 857.39c-12.58 12.37-10.88 34.56 3.84 49.28l17.71 17.92c14.72 14.72 36.7 16.64 49.28 4.26l131.41-129.92c.22 0 .22.22.43.22l101.97-100.91zM286.51 512c0-124.59 100.9-225.5 225.49-225.5 41.6 0 80.43 11.53 113.92 31.15l-73.17 72.32a128.53 128.53 0 00-40.75-6.82c-71.25 0-128.85 57.81-128.85 128.85 0 13.87 2.34 26.88 6.4 39.47l-73.18 72.32c-18.77-33.07-29.86-71.04-29.86-111.79zm673.28 4.7a66.18 66.18 0 00-4.48-21.98c-1.71-4.27-3.42-8.53-5.34-12.8-.42-.21-.42-.43-.42-.85-.22-.43-.43-.64-.64-1.07-17.28-44.8-49.92-115.2-109.66-177.5l-.64.65-119.89 118.61A222.67 222.67 0 01737.71 512c0 124.59-100.91 225.5-225.5 225.5-32.85 0-64.21-7.05-92.58-20.06l-100.27 99.2c4.9 2.13 10.03 4.27 15.36 6.19 50.35 19.62 108.8 31.57 177.5 32h2.77a517.97 517.97 0 00166.4-26.03c17.92-6.61 42.66-20.7 58.45-29.23.21 0 .21-.21.43-.21 51.41-27.73 91.52-63.36 123.3-99.84a489.2 489.2 0 0091.1-149.12c2.77-6.83 4.26-14.3 4.9-21.76 0-.21.22-.43.22-.64v-.64c0-1.28.21-2.56.21-4.05 0-.64.21-1.28.21-1.92-.42-1.28-.42-2.99-.42-4.7zM512 640.84a129 129 0 00128.21-141.44L497.92 640c4.48.64 9.39.85 14.08.85z"
      }
    }]
  },
  "name": "eye-disabled-fill"
};
a['EyeDisabledStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M955.3 496a624.23 624.23 0 00-105.8-174.5 17.2 17.2 0 00-24.33-.65l-.64.64-36.69 35.42a17.7 17.7 0 000 23.89 513.42 513.42 0 0185.97 142.93c-38.82 94.3-136.74 246.62-363.3 246.62-38.83.21-77.44-4.7-114.99-14.3-5.76-1.7-12.16 0-16.43 4.27l-42.88 41.39a17.45 17.45 0 006.62 28.58 518.89 518.89 0 00166.4 26.03c297.17 0 410.66-220.37 444.58-304.64a73.98 73.98 0 001.5-55.68zM751.8 339.41l7.68-7.68L919.89 172.6a32.32 32.32 0 00.22-45.66l-15.15-15.36a32.32 32.32 0 00-45.65-.21L742.4 227.2a436.33 436.33 0 00-225.5-57.39c-316.15.43-419.62 246.4-448.63 330.03a73 73 0 001.28 52.05A486.02 486.02 0 00212.9 751.8L90.45 873.8a32.32 32.32 0 00-.21 45.66l15.15 15.36a32.32 32.32 0 0045.65.21l600.75-595.63zM399.36 567.25c-15.79-34.34-16.43-75.3 2.13-111.78A128.68 128.68 0 01571.31 397L399.36 567.25zM634.88 334.3a214.95 214.95 0 00-237.44 1.28c-97.28 65.28-123.95 195.84-61.01 293.98l-62.51 61.86a384.15 384.15 0 01-123.3-167.68c44.15-123.3 143.57-267.52 366.29-267.52a355.44 355.44 0 01160.64 35.84l-42.67 42.24zm72.75 109.87a9.5 9.5 0 00-4.48 2.56l-57.6 56.96c-.43 1.07-.43 3.84-.43 3.84v6.4c0 71.25-57.6 128.85-128.85 128.85h-5.34c-2.56 0-4.9.86-6.82 2.56l-56.54 55.68a11.1 11.1 0 004.48 18.14 211.96 211.96 0 0077.44 9.6C635.52 720.43 720 636.8 729.17 530.77a219.1 219.1 0 00-8.1-78.93 10.73 10.73 0 00-13.44-7.68z"
      }
    }]
  },
  "name": "eye-disabled-stroke"
};
a['EyeFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M508 688a176 176 0 11176-176 176 176 0 01-176 176zm434.2-201.8C847.4 286.5 704.1 186 512 186S176.6 286.5 81.8 486.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838s335.4-100.5 430.2-300.3a60.29 60.29 0 000-51.5zM396 512a112 112 0 10112-112 112 112 0 00-112 112z"
      }
    }]
  },
  "name": "eye-fill"
};
a['EyeStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M956.8 493.65c-34.56-84.05-148.7-322.98-442.24-322.98-314.24 0-416.85 243.84-445.87 327.04a74.67 74.67 0 001.28 51.84c32.86 81.49 143.36 301.86 444.8 302.08 295.9 0 408.54-219.52 442.03-302.94a74.45 74.45 0 000-55.04zM514.77 766.3c-216.1 0-317.65-132.26-363.94-244.69 42.66-122.67 142.29-266.24 362.66-266.24 114.14 0 269.23 46.3 361.39 266.03-37.55 93.65-134.83 244.9-360.1 244.9zm-1.28-469.12a213.33 213.33 0 10213.34 213.34 213.33 213.33 0 00-213.34-213.34zm0 341.34a128 128 0 11128-128A128 128 0 01513.5 640z"
      }
    }]
  },
  "name": "eye-stroke"
};
a['EyelashStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M955.2 382.74a338.06 338.06 0 01-1.89 3.04C868.44 518.04 705.75 591.6 512.73 591.6c-192.1 0-354.14-72.86-439.35-203.92-.4-.61-1.53-2.42-3.4-5.41a8 8 0 012.7-11.1l48.1-28.73a8 8 0 0110.88 2.61c2.17 3.45 3.49 5.52 3.95 6.22 71.33 107.01 209.2 168.33 377.12 168.33 171.06 0 310.95-63.64 381.06-174.4a7.67 7.67 0 0110.43-2.48l48.3 28.94a8 8 0 012.69 11.09z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M392.23 550.48l54.09 14.5q7.72 2.06 5.65 9.8L414.7 713.85q-2.07 7.73-9.8 5.66l-54.09-14.5q-7.72-2.06-5.65-9.8l37.27-139.08q2.07-7.73 9.8-5.66zM191.77 480.63l39.6 39.6q5.65 5.66 0 11.31L129.54 633.37q-5.65 5.65-11.31 0l-39.6-39.6q-5.65-5.66 0-11.31l101.83-101.83q5.65-5.65 11.31 0zM578.6800000000001 564.9699999999999l54.1-14.5q7.72-2.06 9.8 5.67l37.26 139.09q2.07 7.73-5.65 9.8l-54.1 14.5q-7.72 2.06-9.8-5.67l-37.26-139.09q-2.07-7.73 5.65-9.8zM793.63 520.23l39.6-39.6q5.66-5.65 11.31 0l101.83 101.83q5.65 5.65 0 11.31l-39.6 39.6q-5.66 5.65-11.31 0L793.63 531.54q-5.65-5.65 0-11.31z"
      }
    }]
  },
  "name": "eyelash-stroke"
};
a['FaceFrownCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 94.52c-230.28 0-417 186.72-417 417s186.72 417 417 417 417-186.71 417-417-186.72-417-417-417zm-208.5 332.3a44.68 44.68 0 1144.68 44.68 44.69 44.69 0 01-44.68-44.68zM653.48 680h-44.77a7.52 7.52 0 01-7.54-6.89 89.44 89.44 0 00-178.34 0 7.52 7.52 0 01-7.54 6.89h-44.77a7.45 7.45 0 01-7.45-7.82c4.1-78.47 69.35-141.11 148.93-141.11s144.83 62.64 148.93 141.11a7.45 7.45 0 01-7.45 7.82zm22.34-208.5a44.68 44.68 0 1144.68-44.68 44.69 44.69 0 01-44.68 44.68z"
      }
    }]
  },
  "name": "face-frown-circle-fill"
};
a['FaceFrownCircleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M303.5 426.82a44.68 44.68 0 1044.68-44.68 44.67 44.67 0 00-44.68 44.68zm327.64 0a44.68 44.68 0 1044.68-44.68 44.68 44.68 0 00-44.68 44.68zM512 94.52c-230.28 0-417 186.72-417 417s186.72 417 417 417 417-186.71 417-417-186.72-417-417-417zm244.8 661.81a346.34 346.34 0 01-110.11 74.27 345.84 345.84 0 01-379.58-74.27 346.64 346.64 0 11489.69 0zM512 531.07c-79.58 0-144.83 62.64-148.93 141.11a7.45 7.45 0 007.45 7.82h44.77a7.52 7.52 0 007.54-6.89 89.44 89.44 0 01178.34 0 7.52 7.52 0 007.54 6.89h44.77a7.45 7.45 0 007.45-7.82c-4.1-78.47-69.35-141.11-148.93-141.11z"
      }
    }]
  },
  "name": "face-frown-circle-stroke"
};
a['FaceFrownSquareFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M885 111.27H149a32 32 0 00-32 32v736a32 32 0 0032 32h736a32 32 0 0032-32v-736a32 32 0 00-32-32zM308.5 407a44.68 44.68 0 1144.68 44.68A44.67 44.67 0 01308.5 407zm350 253.18h-44.79a7.52 7.52 0 01-7.54-6.89 89.44 89.44 0 00-178.34 0 7.52 7.52 0 01-7.54 6.89h-44.77a7.45 7.45 0 01-7.45-7.82c4.1-78.47 69.35-141.11 148.93-141.11s144.83 62.64 148.93 141.11a7.45 7.45 0 01-7.45 7.84zm22.34-208.5A44.68 44.68 0 11725.5 407a44.69 44.69 0 01-44.68 44.7z"
      }
    }]
  },
  "name": "face-frown-square-fill"
};
a['FaceFrownSquareStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M289 422a48 48 0 1048-48 48 48 0 00-48 48zm352 0a48 48 0 1048-48 48 48 0 00-48 48zM513 534c-85.5 0-155.6 67.3-160 151.6a8 8 0 008 8.4h48.1a8.08 8.08 0 008.1-7.4A96.17 96.17 0 01513 598c50.5 0 92.1 39.1 95.8 88.6a8.08 8.08 0 008.1 7.4H665a8 8 0 008-8.4C668.6 601.3 598.5 534 513 534zm347 362H164a36 36 0 01-36-36V164a36 36 0 0136-36h696a36 36 0 0136 36v696a36 36 0 01-36 36zM200 200v624h624.05V200z"
      }
    }]
  },
  "name": "face-frown-square-stroke"
};
a['FaceMehCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512.5 96C282.5 96 96 282.5 96 512.5S282.5 929 512.5 929 929 742.5 929 512.5 742.5 96 512.5 96zM304.25 427.9a44.63 44.63 0 1144.63 44.62 44.64 44.64 0 01-44.63-44.62zm357 185.94a7.46 7.46 0 01-7.44 7.43H371.19a7.46 7.46 0 01-7.44-7.43v-44.63a7.46 7.46 0 017.44-7.44h282.62a7.46 7.46 0 017.44 7.44zm14.87-141.32a44.63 44.63 0 1144.63-44.62 44.63 44.63 0 01-44.63 44.62z"
      }
    }]
  },
  "name": "face-meh-circle-fill"
};
a['FaceMehCircleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M303 427.5a44.57 44.57 0 1044.57-44.57A44.57 44.57 0 00303 427.5zm326.86 0a44.57 44.57 0 1044.57-44.57 44.56 44.56 0 00-44.57 44.57zM511 96C281.27 96 95 282.27 95 512s186.27 416 416 416 416-186.27 416-416S740.73 96 511 96zm244.21 660.21a343.62 343.62 0 1174.1-109.75 345.18 345.18 0 01-74.1 109.75zm-103.07-195H369.86a7.45 7.45 0 00-7.43 7.43v44.57a7.45 7.45 0 007.43 7.43h282.28a7.45 7.45 0 007.43-7.43v-44.57a7.45 7.45 0 00-7.43-7.43z"
      }
    }]
  },
  "name": "face-meh-circle-stroke"
};
a['FaceMehSquareFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M885.5 113.71h-736a32 32 0 00-32 32v736a32 32 0 0032 32h736a32 32 0 0032-32v-736a32 32 0 00-32-32zm-576 325.71A44.57 44.57 0 11354.07 484a44.57 44.57 0 01-44.57-44.58zm356.57 185.71a7.45 7.45 0 01-7.43 7.43H376.36a7.45 7.45 0 01-7.43-7.43v-44.57a7.45 7.45 0 017.43-7.43h282.28a7.45 7.45 0 017.43 7.43zM680.93 484a44.57 44.57 0 1144.57-44.57A44.56 44.56 0 01680.93 484z"
      }
    }]
  },
  "name": "face-meh-square-fill"
};
a['FaceMehSquareStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M885.5 111.44h-736a32 32 0 00-32 32v736a32 32 0 0032 32h736a32 32 0 0032-32v-736a32 32 0 00-32-32zm-40 728h-656v-656h656zm-536-402.29a44.57 44.57 0 1044.57-44.57 44.58 44.58 0 00-44.57 44.57zm326.86 0a44.57 44.57 0 1044.57-44.57 44.57 44.57 0 00-44.57 44.57zm22.28 133.72H376.36a7.45 7.45 0 00-7.43 7.43v44.57a7.45 7.45 0 007.43 7.43h282.28a7.45 7.45 0 007.43-7.43V578.3a7.45 7.45 0 00-7.43-7.43z"
      }
    }]
  },
  "name": "face-meh-square-stroke"
};
a['FaceSmileCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M511 95.45c-230.28 0-417 186.72-417 417s186.72 417 417 417 417-186.72 417-417-186.72-417-417-417zm-208.5 332.3a44.68 44.68 0 1144.68 44.68 44.69 44.69 0 01-44.68-44.68zM511 680.93c-79.58 0-144.83-62.64-148.93-141.11a7.45 7.45 0 017.45-7.82h44.77a7.52 7.52 0 017.54 6.89 89.44 89.44 0 00178.34 0 7.52 7.52 0 017.54-6.89h44.77a7.45 7.45 0 017.45 7.82c-4.1 78.47-69.35 141.11-148.93 141.11zm163.82-208.5a44.68 44.68 0 1144.68-44.68 44.69 44.69 0 01-44.68 44.68z"
      }
    }]
  },
  "name": "face-smile-circle-fill"
};
a['FaceSmileCircleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M304.12 427.94a44.6 44.6 0 1044.6-44.6 44.6 44.6 0 00-44.6 44.6zm327.06 0a44.6 44.6 0 1044.6-44.6 44.6 44.6 0 00-44.6 44.6zM512.25 96.24C282.38 96.24 96 282.62 96 512.49s186.38 416.25 416.25 416.25S928.5 742.35 928.5 512.49 742.12 96.24 512.25 96.24zm244.36 660.61A343.78 343.78 0 11830.76 647a345.5 345.5 0 01-74.15 109.85zM653.48 532h-44.69a7.5 7.5 0 00-7.53 6.88 89.28 89.28 0 01-178 0 7.5 7.5 0 00-7.53-6.88H371a7.42 7.42 0 00-7.43 7.8c4.09 78.33 69.22 140.86 148.66 140.86s144.59-62.53 148.68-140.86a7.42 7.42 0 00-7.43-7.8z"
      }
    }]
  },
  "name": "face-smile-circle-stroke"
};
a['FaceSmileSquareFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M877.42 110.8h-736a32 32 0 00-32 32v736a32 32 0 0032 32h736a32 32 0 0032-32v-736a32 32 0 00-32-32zM301.29 406.74a44.6 44.6 0 1144.6 44.6 44.6 44.6 0 01-44.6-44.6zm208.13 252.72c-79.44 0-144.58-62.53-148.66-140.85a7.43 7.43 0 017.43-7.81h44.69a7.51 7.51 0 017.53 6.88 89.28 89.28 0 00178 0 7.51 7.51 0 017.59-6.88h44.69a7.43 7.43 0 017.44 7.81c-4.13 78.32-69.27 140.85-148.71 140.85zm163.52-208.12a44.6 44.6 0 1144.6-44.6 44.59 44.59 0 01-44.6 44.6z"
      }
    }]
  },
  "name": "face-smile-square-fill"
};
a['FaceSmileSquareStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M877.42 110.8h-736a32 32 0 00-32 32v736a32 32 0 0032 32h736a32 32 0 0032-32v-736a32 32 0 00-32-32zm-40 728h-656v-656h656zM301.29 406.74a44.6 44.6 0 1044.6-44.6 44.6 44.6 0 00-44.6 44.6zm327.06 0a44.6 44.6 0 1044.59-44.6 44.59 44.59 0 00-44.59 44.6zm22.29 104.06H606a7.51 7.51 0 00-7.52 6.88 89.28 89.28 0 01-178 0 7.51 7.51 0 00-7.53-6.88h-44.76a7.42 7.42 0 00-7.43 7.81c4.08 78.32 69.22 140.85 148.66 140.85S654 596.93 658.08 518.61a7.43 7.43 0 00-7.44-7.81z"
      }
    }]
  },
  "name": "face-smile-square-stroke"
};
a['FemaleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M693.33 725.33H554.67v-67.62a298.67 298.67 0 10-85.34 0v67.62H330.67a32 32 0 00-32 32v21.34a32 32 0 0032 32h138.66V928a32 32 0 0032 32h21.34a32 32 0 0032-32V810.67h138.66a32 32 0 0032-32v-21.34a32 32 0 00-32-32zM298.67 362.67A213.33 213.33 0 11512 576a213.33 213.33 0 01-213.33-213.33z"
      }
    }]
  },
  "name": "female-stroke"
};
a['FieldAttachmentStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M375.25 933.76a213.33 213.33 0 01-156.16-68.05 217.81 217.81 0 0110.24-301.02L483.2 310.61a120.53 120.53 0 0185.33-35.2 132.27 132.27 0 0172.32 20.06 128 128 0 0121.34 198.4L437.97 718.08a32.21 32.21 0 01-45.22 0L377.6 704a31.79 31.79 0 010-45.23l222.08-223.14a45.01 45.01 0 000-64 42.67 42.67 0 00-28.59-11.1 39.68 39.68 0 00-30.29 12.38L288.64 625.92a131.63 131.63 0 00-6.19 182.61A128 128 0 00385.92 848a134.19 134.19 0 0083.2-40.53L737.28 539.3a213.33 213.33 0 00-160.21-363.95 222.5 222.5 0 00-146.35 67.2L196.05 477.23a32.21 32.21 0 01-45.22 0l-14.94-15.15a31.79 31.79 0 010-45.23l233.39-233.6a309.76 309.76 0 01203.3-93.01 296.75 296.75 0 01229.98 92.16c110.93 116.05 102.4 309.97-11.1 423.47L526.09 871.25a211.84 211.84 0 01-150.83 62.51z"
      }
    }]
  },
  "name": "field-attachment-stroke"
};
a['FieldCalendarStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M874.67 170.67H768V96a32 32 0 00-32-32h-21.33a32 32 0 00-32 32v74.67H341.33V96a32 32 0 00-32-32H288a32 32 0 00-32 32v74.67H149.33a64 64 0 00-64 64v640a64 64 0 0064 64h725.34a64 64 0 0064-64v-640a64 64 0 00-64-64zM256 256v32a32 32 0 0032 32h21.33a32 32 0 0032-32v-32h341.34v32a32 32 0 0032 32H736a32 32 0 0032-32v-32h85.33v128H170.67V256zm-85.33 597.33v-384h682.66v384zm609.92-256H420.27a31.15 31.15 0 00-30.08 32v21.34a31.15 31.15 0 0030.08 32h360.32a31.15 31.15 0 0030.08-32v-21.34a31.15 31.15 0 00-30.08-32zm-481.92 0h-56.75a30.5 30.5 0 00-28.59 32v21.34a30.5 30.5 0 0028.59 32h56.75a30.5 30.5 0 0028.8-32v-21.34a30.5 30.5 0 00-28.8-32z"
      }
    }]
  },
  "name": "field-calendar-stroke"
};
a['FieldCaptionsStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M437.7 133.61l-274 752.85a8 8 0 007.52 10.73h63.85a8 8 0 007.52-5.26L326 662.81h346.68l83.39 229.12a8 8 0 007.52 5.26h63.85a8 8 0 007.56-10.73L561 133.61a8 8 0 00-7.52-5.26H445.22a8 8 0 00-7.52 5.26zm-84.07 453.2l145.69-400.28L645 586.81z"
      }
    }]
  },
  "name": "field-captions-stroke"
};
a['FieldDatastatusStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M419.2 874.67H192v-512h618.67v74.66a32 32 0 0032 32H864a32 32 0 0032-32V128a64 64 0 00-64-64H170.67a64 64 0 00-64 64v768a64 64 0 0064 64H419.2a32 32 0 0032-32v-21.33a32 32 0 00-32-32zm391.47-725.34v128H192v-128z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M688 955.52a218.67 218.67 0 11218.67-218.67A218.88 218.88 0 01688 955.52zm0-362.67a144 144 0 10144 144 144.21 144.21 0 00-144-144z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M677.33 711.9h21.34q32 0 32 32v85.33q0 32-32 32h-21.34q-32 0-32-32v-85.34q0-32 32-32zM645.33 655.15a42.67 42.67 0 1085.34 0 42.67 42.67 0 10-85.34 0z"
      }
    }]
  },
  "name": "field-datastatus-stroke"
};
a['FieldDropdownStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M586.68 255.59a5.46 5.46 0 00-3 9.31l88.68 86.26c2.51 2.41 5.83 1.54 8.47-1.2L763.75 264a5.44 5.44 0 00-5.45-8.11zm0 426.08a5.46 5.46 0 00-3 9.31l88.68 86.26c2.51 2.41 5.83 1.54 8.47-1.2l82.94-85.93a5.44 5.44 0 00-5.47-8.11zM826 408.08v-208H199v208zm72 40a32 32 0 01-32 32H159a32 32 0 01-32-32v-288a32 32 0 0132-32h707a32 32 0 0132 32zM826 823V615H199v208zm72 40a32 32 0 01-32 32H159a32 32 0 01-32-32V575a32 32 0 0132-32h707a32 32 0 0132 32z"
      }
    }]
  },
  "name": "field-dropdown-stroke"
};
a['FieldFormulaStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M477.89 99h1.02c17.03 0 33.09 1.35 48.13 4.1a8 8 0 016.4 9.54l-10.82 51.07a8 8 0 01-8.57 6.34l-2.24-.2a208.38 208.38 0 00-43.46-3.51c-60.67 0-96.13 33.66-109.25 102.78l-9.53 50.5-2.69 13.88h206.2c3.2 0 6.02 1.86 7.3 4.74l74.24 165.31 5.76 12.1a8 8 0 0013.19 1.85l8.7-10.04 145.03-171.2a8 8 0 016.08-2.88h71.8a8 8 0 015.96 13.37L681.86 580.03a8 8 0 00-1.28 8.77l112 234.56a8 8 0 01-7.17 11.52h-65.09a8 8 0 01-7.23-4.74L636.03 663.1a2517.25 2517.25 0 01-5.37-12.16 8 8 0 00-13.38-1.92l-8.77 10.12L462.4 832.32a8 8 0 01-6.14 2.88h-71.81a8 8 0 01-5.95-13.31l209.6-235.97c4.54-4.93 4.8-5.89 1.92-11.9l-85.19-173.25h-172.1L225.48 918.59a8 8 0 01-7.8 6.4h-67.91a8 8 0 01-7.8-9.6l106.62-514.75H134.2a8 8 0 01-7.81-9.6l10.62-51.07a8 8 0 017.81-6.34H262.6L274.94 269C297.54 149.5 357.95 99.01 477.9 99.01z"
      }
    }]
  },
  "name": "field-formula-stroke"
};
a['FieldIdStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M160 352a16 16 0 0116 16v32a16 16 0 01-16 16h-32v384h768V416h-32a16 16 0 01-16-16v-32a16 16 0 0116-16h64a32 32 0 0132 32v448a32 32 0 01-32 32H96a32 32 0 01-32-32V384a32 32 0 0132-32zm185-192v63.87h-35.83v384.26H345V672H213v-63.87h35.56V223.87H213V160h132zm189.13 0c81.66 0 142.55 19.82 182.68 59.46 40.13 39.63 60.19 102.6 60.19 188.9 0 87.65-20.6 153.5-61.78 197.56C674.04 649.97 612.8 672 531.48 672H398v-63.87h37.97V223.87H398V160zm-1.78 64H494v384h37.82c61.35 0 106.22-15.79 134.6-47.36 28.39-31.58 42.58-81.2 42.58-148.88 0-43.46-5.95-78.89-17.85-106.27-11.9-27.4-30.77-47.82-56.6-61.29-25.82-13.47-59.9-20.2-102.2-20.2z"
      }
    }]
  },
  "name": "field-id-stroke"
};
a['FieldInputStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M291.63 768h22.61a32.21 32.21 0 0030.3-21.33L403.2 576h217.6l58.67 170.67A32.21 32.21 0 00709.76 768h22.61a32 32 0 0030.08-42.67L549.12 106.67a32 32 0 00-30.3-21.34h-15.35a32 32 0 00-30.3 21.34L259.84 725.33A32 32 0 00291.63 768zM512 259.2l79.57 231.47H432.43zM117.33 853.33h789.34q32 0 32 32v21.34q0 32-32 32H117.33q-32 0-32-32v-21.34q0-32 32-32z"
      }
    }]
  },
  "name": "field-input-stroke"
};
a['FieldMailStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 128H128a64 64 0 00-64 64v640a64 64 0 0064 64h768a64 64 0 0064-64V192a64 64 0 00-64-64zm-21.33 85.33zm-66.14 0L512 457.17 213.33 213.33zm-659.2 597.34V270.93l322.14 262.4a64 64 0 0081.06 0l322.14-263.68v541.02z"
      }
    }]
  },
  "name": "field-mail-stroke"
};
a['FieldNumberStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M117.33 213.33H128v501.34a32 32 0 0031.79 32h21.33a32 32 0 0032.21-32V192a64 64 0 00-64-64h-32a32 32 0 00-32 32v21.33a32 32 0 0032 32zm256 533.34H544a32 32 0 0032-32v-21.34a32 32 0 00-32-32H405.33v-192h117.34A53.33 53.33 0 00576 416V192a64 64 0 00-64-64H352a32 32 0 00-32 32v21.33a32 32 0 0032 32h138.67V384H373.33A53.33 53.33 0 00320 437.33v256a53.33 53.33 0 0053.33 53.34zm512-618.67H714.67a32 32 0 00-32 32v21.33a32 32 0 0032 32h138.66V384H714.67a32 32 0 00-32 32v21.33a32 32 0 0032 32h138.66v192H714.67a32 32 0 00-32 32v21.34a32 32 0 0032 32h170.66a53.33 53.33 0 0053.34-53.34v-512A53.33 53.33 0 00885.33 128zm-768 725.12h789.34q32 0 32 32v21.33q0 32-32 32H117.33q-32 0-32-32v-21.33q0-32 32-32z"
      }
    }]
  },
  "name": "field-number-stroke"
};
a['FieldOcr'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M292.27 379.73c-72.54 0-117.34 49.07-117.34 130.14s44.8 132.26 117.34 132.26 117.33-51.2 117.33-132.26c-2.13-78.94-46.93-130.14-117.33-130.14zm0 206.94c-29.87 0-49.07-29.87-49.07-76.8s19.2-74.67 49.07-74.67c32 0 51.2 27.73 51.2 74.67-2.14 46.93-21.34 76.8-51.2 76.8zm322.13-6.4c-8.53-8.54-21.33-10.67-32-4.27s-21.33 10.67-32 10.67c-34.13 0-55.47-27.74-55.47-74.67 0-44.8 23.47-74.67 55.47-74.67 10.67 0 19.2 2.14 27.73 8.54 10.67 6.4 23.47 4.26 29.87-6.4l4.27-6.4c4.26-4.27 6.4-12.8 4.26-19.2 0-6.4-4.26-12.8-10.66-17.07-17.07-10.67-38.4-17.07-57.6-17.07-57.6 0-121.6 40.54-121.6 132.27 0 64 36.26 130.13 119.46 130.13 25.6 0 49.07-8.53 68.27-23.46 4.27-4.27 8.53-8.54 8.53-14.94s-2.13-12.8-6.4-19.2l-2.13-4.26zm104.53 34.13v-64h23.47l38.4 74.67c4.27 8.53 12.8 12.8 21.33 12.8h17.07c8.53 0 17.07-4.27 21.33-12.8 4.27-6.4 4.27-17.07 0-23.47l-36.26-64c27.73-12.8 42.66-38.4 42.66-72.53 0-53.34-34.13-81.07-100.26-81.07h-70.4a23.68 23.68 0 00-23.47 23.47v204.8a23.67 23.67 0 0023.47 23.46h17.06c14.94 2.14 25.6-8.53 25.6-21.33zm0-177.07h23.47c29.87 0 40.53 8.54 40.53 27.74 0 21.33-12.8 32-40.53 32h-23.47v-59.74zm-601.6-96H128c17.07 0 32-14.93 32-32V160h149.33c17.07 0 32-14.93 32-32v-10.67c0-17.06-14.93-32-32-32h-192c-17.06 0-32 14.94-32 32v192c0 17.07 14.94 32 32 32zm789.34-256h-192c-17.07 0-32 14.94-32 32V128c0 17.07 14.93 32 32 32H864v149.33c0 17.07 14.93 32 32 32h10.67c17.06 0 32-14.93 32-32v-192c0-17.06-14.94-32-32-32zm0 597.34H896c-17.07 0-32 14.93-32 32V864H714.67c-17.07 0-32 14.93-32 32v10.67c0 17.06 14.93 32 32 32h192c17.06 0 32-14.94 32-32v-192c0-17.07-14.94-32-32-32zM309.33 864H160V714.67c0-17.07-14.93-32-32-32h-10.67c-17.06 0-32 14.93-32 32v192c0 17.06 14.94 32 32 32h192c17.07 0 32-14.94 32-32V896c0-17.07-14.93-32-32-32z"
      }
    }]
  },
  "name": "field-ocr"
};
a['FieldPictureStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 128H128a64 64 0 00-64 64v640a64 64 0 0064 64h768a64 64 0 0064-64V192a64 64 0 00-64-64zm-21.33 85.33V635.1L768 536.96a64 64 0 00-87.04 0L570.24 640 298.67 389.12a64 64 0 00-87.04 0L149.33 448V213.33zM149.33 564.05L256 465.07l251.52 234.66-120.53 110.94H149.33zM512 810.67L725.33 612.9l149.34 138.66v59.1zM672 352a53.33 53.33 0 10106.67 0A53.33 53.33 0 10672 352z"
      }
    }]
  },
  "name": "field-picture-stroke"
};
a['FieldPositionStroke07'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M158.72 875.78H863.8q32 0 32 32v21.3q0 32-32 32H158.72q-32.05 0-32-32v-21.3q-.2-32.26 32-32zm314.88-96.06a58.88 58.88 0 0076.19 0c53.5-46.08 149.3-128 190.25-165.58 134.1-120.47 140.6-322.04 14.6-450.3A339.97 339.97 0 00529.05 64h-17.46c-183.91-.15-333.16 142.18-333.36 318a311.8 311.8 0 00105.26 232.4c41.83 37.48 136.76 119.45 190.11 165.32zM512 145.56h13c136.86 6.6 242.23 117.76 235.52 248.78a232.6 232.6 0 01-77.67 160.67C646.4 587.88 567.25 657 512.2 702.87c-54.16-46.7-133.12-115-170.64-147.86a229.58 229.58 0 01-10.76-334.85 253.18 253.18 0 01181.2-74.6z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M512 523.72a128 128 0 10-128-128 128 128 0 00128 128zm0-168.96a42.7 42.7 0 11-42.65 42.65A42.65 42.65 0 01512 354.56z"
      }
    }]
  },
  "name": "field-position-stroke-07"
};
a['FieldPositionStroke08'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M291.84 791.4h22.63a32.36 32.36 0 0030.26-22.84l58.67-182.73H621l58.68 182.73a32.36 32.36 0 0030.31 22.84h22.17a33.23 33.23 0 0031.9-34.36 36.6 36.6 0 00-1.8-11.31L549.13 83.3a32.2 32.2 0 00-30.31-22.83h-15.36a32.1 32.1 0 00-30.26 22.83L259.84 745.73a34.92 34.92 0 0019.46 43.72 29.9 29.9 0 0012.34 1.95zM512 246.63l79.56 247.8H432.44zM117.35 875.78h789.3q32 0 32 32v21.3q0 32-32 32h-789.3q-32.05 0-32-32v-21.3q0-32.26 32-32z"
      }
    }]
  },
  "name": "field-position-stroke-08"
};
a['FieldPositionStroke09'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64a32.3 32.3 0 00-22.63 9.37l-15.36 15.36-238.08 238.08a31.85 31.85 0 000 44.95v.26l14.95 15.36a32.82 32.82 0 0022.63 9.42 31.85 31.85 0 0022.63-9.42l174.08-173.62v544.61a32 32 0 0032 32h21.35a32 32 0 0032-32V215.04L727.5 386.97a31.85 31.85 0 0022.63 9.42 32.82 32.82 0 0022.99-9.42l14.95-15.36a31.74 31.74 0 00.26-44.9l-.26-.31L549.99 88.32l-15.36-15.36A32.3 32.3 0 00512 64zm384 810.65H128a32 32 0 00-32 32V928a32 32 0 0032 32h768a32 32 0 0032-32v-21.35a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "field-position-stroke-09"
};
a['FieldPositionStroke10'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M803.84 492.19H640v-79.42c90.47-66.81 106.44-190.25 35.84-275.7A212.63 212.63 0 00512 61.43c-114.74 0-207.92 87.8-208.08 196.15a192.67 192.67 0 0083.92 157.8v76.8h-166.4c-35.33 0-64 27.03-64 60.41v180.12c0 33.33 28.67 60.42 64 60.42h582.4c35.33 0 64-27.09 64-60.42V552.6c-.2-33.38-28.88-60.41-64-60.41zm-21.35 220.16h-539.7V572.72H473.8v-204.8a119.45 119.45 0 01-79.15-78.84 106.5 106.5 0 01-4.66-31.03c0-63.95 54.89-115.82 122.88-115.82s122.88 51.87 122.88 115.82a106.5 106.5 0 01-4.66 31.03 118.17 118.17 0 01-75.98 76.8v206.69h227.64zm94.16 161.28h-725.1c-24.06 0-43.52 14.28-43.52 32v21.09c0 17.66 19.46 32 43.52 32h725.1c24.06 0 43.52-14.34 43.52-32v-21.3c0-17.51-19.46-31.8-43.52-31.8z"
      }
    }]
  },
  "name": "field-position-stroke-10"
};
a['FieldPositionStroke11'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M117.35 160.77H128v596.02c0 20.94 14.18 37.89 31.8 38.04h21.3c17.71 0 32.1-16.74 32.25-37.79V135.42c0-42.03-28.67-76.13-64-76.13h-32c-17.71 0-32 17.05-32 38.1v25.49c0 20.84 14.29 37.89 32 37.89zm256 634.06H544c17.66 0 32-17 32-38.04v-25.35c0-21.04-14.34-38.04-32-38.04H405.35V465.1h117.3c29.5 0 53.35-28.36 53.35-63.38V135.48c0-42.04-28.67-76.14-64-76.14H352c-17.66 0-32 17.05-32 38.1v25.44c0 21 14.34 38.04 32 38.04h138.65v202.6h-117.3c-29.5 0-53.35 28.52-53.35 63.54v304.38c0 35.02 23.86 63.39 53.35 63.39zm512-735.54h-170.7c-17.66 0-32 17.05-32 38.1v25.49c0 21 14.34 38.04 32 38.04h138.7v202.6h-138.7c-17.66 0-32 17.05-32 38.04v25.6c0 21.04 14.34 38.04 32 38.04h138.7v228.3h-138.7c-17.66 0-32 17-32 38.05v25.34c0 21.04 14.34 38.04 32 38.04h170.7c29.44 0 53.3-28.36 53.3-63.38V122.88c0-35.02-23.86-63.44-53.3-63.44zm-768 816.49h789.3q32 0 32 32v21.3q0 32-32 32h-789.3q-32.05 0-32-32v-21.3q0-32.26 32-32z"
      }
    }]
  },
  "name": "field-position-stroke-11"
};
a['FieldPositionStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M159.36 853.33h705.28q32 0 32 32v21.34q0 32-32 32H159.36q-32 0-32-32v-21.34q0-32 32-32zM473.6 812.8a56.96 56.96 0 0076.16 0c53.55-48 149.33-133.97 190.3-173.23A333.23 333.23 0 00529.05 64h-17.49a333.01 333.01 0 00-228.05 576c41.81 39.04 136.75 124.8 190.08 172.8zM512 149.33h13.01a248.1 248.1 0 01157.66 428.38C646.19 612.05 567.04 684.37 512 732.37a41408.48 41408.48 0 01-170.67-154.66A247.9 247.9 0 01512 149.33zm0 374.4a128 128 0 10-128-128 128 128 0 00128 128zm0-169.17a42.67 42.67 0 11-42.67 42.67A42.67 42.67 0 01512 354.56z"
      }
    }]
  },
  "name": "field-position-stroke"
};
a['FieldRadioStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 149.33c199.9 0 362.67 162.78 362.67 362.67S711.89 874.67 512 874.67 149.33 711.89 149.33 512 312.11 149.33 512 149.33M512 64C264.53 64 64 264.53 64 512s200.53 448 448 448 448-200.53 448-448S759.47 64 512 64zM288 516.05a224 224 0 10448 0 224 224 0 10-448 0z"
      }
    }]
  },
  "name": "field-radio-stroke"
};
a['FieldReferenceStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M912.85 551.04a153.39 153.39 0 00-212.26 7.47L682.67 576a31.79 31.79 0 000 45.23l14.93 15.14a32.21 32.21 0 0045.23 0l21.33-21.33a65.5 65.5 0 0182.35-10.03 64 64 0 0110.02 98.78l-22.61 22.61a31.79 31.79 0 000 45.23l14.93 15.14a32.43 32.43 0 0045.44 0l23.04-21.33a149.33 149.33 0 00-4.48-214.4zM408.11 325.76a21.33 21.33 0 006.82-27.1l-19.2-38.6a21.33 21.33 0 00-30.93-8.33 193.92 193.92 0 00-87.47 161.71v55.9a21.33 21.33 0 0021.34 21.33h106.66a21.33 21.33 0 0021.34-21.34v-42.66a21.33 21.33 0 00-21.34-21.34h-42.66a108.16 108.16 0 0145.44-79.57zm208.85 143.57v-42.66a21.33 21.33 0 00-21.33-21.34h-40.96a108.16 108.16 0 0144.8-78.72 21.33 21.33 0 006.82-27.94l-19.2-38.62a21.33 21.33 0 00-30.93-8.32 193.92 193.92 0 00-86.83 161.71v55.9a21.33 21.33 0 0021.34 21.33h106.66a21.33 21.33 0 0019.63-21.34zm155.95 363.95a31.79 31.79 0 00-45.23 0l-21.33 21.33A65.5 65.5 0 01624 864.64a64 64 0 01-10.03-98.56l22.62-22.61a32 32 0 000-45.44l-14.94-14.94a31.79 31.79 0 00-45.65-.42l-18.35 18.13a153.39 153.39 0 00-7.46 212.27 149.33 149.33 0 00213.33 3.41l22.83-22.61a32.43 32.43 0 000-45.44zM667.35 742.69l75.43-75.43q22.62-22.62 45.25 0l15.09 15.09q22.62 22.63 0 45.25l-75.43 75.43q-22.63 22.63-45.25 0l-15.09-15.09q-22.63-22.62 0-45.25zM419.41 874.67H192V149.33h618.67v288a32 32 0 0032 32H864a32 32 0 0032-32V128a64 64 0 00-64-64H170.67a64 64 0 00-64 64v768a64 64 0 0064 64H419.4a32 32 0 0032-32v-21.33a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "field-reference-stroke"
};
a['FieldSelectStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M874 782H150V242h724v540zM110 170a32 32 0 00-32 32v620a32 32 0 0032 32h804a32 32 0 0032-32V202a32 32 0 00-32-32H110zm339.09 230.56h55.05a16 16 0 0113 6.66l95.29 132.38 95.32-132.38a16 16 0 0113-6.66h55a8 8 0 016.49 12.68L618.93 640.11a8 8 0 01-13 0L442.6 413.24a8 8 0 016.49-12.68z"
      }
    }]
  },
  "name": "field-select-stroke"
};
a['FieldSerialnumberStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M522.67 277.33h-64a32 32 0 00-32 32v21.34a32 32 0 0032 32h10.66v352a32 32 0 0032 32h21.34a32 32 0 0032-32V309.33a32 32 0 00-32-32zm-135.9 486.4a32 32 0 00-39.04-22.82l-21.33 5.54a31.79 31.79 0 00-22.61 39.04l7.89 30.3a362.67 362.67 0 0160.59-640 32 32 0 0018.13-39.04l-6.61-21.34a32.43 32.43 0 00-42.67-20.05A448 448 0 0064 550.19a456.96 456.96 0 00309.33 388.48l27.95 9.81a21.33 21.33 0 0027.73-25.6zm570.67-287.57A457.17 457.17 0 00652.37 86.61L624 76.6a21.33 21.33 0 00-27.95 25.38l41.39 158.3a32 32 0 0039.04 22.82l21.33-5.33a32 32 0 0022.83-39.04l-7.25-28.16a362.67 362.67 0 01-64 637.44 31.57 31.57 0 00-18.14 38.83l6.4 21.33a32.21 32.21 0 0042.67 20.05 448 448 0 00277.12-452.05z"
      }
    }]
  },
  "name": "field-serialnumber-stroke"
};
a['FieldSummaryStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M912.85 551.04a153.39 153.39 0 00-212.26 7.47L682.67 576a31.79 31.79 0 000 45.23l14.93 15.14a32.21 32.21 0 0045.23 0l21.33-21.33a65.5 65.5 0 0182.35-10.03 64 64 0 0110.02 98.78l-22.61 22.61a31.79 31.79 0 000 45.23l14.93 15.14a32.43 32.43 0 0045.44 0l23.04-21.33a149.33 149.33 0 00-4.48-214.4zM772.91 833.28a31.79 31.79 0 00-45.23 0l-21.33 21.33A65.5 65.5 0 01624 864.64a64 64 0 01-10.03-98.56l22.62-22.83a31.79 31.79 0 000-45.22l-14.94-14.94a31.79 31.79 0 00-45.65-.42l-18.35 18.13a153.39 153.39 0 00-7.46 212.27 149.33 149.33 0 00213.33 3.41l22.83-22.61a32.43 32.43 0 000-45.44zM667.35 742.69l75.43-75.43q22.62-22.62 45.25 0l15.09 15.09q22.62 22.63 0 45.25l-75.43 75.43q-22.63 22.63-45.25 0l-15.09-15.09q-22.63-22.62 0-45.25zM462.51 554.67a64 64 0 000-85.34L256 239.57v-90.24h512v160a32 32 0 0032 32h21.33a32 32 0 0032-32V128a64 64 0 00-64-64H234.67a64 64 0 00-64 64v119.9a64 64 0 0016.42 42.66L386.13 512 186.88 733.44a64 64 0 00-16.43 42.67V896a64 64 0 0064 64h202.67a32 32 0 0032.21-32v-21.33a32 32 0 00-32-32H256v-90.24z"
      }
    }]
  },
  "name": "field-summary-stroke"
};
a['FieldTextareaStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M117.33 853.33h789.34q32 0 32 32v21.34q0 32-32 32H117.33q-32 0-32-32v-21.34q0-32 32-32zm512.64-768h276.48q32 0 32 32v21.34q0 32-32 32H629.97q-32 0-32-32v-21.34q0-32 32-32zm0 256h276.48q32 0 32 32v21.34q0 32-32 32H629.97q-32 0-32-32v-21.34q0-32 32-32zm-512.64 256h789.34q32 0 32 32v21.34q0 32-32 32H117.33q-32 0-32-32v-21.34q0-32 32-32zm30.51-106.66h22.83a32 32 0 0029.44-19.63l27.09-64h142.08l27.1 64a32 32 0 0030.29 19.63h23.25a32 32 0 0029.44-44.38L335.57 104.96a31.57 31.57 0 00-29.86-19.63h-14.08a31.57 31.57 0 00-29.44 19.63L118.4 446.29a32 32 0 0029.44 44.38zm150.83-252.8l35.2 83.41h-70.4z"
      }
    }]
  },
  "name": "field-textarea-stroke"
};
a['FieldTimeStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M650.67 639.57h234.66q32 0 32 32v21.34q0 32-32 32H650.67q-32 0-32-32v-21.34q0-32 32-32zm0 170.67h234.66q32 0 32 32v21.33q0 32-32 32H650.67q-32 0-32-32v-21.33q0-32 32-32zm-128-574.5h-21.34a32 32 0 00-32 32v227.4L348.37 616.12a31.79 31.79 0 000 45.22l14.94 15.15a32.21 32.21 0 0045.22 0l128-128a64 64 0 0018.14-44.59V267.73a32 32 0 00-32-32zM512 64a448 448 0 000 896 42.67 42.67 0 000-85.33A362.67 362.67 0 11874.67 512a42.67 42.67 0 0085.33 0A448 448 0 00512 64z"
      }
    }]
  },
  "name": "field-time-stroke"
};
a['FileAddStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M844.6 301.6L629.4 86.4a31.94 31.94 0 00-22.6-9.4H202a32 32 0 00-32 32v806a32 32 0 0032 32h620a32 32 0 0032-32V324.3a32.18 32.18 0 00-9.4-22.7zM592 150.8L780.2 339H592zM782 875H242V149h282v216a42 42 0 0042 42h216zM544 502a8 8 0 00-8-8h-48a8 8 0 00-8 8v108H372a8 8 0 00-8 8v48a8 8 0 008 8h108v108a8 8 0 008 8h48a8 8 0 008-8V674h108a8 8 0 008-8v-48a8 8 0 00-8-8H544z"
      }
    }]
  },
  "name": "file-add-stroke"
};
a['FileArchiveStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M844.6 301.6L629.4 86.4a31.9 31.9 0 00-22.6-9.4H202a32 32 0 00-32 32v806a32 32 0 0032 32h620a32 32 0 0032-32V324.3a32.18 32.18 0 00-9.4-22.7zM592 150.8L780.2 339H592V150.8zM782 875H242V149h282v216a42 42 0 0042 42h216v468zM449 272h-64v64h64v64h-64v64h64v64h-64v64h64v160H321V528h64v-64h-64v-64h64v-64h-64v-64h64v-64h-64v-64h64v64h64z"
      }
    }]
  },
  "name": "file-archive-stroke"
};
a['FileAudioStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M606.8 77a31.9 31.9 0 0122.6 9.4l215.2 215.2a32.18 32.18 0 019.4 22.7V915a32 32 0 01-32 32H202a32 32 0 01-32-32V109a32 32 0 0132-32zM524 149H242v726h540V407H566a42 42 0 01-42-42V149zm112.69 356.28A28 28 0 01647 526.95v172.21a47 47 0 01-46.78 51.52 47 47 0 116.78-93.5V542.65l-136.24 36.61v149.94A47 47 0 11424 686.95a46 46 0 016.79.5V570.06a28.13 28.13 0 0121.59-27.26l160.41-43.1.58-.13a28 28 0 0123.32 5.71zM592 150.8V339h188.2L592 150.8z"
      }
    }]
  },
  "name": "file-audio-stroke"
};
a['FileBlankStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M844.6 301.6L629.4 86.4a31.9 31.9 0 00-22.6-9.4H202a32 32 0 00-32 32v806a32 32 0 0032 32h620a32 32 0 0032-32V324.3a32.18 32.18 0 00-9.4-22.7zM592 150.8L780.2 339H592V150.8zM782 875H242V149h282v216a42 42 0 0042 42h216v468z"
      }
    }]
  },
  "name": "file-blank-stroke"
};
a['FileContentStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M330 495h364q8 0 8 8v48q0 8-8 8H330q-8 0-8-8v-48q0-8 8-8zm0 136h164q8 0 8 8v48q0 8-8 8H330q-8 0-8-8v-48q0-8 8-8zm514.6-329.4L629.4 86.4a31.94 31.94 0 00-22.6-9.4H202a32 32 0 00-32 32v806a32 32 0 0032 32h620a32 32 0 0032-32V324.3a32.18 32.18 0 00-9.4-22.7zM592 150.8L780.2 339H592zM782 875H242V149h282v216a42 42 0 0042 42h216z"
      }
    }]
  },
  "name": "file-content-stroke"
};
a['FileDocumentStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M844.6 301.6L629.4 86.4a31.9 31.9 0 00-22.6-9.4H202a32 32 0 00-32 32v806a32 32 0 0032 32h620a32 32 0 0032-32V324.3a32.18 32.18 0 00-9.4-22.7zM592 150.8L780.2 339H592V150.8zM782 875H242V149h282v216a42 42 0 0042 42h216v468zM630 530a8 8 0 01-8 8h-86v245a8 8 0 01-8 8h-32a8 8 0 01-8-8V538h-86a8 8 0 01-8-8v-32a8 8 0 018-8h220a8 8 0 018 8v32z"
      }
    }]
  },
  "name": "file-document-stroke"
};
a['FileExcelStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M606.8 77a31.9 31.9 0 0122.6 9.4l215.2 215.2a32.18 32.18 0 019.4 22.7V915a32 32 0 01-32 32H202a32 32 0 01-32-32V109a32 32 0 0132-32zM524 149H242v726h540V407H566a42 42 0 01-42-42V149zm-81.46 341a12 12 0 0110.27 5.79l61.84 102.36 61.22-102.31a12 12 0 0110.29-5.84h35.7a12 12 0 0110.09 18.5L546.65 641l83.83 130.52A12 12 0 01620.43 790H582.9a12 12 0 01-10.23-5.72l-62.24-101.45-62.76 101.48a12 12 0 01-10.24 5.69H403a12 12 0 11-10.16-18.38l83.45-132.79-82.33-130.42A12 12 0 01404.1 490h38.44zM592 150.8V339h188.2L592 150.8z"
      }
    }]
  },
  "name": "file-excel-stroke"
};
a['FileExceptionStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M488 489h48q8 0 8 8v172q0 8-8 8h-48q-8 0-8-8V497q0-8 8-8zm-16 262a40 40 0 1080 0 40 40 0 10-80 0zm372.6-449.4L629.4 86.4a31.94 31.94 0 00-22.6-9.4H202a32 32 0 00-32 32v806a32 32 0 0032 32h620a32 32 0 0032-32V324.3a32.18 32.18 0 00-9.4-22.7zM592 150.8L780.2 339H592zM782 875H242V149h282v216a42 42 0 0042 42h216z"
      }
    }]
  },
  "name": "file-exception-stroke"
};
a['FileExeStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M606.8 77a31.9 31.9 0 0122.6 9.4l215.2 215.2a32.18 32.18 0 019.4 22.7V915a32 32 0 01-32 32H202a32 32 0 01-32-32V109a32 32 0 0132-32zM524 149H242v726h540V407H566a42 42 0 01-42-42V149zm-45.73 295a191.44 191.44 0 0167.45 0l1.15.2a13.62 13.62 0 0110.96 10.92l6.66 36.06a148.33 148.33 0 0142.31 24.42l34.5-12.27a13.65 13.65 0 0114.92 4.03l.76.89a188.03 188.03 0 0133.8 58.46l.39 1.11a13.6 13.6 0 01-3.95 14.95l-27.78 23.75a151.31 151.31 0 010 49.01l27.78 23.75a13.7 13.7 0 014.04 14.85l-.39 1.1a189.48 189.48 0 01-33.8 58.47l-.77.91a13.6 13.6 0 01-14.9 4.04l-34.5-12.27a149.25 149.25 0 01-42.3 24.42l-6.68 36.05a13.6 13.6 0 01-10.96 10.92l-1.15.22a190.18 190.18 0 01-67.45 0l-1.15-.22a13.6 13.6 0 01-10.96-10.92l-6.68-36.2a147.1 147.1 0 01-42.03-24.33l-34.74 12.36a13.65 13.65 0 01-14.91-4.04l-.77-.92a188.44 188.44 0 01-33.8-58.46l-.39-1.1a13.6 13.6 0 013.95-14.96l28.03-23.99a150.75 150.75 0 010-48.42l-28.16-23.98a13.63 13.63 0 01-3.95-14.94l.39-1.1a189.34 189.34 0 0133.8-58.47l.76-.92a13.6 13.6 0 0114.91-4.03l34.75 12.33a150.22 150.22 0 0142.03-24.33l6.71-36.23a13.6 13.6 0 0110.97-10.92zm95.9 141.33a74.67 74.67 0 00-135.3 56.02 74.66 74.66 0 0073.21 60.1 74.68 74.68 0 0052.81-21.86 74.64 74.64 0 009.29-94.26zM592 150.8V339h188.2L592 150.8z"
      }
    }]
  },
  "name": "file-exe-stroke"
};
a['FileImageStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M360.04 531a40 40 0 1080 0 40 40 0 10-80 0zM696 785H328a8 8 0 01-6.3-12.9l99.8-127.2a8 8 0 0112.6 0l41.1 52.4 77.8-99.2a8 8 0 0112.6 0l136.5 174A7.88 7.88 0 01696 785zm148.6-483.4L629.4 86.4a31.94 31.94 0 00-22.6-9.4H202a32 32 0 00-32 32v806a32 32 0 0032 32h620a32 32 0 0032-32V324.3a32.18 32.18 0 00-9.4-22.7zM592 150.8L780.2 339H592zM782 875H242V149h282v216a42 42 0 0042 42h216z"
      }
    }]
  },
  "name": "file-image-stroke"
};
a['FileListStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M780.9 149v726H243V149m578-72H203a32 32 0 00-32 32v806a32 32 0 0032 32h618a32 32 0 0032-32V109a32 32 0 00-32-32zM330 696a40 40 0 1080 0 40 40 0 10-80 0zm0-184a40 40 0 1080 0 40 40 0 10-80 0zm0-184a40 40 0 1080 0 40 40 0 10-80 0zm142 336h214q8 0 8 8v48q0 8-8 8H472q-8 0-8-8v-48q0-8 8-8zm0-184h214q8 0 8 8v48q0 8-8 8H472q-8 0-8-8v-48q0-8 8-8zm0-184h214q8 0 8 8v48q0 8-8 8H472q-8 0-8-8v-48q0-8 8-8z"
      }
    }]
  },
  "name": "file-list-stroke"
};
a['FilePdfStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M606.8 77a31.9 31.9 0 0122.6 9.4l215.2 215.2a32.18 32.18 0 019.4 22.7V915a32 32 0 01-32 32H202a32 32 0 01-32-32V109a32 32 0 0132-32zM524 149H242v726h540V407H566a42 42 0 01-42-42V149zm-27.98 299.03c16.57.67 29.73 11.54 33 30.13a109.42 109.42 0 011.83 28c-.68 13.34-3 26.57-7.3 44.7l-1.24 5.18-.08.36-.99 4.02c11.62 30.25 28 50.84 52.28 65.83 18.33-2.29 34.47-3.45 49.65-3 21.36.68 37.1 4.71 45.66 13.12 8.28 8.26 11.35 23.2 7.5 36.08-4.4 14.67-16.55 24-34.53 24-21.78 0-54.12-9.83-82.09-24.8-16.12 2.74-33.82 7.55-57.2 15.16-5.4 1.76-10.87 3.58-18.39 6.12l-11.9 4-11 3.7c-32.77 56.22-62.44 81.12-86.6 79.24-9.57-.74-17.55-5.85-22.85-13.73-4.67-6.95-6.72-15.43-5.36-21.9 2.81-14 13-27.35 29.3-40.32 12.33-9.82 27.05-18.68 45.94-28.43 14.12-24.85 35.21-69.5 51.17-107.5-12.53-48.52-16-77-10.08-98.59 3.63-13.38 17.84-22 33.28-21.37zm-64.44 240.55L420.38 699l-.1.1c-1.5 1.36-8.04 7.2-9.09 8.13a320.41 320.41 0 00-12.79 12.12 136.19 136.19 0 00-17.43 20.87 55.41 55.41 0 00-5.28 9.95l-.32.81-.13.34v.36l.01.17a2.08 2.08 0 001.26 1.74c.36.15.74.2 1.12.16a4.09 4.09 0 001.13-.3 15.34 15.34 0 002.61-1.43 62.6 62.6 0 009.1-7.5c9.4-9.09 20.34-22.93 32.43-42.1l.56-.9 8.12-12.93zm65.3-100.77l-1.53 4-.55 1.45c-11.9 31.3-23 56.38-34.95 77.36l-.56.96-2.8 4.88 5.25-2 .19-.07c6.29-2.43 29.61-11.92 27.45-11.1 20.44-8.24 35.47-13.29 51.48-16.66l.86-.18 4.38-.9-3.59-2.67-.77-.57c-16.14-12.1-30.81-29.24-42.23-49.72l-.54-.98-2.09-3.8zm103 64.04l-.86.06-8.2.61 7.56 3.23.9.38c29.24 12.39 45.9 15.08 53.67 12a6.75 6.75 0 002.17-1.28 4.64 4.64 0 001.36-6.3c-1.2-2.18-3.95-4.07-8.04-5.56-9.49-3.47-25.72-4.77-48.57-3.14zM496.75 470.67c-4.8 0-6 9.12-5.29 24.32.62 13.1 2.8 27.57 5.82 37.37l.2.63 1.4 4.38 2.25-4 .17-.3c3.56-6.66 5.74-21.28 5.52-35.35-.24-16.24-3.33-27.05-10.07-27.05zM592 150.8V339h188.2L592 150.8z"
      }
    }]
  },
  "name": "file-pdf-stroke"
};
a['FilePptStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M416 787a8 8 0 01-8-8V503a8 8 0 018-8h104c57.41 0 96 37.91 96 94.34 0 27.69-9.06 51.25-26.19 68.14s-41.46 26-70 26h-63.28V779a8 8 0 01-8 8zm40.53-143.33h38.9c25.65 0 42.77-3.78 53.89-11.91 11.8-8.63 17.3-22.11 17.3-42.42 0-17-4.78-30.46-14.2-39.9s-22.75-14.22-39.67-14.22h-56.22zM844.6 301.6L629.4 86.4a31.94 31.94 0 00-22.6-9.4H202a32 32 0 00-32 32v806a32 32 0 0032 32h620a32 32 0 0032-32V324.3a32.18 32.18 0 00-9.4-22.7zM592 150.8L780.2 339H592zM782 875H242V149h282v216a42 42 0 0042 42h216z"
      }
    }]
  },
  "name": "file-ppt-stroke"
};
a['FileTypeArchiveFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M371.2 76.8H512V0h435.2c51.2 0 76.8 25.6 76.8 76.8v870.4c0 51.2-25.6 76.8-76.8 76.8H76.8C25.6 1024 0 998.4 0 947.2V76.8C0 25.6 25.6 0 76.8 0h294.4v76.8zM512 307.2H371.2v230.4a51.2 51.2 0 0051.2 51.2h179.2a51.2 51.2 0 0051.2-51.2V384H512v-76.8zm140.8-76.8H512v76.8h140.8v-76.8zM512 153.6H371.2v76.8H512v-76.8zm140.8-76.8H512v76.8h140.8V76.8zM448 448h128v76.8H448z"
      }
    }]
  },
  "name": "file-type-archive-fill"
};
a['FileTypeAudioFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 0l256 256v691.2a76.8 76.8 0 01-76.8 76.8H76.8A76.8 76.8 0 010 947.2V76.8A76.8 76.8 0 0176.8 0H768zM541.85 316.34a25.6 25.6 0 00-32.54 24.65v186.98a94.72 94.72 0 00-98.74-2.22 95.62 95.62 0 00-47.56 82.74 95.62 95.62 0 0047.56 82.71 94.72 94.72 0 0095.06 0 95.62 95.62 0 0046.59-96.38V394.29l83.45 23.1a36.84 36.84 0 0045.03-24.71 35.05 35.05 0 00-24-44zM742.4 25.6v179.2a76.8 76.8 0 0076.8 76.8h179.2l-256-256z"
      }
    }]
  },
  "name": "file-type-audio-fill"
};
a['FileTypeDocumentFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 0l256 256v691.2a76.8 76.8 0 01-76.8 76.8H76.8A76.8 76.8 0 010 947.2V76.8A76.8 76.8 0 0176.8 0H768zM650.24 331.11H365.7v48.64H479.5V678.4h56.91V379.75h113.82v-48.64zM742.4 25.6v179.2a76.8 76.8 0 0076.8 76.8h179.2l-256-256z"
      }
    }]
  },
  "name": "file-type-document-fill"
};
a['FileTypeExcelFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 0l256 256v691.2c0 42.24-34.56 76.8-76.8 76.8H76.8C34.56 1024 0 989.44 0 947.2V76.8C0 34.56 34.56 0 76.8 0H768zM421.12 344.32h-64L473.6 512 346.88 691.2h65.28l92.16-138.24 93.44 138.24h65.28L537.6 512l117.76-167.68h-65.28L505.6 469.76l-84.48-125.44zM742.4 25.6v179.2c0 42.24 34.56 76.8 76.8 76.8h179.2l-256-256z"
      }
    }]
  },
  "name": "file-type-excel-fill"
};
a['FileTypeExeFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 0l256 256v691.2a76.8 76.8 0 01-76.8 76.8H76.8A76.8 76.8 0 010 947.2V76.8A76.8 76.8 0 0176.8 0H768zM465.15 252.16l-1.6.3a18.9 18.9 0 00-15.22 15.16L439 317.96a208.61 208.61 0 00-58.37 33.8l-48.26-17.13a18.88 18.88 0 00-20.71 5.6l-1.06 1.28a263.1 263.1 0 00-46.95 81.23l-.54 1.54a18.95 18.95 0 005.5 20.77l39.1 33.32a209.55 209.55 0 000 67.27l-38.94 33.34a18.91 18.91 0 00-5.47 20.77l.53 1.54a261.86 261.86 0 0046.95 81.23l1.06 1.27a18.95 18.95 0 0020.71 5.61l48.26-17.17a204.3 204.3 0 0058.37 33.81l9.27 50.3a18.9 18.9 0 0015.23 15.17l1.6.3a264.03 264.03 0 0093.68 0l1.6-.3a18.9 18.9 0 0015.22-15.17l9.26-50.1a207.27 207.27 0 0058.76-33.93l47.9 17.06a18.88 18.88 0 0020.72-5.61l1.06-1.27a263.3 263.3 0 0046.96-81.23l.53-1.54a19.04 19.04 0 00-5.62-20.63l-38.58-33a210.33 210.33 0 000-68.1l38.58-33a18.89 18.89 0 005.5-20.78l-.53-1.53a261.28 261.28 0 00-46.96-81.24l-1.06-1.24a18.95 18.95 0 00-20.72-5.6l-47.9 17.05a206 206 0 00-58.77-33.93l-9.25-50.1a18.92 18.92 0 00-15.23-15.17l-1.6-.29a265.78 265.78 0 00-93.68 0zm133.2 196.38a103.75 103.75 0 01-12.9 130.97 103.7 103.7 0 01-73.34 30.38 103.73 103.73 0 01-39.65-199.56 103.69 103.69 0 01125.9 38.21zM742.4 25.6v179.2a76.8 76.8 0 0076.8 76.8h179.2l-256-256z"
      }
    }]
  },
  "name": "file-type-exe-fill"
};
a['FileTypeImageFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 0l256 256v691.2c0 42.24-34.56 76.8-76.8 76.8H76.8C34.56 1024 0 989.44 0 947.2V76.8C0 34.56 34.56 0 76.8 0H768zM620.8 482.56l-131.84 198.4L408.32 576c-2.56-2.56-3.84-5.12-6.4-6.4-16.64-12.8-40.96-10.24-53.76 6.4l-97.28 124.16a25.68 25.68 0 0020.48 40.96H486.4c1.28 0 2.56 0 5.12-1.28 2.56 0 3.84 1.28 6.4 1.28h313.6c5.12 0 10.24-1.28 14.08-3.84 10.24-6.4 12.8-23.04 5.12-34.56L684.8 482.56a38.96 38.96 0 00-10.24-10.24c-17.92-11.52-40.96-6.4-53.76 10.24zM345.6 256a76.8 76.8 0 100 153.6 76.8 76.8 0 000-153.6zM742.4 25.6v179.2c0 42.24 34.56 76.8 76.8 76.8h179.2l-256-256z"
      }
    }]
  },
  "name": "file-type-image-fill"
};
a['FileTypePdfFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 0l256 256v691.2c0 42.24-34.56 76.8-76.8 76.8H76.8C34.56 1024 0 989.44 0 947.2V76.8C0 34.56 34.56 0 76.8 0H768zM296.96 409.6H192v256h38.4v-99.84h65.28c61.44 0 92.16-25.6 92.16-78.08s-29.44-78.08-90.88-78.08zm221.44 0h-92.16v256h92.16c40.96 0 71.68-11.52 93.44-34.56 20.48-21.76 30.72-53.76 30.72-93.44 0-40.96-10.24-71.68-30.72-93.44-20.48-23.04-52.48-34.56-93.44-34.56zm337.92 0H680.96v256h39.68V550.4h126.72v-33.28H720.64v-74.24h135.68V409.6zM512 442.88c32 0 55.04 7.68 70.4 23.04 14.08 15.36 21.76 38.4 21.76 71.68 0 32-7.68 56.32-21.76 71.68-15.36 15.36-39.68 23.04-71.68 23.04h-46.08V442.88zm-218.88 1.28c19.2 0 33.28 2.56 42.24 10.24 8.96 6.4 14.08 17.92 14.08 33.28s-3.84 26.88-12.8 34.56c-8.96 6.4-23.04 10.24-42.24 10.24h-65.28v-88.32zM742.4 25.6v179.2c0 42.24 34.56 76.8 76.8 76.8h179.2l-256-256z"
      }
    }]
  },
  "name": "file-type-pdf-fill"
};
a['FileTypePptFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 0l256 256v691.2c0 42.24-34.56 76.8-76.8 76.8H76.8C34.56 1024 0 989.44 0 947.2V76.8C0 34.56 34.56 0 76.8 0H768zM561.92 344.32H418.56V691.2h52.48V555.52h89.6c83.2 0 125.44-35.84 125.44-106.24 0-70.4-40.96-104.96-124.16-104.96zm-2.56 46.08c25.6 0 43.52 3.84 56.32 14.08 11.52 8.96 17.92 24.32 17.92 46.08 0 20.48-6.4 35.84-17.92 46.08-12.8 8.96-30.72 14.08-57.6 14.08h-85.76V390.4zM742.4 25.6v179.2c0 42.24 34.56 76.8 76.8 76.8h179.2l-256-256z"
      }
    }]
  },
  "name": "file-type-ppt-fill"
};
a['FileTypeUnknownFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 0l256 256v691.2a76.8 76.8 0 01-76.8 76.8H76.8A76.8 76.8 0 010 947.2V76.8A76.8 76.8 0 0176.8 0H768zM514.56 615.53c-10.57 0-19.2 3.35-25.93 10.06-7.68 6.73-11.01 15.36-11.01 25.93s3.33 19.2 11 25.9C495.37 684.17 504 688 514.57 688c10.55 0 19.2-3.35 26.88-10.09 6.73-6.7 10.57-15.84 10.57-26.39s-3.84-19.2-10.57-25.9c-7.2-6.74-16.3-10.1-26.88-10.1zm8.63-276.97c-35.51 0-63.36 10.09-83.97 30.23-21.15 20.18-31.23 48-31.23 83.54h54.73c0-20.64 3.84-36.48 12-47.54 9.6-12.96 24.48-19.2 45.11-19.2 16.34 0 29.29 4.35 38.4 13.46 8.66 9.12 13.44 21.58 13.44 37.43 0 12-4.3 23.53-12.95 34.07l-5.76 6.74c-31.2 27.82-49.92 48-56.17 60.95-6.7 12.95-9.6 28.8-9.6 47.05V592h55.22v-6.7c0-11.53 2.38-22.1 7.17-31.7a68.94 68.94 0 0119.2-23.53c23.04-20.14 37-33.1 41.3-37.91 11.51-15.36 17.76-35.05 17.76-59.03 0-29.29-9.6-52.33-28.8-69.12-19.2-17.28-44.65-25.45-75.83-25.45zM742.4 25.6v179.2a76.8 76.8 0 0076.8 76.8h179.2l-256-256z"
      }
    }]
  },
  "name": "file-type-unknown-fill"
};
a['FileTypeVideoFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 0l256 256v691.2a76.8 76.8 0 01-76.8 76.8H76.8A76.8 76.8 0 010 947.2V76.8A76.8 76.8 0 0176.8 0H768zM422.48 342.43A25.6 25.6 0 00384 364.54v303.5a25.6 25.6 0 0038.48 22.11l260.6-151.73a25.6 25.6 0 000-44.26L422.48 342.4zM742.4 25.6v179.2a76.8 76.8 0 0076.8 76.8h179.2l-256-256z"
      }
    }]
  },
  "name": "file-type-video-fill"
};
a['FileTypeWordFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 0l256 256v691.2c0 42.24-34.56 76.8-76.8 76.8H76.8C34.56 1024 0 989.44 0 947.2V76.8C0 34.56 34.56 0 76.8 0H768zM344.32 344.32h-60.16L384 691.2h56.32l70.4-267.52h2.56l70.4 267.52H640l101.12-346.88h-60.16L613.12 614.4h-2.56l-71.68-270.08h-55.04l-70.4 270.08h-2.56l-66.56-270.08zM742.4 25.6v179.2c0 42.24 34.56 76.8 76.8 76.8h179.2l-256-256z"
      }
    }]
  },
  "name": "file-type-word-fill"
};
a['FileUnknownStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M479.99 774a32 32 0 1064 0 32 32 0 10-64 0zm67.7-97.5a14.09 14.09 0 00-9.7 13.3V702a10 10 0 01-10 10H496a10 10 0 01-10-10v-32c.2-19.8 15.4-37.3 34.7-40.1C549 626.2 570 604.3 570 579c0-28.1-25.8-51.5-58-51.5s-58 23.4-58 51.6a9.61 9.61 0 01-9.8 9.4h-32.4a9.56 9.56 0 01-9.8-9.5c0-57.4 50.1-103.7 111.5-103 59.3.8 107.7 46.1 108.5 101.6.69 44.9-29.71 84.5-74.31 98.9zM844.6 301.6L629.4 86.4a31.94 31.94 0 00-22.6-9.4H202a32 32 0 00-32 32v806a32 32 0 0032 32h620a32 32 0 0032-32V324.3a32.18 32.18 0 00-9.4-22.7zM592 150.8L780.2 339H592zM782 875H242V149h282v216a42 42 0 0042 42h216z"
      }
    }]
  },
  "name": "file-unknown-stroke"
};
a['FileVideoStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M606.8 77a31.9 31.9 0 0122.6 9.4l215.2 215.2a32.18 32.18 0 019.4 22.7V915a32 32 0 01-32 32H202a32 32 0 01-32-32V109a32 32 0 0132-32zM524 149H242v726h540V407H566a42 42 0 01-42-42V149zm-63.56 337.83l155 134.1a7.51 7.51 0 010 11.34l-155 134.1a7.52 7.52 0 01-12.44-5.69V492.51a7.52 7.52 0 0112.44-5.68zM592 150.8V339h188.2L592 150.8z"
      }
    }]
  },
  "name": "file-video-stroke"
};
a['FileWordStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M576.41 782a8 8 0 01-7.73-5.93L512 575.38 455.34 776a8 8 0 01-7.74 6h-32a8 8 0 01-7.72-5.92L333.7 510a8 8 0 015.66-9.77 8.13 8.13 0 012.08-.27h35.38a8 8 0 017.79 6.19L430.72 695l7.76.07 49.66-188.93a8 8 0 017.77-6.11h32.19a8 8 0 017.76 6.06l49.77 189.37 7.76-.07 45.79-189.11A8 8 0 01647 500h35.57a8 8 0 018 8 8.13 8.13 0 01-.27 2.08L615.92 776a8 8 0 01-7.73 6zM844.6 301.6L629.4 86.4a31.94 31.94 0 00-22.6-9.4H202a32 32 0 00-32 32v806a32 32 0 0032 32h620a32 32 0 0032-32V324.3a32.18 32.18 0 00-9.4-22.7zM592 150.8L780.2 339H592zM782 875H242V149h282v216a42 42 0 0042 42h216z"
      }
    }]
  },
  "name": "file-word-stroke"
};
a['FilterFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M349 642v196a31.86 31.86 0 0031.8 32h262.4a31.86 31.86 0 0031.8-32V642zm531.08-488h-736.2c-24.5 0-39.8 26.7-27.5 48l221.19 376H686.4l221.28-376c12.2-21.3-3.1-48-27.6-48z"
      }
    }]
  },
  "name": "filter-fill"
};
a['FilterLineStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M867.3 147.91H158.62l-27.79 62.07 208.43 228.8V618.5h74.11V423.96l-9.26-25.01L242 222.02H783L620.89 398.95l-9.27 25.01v364.06l-112.09-40.76-25.94 69.48 162.11 59.28 50.03-35.2V438.78l208.43-228.8z"
      }
    }]
  },
  "name": "filter-line-stroke"
};
a['FilterStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M613 561.4l-9.5 16.6h-183l-9.5-16.6L212.68 226h598.6zM603.38 798h-182.8V642h182.9v156zm276.7-644h-736.2c-24.5 0-39.8 26.7-27.5 48L349 597.4V838a31.86 31.86 0 0031.8 32h262.4a31.86 31.86 0 0031.8-32V597.4L907.68 202c12.2-21.3-3.1-48-27.6-48z"
      }
    }]
  },
  "name": "filter-stroke"
};
a['FlagStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M503.47 586.45v20.06h151.46a46.5 46.5 0 0046.51-46.3V366.3h-85.33v154.88H180.9V215.04h435.2v64h85.33V176.21a46.72 46.72 0 00-46.5-46.5H180.04V96.85A32.85 32.85 0 00147.2 64H128a32.85 32.85 0 00-33.28 32.85v830.3A32.85 32.85 0 00128 960h19.2a32.85 32.85 0 0032.85-32.85v-320h238.08v-20.06z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M886.61 279.68H701.44v86.61h142.5v311.26H502.62V606.5h-85.33v114.56a42.67 42.67 0 0042.67 42.66H886.6a42.67 42.67 0 0042.67-42.66V322.99a42.67 42.67 0 00-42.67-43.31z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M418.13 586.45h85.34v20.06h-85.34zm197.98-306.77h85.33v86.83h-85.33z"
      }
    }]
  },
  "name": "flag-stroke"
};
a['FolderAddStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M149.33 830.08V193.92h244.91l71.04 89.17 25.39 31.79h40.74l343.26 1.92v256H960V292.05a62.3 62.3 0 00-64-60.58l-364.37-1.71-77.23-97.07a65.28 65.28 0 00-50.99-24.1H128a62.3 62.3 0 00-64 60.58v685.66a62.3 62.3 0 0064 60.58h504.53v-85.33z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M928 712.75h-85.33V627.4a32 32 0 00-32-32h-21.34a32 32 0 00-32 32v85.34H672a32 32 0 00-32 32v21.33a32 32 0 0032 32h85.33v85.33a32 32 0 0032 32h21.34a32 32 0 0032-32v-85.33H928a32 32 0 0032-32v-21.33a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "folder-add-stroke"
};
a['FolderCreateStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M394.24 193.92l71.04 89.17 25.39 31.79h40.74l343.26 1.92v513.28H149.33V193.92h244.91m9.17-85.33H128a62.3 62.3 0 00-64 60.58v685.66a62.3 62.3 0 0064 60.58h768a62.3 62.3 0 0064-60.58V292.05a62.3 62.3 0 00-64-60.58l-364.37-1.71-77.23-97.07a65.28 65.28 0 00-50.99-24.1z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M672 533.33H554.67V416a32 32 0 00-32-32h-21.34a32 32 0 00-32 32v117.33H352a32 32 0 00-32 32v21.34a32 32 0 0032 32h117.33V736a32 32 0 0032 32h21.34a32 32 0 0032-32V618.67H672a32 32 0 0032-32v-21.34a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "folder-create-stroke"
};
a['FolderFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M455.9 153.81A62.5 62.5 0 00405.32 128H129.5a64 64 0 00-64 64v32a32 32 0 0032.22 32h371.62a31.79 31.79 0 0025.6-51.2zM129.07 321.5h765.86q65.07 0 65.07 65.06v444.16q0 65.07-65.07 65.07H129.07Q64 895.79 64 830.72V386.56q0-65.07 65.07-65.07z"
      }
    }]
  },
  "name": "folder-fill"
};
a['FolderOpenStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M780.16 915.2a52.05 52.05 0 0034.13-13.23 82.99 82.99 0 01-42.66 13.23zM149.33 542.3V193.91h189.44l57.82 83.41 25.17 36.7h44.59l283.73 1.7v47.58h85.33v-71.26a58.24 58.24 0 00-54.82-60.58l-313.82-1.71L400 132.69a53.55 53.55 0 00-43.95-24.1H119.04A58.03 58.03 0 0064 169.17V855.9a52.27 52.27 0 012.99-13.65zM67.2 874.66a55.68 55.68 0 0051.84 40.53h14.5a69.12 69.12 0 01-66.34-40.53zm0 0a66.13 66.13 0 01-3.2-18.78 49.7 49.7 0 003.2 18.78zm67.63 40.74zm754.34-551.25h-53.76v85.33h29.66L835.4 557.87V854.6a62.3 62.3 0 01-21.33 47.36 56.96 56.96 0 0021.33-26.88l121.6-437.76c13.66-36.48-20.26-73.17-67.84-73.17z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M750.08 449.5v-85.34H256a70.61 70.61 0 00-68.9 41.17L149.32 542.3v287.58h9.6l104.32-380.38zm0-85.34h85.33v85.33h-85.33z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M835.41 854.61V557.87l-74.88 272.21h-611.2V542.29L67 842.24A52.27 52.27 0 0064 855.89a66.13 66.13 0 003.2 18.35 69.12 69.12 0 0066.35 40.96h637.44a82.99 82.99 0 0042.66-13.23 62.3 62.3 0 0021.76-47.36z"
      }
    }]
  },
  "name": "folder-open-stroke"
};
a['FolderStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M394.24 208.21l71.04 88.96 25.39 31.79h40.74l343.26 1.92v513.28H149.33V208.21h244.91m9.17-85.33H128a62.3 62.3 0 00-64 60.59V868.9a62.3 62.3 0 0064 60.58h768a62.3 62.3 0 0064-60.58V306.13a62.08 62.08 0 00-64-60.37l-364.37-1.92-77.23-97.07a65.7 65.7 0 00-50.99-23.89z"
      }
    }]
  },
  "name": "folder-stroke"
};
a['ForkStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M871.42 204.11A113.11 113.11 0 10715 308.58v37.77L506.36 613.2 297.71 346.35v-33.76a113.11 113.11 0 10-62 .58v54.54l239.13 305.84v39.52a113.09 113.09 0 1063-3.29v-36.23L777 367.71v-52a113.27 113.27 0 0094.42-111.6zm-656.84 0a51.11 51.11 0 1151.1 51.1 51.16 51.16 0 01-51.1-51.1zm348.53 615.78a51.11 51.11 0 11-51.11-51.1 51.17 51.17 0 0151.11 51.1zm195.21-564.68a51.11 51.11 0 1151.1-51.1 51.17 51.17 0 01-51.1 51.1z"
      }
    }]
  },
  "name": "fork-stroke"
};
a['FormEditStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M890.24 122.24l15.15 15.15c12.58 12.58 12.58 32.85 0 45.22l-321.71 321.5c-12.59 12.58-32.85 12.58-45.23 0l-15.14-15.15a31.79 31.79 0 010-45.23L845 122.24a31.79 31.79 0 0145.23 0zm-53.97 413.44v268.59c0 17.7-14.3 32-32 32H219.73c-17.7 0-32-14.3-32-32V219.73c0-17.7 14.3-32 32-32h281.6c17.71 0 32-14.29 32-32v-17.06c0-17.71-14.29-32-32-32H138.67c-17.71 0-32 14.29-32 32v746.66c0 17.71 14.29 32 32 32h746.66c17.71 0 32-14.29 32-32V535.68c0-17.7-14.29-32-32-32h-17.06c-17.71 0-32 14.3-32 32z"
      }
    }]
  },
  "name": "form-edit-stroke"
};
a['FormLinkStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M912.85 551.04a153.39 153.39 0 00-212.26 7.47L682.67 576a31.79 31.79 0 000 45.23l14.93 15.14a32.21 32.21 0 0045.23 0l21.33-21.33a65.5 65.5 0 0182.35-10.03 64 64 0 0110.02 98.78l-22.61 22.61a31.79 31.79 0 000 45.23l14.93 15.14a32.43 32.43 0 0045.44 0l23.04-21.33a149.33 149.33 0 00-4.48-214.4zM772.91 833.28a31.79 31.79 0 00-45.23 0l-21.33 21.33A65.5 65.5 0 01624 864.64a64 64 0 01-10.03-98.56l22.62-22.61a32 32 0 000-45.44l-14.94-14.94a31.79 31.79 0 00-45.65-.42l-18.35 18.13a153.39 153.39 0 00-7.46 212.27 149.33 149.33 0 00213.33 3.41l22.83-22.61a32.43 32.43 0 000-45.44zM667.35 742.69l75.43-75.43q22.62-22.62 45.25 0l15.09 15.09q22.62 22.63 0 45.25l-75.43 75.43q-22.63 22.63-45.25 0l-15.09-15.09q-22.63-22.62 0-45.25zM419.41 874.67H192v-512h618.67v74.66a32 32 0 0032 32H864a32 32 0 0032-32V128a64 64 0 00-64-64H170.67a64 64 0 00-64 64v768a64 64 0 0064 64H419.4a32 32 0 0032-32v-21.33a32 32 0 00-32-32zm391.26-725.34v128H192v-128z"
      }
    }]
  },
  "name": "form-link-stroke"
};
a['FormulaDivisionStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M124.04 846.59L844.7 128.95q5.62-5.59 11.2.03l39.14 39.3q5.59 5.6-.02 11.2L174.35 897.12q-5.61 5.6-11.2-.02L124 857.8q-5.59-5.61.03-11.2z"
      }
    }]
  },
  "name": "formula-division-stroke"
};
a['FormulaEqStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M936.85 412.97H87.15c-9.84 0-17.83-3.55-17.83-7.93V349.6c0-4.38 8-7.93 17.83-7.93h849.7c9.9 0 17.83 3.55 17.83 7.93v55.45c0 4.38-7.99 7.93-17.83 7.93zm0 266.4H87.15c-9.84 0-17.83-3.55-17.83-7.93v-55.46c0-4.37 8-7.92 17.83-7.92h849.7c9.9 0 17.83 3.55 17.83 7.92v55.46c0 4.38-7.99 7.93-17.83 7.93z"
      }
    }]
  },
  "name": "formula-eq-stroke"
};
a['FormulaGteStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M885.48 405.64L216.02 114.42a7.92 7.92 0 00-11.02 7.26v60.68a7.92 7.92 0 004.76 7.27l510.2 221.65v3.54L209.75 638.3a7.92 7.92 0 00-4.74 7.25v60.55a7.92 7.92 0 0011.1 7.26l669.4-293.2a7.92 7.92 0 00-.02-14.52zm-8.85 133.04L209.78 826.92a7.92 7.92 0 00-4.78 7.27v56.22c0 10.42 5.84 14.26 11.07 11.99L882.92 613a7.92 7.92 0 004.77-7.27v-59.8a7.92 7.92 0 00-11.06-7.26z"
      }
    }]
  },
  "name": "formula-gte-stroke"
};
a['FormulaLteStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M171.98 410.83L841.44 119.6a7.92 7.92 0 0111.06 7.26v60.68a7.92 7.92 0 01-4.77 7.27L337.5 416.47v3.54l510.22 223.48a7.92 7.92 0 014.76 7.25v60.54a7.92 7.92 0 01-11.1 7.26l-669.4-293.13a7.92 7.92 0 010-14.58zm8.85 133.04l666.9 288.2a7.92 7.92 0 014.77 7.26v56.22c0 10.42-5.84 14.26-11.07 11.99L174.53 618.2a7.92 7.92 0 01-4.76-7.27v-59.8a7.92 7.92 0 0111.06-7.27z"
      }
    }]
  },
  "name": "formula-lte-stroke"
};
a['FormulaMultiplicationStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M912.63 442.68l-16.92-52.82a7.92 7.92 0 00-9.95-5.13L550.24 492.11a1.98 1.98 0 01-2.59-1.9v-346.7a7.92 7.92 0 00-7.92-7.92h-55.46a7.92 7.92 0 00-7.92 7.92v346.7a1.98 1.98 0 01-2.59 1.88L138.24 384.72a7.92 7.92 0 00-9.95 5.13l-16.92 52.83a7.92 7.92 0 005.13 9.96l337.33 107.95L245.6 842.87a7.92 7.92 0 001.68 11.08l44.63 32.92a7.92 7.92 0 0011.13-1.67L512 601.85 720.96 885.2a7.92 7.92 0 0011.08 1.67l44.64-32.92a7.92 7.92 0 001.72-11.08L571.82 562.82a1.98 1.98 0 01.99-3.07l334.73-107.12a7.92 7.92 0 005.09-9.95z"
      }
    }]
  },
  "name": "formula-multiplication-stroke"
};
a['FormulaNeqStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M369.85 910.27L71.1 511.01a7.92 7.92 0 01.3-9.9l323.92-381.48a7.92 7.92 0 0111.16-.9l42.28 35.88a7.92 7.92 0 01.9 11.17l-287.1 338.17a7.92 7.92 0 00-.3 9.9l264.67 353.68a7.92 7.92 0 01-1.6 11.09l-44.4 33.22a7.92 7.92 0 01-11.1-1.57zm273.21 1.6l-44.4-33.22a7.92 7.92 0 01-1.6-11.1l264.68-353.73a7.92 7.92 0 00-.3-9.9L574.32 165.78a7.92 7.92 0 01.91-11.17l42.28-35.89a7.92 7.92 0 0111.16.91L952.6 501.11a7.92 7.92 0 01.3 9.9L654.15 910.27a7.92 7.92 0 01-11.09 1.6z"
      }
    }]
  },
  "name": "formula-neq-stroke"
};
a['FormulaStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M853.33 896H200.75a72.53 72.53 0 01-68.06-45.65 69.33 69.33 0 0116.64-76.38L428.37 512 149.33 250.03A69.97 69.97 0 01132.05 173a72.32 72.32 0 0168.7-45.01h652.58a42.67 42.67 0 010 85.33H234.67l263.89 247.9a70.19 70.19 0 010 102.4l-263.9 247.04h618.67a42.67 42.67 0 010 85.33z"
      }
    }]
  },
  "name": "formula-stroke"
};
a['FrozenStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M928.43 469.33H759.04L878.51 307a31.79 31.79 0 00-6.83-44.59l-17.07-12.8a32 32 0 00-43.94 6.4L653 469.33h-98.34v-99.2L768 213.33a32 32 0 007.04-44.8l-12.59-17.28a32 32 0 00-44.8-6.82l-162.98 120.1V115.2a32 32 0 00-32-32h-21.34a32 32 0 00-32 32.85v148.06L308.48 145.49a32 32 0 00-44.8 6.83l-12.59 17.07a32 32 0 006.62 44.8l211.62 155.94v99.2h-97.49L216.74 256a31.79 31.79 0 00-44.58-6.83l-17.28 12.38a32 32 0 00-7.04 44.8l118.4 162.98H95.57a32 32 0 00-31.57 32v21.34a32 32 0 0031.57 32h172.16L148.05 717a31.79 31.79 0 006.83 44.59l17.28 12.8a31.79 31.79 0 0044.59-6.4l157.01-213.33h95.57v96.64L257.71 807.25a31.79 31.79 0 00-6.62 44.59l12.59 17.28a32 32 0 0044.8 6.83l160.85-118.62V905.4a32 32 0 0032 32h21.34a32 32 0 0032-32V756.05l163.62 119.47a32 32 0 0044.8-7.04l12.59-17.28a31.79 31.79 0 00-7.68-43.95L554.67 651.1v-96.42h100.05L810.67 768a32 32 0 0044.8 6.83l17.28-12.38a32 32 0 006.82-44.8L760.32 554.67h168.1a32 32 0 0031.58-32v-21.34a32 32 0 00-31.57-32z"
      }
    }]
  },
  "name": "frozen-stroke"
};
a['FullPageStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M139.95 298.67h-64A10.88 10.88 0 0165.28 288V96a32 32 0 0132-32h192a10.67 10.67 0 0110.67 10.67v64a10.67 10.67 0 01-10.67 10.66H150.61V287.8a10.67 10.67 0 01-10.66 10.88zm810.66-1.71h-64a10.67 10.67 0 01-10.66-10.67V149.33h-139.1a10.67 10.67 0 01-10.66-10.66v-64A10.67 10.67 0 01736.85 64h192a32 32 0 0132 32v192a10.88 10.88 0 01-10.24 8.96zM929.28 960h-192a10.67 10.67 0 01-10.67-10.67v-64a10.67 10.67 0 0110.67-10.66H876.8V736a10.67 10.67 0 0110.67-10.67h64A10.67 10.67 0 01962.13 736v192a32 32 0 01-32.85 32zm-639.57 0h-192a32 32 0 01-32-32V736a10.67 10.67 0 0110.66-10.67h64A10.67 10.67 0 01151.04 736v138.67h139.1a10.67 10.67 0 0110.66 10.66v64A10.88 10.88 0 01289.7 960zM364.8 294.83h297.39q64 0 64 64v301.01q0 64-64 64H364.8q-64 0-64-64V358.83q0-64 64-64z"
      }
    }]
  },
  "name": "full-page-stroke"
};
a['FullscreenExitStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M332.16 392.1l-49.28 49.29c-10.03 10.02-2.99 27.3 11.3 27.3l142.94.64c17.7 0 32.21-14.5 32.21-32.21l-1.06-142.72c0-14.3-17.28-21.33-27.31-11.3l-48.64 48.63L204.59 144c-17.07-17.07-40.96-20.7-53.55-8.32l-14.72 15.36c-12.59 12.37-8.96 36.48 8.1 53.33l187.74 187.74zm360.1 239.37l48.86-48.86c10.03-10.02 2.99-27.3-11.3-27.3l-142.94-.64a32.32 32.32 0 00-32.21 32.21l1.06 142.72c0 14.3 17.28 21.33 27.31 11.3l49.07-49.06 187.09 187.1c17.07 17.06 40.96 20.69 53.55 8.31l15.14-15.14c12.59-12.59 8.75-36.48-8.32-53.55l-187.3-187.1zm-254.71-76.8l-142.72 1.06c-14.3 0-21.34 17.28-11.31 27.31l48.21 48.21-187.3 187.31c-17.07 17.07-20.7 40.96-8.32 53.55l15.14 15.14c12.59 12.59 36.48 8.75 53.55-8.32l187.3-187.3 49.71 49.7c10.03 10.03 27.31 2.99 27.31-11.3l.64-143.15c0-17.92-14.3-32.43-32.21-32.21zm149.33-85.34l142.72-1.06c14.3 0 21.33-17.28 11.3-27.31l-48.85-48.85L879.8 204.37c17.06-17.06 20.69-40.96 8.32-53.54l-15.15-15.15c-12.59-12.59-36.48-8.75-53.55 8.32L631.68 331.73l-48.85-48.85c-10.03-10.03-27.31-2.99-27.31 11.3l-.85 142.94c0 17.92 14.5 32.43 32.21 32.21z"
      }
    }]
  },
  "name": "fullscreen-exit-stroke"
};
a['FullscreenStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M266.24 205.82l49.15-49.15c10.24-10.24 3.07-27.13-11.26-27.13l-142.85-.52a32.12 32.12 0 00-32.26 32.26l1.03 142.85c0 14.33 17.4 21.5 27.13 11.26l48.64-48.64 187.9 187.9c16.9 16.9 40.97 20.49 53.77 8.2l14.85-15.36c12.8-12.29 9.21-36.35-8.2-53.25l-187.9-188.42zm491.52 611.84l-48.64 48.64c-10.24 10.24-3.07 27.14 11.26 27.14l142.85.51a32.12 32.12 0 0032.26-32.25l-1.03-142.85c0-14.34-17.4-21.5-27.13-11.27l-49.15 49.16L631.3 569.86c-16.9-16.9-40.96-20.48-53.76-8.2l-15.36 15.36c-12.8 12.8-8.7 36.36 8.19 53.76l187.39 186.88zm-597 76.8l142.86-1.02c14.33 0 21.5-17.4 11.26-27.14l-48.13-48.12 187.4-187.4c16.89-16.9 20.47-40.96 8.19-53.76l-15.36-15.36c-12.8-12.8-36.36-8.7-53.76 8.2l-186.88 187.9-49.67-49.66c-10.24-10.24-27.13-3.08-27.13 11.26l-.52 143.36c0 17.4 13.83 32.26 31.75 31.74zm702.47-765.95l-142.85 1.03c-14.33 0-21.5 17.4-11.26 27.13l48.64 48.64-187.9 187.9c-16.9 16.9-20.48 40.97-8.2 53.77l15.36 15.36c12.8 12.8 36.36 8.7 53.76-8.2l187.9-187.9 48.65 48.64c10.24 10.24 27.13 3.07 27.13-11.26l1.03-142.85c0-18.43-14.34-32.77-32.26-32.26z"
      }
    }]
  },
  "name": "fullscreen-stroke"
};
a['GiftFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M611.84 314.24h-67.2V247a67.2 67.2 0 1167.2 67.2zm-132.48 0h-67.2a67.2 67.2 0 1167.2-67.2zm385.92 3.84h-141.7A132.41 132.41 0 00512 160.06a132.4 132.4 0 00-211.58 158h-141.7A30.69 30.69 0 00128 348.8v134.4h351.36V318.08h65.28V483.2H896V348.8a30.69 30.69 0 00-30.72-30.72zM544.64 909.44H819.2a30.69 30.69 0 0030.72-30.72V548.48H544.64zm-370.56-30.72a30.69 30.69 0 0030.72 30.72h274.56v-361H174.08z"
      }
    }]
  },
  "name": "gift-fill"
};
a['GiftStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M881.28 277.33h-128a146.99 146.99 0 0014.72-64A149.33 149.33 0 00512 108.6a149.33 149.33 0 00-256 104.74 146.99 146.99 0 0014.3 64h-128a64 64 0 00-64 64v149.34a64 64 0 0052.69 62.72V896a64 64 0 0064 64h633.6a64 64 0 0064-64V551.9a64 64 0 0052.69-62.73V341.33a64 64 0 00-64-64zm-21.33 192H554.67V362.67h305.28zm-241.28-320a64 64 0 014.26 128h-68.26v-68.26a64 64 0 0164-59.74zm-277.34 64a64 64 0 01128-4.26v68.26H401.5a64 64 0 01-60.16-64zM164.05 362.67h305.28v105.17H164.05zm52.7 512v-321.5h252.58v321.5zm337.92 0v-321.5h252.58v321.5z"
      }
    }]
  },
  "name": "gift-stroke"
};
a['GreateThanStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M877.65 554.67a32.21 32.21 0 00-12.37 2.56L125.65 868.48a31.57 31.57 0 00-17.06 42.67l8.1 19.62a32.64 32.64 0 0042.67 17.28l738.99-311.89a31.79 31.79 0 0017.06-42.67l-8.1-19.62a32.21 32.21 0 00-29.66-19.2zM146.35 76.59a32.21 32.21 0 00-29.66 19.62l-8.1 19.63a31.79 31.79 0 0017.06 42.67l622.72 261.12 110.3-46.3L158.72 79.15a32.21 32.21 0 00-12.37-2.56z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M748.37 419.63L125.65 681.39a31.79 31.79 0 00-17.06 42.66l8.1 19.63a32 32 0 0042.67 17.07l699.3-294.83-110.29-46.3zm149.98-29.44h.21-.21zm-12.38-2.56a32 32 0 1012.59 2.56 29.87 29.87 0 00-12.37-2.56z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M858.67 373.33l-110.3 46.3 110.3 46.29 40.1-16.85a32.85 32.85 0 01-12.8 2.77 32 32 0 010-64 30.3 30.3 0 0111.74 2.35l-39.04-16.43z"
      }
    }]
  },
  "name": "greate-than-stroke"
};
a['GroupFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M880 112H274a8 8 0 00-8 8v56a8 8 0 008 8h566v556a8 8 0 008 8h56a8 8 0 008-8V144a32 32 0 00-32-32zM752 240H154a32 32 0 00-32 32v588a32 32 0 0032 32h598a32 32 0 0032-32V272a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "group-fill"
};
a['GroupStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M880 112H274a8 8 0 00-8 8v56a8 8 0 008 8h566v556a8 8 0 008 8h56a8 8 0 008-8V144a32 32 0 00-32-32zM712 820H194V312h518v508zm40-580H154a32 32 0 00-32 32v588a32 32 0 0032 32h598a32 32 0 0032-32V272a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "group-stroke"
};
a['GroupTopicStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M806 125h-64a8 8 0 00-8 8v339H290V133a8 8 0 00-8-8h-64a8 8 0 00-8 8v758a8 8 0 008 8h64a8 8 0 008-8V552h444v339a8 8 0 008 8h64a8 8 0 008-8V133a8 8 0 00-8-8z"
      }
    }]
  },
  "name": "group-topic-stroke"
};
a['GroupingFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M373.33 190.93H480q32 0 32 32v21.34q0 32-32 32H373.33q-32 0-32-32v-21.34q0-32 32-32z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M853.33 469.33v-192a64 64 0 00-64-64H682.67V128a64 64 0 00-64-64h-384a64 64 0 00-64 64v341.33a64 64 0 00-64 64V896a64 64 0 0064 64h682.66a64 64 0 0064-64V533.33a64 64 0 00-64-64zm-256-256v405.34h-128v-85.34a64 64 0 00-64-64H256v-320h341.33zm170.67 256h-85.33V298.67H768z"
      }
    }]
  },
  "name": "grouping-fill"
};
a['GroupingStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M480 192H373.33a32 32 0 00-32 32v21.33a32 32 0 0032 32H480a32 32 0 0032-32V224a32 32 0 00-32-32z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M768 298.67v170.66h-85.33V298.67H768M618.67 64h-384a64 64 0 00-64 64v341.33a64 64 0 00-64 64V896a64 64 0 0064 64h682.66a64 64 0 0064-64V533.33a64 64 0 00-64-64v-192a64 64 0 00-64-64H682.67V128a64 64 0 00-64-64zM256 469.33v-320h341.33v469.34h-128v-85.34a64 64 0 00-64-64H256zM448 704h170.67a64 64 0 0064-64v-85.33H832v320H192v-320h192V640a64 64 0 0064 64z"
      }
    }]
  },
  "name": "grouping-stroke"
};
a['HandClickStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M274.13 297.17a42.67 42.67 0 0042.67-35.2 140.8 140.8 0 01276.05 0 42.67 42.67 0 0042.67 35.2 41.39 41.39 0 0032.43-15.36 42.67 42.67 0 008.96-35.62 226.13 226.13 0 00-443.74 0 42.67 42.67 0 0040.96 50.98z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M853.33 621.01c-2.34-47.36-14.72-65.49-42.66-79.14l-232.11-72.54a10.24 10.24 0 01-7.47-10.02V345.6a99.84 99.84 0 00-86.82-100.7h-31.79a96.64 96.64 0 00-96.64 96.43v285.44c-34.77-36.05-106.67-45.65-142.3-9.38l-1.49 1.28c-30.93 31.14-64 77.44-25.17 132.48 4.05 6.61 139.52 182.18 139.52 182.18 23.04 29.23 59.95 26.67 82.77 26.67H768a87.04 87.04 0 0087.04-87.47zm-448 253.66a32.85 32.85 0 01-26.24-13.02C333.44 801.5 275.41 724.48 263.25 707.2a13.23 13.23 0 010-14.72 21.33 21.33 0 0135.42-1.5l80.85 72.75a36.9 36.9 0 0052.05-2.77 36.27 36.27 0 009.6-24.53v-395.1a11.52 11.52 0 013.2-8.1 10.03 10.03 0 018.11-3.42h1.5c4.47 0 31.14-7.04 31.35 15.79v161.5a32.21 32.21 0 0023.26 30.93l38.82 11.09 192 59.52A40.96 40.96 0 01768 647.89l1.92 225.28z"
      }
    }]
  },
  "name": "hand-click-stroke"
};
a['HeartFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M960 384a260.48 260.48 0 00-448-180.48A260.48 260.48 0 0064 384v2.13a260.48 260.48 0 0046.5 147.2 531.42 531.42 0 0024.75 40.75 909.87 909.87 0 00138.88 157.23 1563.1 1563.1 0 00195.2 152.96l8.11 5.12a64 64 0 0068.9 0l8.33-5.12A1613.23 1613.23 0 00750.29 731.3a909.87 909.87 0 00138.88-157.23A493.01 493.01 0 00915 531.41 258.99 258.99 0 00960 385.28V384z"
      }
    }]
  },
  "name": "heart-fill"
};
a['HeartStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M698.88 209.92A175.15 175.15 0 01874.67 384v4.05A171.95 171.95 0 01845 483.63l-2.56 3.84-2.13 4.05a384 384 0 01-21.33 34.77A833.7 833.7 0 01692.9 669.01 1504.85 1504.85 0 01512 810.67a1463.9 1463.9 0 01-179.84-142.3 815.57 815.57 0 01-125.44-141.86c-6.83-10.03-13.44-21.34-21.33-33.28l-2.14-3.84-2.34-3.63a174.3 174.3 0 01-31.58-98.13V384a175.15 175.15 0 01300.8-120.75L512 325.97l61.23-62.93a173.44 173.44 0 01125.65-53.12m0-85.33A260.48 260.48 0 00512 203.52a261.12 261.12 0 00-186.88-78.93A260.7 260.7 0 0064 384v2.13a260.48 260.48 0 0046.5 147.2 531.42 531.42 0 0024.75 40.75 909.87 909.87 0 00138.88 157.23 1563.1 1563.1 0 00195.2 152.96l8.11 5.12a64 64 0 0068.9 0l8.33-5.12A1613.23 1613.23 0 00750.29 731.3a909.87 909.87 0 00138.88-157.23c9.39-14.08 17.92-28.59 25.82-42.67A258.99 258.99 0 00960 385.28V384a260.27 260.27 0 00-261.12-259.41z"
      }
    }]
  },
  "name": "heart-stroke"
};
a['HomeFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M939.78 496.87l-405-410.51a32 32 0 00-45.56 0l-405 410.51c-20 20.22-5.63 54.48 22.78 54.48h88.31v342.81a8 8 0 008 8H461.5l-.15-251.63h101.3l-.15 251.63h258.19a8 8 0 008-8V551.35H917c28.41 0 42.73-34.26 22.78-54.48z"
      }
    }]
  },
  "name": "home-fill"
};
a['HomeMFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M874.67 337.07L571.73 110.93c-38.4-29.86-89.6-29.86-123.73 0L149.33 337.07c-25.6 21.33-42.66 51.2-42.66 85.33v435.2c0 59.73 46.93 102.4 102.4 102.4h601.6c59.73 0 102.4-46.93 102.4-102.4V418.13c4.26-29.86-12.8-64-38.4-81.06zm-320 388.26c0 25.6-17.07 42.67-42.67 42.67s-42.67-17.07-42.67-42.67V554.67c0-25.6 17.07-42.67 42.67-42.67s42.67 17.07 42.67 42.67v170.66z"
      }
    }]
  },
  "name": "home-m-fill"
};
a['HomeMStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M475.9 104.83a73.81 73.81 0 0174.8 1.54l5.55 3.75 69.16 51.84a32 32 0 01-34.4 53.76l-3.96-2.56-69.2-51.8a11.35 11.35 0 00-7.22-2.17l-1.62.34-2.86 1.84-312.1 233.8a12.89 12.89 0 00-2.56 2.57l-1.03 1.8-.3 3.4v451.84c0 4.01 2.35 7.47 4.87 8.92l1.88.68 2.98.22h624.22a10.62 10.62 0 008.83-4.87l.68-1.87.21-3.03V402.99c0-1.33-.25-2.6-.55-3.63l-.77-1.92-2.56-2.3-102.74-76.97a32 32 0 0134.35-53.76l4 2.56 104.41 78.29 5.85 5.12a73.74 73.74 0 0121.67 45.23l.34 7.38v453.67l-.46 6.79a73.81 73.81 0 01-66.74 64.85l-6.57.3-626-.05-6.74-.42a73.81 73.81 0 01-64.86-66.78l-.3-6.52.05-453.98.6-7.72a73.81 73.81 0 0123.2-44.5l5.68-4.7 313.81-235 6.4-4.1z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M512 511.7a40.73 40.73 0 0138.4 42.67v170.66A40.7 40.7 0 01512 767.7a40.7 40.7 0 01-38.4-42.67V554.37A40.7 40.7 0 01512 511.7z"
      }
    }]
  },
  "name": "home-m-stroke"
};
a['HomeStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M939.78 496.87l-405-410.51a32 32 0 00-45.56 0l-405 410.51c-20 20.22-5.63 54.48 22.78 54.48h88.31v342.81a8 8 0 008 8h617.38a8 8 0 008-8V551.35H917c28.41 0 42.73-34.26 22.78-54.48zM562.65 838.16h-101.3V650.53h101.3zm202-350.81v350.81h-138V618.53a32 32 0 00-32-32h-165.3a32 32 0 00-32 32v219.63h-138V487.35h-75.83L512 154.4l328.48 333z"
      }
    }]
  },
  "name": "home-stroke"
};
a['HourglassStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M757.33 315.52V149.33h85.34a32 32 0 0032-32V96a32 32 0 00-32-32H181.33a32 32 0 00-32 32v21.33a32 32 0 0032 32h85.34v166.19A239.36 239.36 0 00370.13 512a239.36 239.36 0 00-103.46 196.48v166.19h-85.34a32 32 0 00-32 32V928a32 32 0 0032 32h661.34a32 32 0 0032-32v-21.33a32 32 0 00-32-32h-85.34V708.48A239.36 239.36 0 00653.87 512a239.36 239.36 0 00103.46-196.48zM672 714.67v160H352V708.48a154.03 154.03 0 01153.81-153.81h12.38A154.03 154.03 0 01672 708.48v6.19zm0-405.34v6.19a154.03 154.03 0 01-153.81 153.81H505.8A154.03 154.03 0 01352 315.52V149.33h320v160z"
      }
    }]
  },
  "name": "hourglass-stroke"
};
a['IdCardStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 128H128a64 64 0 00-64 64v640a64 64 0 0064 64h768a64 64 0 0064-64V192a64 64 0 00-64-64zm-21.33 682.67H149.33V213.33h725.34zM224 383.36h106.67q32 0 32 32v21.33q0 32-32 32H224q-32 0-32-32v-21.33q0-32 32-32zm0 213.76h106.67q32 0 32 32v21.33q0 32-32 32H224q-32 0-32-32v-21.33q0-32 32-32zm237.65 128.21h23.04a31.36 31.36 0 0030.08-25.81 128 128 0 01250.67 0 30.93 30.93 0 0030.08 25.81h23.04a32.21 32.21 0 0031.36-38.4 213.33 213.33 0 00-96.43-142.08A147.63 147.63 0 00789.33 448a149.33 149.33 0 00-298.66 0 147.84 147.84 0 0036.05 96.85 213.33 213.33 0 00-96.43 142.08 32.21 32.21 0 0031.36 38.4zM640 384a64 64 0 11-64 64 64 64 0 0164-64z"
      }
    }]
  },
  "name": "id-card-stroke"
};
a['ImageWatermarkStoke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M847.57 950.19H129.28a64 64 0 01-64-64V123.73a64 64 0 0164-64h333.87a32 32 0 0132 32v21.34a32 32 0 01-32 32H150.6v719.78h675.63l-1.5-367.57a32 32 0 0131.8-32.21h21.33a31.79 31.79 0 0132.21 31.78l1.5 389.12a64 64 0 01-64 64.22z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M820.48 381.87c-64 0-101.33-36.27-130.77-65.5-25.6-25.17-41.39-39.68-67.42-41.17a51.84 51.84 0 00-40.53 13.01 38.61 38.61 0 00-10.03 14.51 17.7 17.7 0 01-16.85 10.67h-51.63a17.28 17.28 0 01-17.06-19.84 123.52 123.52 0 0137.12-67.63 138.67 138.67 0 01104.53-36.05c58.88 3.84 93.87 38.18 121.81 65.7s42.67 40.96 70.83 40.96a55.47 55.47 0 0061.23-45.44 16.85 16.85 0 0116.64-13.65h51.84a17.07 17.07 0 0117.06 19.2 140.8 140.8 0 01-146.77 125.23zM451.2 932.9l-68.7-50.78 270.3-365.01a32 32 0 0151.2-1.5l198.19 236.8-65.28 54.83L682.03 622.3z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M529.7 682.67L295.05 419.4l-160.43 192-65.06-53.76 200.1-239.78a32 32 0 0148.43 0l275.2 309.33z"
      }
    }]
  },
  "name": "Image-watermark-stoke"
};
a['InfoCirlceFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 52.78a458.67 458.67 0 10458.67 458.67A458.67 458.67 0 00512 52.78zM448 244.9a52.37 52.37 0 0152.37-52.38h1.92a52.37 52.37 0 0152.38 52.38v1.92a52.37 52.37 0 01-52.38 52.37h-1.92A52.37 52.37 0 01448 246.85zm224 512.42a32 32 0 01-32 32H384a32 32 0 01-32-32V736a32 32 0 0132-32h85.33V426.11H416a32 32 0 01-32-32v-21.33a32 32 0 0132-32h106.67a32 32 0 0132 32V704H640a32 32 0 0132 32z"
      }
    }]
  },
  "name": "info-cirlce-fill"
};
a['InfoCirlceStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M500.37 192.53h1.92a52.37 52.37 0 0152.38 52.38v1.92a52.37 52.37 0 01-52.38 52.37h-1.92A52.37 52.37 0 01448 246.85v-1.94a52.37 52.37 0 0152.37-52.38zM640 704h-85.33V372.78a32 32 0 00-32-32H416a32 32 0 00-32 32v21.33a32 32 0 0032 32h53.33V704H384a32 32 0 00-32 32v21.33a32 32 0 0032 32h256a32 32 0 0032-32V736a32 32 0 00-32-32zM512 52.93a458.67 458.67 0 10458.67 458.66A458.67 458.67 0 00512 52.93zm0 829.97a371.3 371.3 0 11371.3-371.3A371.71 371.71 0 01512 882.9z"
      }
    }]
  },
  "name": "info-cirlce-stroke"
};
a['InfoStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M448 195a64 64 0 1064-64 64 64 0 00-64 64zm96 168h-64a8 8 0 00-8 8v464a8 8 0 008 8h64a8 8 0 008-8V371a8 8 0 00-8-8z"
      }
    }]
  },
  "name": "info-stroke"
};
a['InsertBehindStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M159.57 876.8h704q32 0 32 32v21.33q0 32-32 32h-704q-32 0-32-32V908.8q0-32 32-32zM832 64H192a64 64 0 00-64 64v640a64 64 0 0064 64h640a64 64 0 0064-64V128a64 64 0 00-64-64zm-21.33 682.67H213.33V149.33h597.34z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M330.24 490.67h139.1v138.66a32 32 0 0032 32h21.33a32.21 32.21 0 0032-32V490.67h138.66a32.21 32.21 0 0032-32v-21.34a32 32 0 00-32-32H554.67V266.67a32 32 0 00-32-32h-21.34a32 32 0 00-32 32v138.66H330.67a32 32 0 00-32 32v21.34a32 32 0 0031.57 32z"
      }
    }]
  },
  "name": "insert-behind-stroke"
};
a['InsertBottomStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M128.58 951.23V891.2c0-5.31 2.75-8 8.32-8h698.24c5.5 0 8.32 2.69 8.32 8v60.03c0 5.31-2.82 8-8.32 8h-698.3c-5.58 0-8.33-2.69-8.33-8zM771 200v540.03H200v-540.1h571M811 128H160a32 32 0 00-32 32v620.03a32 32 0 0032 32h651a32 32 0 0032-32V160a32 32 0 00-32-32zM303.1 446.02c0-4.48 3.59-8 8-8h142.02V296a8 8 0 018-8h48a8 8 0 018 8v142.02h142.02a8 8 0 018 8v48a8 8 0 01-8 8H517.12v141.95a8 8 0 01-8 8.06h-48a8 8 0 01-8-8.06V502.08H311.1a8 8 0 01-8-8v-48z"
      }
    }]
  },
  "name": "insert-bottom-stroke"
};
a['InsertFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M357.12 122.03h515.2q64.43 0 64.43 64.42v651.1q0 64.42-64.43 64.42h-515.2q-64.43 0-64.43-64.42v-651.1q0-64.42 64.43-64.42zm-174.3 779.94h-64c-17.49 0-31.78-9.81-31.78-21.33V144.43c0-11.95 14.3-21.34 31.79-21.34h64c17.7 0 32 9.82 32 21.34V880.2c0 11.95-14.3 21.76-32 21.76z"
      }
    }]
  },
  "name": "insert-fill"
};
a['InsertFrontStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M331.1 618.67h138.23v138.66a32 32 0 0032 32h21.34a32 32 0 0032-32V618.67h138.66a32 32 0 0032-32v-21.34a32 32 0 00-32-32H554.67V394.67a32 32 0 00-32-32h-21.34a32 32 0 00-32 32v138.66H330.67a32 32 0 00-32 32v21.34a32 32 0 0032.42 32zM160.43 62.3h704q32 0 32 32v21.33q0 32-32 32h-704q-32 0-32-32V94.29q0-32 32-32z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M832 192H192a64 64 0 00-64 64v640a64 64 0 0064 64h640a64 64 0 0064-64V256a64 64 0 00-64-64zm-21.33 682.67H213.33V277.33h597.34z"
      }
    }]
  },
  "name": "insert-front-stroke"
};
a['InsertLeftFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M897.07 128h-640a64 64 0 00-64 64v640a64 64 0 0064 64h640a64 64 0 0064-64V192a64 64 0 00-64-64zM790.4 521.81a32 32 0 01-32 32H619.73v138.67a32 32 0 01-32 32H566.4a32.21 32.21 0 01-32-32V554.67H395.73a32.21 32.21 0 01-32-32v-21.34a32 32 0 0132-32H534.4V330.67a32 32 0 0132-32h21.33a32 32 0 0132 32v138.66H758.4a32 32 0 0132 32zM94.93 127.57h21.34q32 0 32 32v704q0 32-32 32H94.93q-32 0-32-32v-704q0-32 32-32z"
      }
    }]
  },
  "name": "insert-left-fill"
};
a['InsertLeftStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M949.33 169.39a32 32 0 0032-32v-21.34a32 32 0 00-32-32H810.67a64 64 0 00-64 64V873.4a64 64 0 0064 64h138.66a32 32 0 0032-32.86V883.2a32 32 0 00-32-32H832V168.53zM628.91 467.63H415.57V254.29a32 32 0 00-32-32h-20.9a32 32 0 00-32 32v213.34H117.33a32 32 0 00-32 32v21.33a32 32 0 0032 32h213.34v213.33a32 32 0 0032 32H384a32 32 0 0032-32V552.96h213.33a32 32 0 0032-32v-21.33a32 32 0 00-32.42-32z"
      }
    }]
  },
  "name": "insert-left-stroke"
};
a['InsertRightFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M910.93 130.13h21.34c17.06 0 32 14.94 32 32v704c0 17.07-14.94 32-32 32h-21.34c-17.06 0-32-14.93-32-32v-704c0-19.2 14.94-32 32-32zM770.13 128h-640c-36.26 0-64 27.73-64 64v640c0 36.27 27.74 64 64 64h640c36.27 0 64-27.73 64-64V192c0-36.27-27.73-64-64-64zM663.47 522.67c0 17.06-14.94 32-32 32H492.8v138.66c0 17.07-14.93 32-32 32h-21.33c-17.07 0-32-14.93-32-32V554.67H268.8c-17.07 0-32-14.94-32-32v-21.34c0-17.06 14.93-32 32-32h138.67V330.67c0-17.07 14.93-32 32-32h21.33c17.07 0 32 14.93 32 32v138.66h138.67c17.06 0 32 14.94 32 32v21.34z"
      }
    }]
  },
  "name": "insert-right-fill"
};
a['InsertRightStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M213.33 84.05H74.67a32 32 0 00-32 32v21.34a32 32 0 0032 32H192v682.66H74.67a32 32 0 00-32 31.15v21.33a32 32 0 0032 32h138.66a64 64 0 0064-64V147.2a64 64 0 00-64-63.15zm692.91 383.58H692.91V254.29a32 32 0 00-32-32H640a32 32 0 00-32 32v213.34H394.67a32 32 0 00-32 32v21.33a32 32 0 0032 32H608v213.33a32 32 0 0032 32h21.33a32 32 0 0032-32V552.96h213.34a32 32 0 0032-32v-21.33a32 32 0 00-32.43-32z"
      }
    }]
  },
  "name": "insert-right-stroke"
};
a['InsertTopStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M128.58 196.03V136c0-5.31 2.75-8 8.32-8h698.24c5.5 0 8.32 2.69 8.32 8v60.03c0 5.31-2.82 7.94-8.32 7.94h-698.3c-5.58 0-8.33-2.63-8.33-7.94zM771 347.2v540.03H200V347.2h571m40-72H160a32 32 0 00-32 32v620.03a32 32 0 0032 32h651a32 32 0 0032-32V307.2a32 32 0 00-32-32zM303.1 593.22c0-4.48 3.59-8 8-8h142.02V443.2a8 8 0 018-8h48a8 8 0 018 8v142.02h142.02a8 8 0 018 8v48a8 8 0 01-8 8H517.12v142.01a8 8 0 01-8 8h-48a8 8 0 01-8-8V649.15H311.1a8 8 0 01-8-7.93v-48z"
      }
    }]
  },
  "name": "insert-top-stroke"
};
a['KeyStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M597.33 64a341.33 341.33 0 00-240 583.47l-42.66 42.66L264.53 640a31.57 31.57 0 00-22.61-9.39 30.93 30.93 0 00-22.61 9.39l-15.15 14.93a32 32 0 000 45.44l49.92 49.92L208 796.8a33.28 33.28 0 00-4.9-7.47l-48.65-48.42a32 32 0 00-45.22 0l-15.15 15.14a32.21 32.21 0 000 45.23l48.64 48.64a33.28 33.28 0 007.25 4.9l-42.66 42.67a32.21 32.21 0 000 45.23l15.14 15.15a32.43 32.43 0 0045.23 0l258.99-258.14A341.33 341.33 0 10597.33 64zm0 597.33a256 256 0 11256-256 256 256 0 01-256 256z"
      }
    }]
  },
  "name": "key-stroke"
};
a['KeyboardCommandStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M666.19 244.62c31.37 0 58.27 11.12 80.2 33.18 21.93 22.04 32.99 48.87 32.99 80.01 0 30.91-11.06 57.73-32.95 79.98-19.73 20.06-43.24 31.18-70.15 33.21l-9.1.34-48.01-.01v81.3l48.01.03c24.6 0 46.53 7.2 65.54 21.5l7 5.7 6.7 6.35c21.9 22.25 32.96 48.95 32.96 79.64 0 31.36-11.06 58.3-32.98 80.35-21.94 22.06-48.84 33.18-80.21 33.18-31.14 0-58.01-11.06-80.16-32.96-19.96-19.74-31.02-43.24-33.04-70.14l-.33-9.1-.04-48.01h-81.29l.01 48.01c0 24.59-7.17 46.51-21.38 65.53l-5.66 6.99-6.32 6.71c-22.16 21.92-49.03 32.97-80.17 32.97s-57.98-11.12-80.02-33.17c-22.05-22.04-33.17-49-33.17-80.36 0-30.7 11.12-57.4 33.13-79.66 19.83-20.04 43.3-31.16 70.03-33.19l9.03-.34 47.98-.04v-81.29l-47.98.01c-24.4 0-46.26-7.2-65.3-21.5l-7.01-5.68-6.75-6.35c-22.01-22.25-33.13-49.08-33.13-80 0-31.14 11.12-57.98 33.17-80.02 22.04-22.05 48.88-33.17 80.02-33.17 31.14 0 58.01 11.06 80.16 32.96 19.96 19.74 31.02 43.24 33.04 70.14l.33 9.1-.01 47.97h81.3l.03-47.98c0-24.58 7.17-46.5 21.38-65.52l5.66-6.99 6.32-6.71c22.16-21.92 49.03-32.97 80.17-32.97zm-261.4 374.55l-46.65.03c-13.02 0-23.93 4.52-33.2 13.8-9.26 9.26-13.78 20.06-13.78 32.85 0 13.03 4.53 23.94 13.79 33.2 9.26 9.26 20.17 13.8 33.2 13.8 12.8 0 23.6-4.53 32.86-13.8 7.95-7.95 12.4-17 13.52-27.5l.27-5.36v-47.02zm214.38 0l.03 47.02c0 12.8 4.52 23.59 13.8 32.86 9.25 9.26 20.16 13.8 33.19 13.8 13.01 0 23.85-4.53 33-13.77 9.16-9.26 13.65-20.18 13.65-33.22 0-12.8-4.52-23.6-13.79-32.87-7.95-7.95-17-12.4-27.5-13.52l-5.36-.27-47.02-.03zM357.8 311.16c-12.81 0-23.62 4.48-32.89 13.65-9.24 9.15-13.77 19.99-13.77 33 0 13.03 4.54 23.94 13.8 33.2 7.94 7.94 17.09 12.4 27.74 13.52l5.46.27h46.64l.01-46.99c0-11.15-3.32-20.7-10.09-28.97l-3.67-4.03c-6.61-6.54-14.08-10.7-22.55-12.55l-5.21-.83-5.47-.27zm308.38 0c-13.05 0-23.97 4.49-33.23 13.65-7.92 7.85-12.38 16.93-13.48 27.56l-.28 5.44-.03 46.98 47.02.01c10.96 0 20.46-3.32 28.8-10.1l4.06-3.7c9.26-9.25 13.8-20.16 13.8-33.19 0-13.03-4.49-23.88-13.63-33.03-9.15-9.14-20-13.62-33.03-13.62zM552.62 471.32h-81.29v81.3h81.3v-81.3z"
      }
    }]
  },
  "name": "keyboard-command-stroke"
};
a['KeyboardCtrlStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M499.33 350.9c8.9 0 16.51 2.96 22.21 8.9 4.53 4.72 7.2 10.71 8.08 17.72l.32 5.44v46.82l8.37.04c15.42 0 25.9 6.5 29.37 18.35l.96 4.7.28 4.64c0 16.12-9.53 25.81-25.6 27.44l-5 .24-8.38-.03v193.05c0 5.63-.98 10.71-3 15.16l-2.35 4.23-3.05 3.77c-5.7 5.94-13.3 8.91-22.2 8.91-8.9 0-16.51-2.97-22.22-8.9-4.52-4.72-7.18-10.71-8.07-17.73l-.33-5.44-.03-193.05-8.33.03c-13.8 0-23.64-5.19-28.04-14.76-.24 6.15-2.66 11.81-6.94 16.73-5.02 5.77-11.78 8.76-19.6 8.76-5.51 0-10.5-1-14.88-3.08l-9.96-4.5a116.2 116.2 0 00-11.73-4.29c-3.72-1.15-8.93-1.78-15.55-1.78-11.68 0-21.38 2.5-29.27 7.4a61.8 61.8 0 00-19.98 19.75 94.32 94.32 0 00-11.76 28 129.93 129.93 0 00-3.86 31.17 130 130 0 003.86 31.17 94.32 94.32 0 0011.76 28 61.8 61.8 0 0019.98 19.76c7.9 4.89 17.59 7.38 29.27 7.38 6.66 0 12.08-.63 16.2-1.83 4.48-1.3 8.3-2.78 11.47-4.43 3.83-2 7.35-3.76 10.54-5.28a31.13 31.13 0 0113.43-3.07c7.24 0 13.57 2.45 18.43 7.32 4.96 4.96 7.31 11.77 7.31 19.88 0 11.88-7.68 22.05-21.63 30.7-13.21 8.19-31.78 12.1-55.75 12.1-21.17 0-39.79-3.96-55.75-11.94-15.8-7.9-29.05-18.58-39.63-32-10.48-13.27-18.25-28.44-23.28-45.46a183.4 183.4 0 01-7.44-52.3c0-18.1 2.48-35.53 7.44-52.3 5.03-17.02 12.8-32.2 23.28-45.47 10.58-13.41 23.82-24.09 39.63-32 15.96-7.98 34.58-11.93 55.75-11.93 23.46 0 42.02 3.52 55.72 10.83 9.96 5.31 16.95 11.7 20.48 19.17.14-15.77 9.64-25.24 25.54-26.83l4.96-.24 8.33-.04.03-46.82c0-5.63.99-10.71 3-15.16l2.36-4.23 3.04-3.77c5.7-5.94 13.31-8.9 22.21-8.9zm193.9 76c9.78 0 17.97 2.95 24.04 9.02 5.96 5.95 9.02 13.5 9.02 22.07 0 15.9-10.38 26.41-28.79 31.2l-5.75 1.25a67.06 67.06 0 00-17.14 5.4 46.73 46.73 0 00-15.3 11.23c-4.58 5-8.47 11.38-11.65 19.18-2.47 6.07-3.98 13.4-4.5 22l-.18 6.7V678.2c0 9.38-2.75 17.27-8.4 23.16-5.7 5.94-13.32 8.91-22.22 8.91-8.9 0-16.5-2.97-22.2-8.9-4.53-4.72-7.2-10.71-8.08-17.73l-.33-5.44V458.97c0-9.38 2.74-17.27 8.4-23.17 5.7-5.94 13.32-8.9 22.21-8.9 8.9 0 16.51 2.96 22.21 8.9a29.1 29.1 0 017.08 12.66l.97 5.23 4.42-4.7 5.34-4.98a78.02 78.02 0 0118.76-12.14 52.6 52.6 0 0122.1-4.98zm72.6-114.01c8.9 0 16.51 2.97 22.21 8.9 4.53 4.73 7.2 10.72 8.07 17.73l.33 5.44v333.25c0 9.38-2.74 17.27-8.4 23.16-5.7 5.94-13.31 8.91-22.2 8.91-8.91 0-16.52-2.97-22.22-8.9-4.53-4.72-7.19-10.71-8.08-17.73l-.32-5.44V344.96c0-9.38 2.74-17.26 8.4-23.16 5.7-5.94 13.32-8.91 22.21-8.91z"
      }
    }]
  },
  "name": "keyboard-ctrl-stroke"
};
a['KeyboardEnterStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M770.07 307.76l-170.03-.56a31.47 31.47 0 00-22.36 9.2 31.44 31.44 0 00-9.27 22.32v7.82c0 8.5 3.38 16.47 9.27 22.34l3.75 3.2a31.54 31.54 0 0018.47 6l125.44 1.26-1.2 145.12H382.45l76.49-64.29a31.52 31.52 0 003.78-44.53l-4.78-5.66a31.7 31.7 0 00-21.32-11.11 31.54 31.54 0 00-23.06 7.08l-186.01 153.8 186.01 153.81a31.69 31.69 0 0044.37-4.02l4.8-5.67a31.53 31.53 0 007.33-23.04l-.8-4.89a31.44 31.44 0 00-10.32-16.6l-76.54-64.33 387.17.02c7.09 0 13.82-2.86 18.76-7.83a26.48 26.48 0 007.71-18.64l.4-234.24a26.48 26.48 0 00-26.38-26.56z"
      }
    }]
  },
  "name": "keyboard-enter-stroke"
};
a['KeyboardEscStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M335.21 392.53c16.3 0 31.13 3.45 44.35 10.36a100.95 100.95 0 0132.65 26.77A119.72 119.72 0 01432 466.6a130.83 130.83 0 016.83 41.66c0 8.63-2.07 15.87-6.67 21.4-4.43 5.31-10.95 7.97-19.26 8.71l-5.21.22H286.83l.57 3.48 1.98 6.86a47.72 47.72 0 0010.08 16.78 47.22 47.22 0 0016.1 11.2c6.3 2.71 13.62 4.1 22.06 4.1 10.47 0 18.88-1.32 25.2-3.83 7.02-2.79 12.77-5.74 17.23-8.84 5-3.47 9.21-6.58 12.59-9.33 5.5-4.48 11.32-7 17.47-7 6.4 0 12.2 2.64 16.93 7.37 5.02 5.02 7.36 11.83 7.36 19.75 0 7.76-3.83 15.02-10.68 22.05-5.83 6-13.33 11.43-22.48 16.38a150.33 150.33 0 01-29.84 12 122.4 122.4 0 01-34.18 4.87c-18.83 0-35.3-3.36-49.31-10.22-13.86-6.78-25.42-15.98-34.55-27.54a111.9 111.9 0 01-19.73-38.97 160.19 160.19 0 01-6.07-44.21c0-15.71 2.4-30.82 7.22-45.28 4.86-14.58 11.83-27.48 20.9-38.63a100.97 100.97 0 0134-27c13.58-6.7 28.8-10.04 45.53-10.04zm194.1 0c8.13 0 16.8 1.04 26.04 3.1a118.42 118.42 0 0125.62 8.7c8.05 3.86 14.9 8.52 20.53 13.98 6.82 6.63 10.5 14.63 10.5 23.49 0 6.64-2.42 12.72-7 17.74-5.04 5.56-12.15 8.17-20.51 8.17a28.27 28.27 0 01-17.05-5.66l-10.13-7.34a60.4 60.4 0 00-11.52-6.24c-3.8-1.61-9.3-2.51-16.47-2.51-8.22 0-14.99 1.7-20.51 5.02-3.88 2.33-5.54 5.36-5.54 10.55 0 2.46 1.06 4.41 3.97 6.63 4.83 3.69 11.07 7.2 18.71 10.47a529.35 529.35 0 0027.01 10.64 179.5 179.5 0 0129.45 13.76 88.17 88.17 0 0124.24 20.6c7.35 9.1 11 20.36 11 33.34 0 13.09-2.65 24.68-8.03 34.63a74.62 74.62 0 01-20.65 24.2c-8.4 6.37-18 11.09-28.73 14.16a116.43 116.43 0 01-32.13 4.46 136.7 136.7 0 01-34.5-4.19c-10.63-2.77-20-6.3-28.08-10.65-8.42-4.52-15.23-9.73-20.37-15.7-5.81-6.75-9-13.96-9-21.54 0-7.75 2.58-14.56 7.77-19.74 5.03-5.04 11.26-7.77 18.13-7.77 6.5 0 12.69 2.12 18.32 6.15l3.85 2.7 9.07 6.1a87.64 87.64 0 0015.7 8c5.24 2.11 12.01 3.22 20.32 3.22 10.42 0 18.02-2.26 23.17-6.48 4.92-4.02 6.9-7.58 6.9-11.1 0-3.6-1.33-6.36-4.48-9.06-4.82-4.14-11.02-8.03-18.62-11.65a413.45 413.45 0 00-26.84-11.56 205.9 205.9 0 01-29.2-14.08c-9.59-5.62-17.66-12.4-24.17-20.3-7.38-8.95-11.06-19.92-11.06-32.43 0-11.85 2.63-22.52 7.94-31.83a72.59 72.59 0 0119.8-22.4 84.4 84.4 0 0126.98-13.3 104.98 104.98 0 0129.58-4.28zm198.14 0c19.97 0 35.9 3.02 47.85 9.4 13.42 7.16 21.14 16.84 21.14 29 0 6.57-2.37 12.63-6.82 17.75-4.88 5.62-11.53 8.55-19.08 8.55-5.1 0-9.78-.93-13.95-2.9l-8.12-3.68a91.52 91.52 0 00-9.3-3.39c-2.67-.83-6.6-1.3-11.72-1.3-8.98 0-16.29 1.88-22.18 5.53a47.26 47.26 0 00-15.3 15.12 74.01 74.01 0 00-9.23 22.01 103.57 103.57 0 00-3.1 24.86c0 8.2 1.03 16.47 3.1 24.86a74.01 74.01 0 009.24 22 47.26 47.26 0 0015.3 15.13c5.88 3.65 13.2 5.53 22.17 5.53 5.18 0 9.3-.48 12.32-1.36a55.07 55.07 0 006.21-2.18l11.42-5.64a29.55 29.55 0 0112.74-2.9c6.96 0 13.17 2.4 17.93 7.17 4.89 4.88 7.17 11.49 7.17 19.14 0 11.39-7.15 20.85-19.7 28.62-11.62 7.2-27.63 10.57-48.09 10.57-18.07 0-34.04-3.39-47.79-10.26a99.53 99.53 0 01-34.06-27.5 114.67 114.67 0 01-19.9-38.86 155.4 155.4 0 01-6.31-44.32c0-15.32 2.1-30.1 6.3-44.32a114.56 114.56 0 0119.91-38.86 99.56 99.56 0 0134.06-27.5c13.75-6.88 29.72-10.27 47.78-10.27zm-414.78 57.18a43.06 43.06 0 00-14.7 12.11 52.13 52.13 0 00-8.76 17.72l-1.73 7.17-.4 2.44h92.45l-.26-1.96-1.65-6.75a57.36 57.36 0 00-8.56-17.66 42.23 42.23 0 00-14.02-12.21 37.13 37.13 0 00-14.21-4.32l-6.18-.3c-9.1-.45-16.39.87-21.98 3.76z"
      }
    }]
  },
  "name": "keyboard-esc-stroke"
};
a['KeyboardNStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M672.14 256c-10.76 0-19.7 3.53-26.4 10.56l-3.04 3.7c-4.61 6.52-6.88 14.72-6.88 24.41l-.01 327.26-236.17-331.57c-8.43-12.3-15.58-20.96-21.57-26-6.68-5.61-15.4-8.36-25.9-8.36-22.1 0-33.6 15.06-33.6 42.12v431.2c0 11.64 3.27 21.12 9.93 28.12 6.7 7.03 15.64 10.56 26.4 10.56 10.77 0 19.7-3.53 26.4-10.56l3.05-3.7c4.61-6.52 6.89-14.72 6.89-24.41l-.03-327.3 236.2 331.6c8.43 12.3 15.58 20.97 21.57 26 6.68 5.62 15.4 8.37 25.9 8.37 22.11 0 33.6-15.06 33.6-42.12v-431.2c0-11.64-3.27-21.12-9.93-28.12-6.7-7.03-15.64-10.56-26.4-10.56z"
      }
    }]
  },
  "name": "keyboard-N-stroke"
};
a['LaptopStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M969.17 837.12l-64-230.19V167.04a64 64 0 00-64-64h-640a64 64 0 00-64 64v439.47l-62.5 224.21-2.14 7.68a70.19 70.19 0 000 11.52 64 64 0 0061.87 64h774.19a64 64 0 0061.86-64 62.08 62.08 0 00-1.28-12.8zM819.84 188.37v384H222.51v-384zM436.91 805.76l6.61-20.05H601.6l6.19 19.84 7.04 22.82H429.44zm409.38 22.61H682.67l-22.4-72.1-3.84-9.6a42.67 42.67 0 00-36.7-25.18H425.4a42.67 42.67 0 00-35.84 23.68l-3.84 11.52-23.04 71.68H163.84l7.9-30.93 25.38-97.28L208 657.49h624l11.3 42.67 26.03 97.7 4.7 17.29 3.62 13.44z"
      }
    }]
  },
  "name": "laptop-stroke"
};
a['LayoutStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 64H128a64 64 0 00-64 64v768a64 64 0 0064 64h768a64 64 0 0064-64V128a64 64 0 00-64-64zm-21.33 234.67h-448V149.33h448zM149.33 149.33h192v725.34h-192zm277.34 725.34V384h448v490.67z"
      }
    }]
  },
  "name": "layout-stroke"
};
a['LikeFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M106.67 554.67V896a64 64 0 0064 64H192V490.67h-21.33a64 64 0 00-64 64zM866.56 321.7h-283.1V174.72a117.97 117.97 0 00-85.33-106.67A122.03 122.03 0 00465.71 64h-2.14a117.33 117.33 0 00-110.72 85.33l-91.94 341.34V960h448a170.67 170.67 0 00165.76-138.67l16.42-128 38.19-298.66a64 64 0 00-62.72-72.96zM341.33 874.67z"
      }
    }]
  },
  "name": "like-fill"
};
a['LikeStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M714.03 874.67h-.86.86zm-68.06 85.54h23.04-23.04zm235.1-149.54l21.33-168.11-21.33 170.67a7.68 7.68 0 010-2.56zm-275.63 64h107.73-230.4 122.67zM870.61 321.7H587.52V174.72a117.97 117.97 0 00-85.33-106.67A122.45 122.45 0 00469.33 64h-1.92a117.12 117.12 0 00-110.72 85.33l-91.73 341.34H153.39a64 64 0 00-64 64V896a64 64 0 0064 64h558.5a170.67 170.67 0 00168.75-146.77l21.33-170.67 31.79-249.17a64 64 0 00-63.15-71.68zM238.72 874.67h-64V576h64zm557.44-73.39a85.33 85.33 0 01-82.13 73.39H324.05V583.89a34.56 34.56 0 008.11-14.5l77.01-286.94L438.4 172.8a32.21 32.21 0 0164 5.33v193.92a34.99 34.99 0 0034.35 34.99H846.5z"
      }
    }]
  },
  "name": "like-stroke"
};
a['LinkStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M642.13 343.47c-8.53 0-17.06 4.26-23.46 8.53l-275.2 275.2c-12.8 12.8-12.8 32 0 44.8l14.93 14.93c6.4 6.4 14.93 8.54 23.47 8.54 8.53 0 17.06-4.27 23.46-8.54l275.2-275.2c12.8-12.8 12.8-32 0-44.8L665.6 352c-6.4-4.27-14.93-8.53-23.47-8.53z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M586.67 716.8c-12.8-12.8-32-12.8-44.8 0l-2.14 2.13-93.86 93.87c-61.87 61.87-164.27 61.87-226.14 0-61.86-61.87-61.86-164.27 0-226.13l93.87-93.87 2.13-2.13c12.8-12.8 12.8-32 0-44.8l-14.93-14.94c-12.8-12.8-32-12.8-44.8 0l-76.8 76.8-21.33 21.34c-96 96-96 251.73 0 347.73s251.73 96 347.73 0l21.33-21.33 76.8-76.8c12.8-12.8 12.8-32 0-44.8l-17.06-17.07zM437.33 324.27c12.8 12.8 32 12.8 44.8 0l2.14-2.14 93.86-93.86c61.87-61.87 164.27-61.87 226.14 0 61.86 61.86 61.86 164.26 0 226.13l-93.87 93.87-2.13 2.13c-12.8 12.8-12.8 32 0 44.8l14.93 14.93c12.8 12.8 32 12.8 44.8 0l76.8-76.8L866.13 512c96-96 96-251.73 0-347.73s-251.73-96-347.73 0l-21.33 21.33-76.8 76.8c-12.8 12.8-12.8 32 0 44.8l17.06 17.07z"
      }
    }]
  },
  "name": "link-stroke"
};
a['ListCheckFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M333.01 415.36a31.29 31.29 0 00-44.16 0l-94.93 94.93-35.63-35.62a31.29 31.29 0 00-44.16 0l-16.85 16.85a31.29 31.29 0 000 44.16l74.45 74.45c6.19 6.19 14.08 9.18 22.19 9.18s16-2.99 22.19-9.18l133.97-133.97a31.29 31.29 0 000-44.16l-17.07-16.64zM106.24 225.06a117.33 117.33 0 10234.67 0 117.33 117.33 0 10-234.67 0zm0 575.58a117.33 117.33 0 10234.67 0 117.33 117.33 0 10-234.67 0zM903.47 150.4h-441.6a34.55 34.55 0 00-34.56 34.56v80.21a34.55 34.55 0 0034.56 34.56h441.81a34.55 34.55 0 0034.56-34.56v-80.21c0-18.99-15.57-34.56-34.77-34.56zm0 287.79h-441.6a34.55 34.55 0 00-34.56 34.56v80.21a34.55 34.55 0 0034.56 34.56h441.81a34.55 34.55 0 0034.56-34.56v-80.21a34.6 34.6 0 00-34.77-34.56zm0 287.78h-441.6a34.55 34.55 0 00-34.56 34.56v80.22a34.55 34.55 0 0034.56 34.56h441.81a34.55 34.55 0 0034.56-34.56v-80.22a34.6 34.6 0 00-34.77-34.56z"
      }
    }]
  },
  "name": "list-check-fill"
};
a['ListCheckStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M172.16 621.87s.21 0 0 0c.21 0 .21 0 0 0 8.32 0 16.43-3.2 22.83-9.39l136.96-136.96c12.58-12.59 12.58-32.85 0-45.23l-17.28-17.28c-6.19-6.18-14.51-9.38-22.62-9.38s-16.42 3.2-22.61 9.38l-97.07 97.07-36.48-36.48c-6.18-6.19-14.5-9.39-22.61-9.39s-16.43 3.2-22.61 9.39l-17.28 17.28a31.79 31.79 0 000 45.23l76.16 76.16c6.4 6.4 14.5 9.6 22.61 9.6zm756.9 158.29H451.64c-17.71 0-32 14.3-32 32v21.33c0 17.71 14.29 32 32 32h477.44c17.7 0 32-14.29 32-32v-21.33c0-17.7-14.3-32-32-32zm0-310.19H451.64c-17.71 0-32 14.3-32 32v21.34c0 17.7 14.29 32 32 32h477.44c17.7 0 32-14.3 32-32v-21.34c0-17.49-14.3-32-32-32zm0-309.97H451.64c-17.71 0-32 14.3-32 32v21.33c0 17.71 14.29 32 32 32h477.44c17.7 0 32-14.29 32-32V192c0-17.7-14.3-32-32-32zm-726.4-96a138.67 138.67 0 100 277.33 138.67 138.67 0 000-277.33zm0 192a53.33 53.33 0 010-106.67 53.33 53.33 0 010 106.67zm0 428.16a138.67 138.67 0 100 277.33 138.67 138.67 0 000-277.33zm0 192a53.33 53.33 0 010-106.67 53.33 53.33 0 010 106.67z"
      }
    }]
  },
  "name": "list-check-stroke"
};
a['ListStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M384 149.33V384H149.33V149.33H384M426.67 64h-320A42.67 42.67 0 0064 106.67v320a42.67 42.67 0 0042.67 42.66h320a42.67 42.67 0 0042.66-42.66v-320A42.67 42.67 0 00426.67 64zM928 135.25H586.67a32 32 0 00-32 32v21.34a32 32 0 0032 32H928a32 32 0 0032-32v-21.34a32 32 0 00-32-32zm0 177.07H586.67a32 32 0 00-32 32v21.33a32 32 0 0032 32H928a32 32 0 0032-32v-21.33a32 32 0 00-32-32zM384 640v234.67H149.33V640H384m42.67-85.33h-320A42.67 42.67 0 0064 597.33v320A42.67 42.67 0 00106.67 960h320a42.67 42.67 0 0042.66-42.67v-320a42.67 42.67 0 00-42.66-42.66zM928 626.35H586.67a32 32 0 00-32 32v21.33a32 32 0 0032 32H928a32 32 0 0032-32v-21.33a32 32 0 00-32-32zm0 177.06H586.67a32 32 0 00-32 32v21.34a32 32 0 0032 32H928a32 32 0 0032-32V835.4a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "list-stroke"
};
a['LoadingShortStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M890.32 512a36 36 0 01-35.85-32.74 344.14 344.14 0 00-309.73-309.73A36 36 0 01512 133.68a36 36 0 0139.34-35.86 415.79 415.79 0 01374.84 374.84A36 36 0 01890.32 512z"
      }
    }]
  },
  "name": "loading-short-stroke"
};
a['LoadingStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 928A415.76 415.76 0 0197.82 551.34 36 36 0 01133.68 512a36 36 0 0135.85 32.74 344 344 0 10375.21-375.21A36 36 0 01512 133.68a36 36 0 0139.34-35.86 415.91 415.91 0 01254.82 708.34A414.87 414.87 0 01512 928z"
      }
    }]
  },
  "name": "loading-stroke"
};
a['LockFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M897.92 429.01h-89.17V277.33A213.33 213.33 0 00595.4 64H426.67a213.33 213.33 0 00-213.34 213.33v152.11h-87.25a64 64 0 00-64 64V896a64 64 0 0064 64h771.84a64 64 0 0064-64V492.8a64 64 0 00-64-63.79zM428.59 644.48a80.85 80.85 0 11121.17 69.76v69.33a30.3 30.3 0 01-30.3 30.3H499.2a30.08 30.08 0 01-29.87-30.3v-69.33a80.85 80.85 0 01-39.68-69.76zM298.67 277.33a128 128 0 01128-128h168.96a128 128 0 01128 128v152.11H298.67z"
      }
    }]
  },
  "name": "lock-fill"
};
a['LockStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M591.15 644.48a80.85 80.85 0 10-121.82 69.76v69.33a30.08 30.08 0 0030.3 30.3h20.26a30.3 30.3 0 0030.3-30.3v-69.33a80.85 80.85 0 0040.96-69.76z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M897.92 429.01h-89.17V277.33A213.33 213.33 0 00595.4 64H426.67a213.33 213.33 0 00-213.34 213.33v152.11h-87.25a64 64 0 00-64 64V896a64 64 0 0064 64h771.84a64 64 0 0064-64V492.8a64 64 0 00-64-63.79zM298.67 277.33a128 128 0 01128-128h168.96a128 128 0 01128 128v152.11H298.67zm577.7 597.34H147.63V514.35h728.74z"
      }
    }]
  },
  "name": "lock-stroke"
};
a['LogoAlipayCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M751.31 606.73c93.17 31.09 144 40 155.16 41.7A414.85 414.85 0 00929 513c0-230.28-186.72-417-417-417S95 282.72 95 513s186.72 417 417 417c145.11 0 272.91-74.19 347.66-186.63-70.37-27.73-198.82-79.11-267-111.79-65.06 79.77-149 128.27-236.14 128.27-147.44 0-197.43-128.54-127.71-213.15 15.17-18.43 41.14-36 81.26-46 62.83-15.35 162.89 9.59 256.62 40.4a509.9 509.9 0 0041.61-101.36H319.42v-29.13h148.93V358.3H288v-29.13h180.35v-74.56s0-12.57 12.75-12.57h72.79v87.13h178.43v29.13H554v52.31h145.56c-14 56.87-35.09 109.28-61.62 155.26 44.21 15.92 83.86 31 113.37 40.86zm-428.64-62.36c-18.43 1.86-53.14 10-72 26.62-56.78 49.33-22.8 139.62 92.15 139.62 66.83 0 133.57-42.54 186-110.77-74.72-36.2-137.92-62.17-206.15-55.47z"
      }
    }]
  },
  "name": "logo-alipay-circle-fill"
};
a['LogoAliwangwangFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M718.2 464.4a37.1 37.1 0 01-74.2 0v-55.1a37.1 37.1 0 0174.2 0zm-175.2 0a37.1 37.1 0 01-74.2 0v-55.1a37.1 37.1 0 0174.2 0zm325.2-79a379.54 379.54 0 00-471.1-211.6C306 131.3 200.8 128 170.6 128c-2.2 0-7.4 0-9.4.2a36.12 36.12 0 00-29.2 16.4 36.82 36.82 0 00-3.4 33.5l64.3 161.6a380.11 380.11 0 00-23 340.8 379.43 379.43 0 00496.8 201.7 379.2 379.2 0 00201.5-496.8z"
      }
    }]
  },
  "name": "logo-aliwangwang-fill"
};
a['LogoAliwangwangStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M505.9 372.2a37.15 37.15 0 00-37.1 37.1v55.1a37.1 37.1 0 0074.2 0v-55.1a37.15 37.15 0 00-37.1-37.1zm175.2 0a37.22 37.22 0 00-37.1 37.1v55.1a37.1 37.1 0 0074.2 0v-55.1a37.15 37.15 0 00-37.1-37.1zm120.7 279.7a307.08 307.08 0 01-65.9 98 301.57 301.57 0 01-97.7 65.9h-.1A307.74 307.74 0 01234.9 652v-.1A309.76 309.76 0 01253.6 375l13.2-22.1-9.5-23.9L206 200a575.67 575.67 0 0159.7 5.6c43.8 6.5 82.5 17.5 114.9 32.6l19 8.9 19.9-6.8a307.77 307.77 0 01382.2 171.8l.1.1.1.1a308 308 0 01-.1 239.6zm66.4-266.5a379.54 379.54 0 00-471.1-211.6C306 131.3 200.8 128 170.6 128c-2.2 0-7.4 0-9.4.2a36.12 36.12 0 00-29.2 16.4 36.82 36.82 0 00-3.4 33.5l64.3 161.6a380.11 380.11 0 00-23 340.8A378.76 378.76 0 00519 912a379 379 0 00349.2-526.6z"
      }
    }]
  },
  "name": "logo-aliwangwang-stroke"
};
a['LogoAndroidFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M181.21 348.55c-29.37 0-53.11 24.12-53.11 53.89V613c0 29.67 23.83 53.89 53.11 53.89s53.12-24.13 53.12-53.89V402.34c0-29.77-23.84-53.79-53.12-53.79zm640.68 0c-29.38 0-53.12 24.12-53.12 53.89V613c0 29.67 23.84 53.89 53.12 53.89S875 642.71 875 613V402.34a53.26 53.26 0 00-53.11-53.79zm-217.32-98a26.17 26.17 0 1126.16-26.17 26.18 26.18 0 01-26.16 26.21zm-202.73 0A26.17 26.17 0 11428 224.42a26.18 26.18 0 01-26.16 26.17zm211.77-99.71l43.68-63.23c2.53-3.7 2-8.66-1.46-11.09s-8.27-1.17-10.8 2.53l-45.33 65.8a272 272 0 00-196.11 0l-45.33-65.67c-2.53-3.69-7.39-5-10.8-2.52s-4 7.19-1.46 11.08L389.68 151c-69.46 32.29-118.1 93.48-124.32 165h472.77c-6.42-71.64-55.13-132.83-124.52-165.12zm-347.38 583.8A41.46 41.46 0 00307.67 776h47.38v117.11c0 29.67 23.83 53.89 53.11 53.89s53.12-24.12 53.12-53.89V775.89H544V893c0 29.67 23.84 53.89 53.12 53.89s53.11-24.12 53.11-53.89V775.89h47.37a41.45 41.45 0 0041.4-41.34V350.1H266.23z"
      }
    }]
  },
  "name": "logo-android-fill"
};
a['LogoAndroidStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M549 233.5c-18.06 0-31.07 13-31.07 31s13.11 31 31.07 31 31.16-13 31.16-31.07S567.15 233.5 549 233.5zm217.09 373.21c0 6.6-3.79 10.29-10.39 10.29s-10.39-3.69-10.39-10.29V378.46c0-6.61 3.79-10.29 10.39-10.29s10.39 3.68 10.39 10.29zm-82.72 149.51H290.55v-388h392.82zM590.36 885c-6.6 0-10.39-3.69-10.39-10.29v-56.5h20.58v58.34C600 882 596.38 885 590.36 885zM394 876.51c-.58 5.44-4.27 8.45-10.19 8.45-6.61 0-10.39-3.69-10.39-10.29v-56.5H394zm-38.16-655C392.2 195 438.61 180.4 486.86 180.4s94.66 14.66 131.07 41.26c31.46 23 52.62 52.62 60.87 85H294.92c8.25-32.48 29.61-62.18 60.87-85.19zm-127.33 385.2c0 6.6-3.78 10.29-10.39 10.29s-10.38-3.69-10.38-10.29V378.46c0-6.61 3.78-10.29 10.38-10.29s10.39 3.68 10.39 10.29zM807.35 327.1c-13.4-13.4-31.75-20.88-51.65-20.88a57.44 57.44 0 00-10.39 1v-1h-3.5c-5.34-29.71-18-58.73-37-84.85a239.77 239.77 0 00-68.73-63l24.36-34.76v-3.2a28.4 28.4 0 01.68-3.69 34.7 34.7 0 001.36-8.64c0-18-13.1-31-31.06-31-9.52 0-18.94 5.53-25.15 15l-28.45 40.87a292.06 292.06 0 00-182.13 0L367.35 92c-6.41-9.32-15.63-15-25.25-15-18.05 0-31.1 13-31.1 31a25.81 25.81 0 006.5 16.89l21.94 31.36a234.87 234.87 0 00-70.09 63.21c-18.84 26.11-31.07 55.14-35.63 84.85h-5.34v1a55.9 55.9 0 00-10.39-1c-19.71 0-38.06 7.28-51.56 20.68a72.14 72.14 0 00-20.87 51.46v228.12c0 19.71 7.28 38 20.78 51.36s31.84 20.88 51.65 20.88a56.69 56.69 0 0010.39-1v90.78a51.73 51.73 0 0051.65 51.56h31v56.6c0 19.71 7.28 38 20.77 51.36S363.66 947 383.46 947s38.06-7.28 51.56-20.68 20.87-31.65 20.87-51.46v-56.5h61.94v56.41c0 19.71 7.28 38 20.78 51.36S570.45 947 590.26 947s38.06-7.28 51.55-21a72.11 72.11 0 0020.88-51.46v-56.5h31a51.68 51.68 0 0051.65-51.56v-88.7a55.81 55.81 0 0010.39 1c19.71 0 38.06-7.28 51.55-20.68s20.87-31.65 20.87-51.46V378.46c-.15-19.71-7.4-37.87-20.8-51.36zm-382.43-93.6c-18.06 0-31.07 13-31.07 31s13.11 31 31.07 31 31.07-13 31.07-31-12.99-31-31.07-31z"
      }
    }]
  },
  "name": "logo-android-stroke"
};
a['LogoAppleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M636.3 211.7c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7zm105.1 305c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C267.1 279.8 157 360.8 157 525.6q0 73 26.7 150.8c23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7z"
      }
    }]
  },
  "name": "logo-apple-fill"
};
a['LogoAppleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M634.3 211.7c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7zm94.5 572c-14.3 19.9-28.7 35.6-41.9 45.7-10.5 8-18.6 11.4-24 11.6-9-.1-17.7-2.3-34.7-8.8-1.2-.5-2.5-1-4.2-1.6l-4.4-1.7c-17.4-6.7-27.8-10.3-41.1-13.8a224.21 224.21 0 00-56.9-7.4 237.71 237.71 0 00-58.1 7.2c-13.9 3.5-25.6 7.4-42.7 13.8-.7.3-8.1 3.1-10.2 3.9-3.5 1.3-6.2 2.3-8.7 3.2-10.4 3.6-17 5.1-22.9 5.2a9 9 0 01-1.8-.2 18.78 18.78 0 01-4.1-1.3c-4.5-1.8-9.9-5.1-16-9.8-14-10.9-29.4-28-45.1-49.9-27.5-38.6-53.5-89.8-66-125.7q-23.1-67.2-23-128.6c0-60.2 17.8-106 48.4-137.1a142.43 142.43 0 0197.8-42.3c5.9.1 14.5 1.5 25.4 4.5 8.6 2.3 18 5.4 30.7 9.9 3.8 1.4 16.9 6.1 18.5 6.7 7.7 2.8 13.5 4.8 19.2 6.6 18.2 5.8 32.3 9 47.6 9 15.5 0 28.8-3.3 47.7-9.8 7.1-2.4 32.9-12 37.5-13.6 25.6-9.1 44.5-14 60.8-15.2a83.61 83.61 0 0113.2-.1c22.7 1.8 42.1 6.3 58.6 13.8-37.6 43.4-57 96.5-56.9 158.4a227.82 227.82 0 005.1 51.8 247.26 247.26 0 0037.9 89 255.27 255.27 0 0054.7 57.8c-11.5 23.7-25.6 48.2-40.4 68.8zm10.6-267c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C265.1 279.8 155 360.8 155 525.6q0 73 26.7 150.8c23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7z"
      }
    }]
  },
  "name": "logo-apple-stroke"
};
a['LogoChromeStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M489.7 925.4c4 .2 8 .4 12 .5-4-.2-8-.3-12-.5zM165 510a346.72 346.72 0 0136.6-155.5l119.7 235.4c44.1 86.7 137.4 139.7 234 121.6l-74 145.1C303.9 840.5 165 691.5 165 510zm-61.5 73.8c26 145 127.1 264 261.6 315.1a416 416 0 01-261.6-315.1zM513 162a347.61 347.61 0 01290.4 156.2l-263.6-13.9c-97.5-5.7-190.2 49.2-222.3 141.1L228.8 309c63.1-88.9 166.9-147 284.2-147zm369.2 156.6l-3-5.7zM513 650.3A140.2 140.2 0 11653.2 510 140.11 140.11 0 01513 650.3zm164.7-14.1c53.5-82.2 52.5-189.4-11.1-263.7l162.4-8.4A347.11 347.11 0 01861 510c0 185.2-144.6 336.6-327.1 347.4zm244.6-200.5l.6 3.3-.6-3.3zm6.7 74.6v-.3c0-229.8-186.2-416-416-416S97 280.2 97 510v.4c0 229.8 186.2 416 416 416s416-186.2 416-416v-.1z"
      }
    }]
  },
  "name": "logo-chrome-stroke"
};
a['LogoDingtalkCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M723.29 453.64c-.93 3.91-3.26 9.68-6.51 16.57h.09l-.37.65c-18.9 40.12-68 118.86-68 118.86l-.28-.46-14.47 24.94h69.34L570.73 789.38l30.07-119.14h-54.55l19-78.84c-15.36 3.63-33.41 8.75-54.92 15.64 0 0-29 16.94-83.67-32.58 0 0-36.86-32.3-15.46-40.4 9.13-3.44 44.12-7.82 71.68-11.45C520.1 517.58 543 515 543 515s-114.77 1.67-142-2.51-61.85-49.49-69.2-89.2c0 0-11.36-21.78 24.48-11.44s184.2 40.21 184.2 40.21-193-58.92-205.89-73.26-37.79-78.37-34.53-117.74c0 0 1.39-9.78 11.54-7.17 0 0 142.69 64.88 240.24 100.43 97.55 35.28 182.34 53.34 171.45 99.32zM512 95C281.72 95 95 281.72 95 512s186.72 417 417 417 417-186.72 417-417S742.28 95 512 95z"
      }
    }]
  },
  "name": "logo-dingtalk-circle-fill"
};
a['LogoDingtalkFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M578.09 232.73C415.59 173.51 177.86 65.29 177.86 65.29c-16.86-4.41-19.24 11.93-19.24 11.93-5.37 65.66 36.11 172.49 57.61 196.46s342.95 122.19 342.95 122.19-247.3-49.87-306.95-67.06-40.73 19.13-40.73 19.13c12.25 66.31 69.75 141.65 115.21 148.74S563.26 501 563.26 501s-38.16 4.4-100.17 12.78c-45.89 6.22-104.25 13.43-119.4 19.12-35.58 13.44 25.79 67.28 25.79 67.28 91 82.54 139.4 54.28 139.4 54.28 35.78-11.5 66-19.89 91.56-26L568.74 760h90.92l-50.08 198.71 220.64-292.22H714.68l24-41.59a4.37 4.37 0 01.43.86s82-131.22 113.39-198.18l.64-1.07H853c5.38-11.61 9.24-21.18 10.75-27.73C882 322.15 740.69 292 578.09 232.73zm0 0"
      }
    }]
  },
  "name": "logo-dingtalk-fill"
};
a['LogoFacebookSquareFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M777.58 352.16h-61.35c-48.09 0-57.41 22.85-57.41 56.45v74h114.82l-15 115.88h-99.82V896H539.11V598.59H439v-116h100.11v-85.41C539.11 298 599.69 244 688.2 244c42.43 0 78.82 3.17 89.47 4.61v103.55zM866.28 128H159.72A30.69 30.69 0 00129 158.72v706.56A30.69 30.69 0 00159.72 896h706.56A30.69 30.69 0 00897 865.28V158.72A30.69 30.69 0 00866.28 128z"
      }
    }]
  },
  "name": "logo-facebook-square-fill"
};
a['LogoGoogleCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M666.07 683.34c-37.7 34.73-89.14 55.16-150.52 55.16a227.55 227.55 0 010-455.09c61.29 0 112.73 22.56 152.19 59.24l-65.18 65.28c-23.59-22.57-53.58-34-86.92-34-59.24 0-109.38 40-127.3 93.79a134.5 134.5 0 000 86.54c17.92 53.77 68.06 93.79 127.21 93.79 30.64 0 56.64-8.08 77-21.73a104.61 104.61 0 0045.41-68.72H515.55v-88h214.22a262.17 262.17 0 014.09 46.52c0 69.35-24.8 127.57-67.79 167.22zM511 95C281.27 95 95 281.27 95 511s186.27 416 416 416 416-186.27 416-416S740.73 95 511 95z"
      }
    }]
  },
  "name": "logo-google-circle-fill"
};
a['LogoTwitterFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4a170.11 170.11 0 0075-94 336.64 336.64 0 01-108.2 41.2A170.1 170.1 0 00672 174c-94.5 0-170.5 76.6-170.5 170.6a195.86 195.86 0 004.2 39.1 484.59 484.59 0 01-351.6-178.5 171 171 0 0052.8 228.2 172 172 0 01-77.1-21.7v2.1a170.55 170.55 0 00136.7 167.4 180.61 180.61 0 01-44.9 5.8 226.84 226.84 0 01-32.2-2.6C211 652 273.9 701.1 348.8 702.7a341.76 341.76 0 01-211.7 72.9 348.63 348.63 0 01-41.2-2.1A482.86 482.86 0 00357.8 850C671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-.5-22.2a367.27 367.27 0 0085.5-88.2z"
      }
    }]
  },
  "name": "logo-twitter-fill"
};
a['LogoWechatFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M780.1 564.2a35.9 35.9 0 1136-35.9 36 36 0 01-36 35.9zm-179.9 0a35.9 35.9 0 1136-35.9 36 36 0 01-36 35.9zm266.5 205.5c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5S420.1 476 420.1 600 540.9 824.5 690 824.5a320 320 0 0088.1-12.3 26.56 26.56 0 017.9-1.2 28.61 28.61 0 0114.3 4.1l59.1 34a10 10 0 005.2 1.7 8.88 8.88 0 009-9c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3a22.57 22.57 0 01-.9-5.7 18.46 18.46 0 017.6-14.5zM279.9 354.1a43.1 43.1 0 1143.2-43.1 43.19 43.19 0 01-43.2 43.1zm215.9-86.2a43.1 43.1 0 11-43.2 43.1 43.19 43.19 0 0143.2-43.1zm194.3 86.5c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 127.8 64 248.4 64 397.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 019.1 17.6 26.87 26.87 0 01-1.1 6.9c-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9a10.82 10.82 0 0010.8 10.8 12.63 12.63 0 006.2-2l70.9-40.9a33.74 33.74 0 0117.2-5 34.13 34.13 0 019.5 1.4 384 384 0 00105.7 14.8c6 0 11.9-.1 17.8-.4a205.28 205.28 0 01-10.9-66c0-135.8 132.2-245.8 295.3-245.8z"
      }
    }]
  },
  "name": "logo-wechat-fill"
};
a['LogoWeiboCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M471.51 575.85c-5-2-11.36.47-14.33 5.4S455.87 592 461 594.1s11.73-.28 14.71-5.4c2.78-5.21.92-10.99-4.2-12.85zM439 589.35c-13.22-5.49-30.16.19-38.35 12.94s-4.38 28.11 8.65 34.07c13.31 6 30.91.27 39.1-12.85 8.22-13.31 3.94-28.51-9.4-34.16zm86.56 30c-17.41 39.37-67.3 60.32-109.65 46.63-40.86-13.21-58.17-53.7-40.3-90.1 17.59-35.74 63.29-55.94 103.78-45.42 41.92 10.86 63.33 50.42 46.2 88.86zm-74.62-131.92C365.86 495.8 301.36 548 306.94 604s78.94 94.48 164 86.1 149.58-60.59 144-116.63-78.94-94.47-164-86.04zm311.35-5.68a19.66 19.66 0 11-37.42-12.1A96.85 96.85 0 00612.62 345a19.7 19.7 0 01-8.28-38.53 136.26 136.26 0 01157.95 175.28zm-98.66-31.93a32.33 32.33 0 00-37.51-41.7 17 17 0 01-7.12-33.23 66.31 66.31 0 0176.89 85.36 17 17 0 01-32.3-10.43zm-193 270.68c-106.57 0-215.57-51.75-215.57-136.92 0-44.49 28.11-96 76.6-144.56 64.69-64.78 140.18-94.38 168.57-65.9 12.57 12.57 13.78 34.26 5.68 60.13-4.19 13 12.19 5.87 12.19 5.87 52.31-22 97.92-23.27 114.59.65 8.93 12.75 8 30.53-.19 51.29-3.82 9.49 1.21 11 8.38 13.12 29.5 9.12 62.27 31.28 62.27 70.28.22 64.69-92.76 146.04-232.48 146.04zM512 95C281.72 95 95 281.72 95 512s186.72 417 417 417 417-186.72 417-417S742.28 95 512 95z"
      }
    }]
  },
  "name": "logo-weibo-circle-fill"
};
a['LogoWeiboFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M440 801.8c-143 14.1-266.5-50.5-275.8-144.5s99.2-181.5 242.2-195.6 266.5 50.5 275.8 144.4S583 787.6 440 801.8zM726 490c-12.2-3.6-20.5-6.1-14.1-22.1 13.8-34.7 15.2-64.7.3-86-28-40.1-104.8-37.9-192.8-1.1 0 0-27.6 12.1-20.6-9.8 13.5-43.5 11.5-79.9-9.6-101-47.7-47.8-174.6 1.8-283.5 110.6C124.3 462.1 77 548.5 77 623.2 77 766.1 260.2 853 439.5 853c235 0 391.3-136.5 391.3-245 0-65.5-55.2-102.6-104.8-118zm156.1-261.5c-56.7-62.9-140.4-86.9-217.7-70.5a33.14 33.14 0 0013.9 64.8A162.69 162.69 0 01867.1 432a33.08 33.08 0 0062.9 20.5v-.1c24.1-75.4 8.9-161.1-47.9-223.9zm-99.8 206a28.6 28.6 0 0035.9-18.3A111.34 111.34 0 00689 272.9a28.43 28.43 0 1011.9 55.6 54.78 54.78 0 0151.9 16.7 54.2 54.2 0 0111.3 53.3 28.45 28.45 0 0018.2 36zM447.8 631.7c-5 8.6-16.1 12.7-24.7 9.1s-11.2-13.1-6.4-21.5c5-8.4 15.6-12.4 24.1-9.1 8.7 3.2 11.8 12.9 7 21.5zm-45.5 58.5c-13.8 22.1-43.5 31.7-65.8 21.6-22-10-28.5-35.7-14.6-57.2 13.7-21.4 42.3-31 64.4-21.7 22.4 9.5 29.6 35 16 57.3zm52-156.2c-68.1-17.7-145 16.2-174.6 76.2-30.1 61.2-1 129.1 67.8 151.3 71.2 23 155.2-12.2 184.4-78.3 28.7-64.6-7.2-131-77.6-149.2z"
      }
    }]
  },
  "name": "logo-weibo-fill"
};
a['MaleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M906.88 84.05H672.21a32 32 0 00-32.21 32v29.02a32 32 0 0032 32h115.84L599.25 365.65a320 320 0 1060.16 61.02L845.87 240.2v113.71a32 32 0 0032 32h29.01a32 32 0 0032-32V116.05a32 32 0 00-32-32zM405.33 854.61A234.67 234.67 0 11640 619.95 234.67 234.67 0 01405.33 854.6z"
      }
    }]
  },
  "name": "male-stroke"
};
a['MedicalChestStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M652 567H544V459a8 8 0 00-8-8h-48a8 8 0 00-8 8v108H372a8 8 0 00-8 8v48a8 8 0 008 8h108v108a8 8 0 008 8h48a8 8 0 008-8V631h108a8 8 0 008-8v-48a8 8 0 00-8-8zm188 268H184V508.4L244.3 333h535.4L840 508.4zM360 189h304v72H360zm479.2 94.1a32 32 0 00-30.4-22.1H736V149a32 32 0 00-32-32H320a32 32 0 00-32 32v112h-72.8a31.91 31.91 0 00-30.4 22.1L112 497v378a32 32 0 0032 32h736a32 32 0 0032-32V497z"
      }
    }]
  },
  "name": "medical-chest-stroke"
};
a['MenuFoldStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M914.35 355.2H410.03A25.17 25.17 0 00384 380.37v34.99a25.17 25.17 0 0025.17 25.17h505.18a25.17 25.17 0 0024.32-25.17v-34.99a25.17 25.17 0 00-25.18-25.17zm0 233.6H410.03A25.17 25.17 0 00384 614.19v34.77a25.17 25.17 0 0025.17 25.17h505.18a25.17 25.17 0 0024.32-25.17v-34.77a25.17 25.17 0 00-25.18-25.39zm-6.83 236.8H118.19a32 32 0 00-32.86 32v21.33a32 32 0 0032 32h789.34a32 32 0 0032-32V857.6a32 32 0 00-32-32zm0-704H118.19a32 32 0 00-32.86 32v21.33a32 32 0 0032 32h789.34a32 32 0 0032-32V153.6a32 32 0 00-32-32zM258.13 359.25a21.33 21.33 0 00-13.65 5.12L93.87 490.67a21.33 21.33 0 000 32.64l150.61 126.72a21.33 21.33 0 0035.2-16.43V380.59a21.33 21.33 0 00-21.33-21.34z"
      }
    }]
  },
  "name": "menu-fold-stroke"
};
a['MenuUnfoldStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M913.5 355.2H409.16A25.17 25.17 0 00384 380.37v34.99a25.17 25.17 0 0025.17 25.17H913.5a25.17 25.17 0 0025.18-25.17v-34.99a25.17 25.17 0 00-25.18-25.17zm0 233.6H409.16A25.17 25.17 0 00384 614.19v34.77a25.17 25.17 0 0025.17 25.17H913.5a25.17 25.17 0 0025.18-25.17v-34.77a25.17 25.17 0 00-25.18-25.39zm-6.83 236.8H117.33a32 32 0 00-32 32v21.33a32 32 0 0032 32h789.34a32 32 0 0032-32V857.6a32 32 0 00-32-32zm0-704H117.33a32 32 0 00-32 32v21.33a32 32 0 0032 32h789.34a32 32 0 0032-32V153.6a32 32 0 00-32-32zm-800 237.65a21.33 21.33 0 00-21.34 21.34V633.8a21.33 21.33 0 0021.34 21.34 21.33 21.33 0 0013.44-4.91l150.82-126.72a21.33 21.33 0 000-32.64l-150.61-126.5a20.05 20.05 0 00-13.65-5.13z"
      }
    }]
  },
  "name": "menu-unfold-stroke"
};
a['MessageStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M663.7 512a47.9 48 0 1095.8 0 47.9 48 0 10-95.8 0zm-199.6 0a47.9 48 0 1095.8 0 47.9 48 0 10-95.8 0zm-199.6 0a47.9 48 0 1095.8 0 47.9 48 0 10-95.8 0zm247.44-345a341.63 341.63 0 01133.24 26.75h.05a340.41 340.41 0 01109.9 74.05 345.89 345.89 0 01-.85 489.52A342.06 342.06 0 01512.13 857h-1.76A345 345 0 01357 820.07l-15.32-7.75H212.57V682.93l-7.68-15.27a348.34 348.34 0 01-10.53-289A343 343 0 01510.28 167h1.66m0-72h-1.86a415.52 415.52 0 00-382.26 256.16A420.31 420.31 0 00140.57 700v141.5a42.8 42.8 0 0042.71 42.82h141.25A416.53 416.53 0 00510.18 929h1.95a417.27 417.27 0 00294-712A414.41 414.41 0 00511.94 95z"
      }
    }]
  },
  "name": "message-stroke"
};
a['MineFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M614.4 126.98c-213-57.35-430.08 69.63-487.42 282.62S196.6 839.68 409.6 897.02 839.68 827.4 897.02 614.4c57.35-213-69.63-430.08-282.62-487.42zM385.02 503.8c0 24.57-16.38 40.96-40.96 40.96s-40.96-16.39-40.96-40.96v-81.92c0-24.58 16.39-40.96 40.96-40.96s40.96 16.38 40.96 40.96v81.92zm213 0c0 24.57-16.39 40.96-40.96 40.96s-40.96-16.39-40.96-40.96v-81.92c0-24.58 16.38-40.96 40.96-40.96s40.96 16.38 40.96 40.96v81.92z"
      }
    }]
  },
  "name": "mine-fill"
};
a['MineStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M853.33 273.07c-8.53-12.8-29.86-17.07-42.66-8.54-12.8 8.54-17.07 29.87-8.54 42.67 59.74 85.33 76.8 192 51.2 294.4-25.6 89.6-81.06 166.4-162.13 213.33s-174.93 59.74-268.8 34.14C332.8 823.47 256 768 209.07 686.93S149.33 512 170.67 422.4c51.2-187.73 243.2-298.67 430.93-247.47 34.13 8.54 68.27 25.6 98.13 42.67 17.07 8.53 34.14 4.27 42.67-8.53 8.53-12.8 4.27-34.14-8.53-42.67-34.14-21.33-72.54-38.4-115.2-51.2-221.87-64-448 68.27-507.74 290.13C81.07 512 98.13 622.93 153.6 721.07s145.07 166.4 251.73 192c34.14 8.53 72.54 12.8 106.67 12.8 72.53 0 145.07-17.07 209.07-55.47 98.13-55.47 166.4-145.07 192-251.73 34.13-119.47 8.53-243.2-59.74-345.6z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M285.87 413.87v93.86c0 21.34 17.06 38.4 38.4 38.4s38.4-17.06 38.4-38.4v-93.86c0-21.34-17.07-38.4-38.4-38.4s-38.4 17.06-38.4 38.4zm226.13 0v93.86c0 21.34 17.07 38.4 38.4 38.4s38.4-17.06 38.4-38.4v-93.86c0-21.34-17.07-38.4-38.4-38.4s-38.4 17.06-38.4 38.4z"
      }
    }]
  },
  "name": "mine-stroke"
};
a['MinusCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64a448 448 0 10448 448A448 448 0 00512 64zm213.33 458.67a32 32 0 01-32 32H330.67a32 32 0 01-32-32v-21.34a32 32 0 0132-32h362.66a32 32 0 0132 32z"
      }
    }]
  },
  "name": "minus-circle-fill"
};
a['MinusCircleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M502.61 149.33A362.67 362.67 0 11139.95 512 362.67 362.67 0 01502.6 149.33m0-85.33a448 448 0 10448 448 448 448 0 00-448-448z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M683.95 469.33H321.28a32 32 0 00-32 32v21.34a32 32 0 0032 32h362.67a32 32 0 0032-32v-21.34a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "minus-circle-stroke"
};
a['MinusSquareFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 64H128c-35.33 0-64 28.67-64 64v768c0 35.33 28.67 64 64 64h768c35.33 0 64-28.67 64-64V128c0-35.33-28.67-64-64-64zM710.66 555.52H313.34c-20.99 0-37.88-19.46-37.88-43.52s16.9-43.52 37.88-43.52h396.8c21 0 37.9 19.46 37.9 43.52s-16.9 43.52-37.38 43.52z"
      }
    }]
  },
  "name": "minus-square-fill"
};
a['MinusSquareStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M872.96 151.04v721.92H151.04V151.04h721.92M896 64H128c-35.33 0-64 28.67-64 64v768c0 35.33 28.67 64 64 64h768c35.33 0 64-28.67 64-64V128c0-35.33-28.67-64-64-64zM313.34 512h397.32"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M710.66 555.52H313.34c-20.99 0-37.88-19.46-37.88-43.52s16.9-43.52 37.88-43.52h396.8c21 0 37.9 19.46 37.9 43.52s-16.9 43.52-37.38 43.52z"
      }
    }]
  },
  "name": "minus-square-stroke"
};
a['MinusStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M851.2 554.67H172.8c-23.47 0-42.67-19.2-42.67-42.67s19.2-42.67 42.67-42.67h676.27c23.46 0 42.66 19.2 42.66 42.67s-17.06 42.67-40.53 42.67z"
      }
    }]
  },
  "name": "minus-stroke"
};
a['MobilePhoneShakeStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M946.87 385.43l-308.3-308.3a32 32 0 00-45.25 0L77.13 593.32a32 32 0 000 45.25l308.3 308.3a32 32 0 0045.25 0l516.19-516.19a32 32 0 000-45.25zM408.06 867.67L156.33 615.94l459.61-459.61 251.73 251.73zm475.82-182.76l-38.3-38.5a7.91 7.91 0 00-11.2 0L645.7 835a7.91 7.91 0 000 11.2l38.4 38.4a7.91 7.91 0 0011.2 0l188.58-188.49a7.91 7.91 0 000-11.2zM376.17 177.2l-38.4-38.4a7.91 7.91 0 00-11.2 0L138 327.08a7.91 7.91 0 000 11.2l38.5 38.6a7.91 7.91 0 0011.2 0L376.17 188.4a7.91 7.91 0 000-11.2zM347.6 688.99a48 48 0 1067.88-67.89A48 48 0 10347.6 689z"
      }
    }]
  },
  "name": "mobile-phone-shake-stroke"
};
a['MobilePhoneStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 64H256a64 64 0 00-64 64v768a64 64 0 0064 64h512a64 64 0 0064-64V128a64 64 0 00-64-64zm-21.33 85.33v448H277.33v-448zM277.33 874.67v-192h469.34v192zm181.55-96a53.33 53.33 0 10106.67 0 53.33 53.33 0 10-106.67 0z"
      }
    }]
  },
  "name": "mobile-phone-stroke"
};
a['ModuleImportStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M950.61 889.81l-259.2-259.2 74.46-74.66A21.33 21.33 0 00752 519.68l-220.8-11.3a21.33 21.33 0 00-21.33 22.4l11.3 220.8a21.33 21.33 0 0036.27 13.86l74.67-74.45 258.13 259.2a32 32 0 0045.44 0l14.93-15.15a31.79 31.79 0 000-45.23z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M485.76 874.67H149.33V149.33h725.34v335.79a32 32 0 0032 32H928a32 32 0 0032-32V128a64 64 0 00-64-64H128a64 64 0 00-64 64v768a64 64 0 0064 64h357.76a32 32 0 0032-32v-21.33a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "module-import-stroke"
};
a['ModuleViewStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M407 197.5H199v117h208zm40.45-71.5a32 32 0 0131.89 32.11l-.68 197A32 32 0 01446.55 387l-288-1a32 32 0 01-31.89-32.11l.68-197A32 32 0 01159.45 125zM408 520H200v304h208zm40-72a32 32 0 0132 32v384a32 32 0 01-32 32H160a32 32 0 01-32-32V480a32 32 0 0132-32zm376-251H616v627h208zm40-72a32 32 0 0132 32v707a32 32 0 01-32 32H576a32 32 0 01-32-32V157a32 32 0 0132-32z"
      }
    }]
  },
  "name": "module-view-stroke"
};
a['MoreCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 96c229.75 0 416 186.25 416 416S741.75 928 512 928 96 741.75 96 512 282.25 96 512 96zm199.6 368c-26.45 0-47.9 21.49-47.9 48s21.45 48 47.9 48 47.9-21.49 47.9-48-21.45-48-47.9-48zM512 464c-26.45 0-47.9 21.49-47.9 48s21.45 48 47.9 48 47.9-21.49 47.9-48-21.45-48-47.9-48zm-223.55 6.43C273.63 479 264.5 494.85 264.5 512s9.13 33 23.95 41.57a47.81 47.81 0 0047.9 0C351.17 545 360.3 529.15 360.3 512s-9.13-33-23.95-41.57a47.81 47.81 0 00-47.9 0z"
      }
    }]
  },
  "name": "more-circle-fill"
};
a['MoreLineStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M894 472H130a8 8 0 00-8 8v64a8 8 0 008 8h764a8 8 0 008-8v-64a8 8 0 00-8-8zm0 302H130a8 8 0 00-8 8v64a8 8 0 008 8h764a8 8 0 008-8v-64a8 8 0 00-8-8zm0-604H130a8 8 0 00-8 8v64a8 8 0 008 8h764a8 8 0 008-8v-64a8 8 0 00-8-8z"
      }
    }]
  },
  "name": "more-line-stroke"
};
a['MoreStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M426.67 512.43a85.33 85.33 0 10170.66 0 85.33 85.33 0 10-170.66 0zM768 511.57a85.33 85.33 0 10170.67 0 85.33 85.33 0 10-170.67 0zM85.33 512.43a85.33 85.33 0 10170.67 0 85.33 85.33 0 10-170.67 0z"
      }
    }]
  },
  "name": "more-stroke"
};
a['More'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M856.83 146.3H169.98c-32.57 0-58.88 13.96-58.88 31.36v83.59c0 17.28 26.3 31.36 58.88 31.36h686.85c32.58 0 58.88-14.08 58.88-31.36v-83.59c0-17.4-26.3-31.36-58.88-31.36zm0 292.23H169.98c-32.57 0-58.88 14.08-58.88 31.36v83.58c0 17.35 26.3 31.36 58.88 31.36h686.85c32.58 0 58.88-14.01 58.88-31.36V469.9c0-17.28-26.3-31.36-58.88-31.36zm0 292.93H169.98c-32.57 0-58.88 13.95-58.88 31.36v83.52c0 17.4 26.3 31.36 58.88 31.36h686.85c32.58 0 58.88-13.96 58.88-31.36v-83.59c0-17.28-26.3-31.36-58.88-31.36z"
      }
    }]
  },
  "name": "More"
};
a['MoveFavoriteStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M431.57 186.88h432.86v362.67a39.25 39.25 0 0039.46 42.66 41.17 41.17 0 0039.26-42.66v-384a61.44 61.44 0 00-58.88-64h-452.7c-39.25 0-39.25 42.66-39.25 42.66a41.17 41.17 0 0039.25 42.67z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M692.27 289.28H187.09a64 64 0 00-64 64v46.08a32 32 0 0032 32h21.34a32 32 0 0032-32v-24.75h462.5v462.51h-462.5v-32.21a32 32 0 00-32-32h-21.34a32 32 0 00-32 32v53.54a64 64 0 0064 64h505.18a64 64 0 0064-64V353.28a64 64 0 00-64-64z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M543.15 593.28L396.37 474.45a13.65 13.65 0 00-21.33 10.46v76.37H113.07a32 32 0 00-32 32v21.33a32 32 0 0032 32h261.12V723a13.65 13.65 0 0021.33 10.45l146.77-118.83a13.65 13.65 0 00.86-21.33z"
      }
    }]
  },
  "name": "Move-favorite-stroke"
};
a['MoveLeftStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M865.92 59.52h-21.33a32 32 0 00-32 32v832a32 32 0 0032 32h21.33a32 32 0 0032-32v-832a32 32 0 00-32-32zM652.59 462.93H280.75a32 32 0 00-32 32v21.34a32 32 0 0032 32h371.84a32 32 0 0032-32v-21.34a32 32 0 00-32-32z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M268.37 346.24a31.57 31.57 0 00-23.89 10.88l-110.72 128a32 32 0 000 42.67l110.72 128a31.15 31.15 0 0023.9 11.09 31.79 31.79 0 0032.2-32V378.24a31.79 31.79 0 00-32.2-32z"
      }
    }]
  },
  "name": "move-left-stroke"
};
a['MoveRightStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M179.41 64h-21.33a32 32 0 00-32 32v832a32 32 0 0032 32h21.33a32 32 0 0032-32V96a32 32 0 00-32-32zm563.84 406.4H371.41a32 32 0 00-32 32v21.33a32 32 0 0032 32h371.84a32 32 0 0032-32V502.4a32 32 0 00-32-32z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M755.63 353.7a31.79 31.79 0 00-32.22 32V640a32 32 0 0056.11 21.33l110.72-128a32 32 0 000-42.66l-110.72-128a31.15 31.15 0 00-23.9-11.1z"
      }
    }]
  },
  "name": "move-right-stroke"
};
a['MoveStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M907.1 488.53L805.54 388.27c-10.03-10.03-27.31-2.78-27.31 11.3v69.12H553.6V245.33h69.76c14.3 0 21.33-17.06 11.3-27.3L533.98 116.48c-12.58-12.59-33.06-12.59-45.44 0L388.27 218.03c-10.03 10.02-2.78 27.3 11.3 27.3h68.7V470.4H246.19v-70.19c0-14.29-17.07-21.33-27.31-11.3L117.33 489.6c-12.58 12.59-12.58 33.07 0 45.44l101.55 100.27c10.03 10.02 27.3 2.77 27.3-11.31v-68.05h222.94v221.44h-68.9c-14.3 0-21.34 17.06-11.31 27.3L489.6 906.24c12.59 12.59 33.07 12.59 45.44 0l100.27-101.55c10.02-10.02 2.77-27.3-11.31-27.3h-69.33V554.03h224v69.12c0 14.29 17.06 21.33 27.3 11.3l101.55-100.69c12.37-12.16 12.37-32.64-.43-45.23z"
      }
    }]
  },
  "name": "move-stroke"
};
a['MoveToStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M624.21 499.63L457.6 364.37a15.57 15.57 0 00-25.39 12.16v92.8H131a32 32 0 00-32 32v21.34a32 32 0 0032 32H432.2v92.37a15.57 15.57 0 0025.39 12.16l166.61-135.25a15.57 15.57 0 000-24.32z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M861.01 128h-640a64 64 0 00-64 64v113.07a32 32 0 0032 32h21.34a32 32 0 0032-32v-91.74h597.33v597.34H242.35V704a32 32 0 00-32-32H189a32 32 0 00-31.57 32v128a64 64 0 0064 64h640a64 64 0 0064-64V192a64 64 0 00-64.43-64z"
      }
    }]
  },
  "name": "move-to-stroke"
};
a['NewDataStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M419.33 874.5H192v-512h618.5v74.75a31.58 31.58 0 0031.74 31.74h21.5a31.58 31.58 0 0031.75-31.74V128c0-35.33-28.67-64-64-64h-661c-35.32 0-64 28.67-64 64v768c0 35.33 28.68 64 64 64h248.84a31.58 31.58 0 0031.74-31.74v-21.5c.51-17.93-13.82-32.26-31.74-32.26zm391.17-725v128H192v-128h618.5z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M780.8 558.08V917.5a42.4 42.4 0 01-42.5 42.5 42.4 42.4 0 01-42.5-42.5V558.08a42.4 42.4 0 0142.5-42.5c23.56 0 42.5 19.46 42.5 42.5z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M558.6 695.3h359.42a42.4 42.4 0 0142.5 42.5 42.4 42.4 0 01-42.5 42.49H558.59a42.4 42.4 0 01-42.5-42.5c.52-23.55 19.46-42.5 42.5-42.5z"
      }
    }]
  },
  "name": "New-data-stroke"
};
a['NotEquaToStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M720.64 85.33a31.79 31.79 0 00-27.73 16l-138.24 240H110.29a32 32 0 00-32 32v21.34a32 32 0 0032 32h394.46l-99.42 170.66H110.3a32 32 0 00-32 32v21.34a32 32 0 0032 32h246.62L243.2 880.2a32 32 0 0012.8 43.74l18.35 10.66a33.92 33.92 0 0016 4.27 32 32 0 0027.73-16l137.39-240.21h444.16a32 32 0 0032-32v-21.34a32 32 0 00-32-32H504.75l98.56-170.66h296.32a32 32 0 0032-32v-21.34a32 32 0 00-32-32H652.59l114.13-197.76a32 32 0 00-11.73-42.66l-18.35-10.67a33.92 33.92 0 00-16-4.27z"
      }
    }]
  },
  "name": "not-equa-to-stroke"
};
a['NotEqualToStoke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M103.68 276.05h825.81q32 0 32 32v21.34q0 32-32 32H103.68q-32 0-32-32v-21.34q0-32 32-32zM103.68 596.05h825.81q32 0 32 32v21.34q0 32-32 32H103.68q-32 0-32-32v-21.34q0-32 32-32z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M222.11 881.79L643.87 92.23q15.08-28.23 43.3-13.15L706 89.13q28.23 15.08 13.15 43.3L297.38 922q-15.08 28.23-43.3 13.15l-18.82-10.05q-28.23-15.08-13.15-43.3z"
      }
    }]
  },
  "name": "not-equal-to-stoke"
};
a['NoticeFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 93.87C281.6 93.87 93.87 281.6 93.87 512v17.07c4.26 51.2 12.8 102.4 34.13 149.33l4.27 4.27-25.6 132.26c-4.27 12.8 0 21.34 0 34.14 8.53 38.4 51.2 64 89.6 51.2L307.2 870.4c59.73 34.13 132.27 51.2 200.53 51.2 230.4 0 418.14-187.73 418.14-418.13S742.4 93.87 512 93.87zm0 618.66c-89.6 0-162.13-72.53-162.13-157.86 0-17.07 12.8-34.14 34.13-34.14s34.13 12.8 34.13 34.14c0 51.2 42.67 93.86 93.87 93.86s93.87-42.66 93.87-93.86c0-17.07 12.8-34.14 34.13-34.14s34.13 12.8 34.13 34.14c0 89.6-72.53 157.86-162.13 157.86z"
      }
    }]
  },
  "name": "notice-fill"
};
a['NoticeStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M853.33 273.07c-8.53-12.8-29.86-17.07-42.66-8.54-12.8 8.54-17.07 29.87-8.54 42.67 98.14 136.53 81.07 324.27-34.13 448C652.8 874.67 465.07 896 324.27 806.4c-8.54-4.27-17.07-8.53-25.6-4.27l-132.27 25.6c-4.27 0-8.53 0-12.8-4.26-4.27-4.27-4.27-8.54-4.27-12.8l38.4-149.34c4.27-8.53 4.27-17.06 0-25.6C128 499.2 170.67 337.07 285.87 243.2a353.13 353.13 0 01413.86-25.6c12.8 8.53 34.14 4.27 42.67-8.53 8.53-17.07 4.27-34.14-8.53-42.67C580.27 64 384 76.8 247.47 192 110.93 307.2 64 490.67 123.73 657.07l-38.4 145.06c-8.53 25.6 0 51.2 17.07 72.54 17.07 17.06 42.67 25.6 68.27 21.33l128-25.6c68.26 38.4 140.8 59.73 213.33 59.73 110.93 0 217.6-42.66 298.67-128C947.2 657.07 968.53 435.2 853.33 273.07z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M605.87 554.67c0 51.2-42.67 93.86-93.87 93.86s-93.87-42.66-93.87-93.86c0-17.07-12.8-34.14-34.13-34.14s-34.13 17.07-34.13 34.14c0 89.6 72.53 162.13 162.13 162.13s162.13-72.53 162.13-162.13c0-17.07-12.8-34.14-34.13-34.14s-34.13 17.07-34.13 34.14z"
      }
    }]
  },
  "name": "notice-stroke"
};
a['NotificationStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M840 819.7L318.8 610.3l-12.9-5.2H184V416.9h121.9l12.9-5.2L840 202.3zm-496-58.4a47.91 47.91 0 01-48-47.8 47.29 47.29 0 0111-30.4l84.9 34.1a48.13 48.13 0 01-47.9 44.1zM880 111a30.35 30.35 0 00-11.6 2.3L292 344.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7a120 120 0 00-5.7 36.4c0 65.9 53.8 119.5 120 119.5a120.22 120.22 0 00115.9-88.4l408.6 164.2a32.36 32.36 0 0011.6 2.3c16.9 0 32-14.2 32-33.2V144.2C912 125.2 897 111 880 111z"
      }
    }]
  },
  "name": "notification-stroke"
};
a['NumberOfPagesStoke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M833.5 958.3h-640a64 64 0 01-64-64V123.94a64 64 0 0164-64h421.33a42.67 42.67 0 0129.22 11.52l240 225.06a42.67 42.67 0 0113.44 31.15v566.61a64 64 0 01-64 64zm-618.67-85.34h597.33V346.03L597.33 145.28h-384z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M442.67 390.19a11.1 11.1 0 00-8.32-3.63h-33.71a12.37 12.37 0 00-5.97 1.5l-80.22 42.66a15.57 15.57 0 00-7.89 11.3l-5.55 36.91a13.01 13.01 0 005.12 12.38 14.08 14.08 0 0014.51 0l46.93-24.54L336 693.33a16.43 16.43 0 003.63 13.44 17.28 17.28 0 0012.58 5.55H384a21.33 21.33 0 0019.84-17.5l42.67-295.89a10.67 10.67 0 00-3.84-8.74zm265.17 40.74a81.92 81.92 0 00-34.77-36.48 113.7 113.7 0 00-54.4-13.01 136.1 136.1 0 00-71.26 18.13 115.63 115.63 0 00-42.66 45.66 13.23 13.23 0 003.84 17.49l24.53 15.79a12.59 12.59 0 0010.03 1.7 16.43 16.43 0 0010.24-7.89 77.01 77.01 0 0121.33-23.04 60.8 60.8 0 0135.84-10.67 34.77 34.77 0 0138.19 43.74A66.56 66.56 0 01635.73 512a203.52 203.52 0 01-33.06 34.56L472.75 661.33a21.33 21.33 0 00-6.62 12.38l-2.77 19.84a16.64 16.64 0 003.63 13.44 17.28 17.28 0 0012.58 5.54h187.31a21.33 21.33 0 0019.84-17.49l2.99-21.33a17.7 17.7 0 00-3.84-13.44 16.21 16.21 0 00-12.59-5.55H566.61l69.55-62.5c17.5-15.15 31.36-28.38 41.39-38.83a158.93 158.93 0 0025.17-33.28 101.76 101.76 0 0012.37-37.12 91.1 91.1 0 00-7.25-52.06z"
      }
    }]
  },
  "name": "number-of-pages-stoke"
};
a['OpenStoke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M97.92 212.05h470.4q32 0 32 32v21.34q0 32-32 32H97.92q-32 0-32-32v-21.34q0-32 32-32zM97.92 466.77h470.4q32 0 32 32v21.34q0 32-32 32H97.92q-32 0-32-32v-21.34q0-32 32-32zM97.28 724.05h470.4q32 0 32 32v21.34q0 32-32 32H97.28q-32 0-32-32v-21.34q0-32 32-32zM940.8 494.08l-213.33-123.3a21.33 21.33 0 00-32 18.34v246.61a21.33 21.33 0 0032 18.56L940.8 531a21.33 21.33 0 000-36.91z"
      }
    }]
  },
  "name": "open-stoke"
};
a['PageStoke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M833.5 958.3h-640a64 64 0 01-64-64V123.94a64 64 0 0164-64h421.33a42.67 42.67 0 0129.22 11.52l240 225.06a42.67 42.67 0 0113.44 31.15v566.61a64 64 0 01-64 64zm-618.67-85.34h597.33V346.03L597.33 145.28h-384z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M676.27 504.53a17.07 17.07 0 0017.06-17.06V457.6a17.07 17.07 0 00-17.06-17.07h-34.35l12.8-71.46A17.07 17.07 0 00637.87 349h-30.3a17.07 17.07 0 00-16.85 14.08l-13.65 77.44H483.2l12.8-71.46A17.07 17.07 0 00479.15 349H448a17.07 17.07 0 00-16.85 14.08l-13.66 77.44h-70.61a17.07 17.07 0 00-17.07 17.07v29.87a17.07 17.07 0 0017.07 17.06h59.95l-17.5 98.35h-42.66a17.07 17.07 0 00-17.07 17.07v29.86a17.07 17.07 0 0017.07 17.07h31.14l-11.52 64a16.85 16.85 0 0016.43 20.05h30.5a17.07 17.07 0 0016.86-14.08l12.59-70.82h93.86l-11.73 64a17.07 17.07 0 0016.85 20.05h30.3A17.07 17.07 0 00588.8 736l12.59-70.83h74.66a17.07 17.07 0 0017.07-17.06v-29.87a16.85 16.85 0 00-17.07-17.07h-64l17.5-98.34zm-128 98.35H454.4l17.5-98.35h93.65z"
      }
    }]
  },
  "name": "page-stoke"
};
a['PaintBucketStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M880 832H144a32.09 32.09 0 00-32 32v46a8 8 0 008 8h784a8 8 0 008-8v-46a32.09 32.09 0 00-32-32zM671 444.56l-256-256a16.32 16.32 0 00-2-1.7l-78.2-78.2a9.11 9.11 0 00-12.8 0l-48 48a9.11 9.11 0 000 12.8l67.2 67.2-207.8 207.9a18 18 0 000 25.6l255.9 256a18 18 0 0025.6 0l256.1-256a18 18 0 000-25.6zm-447.6 11.9l178.8-178.9 178.9 178.9zm543 303.8c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8s-79.4 87.3-79.4 140.8c0 44.3 35.7 80.5 79.4 80.5z"
      }
    }]
  },
  "name": "paint-bucket-stroke"
};
a['PaletteFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M515.1 136.08c-141.34-2.9-268.55 52.34-352.3 140.92C100.3 343.14 62 427.84 60.09 520.81a351.4 351.4 0 0019.53 123c7.68 22.08 35.58 29 52.42 12.75a193.83 193.83 0 01140.45-54.36c106.71 3 191.55 92.52 188.92 199.24a193.88 193.88 0 01-17.52 76.11c-9.27 20.22 4.75 43.35 26.93 45q13.92 1 28.08 1.35c246.82 5.07 450.53-167.17 455-384.73S761.92 141.16 515.1 136.08zM276.8 440.25a55 55 0 1156.12-53.86 55 55 0 01-56.12 53.86zm209.12-52.71A55 55 0 11542 333.68a55 55 0 01-56.08 53.86zm210.35-14.68a55 55 0 11-56.12 53.86 55 55 0 0156.12-53.86zm28.94 343.67A73 73 0 11799.7 645a73 73 0 01-74.49 71.53z"
      }
    }]
  },
  "name": "palette-fill"
};
a['PalletFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M730.88 331.3c-27.52-27.51-42.67-26.87-64-130.13S571.95 65.5 490.67 65.5C244.05 65.5 64 265.4 64 512a446.5 446.5 0 00448 446.5c246.61 0 449.7-165.33 448-411.94-2.13-223.57-186.45-172.8-229.12-215.25zm-484.7 135.9a56.75 56.75 0 1156.75 56.75 56.75 56.75 0 01-56.74-56.75zm125.23 215.47a45.44 45.44 0 1145.44-45.44 45.23 45.23 0 01-45.44 45.44zm33.92-309.98a71.04 71.04 0 1171.04-71.04 71.04 71.04 0 01-71.04 71.04z"
      }
    }]
  },
  "name": "pallet-fill"
};
a['PalletStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M490.67 150.83c64 0 82.98 25.81 91.73 67.62 20.27 98.35 40.96 130.35 79.57 165.12l8.75 7.9a193.28 193.28 0 00106.67 45.44c66.34 13.01 96.64 18.98 97.28 110.08A303.36 303.36 0 01786.35 768a387.63 387.63 0 01-275.2 106.67A362.67 362.67 0 01149.33 512c0-205.87 146.99-361.17 341.34-361.17m0-85.34C244.05 65.5 64 265.4 64 512a446.5 446.5 0 00448 446.5c246.61 0 449.7-165.33 448-411.94-1.5-223.57-185.81-172.8-228.48-215.25-27.52-27.52-42.67-26.88-64-130.14S571.95 65.5 490.67 65.5z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M405.33 230.61a71.04 71.04 0 1071.04 71.04 71.04 71.04 0 00-71.04-71.04zm-102.4 179.84a56.75 56.75 0 1056.75 56.75 56.75 56.75 0 00-56.75-56.75zM371.41 592a45.44 45.44 0 1045.44 45.44A45.44 45.44 0 00371.41 592z"
      }
    }]
  },
  "name": "pallet-stroke"
};
a['PaperPlaneStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M935.04 84.05a67.84 67.84 0 00-48.43-21.33 56.1 56.1 0 00-10.45 0 62.08 62.08 0 00-14.08 3.63l-3.63 1.49-757.12 327.04-5.33 2.35a64 64 0 00-21.33 15.14l-4.48 5.34A66.77 66.77 0 0096.85 518.4l4.06 1.7 145.28 61.23a33.07 33.07 0 0013.01 2.78 32 32 0 0029.65-19.84l7.47-18.14a28.37 28.37 0 002.35-12.8 31.79 31.79 0 00-19.42-29.44L192 465.71l-13.87-5.76-7.46-2.78 5.76-2.13 15.57-5.55 643.2-277.33 23.04-10.03 4.7-1.92v5.55l-4.49 24.32L768 663.47l-6.83 37.12v5.33l-6.61-1.92-34.35-15.15-70.18-29.44-159.36-67.62L663.25 419.4a32.43 32.43 0 000-45.44l-15.14-14.93a31.79 31.79 0 00-45.23 0L401.71 560.21a33.07 33.07 0 00-6.62 9.82 29.65 29.65 0 00-2.56 12.16v335.14A42.67 42.67 0 00435.2 960h1.5a30.5 30.5 0 0018.55-4.05l153.82-88.75a32.21 32.21 0 0011.73-42.67l-10.67-18.56a32 32 0 00-43.73-11.73l-88.53 51.2V678.61l266.66 112.64 3.42 1.28a67.41 67.41 0 0090.02-48.21v-1.7l1.71-8.54 112.21-588.16v-4.27a93.01 93.01 0 001.07-11.09 67.2 67.2 0 00-17.92-46.5z"
      }
    }]
  },
  "name": "paper-plane-stroke"
};
a['PauseCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64a448 448 0 10448 448A448 448 0 00512 64zm-85.33 629.33a32 32 0 01-32 32h-21.34a32 32 0 01-32-32V330.67a32 32 0 0132-32h21.34a32 32 0 0132 32zm256 0a32 32 0 01-32 32h-21.34a32 32 0 01-32-32V330.67a32 32 0 0132-32h21.34a32 32 0 0132 32z"
      }
    }]
  },
  "name": "pause-circle-fill"
};
a['PauseCircleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 149.33A362.67 362.67 0 11149.33 512 362.67 362.67 0 01512 149.33M512 64a448 448 0 10448 448A448 448 0 00512 64z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M394.67 298.67h-21.34a32 32 0 00-32 32v362.66a32 32 0 0032 32h21.34a32 32 0 0032-32V330.67a32 32 0 00-32-32zm256 0h-21.34a32 32 0 00-32 32v362.66a32 32 0 0032 32h21.34a32 32 0 0032-32V330.67a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "pause-circle-stroke"
};
a['PayCircleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 149.33c200.53 0 362.67 162.14 362.67 362.67S712.53 874.67 512 874.67 149.33 712.53 149.33 512 311.47 149.33 512 149.33M512 64C264.53 64 64 264.53 64 512s200.53 448 448 448 448-200.53 448-448S759.47 64 512 64z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M646.4 266.67h-25.6c-10.67 0-21.33 6.4-27.73 14.93L512 422.4l-81.07-140.8c-6.4-8.53-14.93-14.93-27.73-14.93h-25.6c-17.07 0-32 14.93-32 32 0 6.4 2.13 10.66 4.27 17.06l87.46 149.34h-44.8c-17.06 0-32 14.93-32 32v21.33c0 17.07 14.94 32 32 32h76.8v38.4h-74.66c-17.07 0-32 14.93-32 32v21.33c0 17.07 14.93 32 32 32h74.66v51.2c0 17.07 14.94 32 32 32h21.34c17.06 0 32-14.93 32-32V672h74.66c17.07 0 32-14.93 32-32v-21.33c0-17.07-14.93-32-32-32h-74.66V550.4h74.66c17.07 0 32-14.93 32-32v-21.33c0-17.07-14.93-32-32-32h-42.66L672 317.87v-2.14c2.13-4.26 4.27-10.66 4.27-17.06 0-17.07-14.94-32-32-32h2.13z"
      }
    }]
  },
  "name": "pay-circle-stroke"
};
a['PenStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M713.1 659L450.3 400.1 597.6 255l262.8 259zm-168.5 76.1L373.2 566.2l68.6-67.6 171.4 168.9zm-154.8 62.1H229.6l134.4-133 80.1 78.9zm567.8-288.8L603.2 159.2a7.91 7.91 0 00-11.2 0L353.3 394.4a8 8 0 00-.1 11.3l.1.1 40 39.4-117.2 115.3a8 8 0 00-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1a8.11 8.11 0 00-8.1 8V861a8 8 0 008 8h344.9a7.87 7.87 0 005.6-2.3l76.1-75.6 40.4 39.8a7.91 7.91 0 0011.2 0l117.1-115.6 40.1 39.5a7.91 7.91 0 0011.2 0l238.7-235.2a7.65 7.65 0 00.3-11.2z"
      }
    }]
  },
  "name": "pen-stroke"
};
a['PhoneStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M919.25 204.8L796.16 81.5a64 64 0 00-90.67 0l-38.61 38.82-76.16 75.95-32.43 32.42a65.07 65.07 0 000 90.46l17.07 17.06 92.8 92.8a550.19 550.19 0 01-100.27 139.1 544.43 544.43 0 01-138.88 100.05L336.21 576l-17.06-17.07a65.07 65.07 0 00-90.46 0l-32.42 32-75.95 75.95-38.83 38.83a64 64 0 000 90.45l123.31 123.1c36.48 36.69 92.8 48.42 159.15 38.82a386.56 386.56 0 0047.78-10.45 651.73 651.73 0 00182.19-87.04 981.33 981.33 0 00146.13-120.54 955.1 955.1 0 00120.32-146.13 647.04 647.04 0 0087.26-182.19 381.65 381.65 0 0010.24-47.57c9.81-65.5-1.92-122.88-38.62-159.36zm-59.73 203.3a507.73 507.73 0 01-27.1 64 691.2 691.2 0 01-44.58 76.17 887.25 887.25 0 01-108.16 130.98 887.25 887.25 0 01-130.99 108.16A691.2 691.2 0 01472.53 832a478.5 478.5 0 01-64 27.1c-65.7 21.33-120.53 21.33-143.14 0l-99.42-99-8.96-9.17 8.75-8.74 4.9-4.48 55.47-55.04 47.79-47.79 17.7 17.7 48.43 48.43 69.34 69.34a501.12 501.12 0 0083.2-37.55 621.01 621.01 0 00135.68-103.47 627.63 627.63 0 00103.46-135.68 501.12 501.12 0 0037.55-83.2l-69.33-69.33-48.43-48.43-17.7-17.7 48.85-48.86 54.82-55.46 4.7-4.48 8.74-8.75 8.96 9.17 98.99 98.99c22.61 21.97 22.83 76.8.64 142.5z"
      }
    }]
  },
  "name": "phone-stroke"
};
a['PlugInCenterFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M702.72 250.45L547.2 94.93a66.35 66.35 0 00-93.65 0L83.2 465.07a66.56 66.56 0 000 93.86l370.35 370.14a66.35 66.35 0 0093.65 0l155.52-155.52a42.67 42.67 0 000-59.1l-172.8-172.8a42.67 42.67 0 010-59.09l172.8-173.01a42.67 42.67 0 000-59.1z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M817.16 344.63l125.8 125.81q41.64 41.64 0 83.27l-125.8 125.8q-41.64 41.64-83.27 0l-125.81-125.8q-41.63-41.63 0-83.27l125.8-125.8q41.64-41.64 83.28 0z"
      }
    }]
  },
  "name": "Plug-in-center-fill"
};
a['PlugInCenterStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M490.67 849.92L167.89 527.79a21.33 21.33 0 010-30.08l322.78-322.14a21.33 21.33 0 0130.08 0l129.28 129.5a21.33 21.33 0 0030.29 0l30.08-30.3a21.33 21.33 0 000-30.08L552.75 87.68a67.41 67.41 0 00-95.58 0L77.44 467.63a64 64 0 000 90.45l379.73 380.59a68.05 68.05 0 0095.58 0l157.01-157.02a21.33 21.33 0 000-30.29l-30.08-30.08a21.33 21.33 0 00-30.3 0L520.12 850.56a21.33 21.33 0 01-29.44-.64z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M754.35 705.07a59.73 59.73 0 01-42.67-17.5L576 551.68a59.95 59.95 0 010-85.33l135.9-135.9a61.23 61.23 0 0185.33 0l135.89 135.9a59.95 59.95 0 010 85.33l-135.9 135.9a59.73 59.73 0 01-42.87 17.49zM624 509.23L754.35 640l130.34-130.13-130.34-130.35z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M754.35 711.47a65.92 65.92 0 01-46.94-19.42L571.52 556.16a66.13 66.13 0 010-93.87l135.9-136.1a66.56 66.56 0 0146.93-18.78 66.56 66.56 0 0146.93 18.78l135.9 136.1a66.13 66.13 0 010 93.87l-135.9 135.9a65.92 65.92 0 01-46.93 19.4zm0-391.26a53.97 53.97 0 00-37.98 15.15l-135.89 135.9a53.55 53.55 0 000 75.73l135.9 135.68a55.04 55.04 0 0075.94 0l135.9-136.11a53.76 53.76 0 000-75.73l-135.9-135.9A54.19 54.19 0 00754.35 320zm0 328.32l-139.31-139.3 139.3-139.31 139.31 139.3zm-121.18-139.3L754.35 630.4l120.32-121.17-121.18-121.39z"
      }
    }]
  },
  "name": "Plug-in-center-stroke"
};
a['Plugin'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M466.82 94.4A113.54 113.54 0 01573.7 245.76h157.7a75.52 75.52 0 0175.51 75.52v157.76a113.54 113.54 0 110 213.82v157.76a75.52 75.52 0 01-75.52 75.78H573.95a113.54 113.54 0 10-214.01 0h-157.7a75.52 75.52 0 01-75.52-75.78V693.63a113.28 113.28 0 100-213.89v-157.7a75.5 75.5 0 0175.52-75.51h157.7A113.4 113.4 0 01467 95.36l-.2-.96z"
      }
    }]
  },
  "name": "plugin"
};
a['PlusCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64a448 448 0 10448 448A448 448 0 00512 64zm213.33 457.6a32 32 0 01-32 33.07H554.67v138.66a32 32 0 01-32 32h-19.2a32 32 0 01-32-32V554.67h-140.8a32 32 0 01-32-32v-19.2a32 32 0 0132-32H470.4v-140.8a32 32 0 0132-32h19.2a32 32 0 0133.07 32V470.4h138.66a32 32 0 0132 32z"
      }
    }]
  },
  "name": "plus-circle-fill"
};
a['PlusCircleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 149.33c199.9 0 362.67 162.78 362.67 362.67S711.89 874.67 512 874.67c-199.9 0-362.67-162.78-362.67-362.67S312.11 149.33 512 149.33M512 64C264.53 64 64 264.53 64 512s200.53 448 448 448 448-200.53 448-448S759.47 64 512 64zm186.45 400H554.67V328.32c0-17.7-14.3-32-32-32h-21.34c-17.7 0-32 14.3-32 32V464H325.55c-17.71 0-32 14.3-32 32v21.33c0 17.71 14.29 32 32 32h143.78v151.9c0 17.7 14.3 32 32 32h21.34c17.7 0 32-14.3 32-32v-151.9h143.78c17.71 0 32-14.29 32-32V496c0-17.7-14.29-32-32-32z"
      }
    }]
  },
  "name": "plus-circle-stroke"
};
a['PlusSquareFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 64H128c-35.33 0-64 28.67-64 64v768c0 35.33 28.67 64 64 64h768c35.33 0 64-28.67 64-64V128c0-35.33-28.67-64-64-64zM730.62 514.56a31.58 31.58 0 01-31.74 31.74H555.01v152.07a31.58 31.58 0 01-31.75 31.74h-21.5a31.58 31.58 0 01-31.74-31.74V546.3H325.63a31.58 31.58 0 01-31.74-31.74v-21.5a31.58 31.58 0 0131.74-31.75H469.5V325.63a31.58 31.58 0 0131.75-31.74h21.5a31.58 31.58 0 0131.75 31.74v135.68h143.87a31.58 31.58 0 0131.74 31.75v21.5z"
      }
    }]
  },
  "name": "plus-square-fill"
};
a['PlusSquareStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M874.67 149.33v725.34H149.33V149.33h725.34M896 64H128c-35.41 0-64 28.59-64 64v768c0 35.41 28.59 64 64 64h768c35.41 0 64-28.59 64-64V128c0-35.41-28.59-64-64-64z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M698.45 461.23H554.67V325.55c0-17.71-14.3-32-32-32h-21.34c-17.7 0-32 14.29-32 32v135.68H325.55c-17.71 0-32 14.29-32 32v21.33c0 17.7 14.29 32 32 32h143.78v151.9c0 17.7 14.3 32 32 32h21.34c17.7 0 32-14.3 32-32v-151.9h143.78c17.71 0 32-14.3 32-32v-21.33c0-17.71-14.29-32-32-32z"
      }
    }]
  },
  "name": "plus-square-stroke"
};
a['PlusStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M863.79 469.12H554.67V160c0-17.7-14.3-32-32-32h-21.34c-17.7 0-32 14.3-32 32v309.12H160.21c-17.7 0-32 14.3-32 32v21.33c0 17.71 14.3 32 32 32h309.12v309.12c0 17.71 14.3 32 32 32h21.34c17.7 0 32-14.29 32-32V554.45h309.12c17.7 0 32-14.29 32-32v-21.33c0-17.7-14.3-32-32-32z"
      }
    }]
  },
  "name": "plus-stroke"
};
a['PoweroffCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M509.87 64c-247.47 0-448 200.53-448 448s200.53 448 448 448 448-200.53 448-448-200.54-448-448-448zM467.2 275.2c0-17.07 14.93-32 32-32h21.33c17.07 0 32 14.93 32 32V512c0 17.07-14.93 32-32 32H499.2c-17.07 0-32-14.93-32-32V275.2zm245.33 418.13C608 804.27 433.07 810.67 320 706.13c-110.93-104.53-117.33-279.46-12.8-390.4 2.13-2.13 4.27-6.4 8.53-8.53 14.94-10.67 34.14-8.53 44.8 6.4l12.8 17.07c10.67 12.8 10.67 29.86-2.13 42.66-70.4 74.67-70.4 192 0 264.54 74.67 76.8 194.13 78.93 270.93 4.26 76.8-74.66 78.94-194.13 4.27-270.93-4.27-6.4-8.53-12.8-8.53-21.33s2.13-17.07 8.53-23.47l8.53-10.67c2.14-4.26 6.4-6.4 10.67-10.66 14.93-8.54 34.13-4.27 44.8 10.66 102.4 104.54 102.4 270.94 2.13 377.6z"
      }
    }]
  },
  "name": "poweroff-circle-fill"
};
a['PoweroffStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M501.97 564.48h21.34a31.36 31.36 0 0031.36-31.15v-422.4a31.36 31.36 0 00-31.36-31.36h-21.34a31.36 31.36 0 00-31.36 31.36v422.4a31.36 31.36 0 0031.36 31.15z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M682.67 221.65A41.17 41.17 0 00700.16 256a330.03 330.03 0 01142.08 292.27A330.88 330.88 0 11325.97 256a42.67 42.67 0 0017.92-35.2 42.67 42.67 0 00-66.56-35.84 416.21 416.21 0 10473.39 1.92 42.67 42.67 0 00-68.05 34.77z"
      }
    }]
  },
  "name": "poweroff-stroke"
};
a['PrinterFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 393.81h-72.53v-.21h-.86c.43-1.92.86-3.84.86-5.97V118.19c0-17.5-19.2-31.58-42.67-31.58H243.2c-23.47 0-42.67 14.08-42.67 31.58v269.44c0 2.13.22 4.05.86 5.97h-.86v.21H128a42.8 42.8 0 00-42.67 42.67v345.6A42.8 42.8 0 00128 824.75h91.73v93.86a42.8 42.8 0 0042.67 42.67h499.2a42.8 42.8 0 0042.67-42.67v-93.86H896a42.8 42.8 0 0042.67-42.67v-345.6A42.67 42.67 0 00896 393.81zm-42.67 345.6H804.7v-72.53a42.8 42.8 0 00-42.66-42.67H261.97a42.8 42.8 0 00-42.66 42.67v72.53h-48.64V479.15h682.66V739.4z"
      }
    }]
  },
  "name": "printer-fill"
};
a['PrinterStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M384.43 708.05h256a21.4 21.4 0 0021.33-21.33v-42.67a21.4 21.4 0 00-21.33-21.33h-256a21.4 21.4 0 00-21.34 21.33v42.67c0 11.95 9.6 21.33 21.34 21.33zM876.8 388.91h-53.33V142.72c0-31.57-27.74-57.39-61.87-57.39H262.4c-34.13 0-61.87 25.82-61.87 57.39v246.19H147.2c-34.13 0-61.87 28.8-61.87 64.42v303.58c0 35.62 27.74 64.42 61.87 64.42h72.1v76.59a61.91 61.91 0 0061.87 61.87h460.8a61.91 61.91 0 0061.87-61.87v-76.59h72.96c34.13 0 61.87-28.8 61.87-64.42V453.33c0-35.41-27.74-64.42-61.87-64.42zM285.87 164.48h452.26v224H285.87v-224zm567.46 568.1h-49.49V715.1c0-17.7-14.3-32-32-32h-21.33c-17.71 0-32 14.3-32 32v159.58H304.64V715.09c0-17.7-14.3-32-32-32h-21.33c-17.71 0-32 14.3-32 32v17.5h-48.64V477.87h682.66v254.72z"
      }
    }]
  },
  "name": "printer-stroke"
};
a['ProcessFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M734.93 730.24a30.55 30.55 0 00-30.5 30.72 30.5 30.5 0 0030.5 30.5c16.86 0 30.72-13.65 30.72-30.5a30.73 30.73 0 00-30.72-30.72zM289.28 428.37a30.72 30.72 0 000 61.44c16.85 0 30.5-13.86 30.5-30.72s-13.65-30.72-30.5-30.72zM896 106.24H128c-35.41 0-64 28.59-64 64v682.67c0 35.41 28.59 64 64 64h768c35.41 0 64-28.59 64-64V170.24c0-35.41-28.59-64-64-64zM149.33 234.45c0-17.7 14.3-32 32-32h661.34c17.7 0 32 14.3 32 32v53.34H149.33v-53.34zM875.1 771.41a21.03 21.03 0 01-21.12 21.12h-30.72a93.68 93.68 0 01-88.32 62.3 93.4 93.4 0 01-88.1-62.3H256.2c-29.44 0-56.53-10.88-76.16-30.29-19.41-19.41-30.29-45.65-30.93-74.24-1.28-60.8 50.77-109.65 111.57-109.65h506.03c24.53 0 45.23-19.84 45.01-44.38-.21-25.81-17.7-43.3-43.73-43.3H377.6a94.08 94.08 0 01-88.32 62.29c-40.75 0-75.52-26.03-88.53-62.3h-30.51a21.03 21.03 0 01-21.12-21.11v-20.91a21.03 21.03 0 0121.12-21.12h30.5c13.02-36.27 47.8-62.3 88.54-62.3 40.53 0 75.3 26.03 88.32 62.3H768c63.36 0 110.72 49.7 106.88 114.13-3.41 56.75-52.48 100.06-109.23 100.06H257.71c-24.75 0-45.87 20.05-45.23 45.01.21 12.37 4.27 22.83 12.16 30.5 7.9 7.9 18.77 11.95 31.57 11.95h390.62a93.4 93.4 0 0188.1-62.29 93.68 93.68 0 0188.32 62.3h30.72c11.74 0 21.12 9.6 21.12 21.11v21.12z"
      }
    }]
  },
  "name": "process-fill"
};
a['ProcessLinkFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M906.73 757.33h-96.15a138.43 138.43 0 00-255.68 0H277.42a91.86 91.86 0 01-96-96 95.1 95.1 0 0126.88-69.46 96.92 96.92 0 0169.12-26.54h469.31A198.23 198.23 0 00949.4 362.67 198.04 198.04 0 00746.73 160H469.25a138.43 138.43 0 00-255.68 0H117.4a42.7 42.7 0 00-42.67 42.67V224a42.7 42.7 0 0042.67 42.67h96.17a138.43 138.43 0 00255.68 0h277.48a96.96 96.96 0 0169.12 26.54 95.21 95.21 0 0126.88 69.46 91.86 91.86 0 01-96 96H277.4A198.04 198.04 0 0074.73 661.33 198.23 198.23 0 00277.4 864h277.5a138.43 138.43 0 00255.68 0h96.15a42.7 42.7 0 0042.67-42.67V800a42.7 42.7 0 00-42.67-42.67z"
      }
    }]
  },
  "name": "process-link-fill"
};
a['ProcessLinkStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M906.67 768H803.2c-17.7-49.7-64.85-85.33-120.53-85.33S579.84 718.29 562.13 768h-284.8c-62.72 0-106.66-43.95-106.66-106.67 0-30.93 10.45-57.6 30.08-77.01 19.2-19.2 46.5-29.65 76.58-29.65h469.34c109.44 0 192-82.56 192-192 0-53.34-19.63-102.19-55.26-137.6-35.41-34.99-83.84-54.4-136.74-54.4h-284.8a127.79 127.79 0 00-120.54-85.34c-55.68 0-102.82 35.63-120.53 85.34H117.33c-17.7 0-32 14.29-32 32V224c0 17.7 14.3 32 32 32H220.8c17.7 49.7 64.85 85.33 120.53 85.33S444.16 305.71 461.87 256h284.8c30.08 0 57.38 10.45 76.58 29.65 19.84 19.42 30.08 46.08 30.08 77.02 0 62.72-43.94 106.66-106.66 106.66H277.33c-52.9 0-101.33 19.42-136.74 54.4-35.63 35.42-55.26 84.27-55.26 137.6 0 109.44 82.56 192 192 192h284.8c17.71 49.71 64.86 85.34 120.54 85.34 55.68 0 102.82-35.63 120.53-85.34h103.47c17.7 0 32-14.29 32-32V800c0-17.7-14.3-32-32-32zM341.33 256c-23.46 0-42.66-19.2-42.66-42.67s19.2-42.66 42.66-42.66S384 189.87 384 213.33 365.01 256 341.33 256zm341.34 597.33c-23.47 0-42.67-19.2-42.67-42.66S659.2 768 682.67 768s42.66 19.2 42.66 42.67-19.2 42.66-42.66 42.66z"
      }
    }]
  },
  "name": "process-link-stroke"
};
a['ProcessStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M275.63 623.45h472.1a93.74 93.74 0 0069.55-157.66 92.42 92.42 0 00-68.27-28.8H370.77a79.04 79.04 0 00-144.64 0h-23.68a21.27 21.27 0 00-21.33 21.34v21.33a21.4 21.4 0 0021.33 21.33h23.68a78.87 78.87 0 00144.43 0h378.45a28.9 28.9 0 0121.76 8.75 29.53 29.53 0 017.47 22.61 30.1 30.1 0 01-30.5 27.1H275.62a94.14 94.14 0 00-94.51 87.46 92.48 92.48 0 0093.23 99.2H652.8a79.02 79.02 0 00144.43 0h23.68a21.25 21.25 0 0021.33-21.33v-21.33a21.12 21.12 0 00-21.33-21.34h-23.68a78.87 78.87 0 00-144.43 0H274.35a29.72 29.72 0 01-21.76-8.74 29.97 29.97 0 0123.04-49.92zm48.42-154.46a25.6 25.6 0 11-25.6-25.6 25.66 25.66 0 0125.6 25.6zm375.47 245.12a25.6 25.6 0 1125.6 25.6 25.6 25.6 0 01-25.6-25.6zm196.5-607.76H128.17a64 64 0 00-64 63.91h-.43v682.67h.43v.08a64 64 0 0064 64h767.85a64 64 0 0064-64V170.35a64 64 0 00-64-64zm-21.33 85.33v74.99H149.5v-74.99zM149.5 352H874.7v479.68H149.5z"
      }
    }]
  },
  "name": "process-stroke"
};
a['ProgressStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M802 490h56q8 0 8 8v390q0 8-8 8h-56q-8 0-8-8V498q0-8 8-8zM484 648h56q8 0 8 8v232q0 8-8 8h-56q-8 0-8-8V656q0-8 8-8zm-318-78h56q8 0 8 8v310q0 8-8 8h-56q-8 0-8-8V578q0-8 8-8zm353.87-120.54l-125.51-187-262.26 172.8A8 8 0 01121 433l-30.8-46.77a8 8 0 012.28-11.08L414.36 163l125.51 187.05 313-206.31A8 8 0 01864 146l30.82 46.76a8 8 0 01-2.28 11.08z"
      }
    }]
  },
  "name": "progress-stroke"
};
a['PushpinFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M878.72 479.15L544.85 145.28a64 64 0 00-90.45 0l-68.7 68.05a64 64 0 000 90.46L417.93 336l-79.36 80c-77.23-23.04-149.33-11.52-195.2 34.56l-7.47 7.47a31.79 31.79 0 000 45.22l162.78 162.99L152.32 812.8a31.79 31.79 0 000 45.23l15.15 15.14a32.21 32.21 0 0045.22 0l146.35-146.56 161.7 161.5a31.79 31.79 0 0045.23 0l7.47-7.47c45.44-45.44 56.96-116.7 34.99-193.28l80-80.21 31.14 31.14a64 64 0 0090.46 0l68.69-68.69a64 64 0 000-90.45z"
      }
    }]
  },
  "name": "pushpin-fill"
};
a['PushpinStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M914.35 436.48L580.48 102.61a64 64 0 00-90.45 0l-68.7 68.7a64 64 0 000 90.45l32.22 32.21-79.36 79.36c-77.23-23.04-149.12-11.52-195.2 34.35l-7.47 7.47a31.79 31.79 0 000 45.22l162.99 162.99-146.56 146.77a31.79 31.79 0 000 45.23l15.14 15.15c12.59 12.58 32.86 12.58 45.23 0l146.56-146.56 161.5 161.49c12.58 12.59 32.85 12.59 45.22 0l7.47-7.47c45.44-45.44 56.96-116.69 34.77-193.28l80.21-80.21 31.15 31.15a64 64 0 0090.45 0l68.7-68.7a64 64 0 000-90.45zM496.64 216.53l38.61-38.61 303.79 303.79-38.61 38.61-16-16-60.38-60.37-117.33 117.33-57.81 57.81-4.7 4.7c21.12 41.38 29.44 81.7 24.11 112.85l-288.21-288c31.78-5.33 72.74 3.41 114.77 25.17l4.27-4.26.42.42 72.54-72.53-.43-.43L574.29 294.4l-59.52-59.73-1.06-1.07-17.07-17.07z"
      }
    }]
  },
  "name": "pushpin-stroke"
};
a['QrCodeSkroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M588.59 549.76h182.4q32 0 32 32v21.33q0 32-32 32h-182.4q-32 0-32-32v-21.33q0-32 32-32zM745.81 709.33h182.4q32 0 32 32v21.34q0 32-32 32h-182.4q-32 0-32-32v-21.34q0-32 32-32zM885.76 549.76H928q32 0 32 32v21.33q0 32-32 32h-42.24q-32 0-32-32v-21.33q0-32 32-32zM588.37 868.9h182.4q32 0 32 32v21.34q0 32-32 32h-182.4q-32 0-32-32v-21.33q0-32 32-32zM885.76 868.9H928q32 0 32 32v21.34q0 32-32 32h-42.24q-32 0-32-32v-21.33q0-32 32-32zM587.95 709.33h42.24q32 0 32 32v21.34q0 32-32 32h-42.24q-32 0-32-32v-21.34q0-32 32-32zM384 145.07v234.66H149.33V145.07H384M64 123.73v277.34a64 64 0 0064 64h277.33a64 64 0 0064-64V123.73a64 64 0 00-64-64H128a64 64 0 00-64 64zm320 512V870.4H149.33V635.73H384M64 614.4v277.33a64 64 0 0064 64h277.33a64 64 0 0064-64V614.4a64 64 0 00-64-64H128a64 64 0 00-64 64zm810.67-469.12v234.67H640V145.28h234.67m-320-21.33v277.33a64 64 0 0064 64H896a64 64 0 0064-64V123.95a64 64 0 00-64-64H618.67a64 64 0 00-64 64z"
      }
    }]
  },
  "name": "QR-code-skroke"
};
a['QrCodeStoke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M622.08 908.8h-21.33c-17.71 0-32-19.84-32-44.37V592.85c0-24.53 14.29-44.37 32-44.37h21.33c17.7 0 32 19.84 32 44.37v271.58c0 24.53-14.08 44.37-32 44.37zm242.13 0h-21.33c-17.7 0-32-19.84-32-44.37V592.85c0-24.53 14.3-44.37 32-44.37h21.33c17.71 0 32 19.84 32 44.37v271.58c-.21 24.53-14.29 44.37-32 44.37zm-478.5-718.93V379.3H196.27V189.87H385.7m53.33-85.34h-296.1a32 32 0 00-32 32v296.11a32 32 0 0032 32h296.1a32 32 0 0032-32v-296.1a32 32 0 00-32-32zm388.7 85.34V379.3H638.28V189.87h189.44m53.34-85.34H584.96a32 32 0 00-32 32v296.11a32 32 0 0032 32h296.1a32 32 0 0032-32v-296.1a32 32 0 00-32-32zM385.7 634.24v189.23H196.27V634.24H385.7m53.33-85.33h-296.1a32 32 0 00-32 32V876.8a32 32 0 0032 32h296.1a32 32 0 0032-32V580.9a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "QR-code-stoke"
};
a['QrcodeStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M888 832h-48a8 8 0 00-8 8v48a8 8 0 008 8h48a8 8 0 008-8v-48a8 8 0 00-8-8zm-142 0h-48a8 8 0 00-8 8v48a8 8 0 008 8h48a8 8 0 008-8v-48a8 8 0 00-8-8zm142-284h-48a8 8 0 00-8 8v134h-78V556a8 8 0 00-8-8H556a8 8 0 00-8 8v332a8 8 0 008 8h48a8 8 0 008-8V644h78v102a8 8 0 008 8h190a8 8 0 008-8V556a8 8 0 00-8-8zM694 338h56a8 8 0 008-8v-56a8 8 0 00-8-8h-56a8 8 0 00-8 8v56a8 8 0 008 8zm138 74H612V192h220zm32-284H556a8 8 0 00-8 8v332a8 8 0 008 8h332a8 8 0 008-8V160a32 32 0 00-32-32zM274 758h56a8 8 0 008-8v-56a8 8 0 00-8-8h-56a8 8 0 00-8 8v56a8 8 0 008 8zm138 74H192V612h220zm56-284H136a8 8 0 00-8 8v308a32 32 0 0032 32h308a8 8 0 008-8V556a8 8 0 00-8-8zM274 338h56a8 8 0 008-8v-56a8 8 0 00-8-8h-56a8 8 0 00-8 8v56a8 8 0 008 8zm138 74H192V192h220zm56-284H160a32 32 0 00-32 32v308a8 8 0 008 8h332a8 8 0 008-8V136a8 8 0 00-8-8z"
      }
    }]
  },
  "name": "qrcode-stroke"
};
a['QuestionCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 53.33C258.77 53.33 53.33 258.77 53.33 512S258.77 970.67 512 970.67 970.67 765.23 970.67 512 765.23 53.33 512 53.33zm53.33 682.24a52.21 52.21 0 01-52.26 52.27h-1.92a52.21 52.21 0 01-52.27-52.27v-1.92a52.21 52.21 0 0152.27-52.26h1.92a52.21 52.21 0 0152.26 52.26v1.92zm125.02-318.93a157.1 157.1 0 01-5.34 31.79 169.92 169.92 0 01-61.22 90.24 174.2 174.2 0 01-49.28 26.45l-4.27 1.07c-11.73 2.77-16 12.16-16 24.32v36.26c0 9.39-7.9 17.07-17.92 17.07h-49.28c-9.81 0-17.92-7.68-17.92-17.07v-36.26c0-8.32 1.07-16.43 2.99-24.32 8.74-36.06 31.14-64 66.98-75.95l4.91-1.5c33.28-10.87 58.03-40.1 61.01-75.09v-6.18c0-49.71-42.24-90.24-94.08-89.6-51.41.42-92.37 41.38-92.37 90.88v22.61c0 9.39-7.9 17.07-17.92 17.07h-49.28c-9.81 0-17.92-7.68-17.92-17.07v-21.97c0-94.94 80.64-173.87 179.41-173.23 82.56.43 152.11 55.25 171.74 129.07a163.9 163.9 0 015.54 42.24v9.17z"
      }
    }]
  },
  "name": "question-circle-fill"
};
a['QuestionCircleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 959.57a446.38 446.38 0 01-174.3-35.2 447.73 447.73 0 01-142.5-96 445.38 445.38 0 01-96-142.5A445.61 445.61 0 0164 511.57a446.38 446.38 0 0135.2-174.29 447.73 447.73 0 0196-142.5 445.38 445.38 0 01142.5-96c55.26-23.47 113.93-35.2 174.3-35.2s119.25 11.94 174.3 35.2a447.73 447.73 0 01142.5 96 445.38 445.38 0 0196 142.5c23.47 55.25 35.2 113.92 35.2 174.3s-11.95 119.25-35.2 174.29a447.73 447.73 0 01-96 142.5 445.38 445.38 0 01-142.5 96c-55.05 23.47-113.93 35.2-174.3 35.2zM512 64c-60.37 0-119.04 11.73-174.3 35.2-53.33 22.61-101.11 54.83-142.29 96s-73.38 88.96-96 142.3a446.38 446.38 0 00-35.2 174.29c0 60.37 11.74 119.04 35.2 174.29a446.82 446.82 0 0096 142.3A446.38 446.38 0 00512 959.57c60.59 0 119.04-11.74 174.3-35.2a446.82 446.82 0 00142.29-96 446.38 446.38 0 00131.2-316.6c0-60.37-11.74-119.03-35.2-174.29-22.62-53.33-54.83-101.12-96-142.29s-88.96-73.39-142.3-96A447.15 447.15 0 00512 64zm0-10.67C258.77 53.33 53.33 258.77 53.33 512S258.77 970.67 512 970.67 970.67 765.23 970.67 512 765.23 53.33 512 53.33zm0 829.87c-204.8 0-371.2-166.4-371.2-371.2 0-204.8 166.4-371.2 371.2-371.2S883.2 307.2 883.2 512c0 204.8-166.4 371.2-371.2 371.2zm1.07-647.25c-98.56-.64-179.42 78.29-179.42 173.22v21.98c0 9.38 7.9 17.06 17.92 17.06h49.28c9.82 0 17.92-7.68 17.92-17.06v-22.62c0-49.28 40.96-90.45 92.38-90.88 51.84-.42 94.08 39.9 94.08 89.6v5.98c-3.2 34.98-27.74 64.21-61.02 75.09l-4.9 1.5c-35.63 12.15-58.24 40.1-66.99 75.94-1.92 7.9-2.99 16-2.99 24.32v36.27c0 9.38 7.9 17.06 17.92 17.06h49.28c9.82 0 17.92-7.68 17.92-17.06v-36.27c0-12.16 4.27-21.55 16-24.32l4.27-1.07A179.74 179.74 0 00624 538.24c29.44-22.61 51.41-53.97 61.23-90.24a173.55 173.55 0 005.33-31.79v-8.74c0-14.51-1.92-28.8-5.55-42.24-19.84-73.82-89.17-128.64-171.94-129.28zm0 445.44h-1.92a52.21 52.21 0 00-52.27 52.26v1.92a52.21 52.21 0 0052.27 52.27h1.92a52.21 52.21 0 0052.26-52.27v-1.92a52.35 52.35 0 00-52.26-52.26z"
      }
    }]
  },
  "name": "question-circle-stroke"
};
a['RdashboardFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M936.96 511.15v.21-.21zm-1.7-36.91A424.75 424.75 0 00548.9 88.11a32.21 32.21 0 00-34.99 32v357.12a32 32 0 0032 32h357.33a32.21 32.21 0 0032-34.99z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M410.45 99.2a424.53 424.53 0 10513.71 513.5 32.21 32.21 0 00-31.36-39.47H481.92a32 32 0 01-32-32V130.35a32 32 0 00-39.47-31.15zm526.51 410.03v1.92z"
      }
    }]
  },
  "name": "rdashboard-fill"
};
a['RectangleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 64H128a64 64 0 00-64 64v768a64 64 0 0064 64h768a64 64 0 0064-64V128a64 64 0 00-64-64zm-21.33 810.67H149.33V149.33h725.34z"
      }
    }]
  },
  "name": "rectangle-stroke"
};
a['RedEnvelopesStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M821 77H203a32 32 0 00-32 32v806a32 32 0 0032 32h618a32 32 0 0032-32V109a32 32 0 00-32-32zm-82.7 72L512 300.49 285.7 149zM243 875V197.43l251.2 168.16a32 32 0 0035.6 0L780.9 197.5V875zm396.5-426.9h-47.8a8.61 8.61 0 00-7.5 4.6l-71.9 141.9-71.7-142a8.38 8.38 0 00-7.5-4.6h-48.8a9.4 9.4 0 00-3.9 1 8.4 8.4 0 00-3.4 11.4l87.4 161.1H419a8.45 8.45 0 00-8.4 8.4V655a8.45 8.45 0 008.4 8.4h63V692h-63a8.45 8.45 0 00-8.4 8.4v25.1a8.45 8.45 0 008.4 8.4h63v49.9a8.45 8.45 0 008.4 8.4h43.7a8.45 8.45 0 008.4-8.4v-49.9h63.3a8.12 8.12 0 008.2-8.5v-25a8.45 8.45 0 00-8.4-8.4h-63.3v-28.6h63.3a8.45 8.45 0 008.4-8.4v-25.1a8.45 8.45 0 00-8.4-8.4h-45.9l87.2-161a7.92 7.92 0 001-4 8.45 8.45 0 00-8.4-8.4z"
      }
    }]
  },
  "name": "red-envelopes-stroke"
};
a['RocketStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M464 390a48 48 0 1048-48 48 48 0 00-48 48zm164.1 404.2a27 27 0 01-17.1 3.4l-19.5-2.4-2.8 19.4a77.48 77.48 0 01-153.4 0l-2.8-19.5-19.5 2.5a32.51 32.51 0 01-3.3.2 27.69 27.69 0 01-13.8-3.7 28.14 28.14 0 01-14.1-24.4 26.37 26.37 0 0114.6-23.8h231.3a26.42 26.42 0 0114.6 23.8 28.36 28.36 0 01-14.2 24.5zM239.2 678A212 212 0 01324 568.7V678zM388 493.1V308.8l124-147 124 147V678H388zm374.3 138.3a210.76 210.76 0 0122.5 46.6H700V568.7a211.6 211.6 0 0162.3 62.7zM864 746c0-111.6-65.4-208-160-252.9V307.3a63.43 63.43 0 00-15.1-41.2L536.5 85.4a32 32 0 00-49 0L335.1 266.1a64 64 0 00-15.1 41.2v185.8C225.4 538 160 634.4 160 746h156.5a77.26 77.26 0 00-3.5 23.8 96.95 96.95 0 0064.5 91.4 146.19 146.19 0 00268.9 0 96.67 96.67 0 0064.5-91.3 91.25 91.25 0 00-3.1-23.8H864z"
      }
    }]
  },
  "name": "rocket-stroke"
};
a['RotateLeftStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M593.81 378.65h-499a30.2 30.2 0 00-30.24 30.24v391.24a30.21 30.21 0 0030.24 30.24h499a30.22 30.22 0 0030.25-30.24V408.89a30.21 30.21 0 00-30.25-30.24zm-41.58 379.89h-415.8V450.47h415.8zM881 316.07c-74.46-95.16-185.22-145.15-297.3-145.72l-.19-60.48a7.37 7.37 0 00-11.9-5.77l-121 95.45a7.44 7.44 0 000 11.63l121.05 95.54a7.35 7.35 0 0011.96-5.72v-60.43a317.88 317.88 0 0136.67 2.36 308.45 308.45 0 01268.76 343.6c-.67 5.11-1.33 10.21-2.27 15.22h70.78A376.59 376.59 0 00881 316.07zm0 0"
      }
    }]
  },
  "name": "rotate-left-stroke"
};
a['RotateRightStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M431.19 378.65a30.21 30.21 0 00-30.25 30.24v391.24a30.22 30.22 0 0030.25 30.24h499a30.21 30.21 0 0030.24-30.24V408.89a30.2 30.2 0 00-30.24-30.24zm41.58 71.82h415.8v308.07h-415.8zM144 312.07a376.59 376.59 0 00-76.56 285.68h70.78c-.94-5-1.6-10.11-2.27-15.22a308.44 308.44 0 01268.76-343.6 317.88 317.88 0 0136.67-2.36V297a7.35 7.35 0 0011.91 5.77l121.05-95.54a7.44 7.44 0 000-11.63l-121-95.45a7.37 7.37 0 00-11.9 5.77l-.19 60.48c-112.08.57-222.84 50.56-297.3 145.72zm0 0"
      }
    }]
  },
  "name": "rotate-right-stroke"
};
a['RowCenteredSpacingFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M378.84 318.63a32 32 0 0045.44 0l30.33-30.59a32 32 0 000-45.07L316.97 104.23a63.74 63.74 0 00-90.52 0L88.83 242.97a32 32 0 000 45.07l30.34 30.6a32 32 0 0045.44 0l53.76-54.21v495.14l-53.76-54.2a32 32 0 00-45.44 0l-30.34 30.59a32 32 0 000 45.07l137.62 138.74a63.74 63.74 0 0090.52 0l137.64-138.74a32 32 0 000-45.07l-30.33-30.6a32 32 0 00-45.44 0l-53.78 54.21V264.43zm174.38-147.96h345.3a46.02 46.02 0 0146.01 46.01v263.68a46.02 46.02 0 01-46.01 46.04h-345.3a46.02 46.02 0 01-46.02-46.04V216.68a46.02 46.02 0 0146.02-46.01zm-20.83 412.26h386.95a25.2 25.2 0 0125.2 25.2v56.28a25.2 25.2 0 01-25.2 25.19H532.39a25.2 25.2 0 01-25.19-25.2v-56.27a25.2 25.2 0 0125.2-25.2zm0 163.74h386.95a25.2 25.2 0 0125.2 25.2v56.27a25.2 25.2 0 01-25.2 25.2H532.39a25.2 25.2 0 01-25.19-25.2v-56.3a25.2 25.2 0 0125.2-25.17z"
      }
    }]
  },
  "name": "row-centered-spacing-fill"
};
a['RowCenteredSpacingStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M345 748.05h-69.47V276H345a7.48 7.48 0 005.9-12.1l-105-133a7.49 7.49 0 00-11.82 0l-105 133.05a7.49 7.49 0 005.9 12.11h69.28V748H135a7.49 7.49 0 00-5.9 12.11l105 133.05a7.49 7.49 0 0011.82 0l105-133a7.48 7.48 0 00-5.92-12.11zM384.5 199h504q8 0 8 8v328q0 8-8 8h-504q-8 0-8-8V207q0-8 8-8zm0 423.33h504q8 0 8 8v44q0 8-8 8h-504q-8 0-8-8v-44q0-8 8-8zm0 141.67h504q8 0 8 8v44q0 8-8 8h-504q-8 0-8-8v-44q0-8 8-8z"
      }
    }]
  },
  "name": "row-centered-spacing-stroke"
};
a['RowMaximumSpacingFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M378.84 318.63a32 32 0 0045.44 0l30.33-30.59a32 32 0 000-45.07L316.97 104.23a63.74 63.74 0 00-90.52 0L88.83 242.97a32 32 0 000 45.07l30.34 30.6a32 32 0 0045.44 0l53.76-54.21v495.14l-53.76-54.2a32 32 0 00-45.44 0l-30.34 30.59a32 32 0 000 45.07l137.62 138.74a63.74 63.74 0 0090.52 0l137.64-138.74a32 32 0 000-45.07l-30.33-30.6a32 32 0 00-45.44 0l-53.78 54.21V264.43zM562.8 170.67h326.14q55.6 0 55.6 55.6V634q0 55.59-55.6 55.59H562.79q-55.59 0-55.59-55.6V226.27q0-55.6 55.6-55.6zm-30.4 576h386.92a25.2 25.2 0 0125.21 25.2v56.27a25.2 25.2 0 01-25.2 25.2H532.4a25.2 25.2 0 01-25.19-25.2v-56.3a25.2 25.2 0 0125.2-25.17z"
      }
    }]
  },
  "name": "row-maximum-spacing-fill"
};
a['RowMaximumSpacingStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M519.5 652h126v32h-126zM345 748.05h-69.47V276H345a7.48 7.48 0 005.9-12.1l-105-133a7.49 7.49 0 00-11.82 0l-105 133.05a7.49 7.49 0 005.9 12.11h69.28V748H135a7.49 7.49 0 00-5.9 12.11l105 133.05a7.49 7.49 0 0011.82 0l105-133a7.48 7.48 0 00-5.92-12.11zM384.5 200h504q8 0 8 8v468q0 8-8 8h-504q-8 0-8-8V208q0-8 8-8zm0 564h504q8 0 8 8v44q0 8-8 8h-504q-8 0-8-8v-44q0-8 8-8z"
      }
    }]
  },
  "name": "row-maximum-spacing-stroke"
};
a['RowMinimumSpacingFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M378.88 318.72a32.06 32.06 0 0045.44 0l30.3-30.5a31.93 31.93 0 000-45.02l-137.6-138.67a63.62 63.62 0 00-90.46 0L88.96 243.2a31.93 31.93 0 000 45.01l30.3 30.51a32.06 32.06 0 0045.43 0l53.76-54.19v495.15l-53.76-54.19a32.06 32.06 0 00-45.44 0L88.75 736a31.93 31.93 0 000 45.01l137.6 138.67a63.62 63.62 0 0090.45 0l137.6-138.67a31.93 31.93 0 000-45.01l-30.3-30.5a32.06 32.06 0 00-45.43 0l-53.76 54.18V264.32l53.97 54.4zM912.43 182.4H539.09c-17.7 0-32 14.3-32 32v85.33c0 17.71 14.3 32 32 32h373.34c17.7 0 32-14.29 32-32V214.4c0-17.7-14.3-32-32-32zm0 254.93H539.09c-17.7 0-32 14.3-32 32v85.34c0 17.7 14.3 32 32 32h373.34c17.7 0 32-14.3 32-32v-85.34c0-17.7-14.3-32-32-32zm0 254.94H539.09c-17.7 0-32 14.29-32 32v85.33c0 17.7 14.3 32 32 32h373.34c17.7 0 32-14.3 32-32v-85.33c0-17.71-14.3-32-32-32z"
      }
    }]
  },
  "name": "row-minimum-spacing-fill"
};
a['RowMinimumSpacingStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M308.48 291.41a21.25 21.25 0 0030.08 0l30.08-30.08a21.25 21.25 0 000-30.08L255.79 118.4a42.75 42.75 0 00-60.38 0L82.56 231.25a21.25 21.25 0 000 30.08l30.08 30.08a21.25 21.25 0 0030.08 0l40.1-40.1v519.25l-39.89-39.9a21.25 21.25 0 00-30.08 0l-30.08 30.09a21.25 21.25 0 000 30.08l112.86 112.85c8.32 8.32 19.2 12.59 30.08 12.59s21.76-4.27 30.08-12.59l112.85-112.85a21.25 21.25 0 000-30.08l-30.08-30.08a21.25 21.25 0 00-30.08 0l-40.1 40.1V251.31l40.1 40.1zm607.79-98.56H489.6c-17.7 0-32 14.3-32 32v42.67c0 17.7 14.3 32 32 32h426.67c17.7 0 32-14.3 32-32v-42.67c0-17.7-14.3-32-32-32zm0 276.7H489.6c-17.7 0-32 14.29-32 32v42.66c0 17.71 14.3 32 32 32h426.67c17.7 0 32-14.29 32-32v-42.66c0-17.71-14.3-32-32-32zm0 253.22H489.6c-17.7 0-32 14.3-32 32v42.67c0 17.7 14.3 32 32 32h426.67c17.7 0 32-14.3 32-32v-42.67c0-17.7-14.3-32-32-32z"
      }
    }]
  },
  "name": "row-minimum-spacing-stroke"
};
a['RowSpacingFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M378.84 318.63a32 32 0 0045.44 0l30.33-30.59a32 32 0 000-45.07L316.97 104.23a63.74 63.74 0 00-90.52 0L88.83 242.97a32 32 0 000 45.07l30.34 30.6a32 32 0 0045.44 0l53.76-54.21v495.14l-53.76-54.2a32 32 0 00-45.44 0l-30.34 30.59a32 32 0 000 45.07l137.62 138.74a63.74 63.74 0 0090.52 0l137.64-138.74a32 32 0 000-45.07l-30.33-30.6a32 32 0 00-45.44 0l-53.78 54.21V264.43zm192.1-147.96h309.83a63.77 63.77 0 0163.76 63.76v555.12a63.77 63.77 0 01-63.76 63.78H570.94a63.77 63.77 0 01-63.74-63.76V234.45a63.77 63.77 0 0163.74-63.78z"
      }
    }]
  },
  "name": "row-spacing-fill"
};
a['RowSpacingStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M343 757.05h-69.47V285H343a7.48 7.48 0 005.9-12.1l-105-133a7.49 7.49 0 00-11.82 0l-105 133.05a7.49 7.49 0 005.9 12.11h69.28V757H133a7.49 7.49 0 00-5.9 12.11l105 133.05a7.49 7.49 0 0011.82 0l105-133a7.48 7.48 0 00-5.92-12.11zM384 208h504q8 0 8 8v638q0 8-8 8H384q-8 0-8-8V216q0-8 8-8z"
      }
    }]
  },
  "name": "row-spacing-stroke"
};
a['RowTextHeightStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M300.59 238.3a21.33 21.33 0 0016.64-35L210.56 71.9a21.33 21.33 0 00-16.85-7.9 21.33 21.33 0 00-16.64 7.9L70.4 203.3a21.33 21.33 0 0016.64 35h64v547.4h-64a21.33 21.33 0 00-16.64 35l106.67 131.4a21.33 21.33 0 0016.64 7.9 21.33 21.33 0 0016.42-7.9L316.8 820.7a21.33 21.33 0 00-16.64-35h-64V238.3zm656 593.7l-1.07-2.99-234.24-594.34-24.96-64a29.87 29.87 0 00-6.19-10.67 34.99 34.99 0 00-14.5-9.39h-1.71a39.47 39.47 0 00-9.17-1.28H633.8a39.47 39.47 0 00-8.74 1.5h-1.71a34.99 34.99 0 00-14.5 9.38 29.87 29.87 0 00-6.2 10.67l-24.95 64-234.67 594.13-1.7 2.99a27.52 27.52 0 00-2.14 10.24 33.07 33.07 0 0033.7 32.43h30.94a33.92 33.92 0 0030.08-19.2v-1.28l26.45-64.86 57.39-145.28H780.8l57.39 145.28 25.81 64v1.28a34.56 34.56 0 0030.3 19.2h30.93a32.85 32.85 0 0032.85-32 27.3 27.3 0 00-1.5-9.81zM554.67 547.41l93.65-237.65 93.87 237.65z"
      }
    }]
  },
  "name": "row-text-height-stroke"
};
a['RuleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M914.52 110h-237a8 8 0 00-8 8v788a8 8 0 008 8h237a8 8 0 008-8V118a8 8 0 00-8-8zm-64 724a8 8 0 01-8 8h-93a8 8 0 01-8-8V190a8 8 0 018-8h93a8 8 0 018 8zM591.07 113.88l-488.42 788A8 8 0 00109.5 914h488.37a8 8 0 008-8V118.09a8 8 0 00-14.8-4.21zm-59.94 725.38H227.87L531.13 358zm-78.68-71.81V626l-85.56 141.45h85.56z"
      }
    }]
  },
  "name": "rule-stroke"
};
a['SafetyStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M812.91 205.58L524.06 88a32.06 32.06 0 00-24.12 0L211.09 205.58a64 64 0 00-39.88 59.28v392.92A32 32 0 00183.49 683l308.17 241.3a32 32 0 0039.41 0L840.46 683a32 32 0 0012.32-25.24v-392.9a64 64 0 00-39.87-59.28zm-32.13 432.67L511.44 848.31l-268.22-210v-368L512 160.87l268.78 109.38zM404.2 452.3a16.1 16.1 0 00-13-6.6H336a8 8 0 00-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7A8 8 0 00688 327h-55.2a16.24 16.24 0 00-13 6.6L468.9 541.4z"
      }
    }]
  },
  "name": "safety-stroke"
};
a['SaveStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M385.07 149.33H640V256H385.07V149.33M342.4 64H128a64 64 0 00-64 64v768a64 64 0 0064 64h768a64 64 0 0064-64V318.08a31.36 31.36 0 00-8.32-27.95L733.87 73.4A31.79 31.79 0 00711.25 64H342.4zM149.33 874.67V149.33h150.4v149.34a42.67 42.67 0 0042.67 42.66h340.27a42.67 42.67 0 0042.66-42.66V184.53l149.34 149.34v540.8z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M512 529.5a85.33 85.33 0 11-85.33 85.33A85.33 85.33 0 01512 529.49m0-85.33a170.67 170.67 0 10170.67 170.67A170.67 170.67 0 00512 444.16z"
      }
    }]
  },
  "name": "save-stroke"
};
a['ScanStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M352 85.33H117.33a32 32 0 00-32 32V352a32 32 0 0032 32h21.34a32 32 0 0032-32V170.67H352a32 32 0 0032-32v-21.34a32 32 0 00-32-32zM138.67 640h-21.34a32 32 0 00-32 32v234.67a32 32 0 0032 32H352a32 32 0 0032-32v-21.34a32 32 0 00-32-32H170.67V672a32 32 0 00-32-32zm768 0h-21.34a32 32 0 00-32 32v181.33H672a32 32 0 00-32 32v21.34a32 32 0 0032 32h234.67a32 32 0 0032-32V672a32 32 0 00-32-32zm0-554.67H672a32 32 0 00-32 32v21.34a32 32 0 0032 32h181.33V352a32 32 0 0032 32h21.34a32 32 0 0032-32V117.33a32 32 0 00-32-32zm21.33 384H96a32 32 0 00-32 32v21.34a32 32 0 0032 32h832a32 32 0 0032-32v-21.34a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "scan-stroke"
};
a['ScheduleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M384.1 170.75h256v128h-256z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M874.77 170.75h-64v128h42.67v128H170.77v-128h42.67v-128h-64a63.91 63.91 0 00-64 64v640a64.04 64.04 0 0064 64h725.33a64.2 64.2 0 0064-64v-640a64.04 64.04 0 00-64-64zM635.41 778.54a31.04 31.04 0 01-30.08 32H245.01a31.04 31.04 0 01-30.08-32V757.2a31.04 31.04 0 0130.08-32h360.32a31.04 31.04 0 0130.08 32zm173.66 0a30.42 30.42 0 01-28.59 32h-57.39a30.42 30.42 0 01-28.58-32V757.2a30.42 30.42 0 0128.58-32h57.39a30.42 30.42 0 0128.59 32zm0-170.45a31.04 31.04 0 01-30.08 32H248a31.04 31.04 0 01-30.08-32v-21.34a31.19 31.19 0 0130.08-32h530.99a31.19 31.19 0 0130.08 32z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M704.1 320.08h42.67a32.21 32.21 0 0032-32v-192a32.09 32.09 0 00-32-32h-42.66a31.96 31.96 0 00-32 32v192a32.09 32.09 0 0032 32zm-426.66 0h42.67a32.21 32.21 0 0032-32v-192a32.09 32.09 0 00-32-32h-42.67a31.96 31.96 0 00-32 32v192a32.09 32.09 0 0032 32z"
      }
    }]
  },
  "name": "schedule-fill"
};
a['ScreenFlippingStoke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M832 177.7V704H501.33V177.7H832m21.33-64H480a42.67 42.67 0 00-42.67 42.67v568.96A42.67 42.67 0 00480 768h373.33A42.67 42.67 0 00896 725.33V156.37a42.67 42.67 0 00-42.67-42.66z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M758.61 810.67h-23.46a19.2 19.2 0 00-18.78 19.2V832H192V501.33h180.48A21.33 21.33 0 00393.81 480v-21.33a21.33 21.33 0 00-21.33-21.34H170.67A42.67 42.67 0 00128 480v373.33A42.67 42.67 0 00170.67 896h566.61a42.67 42.67 0 0042.67-42.67V832a21.33 21.33 0 00-21.34-21.33zM194.77 395.52l-26.02-132.9a8.75 8.75 0 016.82-10.03l25.18-4.91a8.53 8.53 0 0110.02 6.83l15.79 80.85a8.53 8.53 0 0011.73 6.19l64-27.74a8.75 8.75 0 0111.31 4.48l10.67 23.04a8.53 8.53 0 01-4.48 11.31L206.5 401.71a8.53 8.53 0 01-11.74-6.19z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M240.21 357.12l-24.74-7.04a8.75 8.75 0 01-5.76-10.88 201.81 201.81 0 01162.77-144 8.32 8.32 0 019.6 7.9l1.28 25.6a8.32 8.32 0 01-7.25 8.74 158.08 158.08 0 00-125.44 113.92 8.53 8.53 0 01-10.46 5.76z"
      }
    }]
  },
  "name": "screen-flipping-stoke"
};
a['SealStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 61.65a207.79 207.79 0 00-124.16 374.62v81.28h-166.4a64 64 0 00-64 64v190.72a64 64 0 0064 64h582.19a64 64 0 0064-64V581.55a64 64 0 00-64-64H640v-84.06A208 208 0 00512 61.65zm-38.4 324.27a123.1 123.1 0 01-78.93-83.41 119.9 119.9 0 01-4.7-32.86 122.67 122.67 0 01245.34 0 119.9 119.9 0 01-4.7 32.86A122.03 122.03 0 01554.67 384v218.88h227.62v148.05H242.77V602.88h231.04V385.92zm314.03 491.1H254.29a32 32 0 00-32 32v21.33a32 32 0 0032 32h533.34a32 32 0 0032-32V909a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "seal-stroke"
};
a['SealStroke1'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M824.1 797.65H199.9a64 64 0 01-64-64v-144a64 64 0 0164-64H384v-11.09c-3.2-4.48-11.1-13.23-17.07-19.63a272.64 272.64 0 01-85.33-201.6c0-167.68 128-227.2 236.37-227.2s227.2 59.74 227.2 227.2a254.72 254.72 0 01-80.85 192 128 128 0 00-21.33 25.82v14.29h180.69a64 64 0 0164 64v144a64 64 0 01-63.57 64.21zm-602.87-85.33h581.54V610.99H616.96c-58.88 0-58.88-50.99-58.88-100.27 0-36.48 23.25-61.44 43.95-83.41a171.95 171.95 0 0057.81-133.98c0-117.12-76.8-141.86-141.23-141.86-56.32 0-151.04 18.56-151.04 141.86a190.5 190.5 0 0062.3 143.58c19.62 21.33 39.89 42.66 39.89 73.81a222.72 222.72 0 01-3.84 54.83 57.39 57.39 0 01-58.03 45.44H221.23z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M860.8 960H163.2a31.15 31.15 0 01-27.1-34.13v-22.62a31.36 31.36 0 0127.1-34.13h697.6a31.36 31.36 0 0127.1 34.13v22.62A31.15 31.15 0 01860.8 960z"
      }
    }]
  },
  "name": "seal-stroke1"
};
a['SearchFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M454 64c215.4 0 390 174.6 390 390a388.4 388.4 0 01-88.66 247.6L954.4 900.66a8 8 0 010 11.31l-42.43 42.43a8 8 0 01-11.31 0L701.6 755.34A388.4 388.4 0 01454 844C238.6 844 64 669.4 64 454S238.6 64 454 64zm0 72c-175.63 0-318 142.37-318 318s142.37 318 318 318 318-142.37 318-318-142.37-318-318-318zm0 64c140.28 0 254 113.72 254 254S594.28 708 454 708 200 594.28 200 454s113.72-254 254-254z"
      }
    }]
  },
  "name": "search-fill"
};
a['SearchStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M454 64c215.4 0 390 174.6 390 390a388.4 388.4 0 01-88.66 247.6L954.4 900.66a8 8 0 010 11.31l-42.43 42.43a8 8 0 01-11.31 0L701.6 755.34A388.4 388.4 0 01454 844C238.6 844 64 669.4 64 454S238.6 64 454 64zm0 72c-175.63 0-318 142.37-318 318s142.37 318 318 318 318-142.37 318-318-142.37-318-318-318z"
      }
    }]
  },
  "name": "search-stroke"
};
a['SelectDataStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M419.33 874.5H192v-512h618.5v74.75a31.58 31.58 0 0031.74 31.74h21.5a31.58 31.58 0 0031.75-31.74V128c0-35.33-28.67-64-64-64h-661c-35.32 0-64 28.67-64 64v768c0 35.33 28.68 64 64 64h248.84a31.58 31.58 0 0031.74-31.74v-21.5c.51-17.93-13.82-32.26-31.74-32.26zm391.17-725v128H192v-128h618.5z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M947.2 606.72c-16.38-16.38-43.52-16.38-59.9 0L663.04 830.98 559.62 727.55c-15.88-15.87-41.99-15.87-57.86 0l-2.05 2.05c-15.87 15.87-15.87 41.98 0 57.86L634.37 922.1c15.87 15.87 41.98 15.87 57.85 0l1.03-1.02L947.2 667.14c16.9-16.9 16.9-44.04 0-60.42z"
      }
    }]
  },
  "name": "Select-data-stroke"
};
a['SeparateStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M864 128H160a32 32 0 00-32 32v704a32 32 0 0032 32h704a32 32 0 0032-32V160a32 32 0 00-32-32zm-664 72h280v624H200zm624 624H544V200h280z"
      }
    }]
  },
  "name": "separate-stroke"
};
a['ServiceFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M252.32 510.13a27 27 0 0027 27h10v-54h-10a27 27 0 00-27 27zm492.21-26.98h-10v54h10a27 27 0 000-54zM511.91 96c-229.75 0-416 186.25-416 416s186.25 416 416 416 416-186.25 416-416-186.25-416-416-416zm232.62 500.51h-16.95a177 177 0 01-158.1 164.76 55.53 55.53 0 11-.46-54.06 123.48 123.48 0 00105.23-122v-4h.09V440.83a163.17 163.17 0 00-324.85 0v155.68H279.3a86.39 86.39 0 110-172.77h12.42a222.61 222.61 0 01440.38 0h12.43a86.39 86.39 0 010 172.77z"
      }
    }]
  },
  "name": "service-fill"
};
a['ServiceStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M837.79 394h-22.28a306.16 306.16 0 00-607 0h-22.3a115.39 115.39 0 000 230.78h92.7V412.06a234.13 234.13 0 01466.18 0v202.48H745c0 90.8-68.21 166-156.08 176.94a72.16 72.16 0 10.18 64.35 242.31 242.31 0 00219.64-231.06h29a115.39 115.39 0 000-230.78zm-695 115.39A43.45 43.45 0 01186.21 466h19.67v86.78h-19.67a43.45 43.45 0 01-43.39-43.4zm695 43.39h-19.67V466h19.67a43.39 43.39 0 010 86.78z"
      }
    }]
  },
  "name": "service-stroke"
};
a['SettingFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M864 505.6l88.53-107.95a32 32 0 002.35-37.76l-88.1-136.74a32 32 0 00-26.89-14.51h-128L654.3 77.87a32.21 32.21 0 00-29.44-18.99H411.52a32.21 32.21 0 00-29.44 19.41l-58.03 130.35H192a32.21 32.21 0 00-27.3 15.15L81.5 361.17a32.21 32.21 0 002.55 37.12l88.75 107.95-89.81 110.93a32.43 32.43 0 00-2.35 37.12l85.33 137.39a31.79 31.79 0 0027.1 15.15l132.69-1.28 54.61 129.49a31.57 31.57 0 0029.44 19.63h213.34a31.57 31.57 0 0029.22-19.2l58.03-131.2h129.92a32.21 32.21 0 0027.1-14.94l85.33-136.32a32.21 32.21 0 00-1.92-36.9zm-176.85 1.5a169.17 169.17 0 11-169.18-169.18 169.17 169.17 0 01169.18 169.17z"
      }
    }]
  },
  "name": "setting-fill"
};
a['SettingStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 428.59A83.84 83.84 0 11428.37 512 83.84 83.84 0 01512 428.59m0-85.34A169.17 169.17 0 10681.17 512 169.17 169.17 0 00512 343.25z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M584.32 149.33l42.67 98.78 23.25 50.56h154.45l50.99 79.14-64 78.08-42.67 52.91 42.67 53.97 64 80.86-49.7 79.36H648.74l-22.4 50.98-44.16 100.7H439.47l-40.75-96.86-22.4-52.48h-158.5l-50.14-78.72 66.99-81.49L277.33 512l-44.16-53.97-64-78.51 47.15-80.85h157.44l22.4-50.78 44.16-98.56h144M618.67 64H405.33a32.64 32.64 0 00-29.44 19.41l-57.6 129.92H186.45a32.21 32.21 0 00-27.3 15.15l-83.2 137.17a32.43 32.43 0 002.56 37.12L167.25 512 77.44 622.3a32.43 32.43 0 00-2.35 37.11l85.34 137.18a31.79 31.79 0 0026.88 15.14L320 810.67l54.61 129.49a31.79 31.79 0 0029.23 19.63h213.33a32 32 0 0029.02-19.2L704 809.17h130.13a32.21 32.21 0 0027.1-14.93l85.33-136.1a31.79 31.79 0 00-1.92-36.91l-86.61-110.51 88.32-107.73a31.79 31.79 0 002.34-37.76L860.8 228.69a31.79 31.79 0 00-27.1-15.36h-128L648.33 83.41A32.64 32.64 0 00618.67 64z"
      }
    }]
  },
  "name": "setting-stroke"
};
a['ShareLinkFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M910.72 437.76L570.45 97.49c-25.81-25.81-70.18-7.46-70.18 29.02V310.4l-1.5 2.77C231.25 331.1 96.85 521.6 89.17 894.3c-.42 19.84 13.87 37.12 33.28 40.96l14.3 2.78c17.92 3.41 35.84-5.12 44.16-21.34 34.13-66.13 136.32-230.82 319.14-252.8v182.62c0 36.05 43.1 54.61 69.34 29.86L908.8 555.73a82 82 0 001.92-117.97zm-410.45-126.3v1.5h-.86l.86-1.5z"
      }
    }]
  },
  "name": "share-link-fill"
};
a['ShareLinkStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M910.72 437.76L570.45 97.49c-25.81-25.81-70.18-7.46-70.18 29.02v186.45c-268.59 17.28-403.42 208-411.1 581.33-.42 19.84 13.87 37.12 33.28 40.96l14.3 2.78c17.92 3.41 35.84-5.12 44.16-21.34 34.13-66.13 136.32-230.82 319.14-252.8v182.62c0 36.05 43.1 54.61 69.34 29.86L908.8 555.73a82 82 0 001.92-117.97zM582.4 750.93V579h-41.17c-129.92 0-249.18 58.24-344.75 168.53a689.36 689.36 0 00-16.64 20.05c31.15-257.06 146.13-373.54 361.39-373.54h41.17V225.92L852.48 496 582.4 750.93z"
      }
    }]
  },
  "name": "share-link-stroke"
};
a['ShareStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M761.19 672a123 123 0 00-80.81 30.19l-218-159.8a163 163 0 000-62.2L681 323.14a123.18 123.18 0 10-38.18-56.31L434.67 416.38a162.92 162.92 0 00-132.32-67.92c-89.89 0-163 73.13-163 163s73.13 163 163 163a162.91 162.91 0 00132.4-68l208.4 152.78a123.48 123.48 0 10118-87.21zm-1-499a55.48 55.48 0 11-55.48 55.48A55.54 55.54 0 01760.15 173zM302.35 606.5a95 95 0 1195-95 95.13 95.13 0 01-95 95zM761.19 851a55.48 55.48 0 1155.48-55.48A55.55 55.55 0 01761.19 851z"
      }
    }]
  },
  "name": "share-stroke"
};
a['ShopStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M840 445.7c0 59.8-49 108.3-109.3 108.3a109.52 109.52 0 01-95.2-54.9 16 16 0 00-13.9-8.1h-.6a16.13 16.13 0 00-13.9 8.1 109.83 109.83 0 01-190.1.2 16.47 16.47 0 00-28.6 0 109.63 109.63 0 01-95.1 54.7C233 554 184 505.5 184 445.7v-91.2a.47.47 0 01.5-.5h655a.47.47 0 01.5.5zm-30 384.4H640V714a32 32 0 00-32-32H416a32 32 0 00-32 32v116.1H214V607.9c2.9 1.4 5.9 2.8 9 4a182.8 182.8 0 00140.8 0 182.85 182.85 0 0038.7-22.1.64.64 0 01.6 0 182.62 182.62 0 00179.5 22.1 182.85 182.85 0 0038.7-22.1.64.64 0 01.6 0 182.62 182.62 0 00179.5 22.1c3-1.3 6-2.6 9-4v222.2zm-234 0H448V746h128zM214 194h596v88H214zm668 88.1V154a32 32 0 00-32-32H174a32 32 0 00-32 32v128.1a32 32 0 00-30 31.9v131.7a179.45 179.45 0 0030 99.3v325a32 32 0 0032 32h676a32 32 0 0032-32V545a175 175 0 0015.6-28.9 178.75 178.75 0 0014.4-70.4V314a32 32 0 00-30-31.9z"
      }
    }]
  },
  "name": "shop-stroke"
};
a['ShoppingCartStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M908.29 241.15H240.64L213.5 99.33c-1.53-14.34-12.8-25.6-27.13-27.65H96.26C78.85 71.68 64.5 85.5 64 103.42v21.5a31.58 31.58 0 0031.74 31.75h40.96l109.06 574.98c6.14 31.23 33.8 53.25 65.54 51.71h501.24c31.24.51 57.86-21 64-51.71l81.92-415.75c7.17-34.3-15.36-68.1-50.17-74.75zM796.16 698.37h-469.5L256 321.02h614.4l-74.24 377.35zm-463.87 187.9a59.65 59.65 0 0059.9 59.9 59.65 59.65 0 0059.9-59.9 59.65 59.65 0 00-59.9-59.9c-32.77 0-59.9 26.62-59.9 59.9zm353.28 0c0 33.28 26.62 59.9 59.9 59.9s59.9-26.62 59.9-59.9-26.62-59.9-59.9-59.9-59.9 26.62-59.9 59.9z"
      }
    }]
  },
  "name": "shopping-cart-stroke"
};
a['ShortcutStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M504.1 528.21l-26.23 17.28a15.57 15.57 0 01-17.07 0L194.56 368.43a15.57 15.57 0 010-25.82L460.8 165.55a15.57 15.57 0 0117.07 0L744.1 342.6a15.57 15.57 0 010 25.82l-6.19 4.05a42.67 42.67 0 00-10.67 61.01 42.67 42.67 0 0057.82 10.24l33.06-21.33a79.79 79.79 0 000-132.48L504.75 80.85a64 64 0 00-70.83 0L120.53 289.28a79.79 79.79 0 000 132.48l313.39 208.43a64 64 0 0070.83 0l46.5-30.94a42.67 42.67 0 0010.67-61.01 42.67 42.67 0 00-57.81-10.03z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M519.9 495.79l26.23-17.28a15.57 15.57 0 0117.07 0l266.24 177.06a15.57 15.57 0 010 25.82L563.2 858.45a15.57 15.57 0 01-17.07 0L279.9 681.4a15.57 15.57 0 010-25.82l6.19-4.05a42.67 42.67 0 0010.67-61.01 42.67 42.67 0 00-57.82-10.24l-33.06 21.33a79.79 79.79 0 000 132.48l313.38 208.43a64 64 0 0070.83 0l313.39-208.43a79.79 79.79 0 000-132.48L590.08 393.81a64 64 0 00-70.83 0l-46.5 30.94a42.67 42.67 0 00-10.67 61.01 42.67 42.67 0 0057.81 10.03z"
      }
    }]
  },
  "name": "shortcut-stroke"
};
a['SizeStoke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M865.07 925.44h-704a64 64 0 01-64-64V154.67a64 64 0 0164-64H432a64 64 0 0164 64v372.05h369.07a64 64 0 0164 64v270.72a64 64 0 01-64 64zM182.4 840.11h661.33V612.05H411.1V176H182.83z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M306.13 749.65h51.2q17.07 0 17.07 17.07v86.61q0 17.07-17.07 17.07h-51.2q-17.06 0-17.06-17.07v-86.61q0-17.07 17.06-17.07zM543.36 870.4h-51.2a18.35 18.35 0 01-17.07-19.2V721.7a18.13 18.13 0 0117.07-19.2h51.2a18.13 18.13 0 0117.07 19.2v129.5a18.35 18.35 0 01-17.07 19.2zm192.43 0h-64a12.37 12.37 0 01-10.67-13.44v-80a12.37 12.37 0 0110.67-13.23h57.6a19.63 19.63 0 0117.06 21.34v71.89a12.16 12.16 0 01-10.66 13.44zM256 335.36h-85.33a18.13 18.13 0 01-19.2-17.07v-51.2a18.13 18.13 0 0119.2-17.06H256a18.13 18.13 0 0119.2 17.06v51.2a18.13 18.13 0 01-19.2 17.07zm42.67 170.24h-128a18.13 18.13 0 01-19.2-17.07v-51.2a18.13 18.13 0 0119.2-17.06h128a18.13 18.13 0 0119.2 17.06v51.2a18.13 18.13 0 01-19.2 17.07zm-64 172.8h-59.31c-13.65 0-24.75-7.68-24.75-17.07v-51.2c0-9.38 11.1-17.06 24.75-17.06h59.3c13.66 0 24.75 7.68 24.75 17.06v51.2c-1.06 9.39-12.16 17.07-24.74 17.07z"
      }
    }]
  },
  "name": "size-stoke"
};
a['SkinFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M931.2 250.03L796.16 140.16a78.08 78.08 0 00-26.45-13.65l-9.18-1.28h-71.68a31.57 31.57 0 00-28.8 18.13 161.28 161.28 0 01-292.9 0 31.57 31.57 0 00-28.59-18.13h-75.1l-9.17 1.28a78.08 78.08 0 00-26.45 13.65L92.8 250.03a76.16 76.16 0 00-27.3 72.53s37.33 158.5 41.17 171.95c18.34 58.66 56.32 31.14 87.25 21.33l7.47-2.35a1.28 1.28 0 011.7 1.28v231.9c0 152.1 0 152.1 155.74 152.1h305.92c155.73 0 155.73 0 155.73-152.1V514.56a1.28 1.28 0 011.7-1.28l7.47 2.35c30.94 10.02 68.91 37.54 87.26-21.34 4.26-13.44 42.66-171.94 42.66-171.94a76.16 76.16 0 00-28.37-72.32z"
      }
    }]
  },
  "name": "skin-fill"
};
a['SkinStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M733.87 149.33l140.8 139.52-22.83 165.12h-82.56v418.35h-512V453.97h-82.35L153.6 285.65l138.67-136.32h76.37l1.28 1.28a197.33 197.33 0 0091.95 52.48 200.53 200.53 0 00190.93-53.76h81.07M618.67 64l-26.03 25.39A114.56 114.56 0 01512 122.88a115.2 115.2 0 01-80.64-33.07L403.63 64H283.52a64 64 0 00-45.01 18.56L74.88 243.63a31.15 31.15 0 00-9.39 26.66L96.21 512A31.79 31.79 0 00128 539.3h44.37v386.35a32 32 0 0032 32h618.67a32 32 0 0032-32V539.31h42.67a31.79 31.79 0 0032-27.31l33.06-237.65a33.07 33.07 0 00-9.17-27.1L788.05 81.92A64 64 0 00742.83 64z"
      }
    }]
  },
  "name": "skin-stroke"
};
a['SmsStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M241.92000000000002 491.1a53.12 53.12 0 10106.24 0 53.12 53.12 0 10-106.24 0zM729.17 437.55a53.76 53.76 0 00-53.76 53.12 53.33 53.33 0 1053.76-53.34zM462.72 491.3a53.12 53.12 0 10106.24 0 53.12 53.12 0 10-106.24 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M512 97.07C264.53 97.07 64 278.6 64 502.4a377.39 377.39 0 0080.64 231.68l-43.95 121.39a53.97 53.97 0 0051.63 71.46 64 64 0 0015.15-2.13l173.86-48A488.75 488.75 0 00512 907.73c247.47 0 448-181.33 448-405.33S759.47 97.07 512 97.07zm0 725.33h-2.77a400.64 400.64 0 01-162.99-35.63l-114.56 31.58-29.65 8.32 8.96-24.75 31.14-86.4a316.8 316.8 0 01-60.8-82.35 284.8 284.8 0 01-32-130.77c0-176.43 162.78-320 362.67-320s362.67 143.57 362.67 320-162.78 320-362.67 320z"
      }
    }]
  },
  "name": "SMS-stroke"
};
a['SoundStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M657.92 156.37v-5.54a64 64 0 00-95.79-49.5l-9.17 6.62-313.6 223.57H128a64 64 0 00-64 64v232.96a64 64 0 0064 64h110.5l313.4 223.15 10.45 7.46a64 64 0 0031.57 8.54 64 64 0 0064-58.46V161.92c-.43-1.92 0-3.63 0-5.55zM239.36 607.15h-90.03v-190.3h89.18zm332.8-390.83v608.85l-14.3-10.24-233.17-166.4V375.47l232.96-166.4 14.51-10.24zM820.48 469.33h106.67q32 0 32 32v21.34q0 32-32 32H820.48q-32 0-32-32v-21.34q0-32 32-32zM764.8 321.7a32.21 32.21 0 0022.61 9.4 31.79 31.79 0 0023.26-9.4l75.52-75.51a32.21 32.21 0 000-45.23l-15.15-15.15a31.79 31.79 0 00-22.61-9.38 32.21 32.21 0 00-22.62 9.38l-75.52 75.52a32.21 32.21 0 000 45.23zm45.87 380.6a31.79 31.79 0 00-22.62-9.4 32.21 32.21 0 00-22.61 9.4l-15.15 15.14a32.21 32.21 0 000 45.23l75.52 75.52a32.21 32.21 0 0022.62 9.38 31.79 31.79 0 0022.61-9.38l15.15-15.15a32.21 32.21 0 000-45.23z"
      }
    }]
  },
  "name": "sound-stroke"
};
a['SqlStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M310.28 334.42v17.75a26.58 26.58 0 01-26.5 26.52H245.6a26.45 26.45 0 01-25.71-24.66 20.29 20.29 0 01-.26-3.97c0-1.32-.27-2.4-.27-3.71-.26-2.4-.26-4.78-.54-7.15a67.63 67.63 0 00-1.32-7.17 21.97 21.97 0 00-1.58-5.54 6.76 6.76 0 00-.53-1.88 41.34 41.34 0 00-3.71-8.75v-.25a163.07 163.07 0 00-6.36-10.88 54.2 54.2 0 00-49.3-22.53 56.66 56.66 0 00-30.23 7.17l-2.37 1.57a58.73 58.73 0 00-16.17 16.17 74.52 74.52 0 00-9.81 25.99 188.84 188.84 0 00-2.65 30.48c0 12.46.53 22.79 1.32 31a59.3 59.3 0 006.9 22.27 43.97 43.97 0 0015.35 16.7 148.44 148.44 0 0027.84 14.3l69.19 27.3a178.43 178.43 0 0148.77 27.06l.79.79a115.56 115.56 0 0128.37 35.26 162.82 162.82 0 0113.25 48.21 479.17 479.17 0 013.7 55.15v6.36a57.6 57.6 0 01-.25 6.91 298.18 298.18 0 01-7.95 67.05A157.14 157.14 0 01276.6 780a93 93 0 01-11.66 13.25 123.8 123.8 0 01-37.12 25.7 16.23 16.23 0 01-3.16 1.35 170.07 170.07 0 01-70.5 12.97 160.04 160.04 0 01-60.98-11.65 144.02 144.02 0 01-48.77-31.8 155.26 155.26 0 01-32.34-47.45A144.13 144.13 0 01.16 683.5v-7.15a26.58 26.58 0 0126.5-26.52h38.18a26.26 26.26 0 0125.7 24.67v3.7a56.1 56.1 0 001.07 11.68 58.58 58.58 0 001.32 6.61 22.12 22.12 0 001.58 5.57 3.84 3.84 0 00.54 1.85 61.61 61.61 0 003.7 8.75v.28a79.5 79.5 0 006.37 10.07 56.79 56.79 0 0049.04 19.88 87.8 87.8 0 0032.85-5.31 16.21 16.21 0 003.2-1.32 49.24 49.24 0 0019.89-19.1 72.2 72.2 0 008.47-29.67c.79-9.82 1.06-20.7 1.32-32.6v-5.84a67.75 67.75 0 00-.26-7.43c0-13.23-.8-24.38-1.6-33.39a65.83 65.83 0 00-7.14-25.7 45.12 45.12 0 00-16.43-15.92 193.22 193.22 0 00-26.8-13.24L103 526.59a142.2 142.2 0 01-78.46-63.36 217.7 217.7 0 01-19.88-98.6 233.43 233.43 0 019.55-67.33 155.99 155.99 0 0129.42-54.87 127.4 127.4 0 0142.14-34.17 30.08 30.08 0 015.03-2.67 157.1 157.1 0 0168.65-13.78 152.4 152.4 0 01105.5 41.09 34.3 34.3 0 014.52 4.24 137.2 137.2 0 0140.8 97.28zm61.89 11.56a161.28 161.28 0 0113.29-67.32 142.3 142.3 0 0135.43-48.73 149.8 149.8 0 0148.28-28.33 160.85 160.85 0 01158.12 28.33 148.22 148.22 0 0134.56 48.73 161.07 161.07 0 0113.3 67.32v333.06a146.86 146.86 0 01-13.3 64.66l34.84 28.2a26.5 26.5 0 013.63 37.64l-11.93 14.23a26.5 26.5 0 01-37.08 3.5l-32.87-26.89a146.82 146.82 0 01-94.79 32.8 159.57 159.57 0 01-54.48-9.76 142.04 142.04 0 01-48.28-29.22 135.55 135.55 0 01-35.43-46.94 159.79 159.79 0 01-13.3-68.22zm90.36 333.08a60.03 60.03 0 0018.14 48.28 64.09 64.09 0 0042.98 15.5 44.37 44.37 0 0019.5-3.53l-19.67-15.83a26.5 26.5 0 01-3.7-37.68l11.98-14.3a26.5 26.5 0 0136.93-3.62l16.08 12.95V345.98a60.07 60.07 0 00-18.15-48.27 67.29 67.29 0 00-85.93 0 60.03 60.03 0 00-18.16 48.27zm292.31 122.3v-577.7a26.5 26.5 0 0126.54-26.54h37.34a26.5 26.5 0 0126.51 26.5v493a20.89 20.89 0 0020.89 20.87h131.56a26.5 26.5 0 0126.48 26.54v37.34a26.5 26.5 0 01-26.5 26.51H781.34a26.5 26.5 0 01-26.5-26.51z"
      }
    }]
  },
  "name": "sql-stroke"
};
a['StampFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M596 912.09h296.03q6 0 6 6V942q0 6-6 6H596q-6 0-6-6v-23.91q0-6 6-6zm-69.83-39.16a81.43 81.43 0 0126.32-60.56c15.28-14.09 35.22-20.18 56-21.84 6.51-.53 41.51-11.53 45.66-18V729.1a367.28 367.28 0 00-4-4.19c-31.91-26.24-50.81-66.89-50.81-109.85a146.27 146.27 0 01249.92-103.8c1.2 1.2 2.36 2.43 3.51 3.67l-.18-405.28a32 32 0 00-32-32l-618 .64a32 32 0 00-32 32l.83 806a32 32 0 0032 32l323.55.21zM331.75 265.19q0-8 12.51-8l335-.34q12.52 0 12.53 8v48q0 8-12.51 8l-335 .34q-12.51 0-12.53-8zm.18 176l-.05-48q0-8 8-8l214-.22q8 0 8 8v48q0 8-8 8l-214 .22q-7.94-.01-7.95-8zm550.78 413.34c-41.13 0-109.69-32.27-109.69-73.67v-57.57c0-16.16 2.3-20.76 25.14-46.06 18.23-13.8 29.68-36.86 29.68-62.17 0-46.06-36.59-82.87-82.26-82.87s-82.25 36.81-82.25 82.87c0 25.36 11.39 48.37 29.68 62.17 25.14 25.36 25.14 30 25.14 48.36v55.27c0 41.46-68.56 73.67-109.69 73.67a18.08 18.08 0 00-18.29 18.4v27.6H901v-27.6c0-11.5-6.84-18.4-18.29-18.4z"
      }
    }]
  },
  "name": "stamp-fill"
};
a['StarFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M908.1 392.39l-253.9-36.9-113.5-230.1a32 32 0 00-57.4 0l-113.5 230.1-253.9 36.9A32 32 0 0098.2 447l183.7 179.1L238.5 879a32 32 0 0046.4 33.7L512 793.29l227.1 119.4A32 32 0 00785.5 879l-43.4-252.9L925.8 447a32 32 0 00-17.7-54.6z"
      }
    }]
  },
  "name": "star-fill"
};
a['StarStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M498.35 264.75l61.22 130.34L579 436.27l45.01 6.82 145.5 22.19L661.54 576l-30.08 30.72 6.82 42.45L662.83 800l-123.1-68.05-41.38-22.83-41.39 22.83L333.86 800l24.54-150.83 6.83-42.45L335.15 576 227.2 465.28l145.5-22.19 45-6.82 19.42-41.18 61.23-130.34m0-157.44a31.88 31.88 0 00-29.02 18.34L359.9 358.83 111.8 396.8c-25.82 3.84-36.27 35.41-18.14 53.97l180.48 184.96-42.24 259.2c-3.41 20.7 13.02 37.12 31.58 37.12 5.12 0 10.45-1.28 15.57-4.05l219.3-121.17L717.66 928a32.03 32.03 0 0015.58 4.05c18.56 0 34.98-16.64 31.57-37.12l-42.45-259.2 180.48-184.96c18.13-18.56 7.68-50.13-18.14-53.97L636.8 358.83 527.15 125.65a31.57 31.57 0 00-28.8-18.34z"
      }
    }]
  },
  "name": "star-stroke"
};
a['StopFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 66.13c-247.47 0-448 200.54-448 448s200.53 448 448 448 448-200.53 448-448-200.53-448-448-448zm264.53 697.6l-14.93 14.94c-6.4 6.4-14.93 8.53-23.47 8.53-8.53 0-17.06-4.27-23.46-8.53l-467.2-467.2c-12.8-12.8-12.8-34.14 0-44.8l14.93-14.94c6.4-6.4 14.93-8.53 23.47-8.53 8.53 0 17.06 4.27 23.46 8.53l467.2 467.2c12.8 12.8 12.8 32 0 44.8z"
      }
    }]
  },
  "name": "stop-fill"
};
a['StopStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 149.33A362.67 362.67 0 11149.33 512 362.67 362.67 0 01512 149.33M512 64a448 448 0 10448 448A448 448 0 00512 64z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M225.28 165.12l-60.16 60.16 633.6 633.6 60.16-60.16-633.6-633.6z"
      }
    }]
  },
  "name": "stop-stroke"
};
a['StraightlineStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M147.13 825.96l678.82-678.83q5.66-5.65 11.32 0l39.6 39.6q5.65 5.66 0 11.31L198.03 876.87q-5.65 5.65-11.31 0l-39.6-39.6q-5.66-5.66 0-11.31z"
      }
    }]
  },
  "name": "straightline-stroke"
};
a['Sync'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M293.76 584.96l-17.09-9.8a31.87 31.87 0 00-24.51-3.2 31.55 31.55 0 00-19.65 14.92l-20.48 35.65a166.78 166.78 0 01-19.39-36.48 314.69 314.69 0 0177.44-314.5 313.86 313.86 0 01328.06-72.7 31.74 31.74 0 0039.94-16.64l8.32-17.92a32.51 32.51 0 00.64-26.05 32.64 32.64 0 00-18.56-17.92 398.34 398.34 0 00-417.92 91.71 398.2 398.2 0 00-91.78 417.92 30.08 30.08 0 003.65 6.85L98.3 622.91a31.87 31.87 0 00-24.5-3.2 31.55 31.55 0 00-19.66 14.98l-9.79 17.02a32.11 32.11 0 0011.71 43.97l130.18 75.07a32.3 32.3 0 0043.9-11.71l75.14-130.11a31.87 31.87 0 00-11.52-43.97zm674.3-252.6l-130.1-75.08a32.06 32.06 0 00-43.98 11.71l-75.07 130.18c-8.96 15.36-3.65 35.2 11.71 43.9l17.1 9.86a32.64 32.64 0 0024.31 3.2 31.55 31.55 0 0019.65-14.98l22.4-38.78a177.5 177.5 0 0113.18 26.62 304.2 304.2 0 0117.92 87.68v-.19a313.98 313.98 0 01-90.88 240 313.92 313.92 0 01-328.06 72.77 31.74 31.74 0 00-39.94 16.64l-8.32 17.92a32.51 32.51 0 00-.64 25.98 32.74 32.74 0 0018.56 17.92A397.95 397.95 0 00813.63 816a398.2 398.2 0 0091.71-417.92 30.08 30.08 0 00-3.58-6.85l24.06 13.89a32.83 32.83 0 0024.58 3.2 31.55 31.55 0 0019.58-14.91l9.86-17.09a32.13 32.13 0 00-11.78-43.97z"
      }
    }]
  },
  "name": "sync"
};
a['TableBorderBottomStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M533.33 64h-42.66a21.33 21.33 0 00-21.34 21.33V128a21.33 21.33 0 0021.34 21.33h42.66A21.33 21.33 0 00554.67 128V85.33A21.33 21.33 0 00533.33 64zM736 64h-42.67A21.33 21.33 0 00672 85.33V128a21.33 21.33 0 0021.33 21.33H736A21.33 21.33 0 00757.33 128V85.33A21.33 21.33 0 00736 64zm-405.12 0h-42.67a21.33 21.33 0 00-21.33 21.33V128a21.33 21.33 0 0021.33 21.33h42.67A21.33 21.33 0 00352.21 128V85.33A21.33 21.33 0 00330.88 64zM736 469.33h-42.67A21.33 21.33 0 00672 490.67v42.66a21.33 21.33 0 0021.33 21.34H736a21.33 21.33 0 0021.33-21.34v-42.66A21.33 21.33 0 00736 469.33zm-405.12 0h-42.67a21.33 21.33 0 00-21.33 21.34v42.66a21.33 21.33 0 0021.33 21.34h42.67a21.33 21.33 0 0021.33-21.34v-42.66a21.33 21.33 0 00-21.33-21.34zM128 64H85.33A21.33 21.33 0 0064 85.33V128a21.33 21.33 0 0021.33 21.33H128A21.33 21.33 0 00149.33 128V85.33A21.33 21.33 0 00128 64zm810.67 0H896a21.33 21.33 0 00-21.33 21.33V128A21.33 21.33 0 00896 149.33h42.67A21.33 21.33 0 00960 128V85.33A21.33 21.33 0 00938.67 64zm0 405.33H896a21.33 21.33 0 00-21.33 21.34v42.66A21.33 21.33 0 00896 554.67h42.67A21.33 21.33 0 00960 533.33v-42.66a21.33 21.33 0 00-21.33-21.34zm0-202.02H896a21.33 21.33 0 00-21.33 21.33v42.67A21.33 21.33 0 00896 352.64h42.67A21.33 21.33 0 00960 331.31v-42.67a21.33 21.33 0 00-21.33-21.33zm0 405.33H896a21.33 21.33 0 00-21.33 21.33v42.67A21.33 21.33 0 00896 757.97h42.67A21.33 21.33 0 00960 736.64v-42.67a21.33 21.33 0 00-21.33-21.33zM128 469.34H85.33A21.33 21.33 0 0064 490.66v42.66a21.33 21.33 0 0021.33 21.34H128a21.33 21.33 0 0021.33-21.34v-42.66A21.33 21.33 0 00128 469.33zm0-202.03H85.33A21.33 21.33 0 0064 288.64v42.67a21.33 21.33 0 0021.33 21.33H128a21.33 21.33 0 0021.33-21.33v-42.67A21.33 21.33 0 00128 267.31zm0 405.33H85.33A21.33 21.33 0 0064 693.97v42.67a21.33 21.33 0 0021.33 21.33H128a21.33 21.33 0 0021.33-21.33v-42.67A21.33 21.33 0 00128 672.64zm405.33-203.3h-42.66a21.33 21.33 0 00-21.34 21.33v42.66a21.33 21.33 0 0021.34 21.34h42.66a21.33 21.33 0 0021.34-21.34v-42.66a21.33 21.33 0 00-21.34-21.34zm0-202.03h-42.66a21.33 21.33 0 00-21.34 21.33v42.67a21.33 21.33 0 0021.34 21.33h42.66a21.33 21.33 0 0021.34-21.33v-42.67a21.33 21.33 0 00-21.34-21.33zm0 405.33h-42.66a21.33 21.33 0 00-21.34 21.33v42.67a21.33 21.33 0 0021.34 21.33h42.66a21.33 21.33 0 0021.34-21.33v-42.67a21.33 21.33 0 00-21.34-21.33zM927.8 874.67h-832A32 32 0 0064 907.3v21.33A32 32 0 0095.79 960h832a32 32 0 0032-32v-21.33a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "table-border-bottom-stroke"
};
a['TableBorderFullStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M874.67 149.33v725.34H149.33V149.33h725.34M896 64H128a64 64 0 00-64 64v768a64 64 0 0064 64h768a64 64 0 0064-64V128a64 64 0 00-64-64z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M554.67 89.81h-87.04v829.44h87.04V89.81z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M921.81 468.05H92.37v87.04h829.44v-87.04z"
      }
    }]
  },
  "name": "table-border-full-stroke"
};
a['TableBorderLeftStroke42'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M874.67 149.33v725.34H149.33V149.33h725.34M896 64H128a64 64 0 00-64 64v768a64 64 0 0064 64h768a64 64 0 0064-64V128a64 64 0 00-64-64z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M320 469.33h-42.67A21.33 21.33 0 00256 490.67v42.66a21.33 21.33 0 0021.33 21.34H320a21.33 21.33 0 0021.33-21.34v-42.66A21.33 21.33 0 00320 469.33zm213.33 0h-42.66a21.33 21.33 0 00-21.34 21.34v42.66a21.33 21.33 0 0021.34 21.34h42.66a21.33 21.33 0 0021.34-21.34v-42.66a21.33 21.33 0 00-21.34-21.34zm0 213.34h-42.66A21.33 21.33 0 00469.33 704v42.67A21.33 21.33 0 00490.67 768h42.66a21.33 21.33 0 0021.34-21.33V704a21.33 21.33 0 00-21.34-21.33zm0-426.67h-42.66a21.33 21.33 0 00-21.34 21.33V320a21.33 21.33 0 0021.34 21.33h42.66A21.33 21.33 0 00554.67 320v-42.67A21.33 21.33 0 00533.33 256zm213.34 213.33H704a21.33 21.33 0 00-21.33 21.34v42.66A21.33 21.33 0 00704 554.67h42.67A21.33 21.33 0 00768 533.33v-42.66a21.33 21.33 0 00-21.33-21.34z"
      }
    }]
  },
  "name": "table-border-left-stroke-42"
};
a['TableBorderLeftStroke43'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M938.67 469.33H896a21.33 21.33 0 00-21.33 21.34v42.66A21.33 21.33 0 00896 554.67h42.67A21.33 21.33 0 00960 533.33v-42.66a21.33 21.33 0 00-21.33-21.34zm0 202.67H896a21.33 21.33 0 00-21.33 21.33V736A21.33 21.33 0 00896 757.33h42.67A21.33 21.33 0 00960 736v-42.67A21.33 21.33 0 00938.67 672zm0-405.12H896a21.33 21.33 0 00-21.33 21.33v42.67A21.33 21.33 0 00896 352.21h42.67A21.33 21.33 0 00960 330.88v-42.67a21.33 21.33 0 00-21.33-21.33zM533.33 672h-42.66a21.33 21.33 0 00-21.34 21.33V736a21.33 21.33 0 0021.34 21.33h42.66A21.33 21.33 0 00554.67 736v-42.67A21.33 21.33 0 00533.33 672zm0-405.12h-42.66a21.33 21.33 0 00-21.34 21.33v42.67a21.33 21.33 0 0021.34 21.33h42.66a21.33 21.33 0 0021.34-21.33v-42.67a21.33 21.33 0 00-21.34-21.33zM938.67 64H896a21.33 21.33 0 00-21.33 21.33V128A21.33 21.33 0 00896 149.33h42.67A21.33 21.33 0 00960 128V85.33A21.33 21.33 0 00938.67 64zm0 810.67H896A21.33 21.33 0 00874.67 896v42.67A21.33 21.33 0 00896 960h42.67A21.33 21.33 0 00960 938.67V896a21.33 21.33 0 00-21.33-21.33zm-405.34 0h-42.66A21.33 21.33 0 00469.33 896v42.67A21.33 21.33 0 00490.67 960h42.66a21.33 21.33 0 0021.34-21.33V896a21.33 21.33 0 00-21.34-21.33zm202.46 0h-42.67A21.33 21.33 0 00671.79 896v42.67A21.33 21.33 0 00693.12 960h42.67a21.33 21.33 0 0021.33-21.33V896a21.33 21.33 0 00-21.33-21.33zm-405.12 0H288A21.33 21.33 0 00266.67 896v42.67A21.33 21.33 0 00288 960h42.67A21.33 21.33 0 00352 938.67V896a21.33 21.33 0 00-21.33-21.33zM533.33 64h-42.66a21.33 21.33 0 00-21.34 21.33V128a21.33 21.33 0 0021.34 21.33h42.66A21.33 21.33 0 00554.67 128V85.33A21.33 21.33 0 00533.33 64zm202.46 0h-42.67a21.33 21.33 0 00-21.33 21.33V128a21.33 21.33 0 0021.33 21.33h42.67A21.33 21.33 0 00757.12 128V85.33A21.33 21.33 0 00735.79 64zm-405.12 0H288a21.33 21.33 0 00-21.33 21.33V128A21.33 21.33 0 00288 149.33h42.67A21.33 21.33 0 00352 128V85.33A21.33 21.33 0 00330.67 64zm202.66 405.33h-42.66a21.33 21.33 0 00-21.34 21.34v42.66a21.33 21.33 0 0021.34 21.34h42.66a21.33 21.33 0 0021.34-21.34v-42.66a21.33 21.33 0 00-21.34-21.34zm202.46 0h-42.67a21.33 21.33 0 00-21.33 21.34v42.66a21.33 21.33 0 0021.33 21.34h42.67a21.33 21.33 0 0021.33-21.34v-42.66a21.33 21.33 0 00-21.33-21.34zm-405.12 0H288a21.33 21.33 0 00-21.33 21.34v42.66A21.33 21.33 0 00288 554.67h42.67A21.33 21.33 0 00352 533.33v-42.66a21.33 21.33 0 00-21.33-21.34zM117.33 64H96a32 32 0 00-32 31.79v832A32 32 0 0096 960h21.33a32 32 0 0032-32.21v-832a32 32 0 00-32-31.79z"
      }
    }]
  },
  "name": "table-border-left-stroke-43"
};
a['TableBorderLeftStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M191.5 128.5a8 8 0 018 8v752a8 8 0 01-8 8h-56a8 8 0 01-8-8v-752a8 8 0 018-8h56zm348.5 696a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zm-173.5 0a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zm348 0a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zm174 0a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zM540 650.5a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zm348.5 0a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zM540 476.5a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zm-173.5 0a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zm348 0a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zm174 0a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zM540 302.5a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zm348.5 0a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zM540 128.5a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zm-173.5 0a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zm348 0a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zm174 0a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56z"
      }
    }]
  },
  "name": "table-border-left-stroke"
};
a['TableBorderNoneStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M120.75 470.61H78.08a21.33 21.33 0 00-21.33 21.34v42.66a21.33 21.33 0 0021.33 21.34h42.67a21.33 21.33 0 0021.33-21.34v-42.66a21.33 21.33 0 00-21.33-21.34zm0-202.88H78.08a21.33 21.33 0 00-21.33 21.34v42.66a21.33 21.33 0 0021.33 21.34h42.67a21.33 21.33 0 0021.33-21.34v-42.66a21.33 21.33 0 00-21.33-21.34zm0 405.34H78.08a21.33 21.33 0 00-21.33 21.33v42.67a21.33 21.33 0 0021.33 21.33h42.67a21.33 21.33 0 0021.33-21.33V694.4a21.33 21.33 0 00-21.33-21.33zm405.54-405.34h-42.66a21.33 21.33 0 00-21.34 21.34v42.66a21.33 21.33 0 0021.34 21.34h42.66a21.33 21.33 0 0021.34-21.34v-42.66a21.33 21.33 0 00-21.34-21.34zm0 405.34h-42.66a21.33 21.33 0 00-21.34 21.33v42.67a21.33 21.33 0 0021.34 21.33h42.66a21.33 21.33 0 0021.34-21.33V694.4a21.33 21.33 0 00-21.34-21.33zm-405.54 201.6H78.08A21.33 21.33 0 0056.75 896v42.67A21.33 21.33 0 0078.08 960h42.67a21.33 21.33 0 0021.33-21.33V896a21.33 21.33 0 00-21.33-21.33zM930.77 470.6h-42.66a21.33 21.33 0 00-21.34 21.34v42.66a21.33 21.33 0 0021.34 21.34h42.66a21.33 21.33 0 0021.34-21.34v-42.66a21.33 21.33 0 00-21.34-21.34zm0-202.88h-42.66a21.33 21.33 0 00-21.34 21.34v42.66a21.33 21.33 0 0021.34 21.34h42.66a21.33 21.33 0 0021.34-21.34v-42.66a21.33 21.33 0 00-21.34-21.34zm0 405.34h-42.66a21.33 21.33 0 00-21.34 21.33v42.67a21.33 21.33 0 0021.34 21.33h42.66a21.33 21.33 0 0021.34-21.33V694.4a21.33 21.33 0 00-21.34-21.33zm0 201.6h-42.66A21.33 21.33 0 00866.77 896v42.67A21.33 21.33 0 00888.11 960h42.66a21.33 21.33 0 0021.34-21.33V896a21.33 21.33 0 00-21.34-21.33zM120.75 65.07H78.08A21.33 21.33 0 0056.75 86.4v42.67a21.33 21.33 0 0021.33 21.33h42.67a21.33 21.33 0 0021.33-21.33V86.4a21.33 21.33 0 00-21.33-21.33zm810.24 0h-42.67a21.33 21.33 0 00-21.33 21.33v42.67a21.33 21.33 0 0021.33 21.33h42.67a21.33 21.33 0 0021.33-21.33V86.4a21.33 21.33 0 00-21.33-21.33zm-404.48 0h-42.67a21.33 21.33 0 00-21.33 21.33v42.67a21.33 21.33 0 0021.33 21.33h42.67a21.33 21.33 0 0021.33-21.33V86.4a21.33 21.33 0 00-21.33-21.33zm-.22 809.6h-42.66A21.33 21.33 0 00462.29 896v42.67A21.33 21.33 0 00483.63 960h42.66a21.33 21.33 0 0021.34-21.33V896a21.33 21.33 0 00-21.34-21.33zm0-404.06h-42.66a21.33 21.33 0 00-21.34 21.34v42.66a21.33 21.33 0 0021.34 21.34h42.66a21.33 21.33 0 0021.34-21.34v-42.66a21.33 21.33 0 00-21.34-21.34zM323.63 65.07h-42.67a21.33 21.33 0 00-21.33 21.33v42.67a21.33 21.33 0 0021.33 21.33h42.67a21.33 21.33 0 0021.33-21.33V86.4a21.33 21.33 0 00-21.33-21.33zm0 809.6h-42.67A21.33 21.33 0 00259.63 896v42.67A21.33 21.33 0 00280.96 960h42.67a21.33 21.33 0 0021.33-21.33V896a21.33 21.33 0 00-21.33-21.33zm0-404.06h-42.67a21.33 21.33 0 00-21.33 21.34v42.66a21.33 21.33 0 0021.33 21.34h42.67a21.33 21.33 0 0021.33-21.34v-42.66a21.33 21.33 0 00-21.33-21.34zM728.75 65.07h-42.67a21.33 21.33 0 00-21.33 21.33v42.67a21.33 21.33 0 0021.33 21.33h42.67a21.33 21.33 0 0021.33-21.33V86.4a21.33 21.33 0 00-21.33-21.33zm0 809.6h-42.67A21.33 21.33 0 00664.75 896v42.67A21.33 21.33 0 00686.08 960h42.67a21.33 21.33 0 0021.33-21.33V896a21.33 21.33 0 00-21.33-21.33zm0-404.06h-42.67a21.33 21.33 0 00-21.33 21.34v42.66a21.33 21.33 0 0021.33 21.34h42.67a21.33 21.33 0 0021.33-21.34v-42.66a21.33 21.33 0 00-21.33-21.34z"
      }
    }]
  },
  "name": "table-border-none-stroke"
};
a['TableBorderOutsideStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M864 128a32 32 0 0132 32v704a32 32 0 01-32 32H160a32 32 0 01-32-32V160a32 32 0 0132-32h704zm-40 72H200v624h624V200zM540 650.5a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zm0-174a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zm-173.5 0a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zm348 0a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56zM540 302.5a8 8 0 018 8v56a8 8 0 01-8 8h-56a8 8 0 01-8-8v-56a8 8 0 018-8h56z"
      }
    }]
  },
  "name": "table-border-outside-stroke"
};
a['TableBorderRightStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M128 469.33H85.33A21.33 21.33 0 0064 490.67v42.66a21.33 21.33 0 0021.33 21.34H128a21.33 21.33 0 0021.33-21.34v-42.66A21.33 21.33 0 00128 469.33zm0-202.66H85.33A21.33 21.33 0 0064 288v42.67A21.33 21.33 0 0085.33 352H128a21.33 21.33 0 0021.33-21.33V288A21.33 21.33 0 00128 266.67zm0 405.12H85.33A21.33 21.33 0 0064 693.12v42.67a21.33 21.33 0 0021.33 21.33H128a21.33 21.33 0 0021.33-21.33v-42.67A21.33 21.33 0 00128 671.79zm405.33-405.12h-42.66A21.33 21.33 0 00469.33 288v42.67A21.33 21.33 0 00490.67 352h42.66a21.33 21.33 0 0021.34-21.33V288a21.33 21.33 0 00-21.34-21.33zm0 405.12h-42.66a21.33 21.33 0 00-21.34 21.33v42.67a21.33 21.33 0 0021.34 21.33h42.66a21.33 21.33 0 0021.34-21.33v-42.67a21.33 21.33 0 00-21.34-21.33zM128 874.67H85.33A21.33 21.33 0 0064 896v42.67A21.33 21.33 0 0085.33 960H128a21.33 21.33 0 0021.33-21.33V896A21.33 21.33 0 00128 874.67zM128 64H85.33A21.33 21.33 0 0064 85.33V128a21.33 21.33 0 0021.33 21.33H128A21.33 21.33 0 00149.33 128V85.33A21.33 21.33 0 00128 64zm405.33 0h-42.66a21.33 21.33 0 00-21.34 21.33V128a21.33 21.33 0 0021.34 21.33h42.66A21.33 21.33 0 00554.67 128V85.33A21.33 21.33 0 00533.33 64zm-202.45 0h-42.67a21.33 21.33 0 00-21.33 21.33V128a21.33 21.33 0 0021.33 21.33h42.67A21.33 21.33 0 00352.21 128V85.33A21.33 21.33 0 00330.88 64zM736 64h-42.67A21.33 21.33 0 00672 85.33V128a21.33 21.33 0 0021.33 21.33H736A21.33 21.33 0 00757.33 128V85.33A21.33 21.33 0 00736 64zM533.33 874.67h-42.66A21.33 21.33 0 00469.33 896v42.67A21.33 21.33 0 00490.67 960h42.66a21.33 21.33 0 0021.34-21.33V896a21.33 21.33 0 00-21.34-21.33zm-202.45 0h-42.67A21.33 21.33 0 00266.88 896v42.67A21.33 21.33 0 00288.21 960h42.67a21.33 21.33 0 0021.33-21.33V896a21.33 21.33 0 00-21.33-21.33zm405.12 0h-42.67A21.33 21.33 0 00672 896v42.67A21.33 21.33 0 00693.33 960H736a21.33 21.33 0 0021.33-21.33V896A21.33 21.33 0 00736 874.67zM533.33 469.33h-42.66a21.33 21.33 0 00-21.34 21.34v42.66a21.33 21.33 0 0021.34 21.34h42.66a21.33 21.33 0 0021.34-21.34v-42.66a21.33 21.33 0 00-21.34-21.34zm-202.45 0h-42.67a21.33 21.33 0 00-21.33 21.34v42.66a21.33 21.33 0 0021.33 21.34h42.67a21.33 21.33 0 0021.33-21.34v-42.66a21.33 21.33 0 00-21.33-21.34zm405.12 0h-42.67A21.33 21.33 0 00672 490.67v42.66a21.33 21.33 0 0021.33 21.34H736a21.33 21.33 0 0021.33-21.34v-42.66A21.33 21.33 0 00736 469.33zM928 64h-21.33a32 32 0 00-32 32.21v832a32 32 0 0032 31.79H928a32 32 0 0032-32V96a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "table-border-right-stroke"
};
a['TableBorderStyleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M276.05 75.52H106.67a22.61 22.61 0 00-21.34 22.83v50.98a22.4 22.4 0 0021.34 21.34H275.2a22.61 22.61 0 0023.47-21.34V98.35a22.83 22.83 0 00-22.62-22.83zM165.12 453.55h-52.9a26.88 26.88 0 00-26.89 26.88v52.9A26.67 26.67 0 00112.21 560h52.91A26.67 26.67 0 00192 533.33v-52.9a26.88 26.88 0 00-26.88-26.88zM915.84 843.3H106.67a22.61 22.61 0 00-21.34 22.82v51.2a22.4 22.4 0 0021.34 21.34h809.17a22.4 22.4 0 0022.83-21.34v-51.2a22.61 22.61 0 00-22.62-22.82zM539.31 453.55h-53.12a27.1 27.1 0 00-26.88 26.88v52.9A26.88 26.88 0 00486.19 560h53.12a26.67 26.67 0 0026.66-26.67v-52.9a26.88 26.88 0 00-26.66-26.88zm373.12 0H859.3A26.88 26.88 0 00832 480.43v52.9A26.67 26.67 0 00858.88 560H912a26.67 26.67 0 0026.67-26.67v-52.9A26.88 26.88 0 00912 453.55zm-179.84 0h-53.12a27.1 27.1 0 00-26.88 26.88v52.9A26.88 26.88 0 00679.47 560h53.12a26.67 26.67 0 0026.66-26.67v-52.9a26.88 26.88 0 00-26.66-26.88zm-386.78 0H292.7a26.88 26.88 0 00-26.66 26.88v52.9A26.67 26.67 0 00292.69 560h53.12a26.88 26.88 0 0026.88-26.67v-52.9a27.1 27.1 0 00-26.88-26.88zM597.33 75.52H427.95a22.83 22.83 0 00-22.62 22.83v50.98a22.61 22.61 0 0022.62 21.34h169.38a22.4 22.4 0 0021.34-21.34V98.35a22.61 22.61 0 00-21.34-22.83zm320 0H748.8a22.83 22.83 0 00-23.47 22.83v50.98a22.61 22.61 0 0022.62 21.34h169.38a22.4 22.4 0 0021.34-21.34V98.35a22.61 22.61 0 00-21.34-22.83z"
      }
    }]
  },
  "name": "table-border-style-stroke"
};
a['TableBorderTopStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M533.33 875.95h-42.66a21.33 21.33 0 00-21.34 21.33v42.67a21.33 21.33 0 0021.34 21.33h42.66a21.33 21.33 0 0021.34-21.33v-42.67a21.33 21.33 0 00-21.34-21.33zm-202.66 0H288a21.33 21.33 0 00-21.33 21.33v42.67A21.33 21.33 0 00288 961.28h42.67A21.33 21.33 0 00352 939.95v-42.67a21.33 21.33 0 00-21.33-21.33zm405.12 0h-42.67a21.33 21.33 0 00-21.33 21.33v42.67a21.33 21.33 0 0021.33 21.33h42.67a21.33 21.33 0 0021.33-21.33v-42.67a21.33 21.33 0 00-21.33-21.33zM330.67 470.4H288a21.33 21.33 0 00-21.33 21.33v42.67A21.33 21.33 0 00288 555.73h42.67A21.33 21.33 0 00352 534.4v-42.67a21.33 21.33 0 00-21.33-21.33zm405.12 0h-42.67a21.33 21.33 0 00-21.33 21.33v42.67a21.33 21.33 0 0021.33 21.33h42.67a21.33 21.33 0 0021.33-21.33v-42.67a21.33 21.33 0 00-21.33-21.33zm202.88 405.55H896a21.33 21.33 0 00-21.33 21.33v42.67A21.33 21.33 0 00896 961.28h42.67A21.33 21.33 0 00960 939.95v-42.67a21.33 21.33 0 00-21.33-21.33zm-810.67 0H85.33A21.33 21.33 0 0064 897.28v42.67a21.33 21.33 0 0021.33 21.33H128a21.33 21.33 0 0021.33-21.33v-42.67A21.33 21.33 0 00128 875.95zm0-405.55H85.33A21.33 21.33 0 0064 491.73v42.67a21.33 21.33 0 0021.33 21.33H128a21.33 21.33 0 0021.33-21.33v-42.67A21.33 21.33 0 00128 470.4zm0 202.67H85.33A21.33 21.33 0 0064 694.4v42.67a21.33 21.33 0 0021.33 21.33H128a21.33 21.33 0 0021.33-21.33V694.4A21.33 21.33 0 00128 673.07zm0-405.12H85.33A21.33 21.33 0 0064 289.28v42.67a21.33 21.33 0 0021.33 21.33H128a21.33 21.33 0 0021.33-21.33v-42.67A21.33 21.33 0 00128 267.95zM938.67 470.4H896a21.33 21.33 0 00-21.33 21.33v42.67A21.33 21.33 0 00896 555.73h42.67A21.33 21.33 0 00960 534.4v-42.67a21.33 21.33 0 00-21.33-21.33zm0 202.67H896a21.33 21.33 0 00-21.33 21.33v42.67A21.33 21.33 0 00896 758.4h42.67A21.33 21.33 0 00960 737.07V694.4a21.33 21.33 0 00-21.33-21.33zm0-405.12H896a21.33 21.33 0 00-21.33 21.33v42.67A21.33 21.33 0 00896 353.28h42.67A21.33 21.33 0 00960 331.95v-42.67a21.33 21.33 0 00-21.33-21.33zM533.33 470.4h-42.66a21.33 21.33 0 00-21.34 21.33v42.67a21.33 21.33 0 0021.34 21.33h42.66a21.33 21.33 0 0021.34-21.33v-42.67a21.33 21.33 0 00-21.34-21.33zm0 202.67h-42.66a21.33 21.33 0 00-21.34 21.33v42.67a21.33 21.33 0 0021.34 21.33h42.66a21.33 21.33 0 0021.34-21.33V694.4a21.33 21.33 0 00-21.34-21.33zm0-405.12h-42.66a21.33 21.33 0 00-21.34 21.33v42.67a21.33 21.33 0 0021.34 21.33h42.66a21.33 21.33 0 0021.34-21.33v-42.67a21.33 21.33 0 00-21.34-21.33zM928.21 65.28h-832a32 32 0 00-32.21 32v21.33a32 32 0 0032 32h832a32 32 0 0032-32V97.28a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "table-border-top-stroke"
};
a['TableBorderWeightStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M906.67 131.41H117.33a42.67 42.67 0 00-42.66 42.67v128a42.67 42.67 0 0042.66 42.67h789.34a42.67 42.67 0 0042.66-42.67v-128a42.67 42.67 0 00-42.66-42.67zm10.66 394.03H106.67a32 32 0 00-32 32v69.97a32 32 0 0032 32h810.66a32 32 0 0032-32v-69.97a32 32 0 00-32-32zM928 825.6H96a21.33 21.33 0 00-21.33 21.33v24.32A21.33 21.33 0 0096 892.6h832a21.33 21.33 0 0021.33-21.34v-24.32A21.33 21.33 0 00928 825.6z"
      }
    }]
  },
  "name": "Table-border-weight-stroke"
};
a['TableExportStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M624.43 960H177.7a64 64 0 01-64-64V125.44a64 64 0 0164-64h446.72a64 64 0 0164 64v159.57a32 32 0 01-32 32h-21.34a32 32 0 01-32-32V146.77H199.04v727.9h403.84V735.79A32 32 0 01634.45 704h21.34A32.21 32.21 0 01688 736v159.79A64 64 0 01624.43 960zm262.4-406.83H343.25a32 32 0 01-32-32v-21.33a32 32 0 0132-32h543.58zM748.37 708.91l-14.93-15.15a32.21 32.21 0 010-45.44l139.95-138.88-139.52-136.53a32 32 0 010-45.23l14.93-15.36a32 32 0 0145.23 0l178.13 174.5a31.79 31.79 0 010 45.45L793.81 709.33a32 32 0 01-45.44-.42z"
      }
    }]
  },
  "name": "table-export-stroke"
};
a['TableImportStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M871.9 961.5H382.71a64 64 0 01-64-64V737.91a32 32 0 0132-32h21.33a32 32 0 0132 32v138.24h446.51V149.33h-446.5V287.8A32.21 32.21 0 01372.47 320h-21.33a32 32 0 01-32-32V128.21a64 64 0 0164-64h488.74a64 64 0 0164 64v770.14a64 64 0 01-64 63.14zM618.66 554.66h-544a32 32 0 01-32-31.58v-21.33a32 32 0 0132-32.43h544zM479.79 710.6l-14.94-15.14a32 32 0 010-45.23L604.8 512 465.28 375.47a32 32 0 010-45.23l14.93-15.36a32 32 0 0145.23 0L704 488.11a32.21 32.21 0 010 45.22L525.65 710.4a32 32 0 01-45.86.21z"
      }
    }]
  },
  "name": "table-import-stroke"
};
a['TableMergeStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M616.75 106.67h-448a64 64 0 00-64 64v448a64 64 0 0064 64h96a32 32 0 0032-32v-21.34a32 32 0 00-32-32h-74.67V192h405.33v405.33h-96a32 32 0 00-32 32v21.34a32 32 0 0032 32h117.34a64 64 0 0064-64v-448a64 64 0 00-64-64zM851.4 341.33h-96a32 32 0 00-32 32v21.34a32 32 0 0032 32h74.67V832H424.75V426.67h96a32 32 0 0032-32v-21.34a32 32 0 00-32-32H403.4a64 64 0 00-64 64v448a64 64 0 0064 64h448a64 64 0 0064-64v-448a64 64 0 00-64-64z"
      }
    }]
  },
  "name": "table-merge-stroke"
};
a['TableSameHeightStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M917.33 123.1H106.67a32 32 0 00-32 32v32a32 32 0 0032 32h810.66a32 32 0 0032-32v-32a32 32 0 00-32-32zm0 681.8H106.67a32 32 0 00-32 32v32a32 32 0 0032 32h810.66a32 32 0 0032-32v-32a32 32 0 00-32-32zm-10.66-401.06H117.33a42.67 42.67 0 00-42.66 42.67v131.2a42.67 42.67 0 0042.66 42.66h789.34a42.67 42.67 0 0042.66-42.66V446.5a42.67 42.67 0 00-42.66-42.67z"
      }
    }]
  },
  "name": "table-same-height-stroke"
};
a['TableSameSizeStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M894 472H130a8 8 0 00-8 8v64a8 8 0 008 8h764a8 8 0 008-8v-64a8 8 0 00-8-8zm0 302H130a8 8 0 00-8 8v64a8 8 0 008 8h764a8 8 0 008-8v-64a8 8 0 00-8-8zm0-604H130a8 8 0 00-8 8v64a8 8 0 008 8h764a8 8 0 008-8v-64a8 8 0 00-8-8z"
      }
    }]
  },
  "name": "table-same-size-stroke"
};
a['TableSameWidthStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M868.9 74.88h-32a32 32 0 00-32 31.79v810.66a32 32 0 0032 32h32a32 32 0 0032-32V106.67a32 32 0 00-32-32zm-681.8 0h-32a32 32 0 00-32 31.79v810.66a32 32 0 0032 32h32a32 32 0 0032-32V106.67a32 32 0 00-32-32zm390.4 0H446.3a42.67 42.67 0 00-42.67 42.67v789.33a42.67 42.67 0 0042.66 42.67h131.2a42.67 42.67 0 0042.67-42.67V117.55a42.67 42.67 0 00-42.67-42.67z"
      }
    }]
  },
  "name": "table-same-width-stroke"
};
a['TableSplitStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M150.92000000000002 824.36l689.8-682.62q22.75-22.5 45.26.24l15 15.16q22.51 22.75-.24 45.26L210.94 885q-22.74 22.52-45.25-.23l-15-15.16q-22.51-22.75.23-45.26zm540.5-329.43h138.66v329.39H500.69V682.67a10.67 10.67 0 00-18.13-7.68l-57.6 56.96a31.36 31.36 0 00-9.6 22.61v90.88a64 64 0 0064 64h372.05a64 64 0 0064-64V473.6a64 64 0 00-64-64h-85.33a31.57 31.57 0 00-21.33 9.17l-58.67 57.82a10.67 10.67 0 005.33 18.34zm-397.87 102.4H190.08V192h405.33v107.73a10.67 10.67 0 0018.14 7.68l57.6-56.96a31.79 31.79 0 009.6-22.82v-56.96a64 64 0 00-64-64h-448a64 64 0 00-64 64v448a64 64 0 0064 64h50.98a32.64 32.64 0 0022.62-9.18L301 615.68a10.67 10.67 0 00-7.46-18.35z"
      }
    }]
  },
  "name": "table-split-stroke"
};
a['TableStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M874.67 86.4H149.33a64 64 0 00-64 64v725.33a64 64 0 0064 64h725.34a64 64 0 0064-64V150.4a64 64 0 00-64-64zm-704 277.33h193.06v108.38H170.67zm0 193.71h193.06V662.4H170.67zm278.4 0h404.26V662.4H449.07zm0-85.33V363.95h404.26v108.37zm404.26-300.38V278.4H170.67V171.73zm-682.66 576h193.06V854.4H170.67zm278.4 106.67V747.73h404.26V854.4z"
      }
    }]
  },
  "name": "table-stroke"
};
a['TableSubEditStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M938.67 333.65V139.52a64 64 0 00-64-64H149.33a64 64 0 00-64 64v725.33a64 64 0 0064 64h341.34a32 32 0 0032-32v-22.18a32 32 0 00-32-32h-64V674.13h64a32 32 0 0032-32V620.8a32 32 0 00-32-32h-64V418.13h480a32 32 0 0032-32V332.8h-768V160.85h682.66v172.8zM170.67 675h170.66v168.53H170.67zm170.66-256v170.66H170.67V419z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M913.5 552.32l-110.94-64a42.67 42.67 0 00-58.24 15.57L605.65 744.11a47.36 47.36 0 00-4.69 12.58 31.79 31.79 0 0144.37-13.01l25.82 14.72 18.13-31.57 100.05-172.16 73.82 42.66-116.48 202.88v1.07l25.81 14.93a32 32 0 0110.88 44.8 44.59 44.59 0 008.53-10.24l138.67-240.21a42.67 42.67 0 00-17.07-58.24zM732.15 866.35l-40.1-23.04-25.4 14.72-5.33 2.98v-34.34l-40.1-23.26a42.67 42.67 0 01-20.27-45.65 32.43 32.43 0 00-3.63 14.5v145.07a32 32 0 0048 27.74L771 872.32a32 32 0 0010.88-10.45 42.67 42.67 0 01-49.71 4.48z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M770.99 816.21l-25.82-14.93-10.02 17.28-42.67 24.75 40.1 23.04A42.67 42.67 0 00782.3 861a32 32 0 00-11.3-44.8zm-149.76-13.86l40.1 23.25v-50.56l9.6-16.64-25.81-14.72a31.79 31.79 0 00-44.37 13.01 42.67 42.67 0 0020.48 45.66z"
      }
    }]
  },
  "name": "table-sub-edit-stroke"
};
a['TableSubStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M874.67 85.33H149.33a64 64 0 00-64 64v725.34a64 64 0 0064 64h725.34a64 64 0 0064-64V149.33a64 64 0 00-64-64zm-21.34 85.34v170.66H170.67V170.67zM426.67 597.33v-169.6h170.66V598.4zm170.66 85.34v170.66H426.67V682.67zm-256-85.34H170.67v-169.6h170.66zm341.34-169.6h170.66V598.4H682.67zm-512 254.94h170.66v170.66H170.67zm512 170.66V682.67h170.66v170.66z"
      }
    }]
  },
  "name": "table-sub-stroke"
};
a['TabletStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 149.33v725.34H256V149.33h512M784.85 64H239.36a68.48 68.48 0 00-68.7 67.41V892.6a68.48 68.48 0 0068.7 67.41h545.28a68.48 68.48 0 0068.7-67.41V131.4A68.48 68.48 0 00784.63 64z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M512 710.4a57.17 57.17 0 1056.75 57.6A57.17 57.17 0 00512 710.4z"
      }
    }]
  },
  "name": "tablet-stroke"
};
a['TagFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M923.86 468.8l-22.53-305.53a34 34 0 00-30.6-30.6L565.2 110.14h-.4a10.25 10.25 0 00-7.6 2.9L103 567.2a10 10 0 000 14.1L452.7 931a10.14 10.14 0 0014.2 0l454.16-454.2a10.53 10.53 0 002.8-8zm-250.93-19.73a88 88 0 1188-88 88.13 88.13 0 01-88 88z"
      }
    }]
  },
  "name": "tag-fill"
};
a['TagStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M672.93 393.07a32 32 0 1132-32 32 32 0 01-32 32zm0-120a88 88 0 1088 88 88.13 88.13 0 00-88-88zM459.7 830.56L203.44 574.3 589 188.74l239.93 16.33L845.26 445zM923.86 468.8l-22.53-305.53a34 34 0 00-30.6-30.6L565.2 110.14h-.4a10.25 10.25 0 00-7.6 2.9L103 567.2a10 10 0 000 14.1L452.7 931a10.14 10.14 0 0014.2 0l454.16-454.2a10.53 10.53 0 002.8-8z"
      }
    }]
  },
  "name": "tag-stroke"
};
a['TagsFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M889.7 538.8l-39.6-39.5a8 8 0 00-11.3 0l-362 361.3-237.6-237a8 8 0 00-11.3 0l-39.6 39.5a8 8 0 000 11.3l243.2 242.8 39.6 39.5a8 8 0 0011.3 0l407.3-406.6a8 8 0 000-11.3zM605.9 255.9a48 48 0 110 67.9 48.1 48.1 0 010-67.9zM483.2 789.3L861.4 411a7.9 7.9 0 002.3-6.3l-25.5-301.4a16 16 0 00-14.6-14.6L522.2 63.3a7.78 7.78 0 00-6.3 2.3L137.7 443.8a8 8 0 000 11.3l334.2 334.2a7.85 7.85 0 0011.3 0z"
      }
    }]
  },
  "name": "tags-fill"
};
a['TagsStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M889.7 538.8l-39.6-39.5a8 8 0 00-11.3 0l-362 361.3-237.6-237a8 8 0 00-11.3 0l-39.6 39.5a8 8 0 000 11.3l243.2 242.8 39.6 39.5a8 8 0 0011.3 0l407.3-406.6a8 8 0 000-11.3zM606 323.83a48 48 0 10-12.43-46.37A48 48 0 00606 323.83zM545.8 137.6l224.6 19 19 224.6L477.5 693 233.9 449.5zm-62.6 651.7L861.4 411a7.9 7.9 0 002.3-6.3l-25.5-301.4a16 16 0 00-14.6-14.6L522.2 63.3a7.78 7.78 0 00-6.3 2.3L137.7 443.8a8 8 0 000 11.3l334.2 334.2a7.85 7.85 0 0011.3 0z"
      }
    }]
  },
  "name": "tags-stroke"
};
a['TeamAddStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M590.93 147.2C550.4 96 486.4 64 418.13 64h-4.26a216.47 216.47 0 00-177.07 91.73C166.4 258.13 192 384 275.2 454.4 174.93 503.47 104.53 601.6 89.6 712.53c0 2.14-2.13 4.27-2.13 8.54 0 17.06 14.93 32 32 32h21.33c17.07 0 32-14.94 32-32v-2.14c12.8-91.73 76.8-168.53 162.13-198.4C345.6 516.27 352 509.87 352 499.2c0-21.33 2.13-55.47 4.27-74.67 0-8.53-4.27-17.06-10.67-21.33-74.67-42.67-93.87-149.33-23.47-217.6 12.8-12.8 29.87-23.47 49.07-29.87 57.6-17.06 110.93 2.14 145.07 40.54 6.4 8.53 21.33 12.8 32 10.66l19.2-6.4c27.73-8.53 38.4-36.26 23.46-53.33zM275.2 454.4c-2.13 0 0 0 0 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M857.6 448c-14.93-108.8-108.8-192-219.73-192-27.74 0-57.6 6.4-83.2 17.07-64 25.6-113.07 81.06-130.14 149.33-2.13 8.53-4.26 17.07-4.26 25.6a279.56 279.56 0 000 59.73c8.53 55.47 36.26 104.54 74.66 138.67-98.13 46.93-170.66 142.93-183.46 258.13-4.27 17.07 6.4 34.14 23.46 38.4 2.14 0 6.4 2.14 8.54 0h21.33c17.07 0 29.87-12.8 32-27.73C411.73 795.73 509.87 704 631.47 699.73c12.8 0 27.73 0 40.53-2.13 115.2-17.07 200.53-128 185.6-249.6zM648.53 614.4H627.2c-64-6.4-117.33-57.6-123.73-121.6v-14.93c0-72.54 57.6-132.27 130.13-134.4h4.27c74.66-2.14 138.66 55.46 140.8 130.13 2.13 74.67-55.47 136.53-130.14 140.8zm149.34 78.93h-21.34c-17.06 0-32 14.94-32 32V928c0 17.07 14.94 32 32 32h21.34c17.06 0 32-14.93 32-32V725.33c0-17.06-14.94-32-32-32z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M887.47 785.07H684.8c-17.07 0-32 14.93-32 32v21.33c0 17.07 14.93 32 32 32h202.67c17.06 0 32-14.93 32-32v-21.33c0-19.2-12.8-32-32-32z"
      }
    }]
  },
  "name": "team-add-stroke"
};
a['TeamMemberFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M349.92 664.54a357.8 357.8 0 0139.47-34.22 8 8 0 001.83-10.92A255.59 255.59 0 01567 224.1a8 8 0 006-11.67A195.92 195.92 0 00396.23 107c-107.14 1.54-193.63 89.82-193.08 197a195.81 195.81 0 0081.23 157.88c-.32.16-.63.24-.95.39A297 297 0 00102 729.52a6.32 6.32 0 006.32 6.48H290a8 8 0 006.86-3.89 358.32 358.32 0 0153.06-67.57z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M890.26 798.21a303.92 303.92 0 00-161-161c-.32-.16-.64-.24-1-.4A199.1 199.1 0 00811 475.08c0-110.23-89.31-199.55-199.54-199.55s-199.54 89.32-199.54 199.55a199.37 199.37 0 0082.72 161.8c-.33.16-.65.24-1 .4A302.45 302.45 0 00308.93 909.4a6.45 6.45 0 006.44 6.6h592.19a6.45 6.45 0 006.44-6.6 299.81 299.81 0 00-23.74-111.19z"
      }
    }]
  },
  "name": "team-member-fill"
};
a['TeamMemberStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M953.6 919.47C940.8 800 868.27 704 768 654.93a219.8 219.8 0 0078.93-200.53C832 343.47 738.13 258.13 625.07 258.13h-2.14c-100.26 2.14-187.73 70.4-213.33 166.4-4.27 19.2-8.53 38.4-8.53 57.6v27.74c8.53 57.6 36.26 108.8 78.93 142.93C377.6 701.87 307.2 800 294.4 917.33v6.4c0 17.07 12.8 32 32 32h21.33c17.07 0 29.87-12.8 32-29.86C392.53 791.47 512 691.2 646.4 704c117.33 10.67 211.2 104.53 221.87 221.87 2.13 17.06 14.93 29.86 32 29.86h21.33c17.07 0 32-14.93 32-32v-4.26zM486.4 482.13c0-72.53 57.6-134.4 130.13-138.66h8.54c76.8 0 138.66 61.86 138.66 138.66S701.87 620.8 625.07 620.8c-72.54 0-132.27-55.47-138.67-128v-10.67z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M317.87 520.53c10.66-4.26 17.06-10.66 17.06-21.33 0-21.33 2.14-55.47 4.27-74.67 0-8.53-4.27-17.06-10.67-21.33-74.66-42.67-93.86-149.33-23.46-217.6 12.8-12.8 29.86-23.47 49.06-29.87 57.6-17.06 110.94 2.14 145.07 40.54 6.4 8.53 21.33 12.8 32 10.66l19.2-6.4c25.6-8.53 34.13-34.13 21.33-53.33C529.07 96 467.2 64 398.93 64h-4.26a216.47 216.47 0 00-177.07 91.73C147.2 260.27 170.67 384 253.87 454.4 153.6 503.47 83.2 601.6 70.4 712.53c0 2.14-2.13 4.27-2.13 8.54 0 17.06 14.93 32 32 32h21.33c17.07 0 32-14.94 32-32v-2.14c14.93-91.73 76.8-168.53 164.27-198.4z"
      }
    }]
  },
  "name": "team-member-stroke"
};
a['TeamMultipleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M776.1 57.6H128a64 64 0 00-64 64v651.1a32 32 0 0032 32h21.33a32 32 0 0032-32V142.92h626.78a34.99 34.99 0 0034.56-34.98V92.8a35.2 35.2 0 00-34.56-35.2z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M576 461.65a80 80 0 11-80 80 80 80 0 0180-80m0-85.33a165.33 165.33 0 10165.33 165.33A165.33 165.33 0 00576 376.32z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M576 623.57a240 240 0 00-240 240v19.2h85.33v-19.2a154.67 154.67 0 11309.34 0v19.2H816v-19.2a240 240 0 00-240-240z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M874.67 270.93v597.34H277.33V270.93h597.34M896 185.6H256a64 64 0 00-64 64v640a64 64 0 0064 64h640a64 64 0 0064-64v-640a64 64 0 00-64-64z"
      }
    }]
  },
  "name": "team-multiple-stroke"
};
a['TeamNodesStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M640 189.87v106.66H384V189.87h256M789.33 704l18.35 5.55a64 64 0 11-36.7 0l18.35-5.55m-554.66 0l18.34 5.55a64 64 0 11-36.69 0l18.35-5.55m424.32-599.47H363.73a65.7 65.7 0 00-65.06 66.14v145.92a65.7 65.7 0 0065.7 65.7h104.96V448H221.65A29.65 29.65 0 00192 476.8v149.33a149.33 149.33 0 1085.33 0v-92.8h469.34v93.87a149.33 149.33 0 1085.33 0V475.3a28.16 28.16 0 00-28.37-27.3H554.67v-66.13h104.96a65.7 65.7 0 0065.7-65.71v-145.5A65.7 65.7 0 00659 104.54z"
      }
    }]
  },
  "name": "team-nodes-stroke"
};
a['TeamRemoveStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M138.67 691.2c-17.07 0-32 12.8-32 29.87s12.8 32 32 32c17.06 0 32-12.8 32-32 0-17.07-14.94-29.87-32-29.87z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M162.13 691.2c-17.06 0-32 14.93-32 32s14.94 32 32 32 32-14.93 32-32c0-19.2-14.93-32-32-32zM874.67 448c-14.94-108.8-108.8-192-219.74-192-27.73 0-57.6 6.4-83.2 17.07-64 25.6-113.06 81.06-130.13 149.33-2.13 8.53-4.27 17.07-4.27 25.6a279.56 279.56 0 000 59.73c8.54 55.47 36.27 104.54 76.8 138.67-98.13 46.93-170.66 142.93-185.6 258.13-4.26 17.07 6.4 34.14 23.47 38.4 2.13 0 6.4 2.14 8.53 0h21.34c17.06 0 29.86-12.8 32-27.73 14.93-123.73 119.46-217.6 243.2-217.6 10.66 0 19.2 0 29.86-2.13C806.4 682.67 891.73 569.6 874.67 448zm-217.6 166.4c-70.4 0-128-53.33-136.54-121.6v-14.93c0-72.54 57.6-132.27 132.27-136.54h4.27c74.66 0 136.53 61.87 136.53 136.54S731.73 614.4 657.07 614.4zM870.4 729.6c-8.53 0-17.07 4.27-23.47 8.53L697.6 887.47c-12.8 12.8-12.8 32 0 44.8l14.93 14.93c6.4 6.4 14.94 8.53 23.47 8.53s17.07-4.26 23.47-8.53L908.8 797.87c12.8-12.8 12.8-32 0-44.8l-14.93-14.94c-8.54-6.4-14.94-8.53-23.47-8.53z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M736 729.6c-8.53 0-17.07 4.27-23.47 8.53l-14.93 14.94c-12.8 12.8-12.8 32 0 44.8L846.93 947.2c12.8 12.8 32 12.8 44.8 0l14.94-14.93c12.8-12.8 12.8-32 0-44.8L757.33 738.13c-6.4-6.4-12.8-8.53-21.33-8.53zM608 149.33c-40.53-51.2-104.53-83.2-172.8-83.2h-4.27a216.47 216.47 0 00-177.06 91.74c-70.4 104.53-44.8 228.26 38.4 298.66C192 505.6 121.6 603.73 106.67 714.67v8.53c0 17.07 14.93 32 32 32H160c17.07 0 32-14.93 32-32v-2.13c12.8-91.74 76.8-168.54 162.13-198.4 10.67-4.27 17.07-10.67 17.07-21.34 0-21.33 2.13-55.46 4.27-74.66 0-8.54-4.27-17.07-10.67-21.34-74.67-42.66-93.87-149.33-23.47-217.6 12.8-12.8 29.87-23.46 49.07-29.86C448 140.8 501.33 160 535.47 198.4c6.4 8.53 21.33 12.8 32 10.67l19.2-6.4c27.73-8.54 36.26-36.27 21.33-53.34zm-315.73 307.2z"
      }
    }]
  },
  "name": "team-remove-stroke"
};
a['TeamSingleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 618.67h-64v-85.34a64 64 0 00-64-64H554.67v-64H640a64 64 0 0064-64V128a64 64 0 00-64-64H384a64 64 0 00-64 64v213.33a64 64 0 0064 64h85.33v64H256a64 64 0 00-64 64v85.34h-64a64 64 0 00-64 64V896a64 64 0 0064 64h213.33a64 64 0 0064-64V682.67a64 64 0 00-64-64h-64v-64h469.34v64h-64a64 64 0 00-64 64V896a64 64 0 0064 64H896a64 64 0 0064-64V682.67a64 64 0 00-64-64zM405.33 149.33h213.34V320H405.33zM320 704v170.67H149.33V704zm554.67 170.67H704V704h170.67z"
      }
    }]
  },
  "name": "team-single-stroke"
};
a['TeamSubStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 384H682.67a64 64 0 00-64 64v128a64 64 0 0064 64H896a64 64 0 0064-64V448a64 64 0 00-64-64zm-21.33 170.67H704v-85.34h170.67zM896 704H682.67a64 64 0 00-64 64v128a64 64 0 0064 64H896a64 64 0 0064-64V768a64 64 0 00-64-64zm-21.33 170.67H704v-85.34h170.67zM543.79 556.16A31.79 31.79 0 00576 524.37v-21.33a32 32 0 00-31.79-32.21l-245.54-1.5V320H384a64 64 0 0064-64V128a64 64 0 00-64-64H128a64 64 0 00-64 64v128a64 64 0 0064 64h85.33v490.67a64 64 0 0064 64H544a32 32 0 0032-32v-21.34a32 32 0 00-32-32H298.67V554.67zm-394.46-321.5v-85.33h213.34v85.34z"
      }
    }]
  },
  "name": "team-sub-stroke"
};
a['TeamTreeStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M597.33 149.33V320H426.67V149.33h170.66m277.34 635.1v90.24h-89.6v-89.6h89.6m-317.87 0v89.6h-89.6v-89.6h89.6m-317.01 0v89.6h-90.46v-89.6h89.6M640 64H384a42.67 42.67 0 00-42.67 42.67v256A42.67 42.67 0 00384 405.33h85.33V512H182.4a32 32 0 00-32 32v21.33a32.85 32.85 0 001.5 8.96v125.87h-45.23A42.67 42.67 0 0064 742.83v174.5A42.67 42.67 0 00106.67 960H281.6a42.67 42.67 0 0042.67-42.67V742.4a42.67 42.67 0 00-42.67-42.67h-44.8v-102.4h232.53v102.83h-44.8a42.67 42.67 0 00-42.66 42.67v174.5A42.67 42.67 0 00424.53 960h174.94a42.67 42.67 0 0042.66-42.67V742.4a42.67 42.67 0 00-42.66-42.67h-44.8v-102.4H787.2v102.83h-44.8a42.67 42.67 0 00-42.67 42.67v174.5A42.67 42.67 0 00742.4 960h174.93A42.67 42.67 0 00960 917.33V742.4a42.67 42.67 0 00-42.67-42.67h-44.8v-156.8a32 32 0 00-32-32H554.67v-105.6H640a42.67 42.67 0 0042.67-42.66v-256A42.67 42.67 0 00640 64z"
      }
    }]
  },
  "name": "team-tree-stroke"
};
a['TextAlignHorizontalCenterFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M948.27 432.43v151.46q0 42.67-42.67 42.67H110.72q-42.67 0-42.67-42.67V432.43q0-42.67 42.67-42.67H905.6q42.67 0 42.67 42.67z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M516.9 952.1h-34.13q-25.6 0-25.6-25.6v-829q0-25.6 25.6-25.6h34.14q25.6 0 25.6 25.6v829q0 25.6-25.6 25.6z"
      }
    }]
  },
  "name": "text-align-horizontal-center-fill"
};
a['TextAlignHorizontalCenterStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M697.6 472.1H326.4a32 32 0 00-32 32v32a32 32 0 0032 32h371.2a32 32 0 0032-32v-32a32 32 0 00-32-32zm217.6-337.06H108.8a32 32 0 00-32 32v32a32 32 0 0032 32h806.4a32 32 0 0032-32v-32a32 32 0 00-32-32zm0 674.13H108.8a32 32 0 00-32 32v32a32 32 0 0032 32h806.4a32 32 0 0032-32v-32a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "text-align-horizontal-center-stroke"
};
a['TextAlignHorizontalLeftFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M134.4 84.05h-33.7a25.81 25.81 0 00-25.82 25.82v804.26a25.81 25.81 0 0025.81 25.82h33.71a25.81 25.81 0 0025.81-25.82V109.87a25.81 25.81 0 00-25.81-25.82zM245.12 582.4V441.39q0-42.03 42.03-42.03h619.94q42.03 0 42.03 42.03V582.4q0 42.03-42.03 42.03H287.15q-42.03 0-42.03-42.03z"
      }
    }]
  },
  "name": "text-align-horizontal-left-fill"
};
a['TextAlignHorizontalLeftStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M484.7 477.01H113.5a32 32 0 00-32 32v32a32 32 0 0032 32h371.2a32 32 0 0032-32v-32a32 32 0 00-32-32zm435.2-338.13H113.5a32 32 0 00-32 31.79v32a32 32 0 0032 32h806.4a32 32 0 0032-32v-32a32 32 0 00-32-32zm0 674.13H113.5a32 32 0 00-32 32v32a32 32 0 0032 32h806.4a32 32 0 0032-32v-32a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "text-align-horizontal-left-stroke"
};
a['TextAlignHorizontalRightFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M923.3 84.05h-33.7a25.81 25.81 0 00-25.81 25.82v804.26a25.81 25.81 0 0025.81 25.82h33.7a25.81 25.81 0 0025.82-25.82V109.87a25.81 25.81 0 00-25.81-25.82zM778.88 441.6v141.01q0 42.03-42.03 42.03H116.91q-42.03 0-42.03-42.03V441.6q0-42.03 42.03-42.03h619.94q42.03 0 42.03 42.03z"
      }
    }]
  },
  "name": "text-align-horizontal-right-fill"
};
a['TextAlignHorizontalRightStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M922.45 472.1H551.04a32 32 0 00-32 32v32a32 32 0 0032 32h371.41a32 32 0 0032-32v-32a32 32 0 00-32-32zm0 337.07H115.84a32 32 0 00-32 32v32a32 32 0 0032 32h806.61a32 32 0 0032-32v-32a32 32 0 00-32-32zm0-674.13H115.84a32 32 0 00-32 32v32a32 32 0 0032 32h806.61a32 32 0 0032-32v-32a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "text-align-horizontal-right-stroke"
};
a['TextAlignVerticalBottomFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M914.13 863.79H109.87a25.81 25.81 0 00-25.82 25.81v33.7a25.81 25.81 0 0025.82 25.82h804.26a25.81 25.81 0 0025.82-25.81V889.6a25.81 25.81 0 00-25.82-25.81zM582.4 778.88H441.39q-42.03 0-42.03-42.03V116.91q0-42.03 42.03-42.03H582.4q42.03 0 42.03 42.03v619.94q0 42.03-42.03 42.03z"
      }
    }]
  },
  "name": "text-align-vertical-bottom-fill"
};
a['TextAlignVerticalBottomStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M909.87 655.15H103.25a32 32 0 00-32 32v32a32.21 32.21 0 0032 32h806.62a32 32 0 0032-32v-32a32 32 0 00-32-32zm0 170.66H103.25a32 32 0 00-32 32v32a32.21 32.21 0 0032 32h806.62a32 32 0 0032-32v-32a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "text-align-vertical-bottom-stroke"
};
a['TextAlignVerticalCenterFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M432.21000000000004 71.9h151.47q42.67 0 42.67 42.66v794.88q0 42.67-42.67 42.67H432.21q-42.66 0-42.66-42.67V114.56q0-42.67 42.66-42.67z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M952.1 499.20000000000005v34.13q0 25.6-25.6 25.6h-829q-25.6 0-25.6-25.6V499.2q0-25.6 25.6-25.6h829q25.6 0 25.6 25.6z"
      }
    }]
  },
  "name": "text-align-vertical-center-fill"
};
a['TextAlignVerticalCenterStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M914.13 387.84H106.67a32 32 0 00-32 32v32a32.21 32.21 0 0032 32h807.46a32 32 0 0032-32v-32a32 32 0 00-32-32zm3.2 171.1H109.87a32 32 0 00-32 32v32a32 32 0 0032 32h807.46a32 32 0 0032-32v-32a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "text-align-vertical-center-stroke"
};
a['TextAlignVerticalTopFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M918.83 56.75H114.56a25.81 25.81 0 00-25.81 25.81v33.7a25.81 25.81 0 0025.81 25.82h804.27a25.81 25.81 0 0025.81-25.81V82.56a25.81 25.81 0 00-25.81-25.81zM446.92999999999995 245.12h139.74q42.66 0 42.66 42.67v618.66q0 42.67-42.66 42.67H446.93q-42.66 0-42.66-42.67V287.8q0-42.67 42.66-42.67z"
      }
    }]
  },
  "name": "text-align-vertical-top-fill"
};
a['TextAlignVerticalTopStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M915.2 89.17H108.8a32 32 0 00-32 32v32a32 32 0 0032 32h806.4a32 32 0 0032-32v-32a32 32 0 00-32-32zm0 170.67H108.8a32 32 0 00-32 32v32a32 32 0 0032 32h806.4a32 32 0 0032-32v-32a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "text-align-vertical-top-stroke"
};
a['TextAscendLetterStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M913.07 648.53l2.13-2.13 2.13-2.13c0-2.14 2.14-2.14 2.14-4.27 2.13-6.4 2.13-10.67 2.13-17.07v-17.06c0-17.07-14.93-32-32-32H612.27c-17.07 0-32 14.93-32 32v21.33c0 17.07 14.93 32 32 32h177.06l-198.4 224c-6.4 6.4-10.66 14.93-10.66 23.47V928c0 17.07 14.93 32 32 32H889.6c17.07 0 32-14.93 32-32v-21.33c0-17.07-14.93-32-32-32H712.53l200.54-226.14zM614.4 490.67h19.2c14.93 0 27.73-10.67 29.87-23.47L684.8 384h132.27l21.33 83.2c4.27 12.8 14.93 23.47 29.87 23.47h19.2c17.06 0 32-14.94 32-32 0-2.14 0-6.4-2.14-8.54L823.47 89.6C821.33 74.67 808.53 64 793.6 64h-83.2c-14.93 0-29.87 10.67-32 27.73L582.4 448c-2.13 4.27-2.13 6.4-2.13 10.67 0 17.06 14.93 32 34.13 32zm136.53-352l42.67 160h-85.33l42.66-160zM347.73 64H326.4c-17.07 0-32 14.93-32 32v725.33L183.47 710.4c-6.4-6.4-14.94-8.53-23.47-8.53s-17.07 4.26-23.47 8.53l-14.93 14.93c-12.8 12.8-12.8 32 0 44.8l181.33 181.34c4.27 4.26 10.67 6.4 17.07 8.53h27.73c17.07 0 32-14.93 32-32V96c0-17.07-14.93-32-32-32z"
      }
    }]
  },
  "name": "text-ascend-letter-stroke"
};
a['TextAscendStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M501.76 156.59h422.19a29.44 29.44 0 0133.28 33.49v21.33a29.44 29.44 0 01-33.28 33.28H501.76a29.44 29.44 0 01-32.43-31.36V192a29.65 29.65 0 0132.43-35.41zm0 311.04h422.19a29.44 29.44 0 0133.28 33.28v21.33a29.44 29.44 0 01-33.28 33.28H501.76a29.44 29.44 0 01-32.43-32.43v-21.33a29.44 29.44 0 0132.43-34.13zm0 311.25h422.19a29.44 29.44 0 0133.28 33.28v21.33a29.44 29.44 0 01-33.28 33.5H501.76a29.65 29.65 0 01-32.43-32.64V813a29.44 29.44 0 0132.43-34.13zM332.8 928V96a32.85 32.85 0 00-32-32h-21.33a32.85 32.85 0 00-32 32v725.33L136.53 710.4a44.8 44.8 0 00-23.46-8.53 32 32 0 00-23.47 8.53l-14.93 14.93a32.43 32.43 0 000 42.67L256 949.33A34.35 34.35 0 00279.47 960h21.33a32.85 32.85 0 0032-32z"
      }
    }]
  },
  "name": "text-ascend-stroke"
};
a['TextBoldStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M694.61 476.37A238.72 238.72 0 00768 304 240 240 0 00528 64H234.67a64 64 0 00-64 64v770.35A61.65 61.65 0 00232.32 960h370.35a250.45 250.45 0 0091.94-483.63zM256 149.33h272a154.67 154.67 0 010 309.34H256zm346.67 725.34H256V544h346.67a165.33 165.33 0 010 330.67z"
      }
    }]
  },
  "name": "text-bold-stroke"
};
a['TextCapitalStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M872.53 914.77L632.75 256l-62.3-170.67A31.57 31.57 0 00541.23 64H483.4a32 32 0 00-29.86 21.33L391.25 256 151.47 914.77a30.72 30.72 0 00-2.14 13.23 32 32 0 0031.15 32h17.5a31.79 31.79 0 0029.86-21.33L290.14 768l49.49-135.47h344.74L733.87 768l62.29 170.67A31.79 31.79 0 00826.03 960h17.49a32 32 0 0031.15-32 30.72 30.72 0 00-2.14-13.23zM370.56 547.2L512 158.72 653.44 547.2z"
      }
    }]
  },
  "name": "text-capital-stroke"
};
a['TextDescendLetterStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M904.53 874.67H727.47L930.13 646.4c6.4-8.53 8.54-17.07 6.4-25.6v-14.93c0-17.07-14.93-32-32-32H627.2c-17.07 0-32 14.93-32 32v21.33c0 17.07 14.93 32 32 32h177.07L603.73 885.33c-6.4 6.4-10.66 14.94-10.66 23.47v21.33c0 17.07 14.93 32 32 32H902.4c17.07 0 32-14.93 32-32V908.8c2.13-19.2-12.8-34.13-29.87-34.13zm-277.33-384h19.2c14.93 0 27.73-10.67 29.87-23.47L697.6 384H832l21.33 78.93c2.14 14.94 14.94 25.6 32 25.6h19.2c17.07 0 32-14.93 32-32 0-2.13 0-6.4-2.13-8.53l-96-358.4c-4.27-14.93-17.07-25.6-32-25.6h-81.07c-14.93 0-27.73 10.67-29.86 23.47l-98.14 362.66c0 2.14-2.13 6.4-2.13 8.54 0 17.06 14.93 32 32 32zm138.67-352l42.66 160H723.2l42.67-160zM322.13 64H300.8c-8.53 0-17.07 4.27-23.47 10.67L96 256c-10.67 10.67-10.67 29.87 0 42.67l14.93 14.93c6.4 6.4 14.94 8.53 23.47 8.53s17.07-4.26 23.47-8.53L268.8 202.67V928c0 17.07 14.93 32 32 32h21.33c17.07 0 32-14.93 32-32V96c0-17.07-14.93-32-32-32z"
      }
    }]
  },
  "name": "text-descend-letter-stroke"
};
a['TextDescendStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M503.47 157.01h422.18A29.44 29.44 0 01960 190.3v21.34a29.65 29.65 0 01-33.28 33.49H503.47a29.65 29.65 0 01-34.14-31.79V192a29.65 29.65 0 0134.14-34.99zm0 310.62h422.18A29.44 29.44 0 01960 500.9v22.4a29.44 29.44 0 01-33.28 33.28H503.47a29.65 29.65 0 01-34.14-33.28v-22.4a29.65 29.65 0 0134.14-33.28zm0 311.68h422.18A29.44 29.44 0 01960 812.59v21.33a29.44 29.44 0 01-33.28 33.28H503.47a29.65 29.65 0 01-34.14-32.43v-21.33a29.65 29.65 0 0134.14-34.13zM298.67 64h-21.34a34.35 34.35 0 00-23.46 10.67L72.96 256a32.43 32.43 0 000 42.67l14.93 14.93a32 32 0 0023.47 8.53 44.8 44.8 0 0023.47-8.53l110.93-110.93V928a32.85 32.85 0 0031.57 32h21.34a32.85 32.85 0 0032-32V96a32.85 32.85 0 00-32-32z"
      }
    }]
  },
  "name": "text-descend-stroke"
};
a['TextIndentBottomStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M928 792.96H96a32 32 0 00-32 32v32a32 32 0 0032 32h832a32 32 0 0032-32v-32a32 32 0 00-32-32zm-.51-384.38c7.36 0 14.46 2.94 19.65 8.19l13.12 12.99a27.58 27.58 0 010 39.3l-105.6 105.6a28.16 28.16 0 01-3.65 4.73l-13.19 13a27.58 27.58 0 01-20.1 8.19 27.84 27.84 0 01-20.09-8.2l-12.99-12.99a28.1 28.1 0 01-3.71-4.6L675.2 469.11a27.58 27.58 0 010-39.3l13.12-12.99a27.58 27.58 0 0139.3 0l90.17 90.05 90.05-90.05a27.58 27.58 0 0114.2-7.68zm-338.24 48.38a32 32 0 0132 32v32a32 32 0 01-32 32H96a32 32 0 01-32-32v-32a32 32 0 0132-32zM928 121.6H96a32 32 0 00-32 32v32a32 32 0 0032 32h832a32 32 0 0032-32v-32a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "text-indent-bottom-stroke"
};
a['TextIndentLeftStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M928 122.03H96a32 32 0 00-32 32v32a32 32 0 0032 32h832a32 32 0 0032-32v-32a32 32 0 00-32-32zm0 336H434.77a32 32 0 00-32 32v32a32 32 0 0032 32H928a32 32 0 0032-32v-31.36a32 32 0 00-32-32zM244.7 329.39a31.79 31.79 0 00-22.62 9.38L80 480.85a31.79 31.79 0 000 45.23l14.93 15.15a32.64 32.64 0 0045.44 0l141.87-142.08a31.79 31.79 0 000-45.23l-14.93-15.15a32.64 32.64 0 00-22.62-9.38z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M117.76 455.47a31.79 31.79 0 00-22.83 9.38L80 479.8A31.79 31.79 0 0080 525L222.08 667.1a31.79 31.79 0 0022.61 9.39 32.64 32.64 0 0022.62-9.39l14.93-14.93a32 32 0 000-45.44L140.37 464.85a31.57 31.57 0 00-22.61-9.38zM928 793.39H96a32 32 0 00-32 32v32a32 32 0 0032 32h832a32 32 0 0032-32v-32a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "text-indent-left-stroke"
};
a['TextIndentRightStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M928 792.96H96a32 32 0 00-32 32v32a32 32 0 0032 32h832a32 32 0 0032-32v-32a32 32 0 00-32-32zm-338.77-336H96a32 32 0 00-32 32v32a32 32 0 0032 32h493.23a32 32 0 0032-32v-32a32 32 0 00-32-32zm317.01 3.63a32.43 32.43 0 00-22.61 9.17L741.76 611.84a31.79 31.79 0 000 45.23l14.93 15.14a32.64 32.64 0 0022.62 9.39 31.79 31.79 0 0022.61-9.39L944 530.13a31.79 31.79 0 000-45.22l-14.93-15.15a32.43 32.43 0 00-22.83-9.17z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M779.3 334.5a32.64 32.64 0 00-22.6 9.4l-14.94 15.14a31.79 31.79 0 000 45.23l141.87 141.86a32.21 32.21 0 0045.44 0L944 531.2a31.79 31.79 0 000-45.23L801.92 343.9a31.79 31.79 0 00-22.61-9.38zM928 121.6H96a32 32 0 00-32 32v32a32 32 0 0032 32h832a32 32 0 0032-32v-32a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "text-indent-right-stroke"
};
a['TextItalicStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M355.2 915.84l17.5-64H169.16a32 32 0 00-32 32v32a32 32 0 0032 32h490.67a32 32 0 0032-32v-32a32 32 0 00-32-32H472.11L448 940.8z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M372.7 850.77l-17.5 65.07L448 940.8l24.1-90.03 177.07-661.33h-99.41L372.69 850.77z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M854.83 93.44H364.16a32 32 0 00-32 32v32a32 32 0 0032 32h490.67a32 32 0 0032-32v-32a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "text-italic-stroke"
};
a['TextStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M874.67 71.9H149.33a32 32 0 00-32 32v106.66a32 32 0 0032 32h21.34a32 32 0 0032-32v-53.33h266.66v723.84h-94.08a32 32 0 00-32 32v21.33a32 32 0 0032 32H652.6a32 32 0 0032-32v-21.33a32 32 0 00-32-32h-97.92V157.23h266.66v53.33a32 32 0 0032 32h21.34a32 32 0 0032-32V103.89a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "text-stroke"
};
a['TextUnderlineFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 795.3a315.1 315.1 0 00315.3-310.18V96a32 32 0 00-32-32h-21.33a32 32 0 00-32 32v389.12a229.97 229.97 0 01-459.94 0V96a32 32 0 00-32-32h-21.34a32 32 0 00-32 32v389.12A315.52 315.52 0 00512 795.31zM160 874.67h704q32 0 32 32V928q0 32-32 32H160q-32 0-32-32v-21.33q0-32 32-32z"
      }
    }]
  },
  "name": "text-underline-fill"
};
a['TickCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64C264.53 64 64 264.53 64 512s200.53 448 448 448 448-200.53 448-448S759.47 64 512 64zm225.92 349.87L481.49 670.29c-12.58 12.59-32.85 12.59-45.22 0L421.97 656c-.21-.21-.64-.43-.85-.64L286.08 520.32a31.79 31.79 0 010-45.23l15.15-15.14a31.79 31.79 0 0145.22 0l112.22 112.21 218.88-218.88a31.79 31.79 0 0145.22 0l15.15 15.15c12.59 12.8 12.59 33.06 0 45.44z"
      }
    }]
  },
  "name": "tick-circle-fill"
};
a['TickCircleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64C264.53 64 64 264.53 64 512s200.53 448 448 448 448-200.53 448-448S759.47 64 512 64zm0 810.67c-199.9 0-362.67-162.78-362.67-362.67 0-199.9 162.78-362.67 362.67-362.67 199.9 0 362.67 162.78 362.67 362.67 0 199.9-162.78 362.67-362.67 362.67zM722.77 353.7c-6.18-6.19-14.5-9.39-22.61-9.39s-16.43 3.2-22.61 9.39L458.67 572.59 346.45 460.37c-6.18-6.18-14.5-9.38-22.61-9.38s-16.43 3.2-22.61 9.38l-15.15 15.15a31.79 31.79 0 000 45.23l135.04 135.04c.21.21.64.42.85.64l14.3 14.29c6.18 6.19 14.5 9.39 22.61 9.39s16.43-3.2 22.61-9.39l256.43-256.85c12.59-12.59 12.59-32.86 0-45.23l-15.15-14.93z"
      }
    }]
  },
  "name": "tick-circle-stroke"
};
a['TickMultipleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M832 740.48V155.31A91.52 91.52 0 00740.48 64H155.31A91.3 91.3 0 0064 155.52v584.75A91.3 91.3 0 00155.3 832h585.18A91.73 91.73 0 00832 740.48zm-680.96 4.27a5.33 5.33 0 01-1.7-4.27V154.67a5.76 5.76 0 015.97-5.34h585.17a6.19 6.19 0 016.19 5.98v585.17a6.19 6.19 0 01-6.19 6.19H155.31a6.19 6.19 0 01-4.27-1.92zM928 234.67h-21.33a32 32 0 00-32 32v608h-608a32 32 0 00-32 32V928a32 32 0 0032 32H896a64 64 0 0064-64V266.67a32 32 0 00-32-32zm-291.2 73.38a31.79 31.79 0 00-45.23 0L403 496.64l-97.92-98.13a32 32 0 00-45.44 0l-14.94 15.14a31.79 31.79 0 000 45.23l120.54 120.53 15.14 15.15a31.79 31.79 0 0045.23 0l15.15-15.15 211.2-210.98a32.43 32.43 0 000-45.44z"
      }
    }]
  },
  "name": "tick-multiple-stroke"
};
a['TickSquareFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 64H128c-35.33 0-64 28.67-64 64v768c0 35.33 28.67 64 64 64h768c35.33 0 64-28.67 64-64V128c0-35.33-28.67-64-64-64zM286.2 475.65l15.37-15.36a31.77 31.77 0 0122.53-9.22c8.19 0 16.38 3.07 22.52 9.22l112.13 112.13 218.63-219.14c6.14-6.14 14.33-9.22 22.52-9.22s16.39 3.08 22.53 9.22l15.36 15.36c12.8 12.8 12.8 32.77 0 45.06L481.28 670.72a31.77 31.77 0 01-22.53 9.22c-8.19 0-16.38-3.08-22.53-9.22l-14.33-14.34s-.51-.5-1.03-.5L285.7 520.7l-.52-.5a31.54 31.54 0 011.03-44.55z"
      }
    }]
  },
  "name": "tick-square-fill"
};
a['TickSquareStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M874.67 149.33v725.34H149.33V149.33h725.34M896 64H128c-35.41 0-64 28.59-64 64v768c0 35.41 28.59 64 64 64h768c35.41 0 64-28.59 64-64V128c0-35.41-28.59-64-64-64zM737.92 368.64l-15.15-15.15c-6.18-6.18-14.5-9.38-22.61-9.38s-16.43 3.2-22.61 9.38L458.67 572.6 346.45 460.37c-6.18-6.18-14.5-9.38-22.61-9.38s-16.43 3.2-22.61 9.38l-15.15 15.15a31.79 31.79 0 000 45.23l135.04 135.04c.21.21.64.42.85.64l14.3 14.29c6.18 6.19 14.5 9.39 22.61 9.39s16.43-3.2 22.61-9.39l256.43-256.85c12.59-12.38 12.59-32.64 0-45.23z"
      }
    }]
  },
  "name": "tick-square-stroke"
};
a['TickStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M395.95 782.3l2.56 2.55 482.13-482.13-482.13 482.13-2.56-2.56zM196.27 582.4l182.4 182.4-182.4-182.4zm684.37-326.61c-8.1 0-16.43 3.2-22.61 9.38L398.72 724.48l-222.3-222.3c-6.18-6.18-14.5-9.38-22.6-9.38s-16.43 3.2-22.62 9.39l-15.15 15.14a31.79 31.79 0 000 45.23l244.91 244.9 15.15 15.15c6.18 6.19 14.29 9.39 22.61 9.39s16.43-3.2 22.61-9.39L918.4 325.55c12.59-12.59 12.59-32.86 0-45.23l-15.15-15.15a31.81 31.81 0 00-22.61-9.38z"
      }
    }]
  },
  "name": "tick-stroke"
};
a['TimeFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M511 95C280.72 95 94 281.72 94 512s186.72 417 417 417 417-186.72 417-417S741.28 95 511 95zm176.19 522.07v.11l-28.06 38.35a12.19 12.19 0 01-17 2.62l-162.6-118.64a12.08 12.08 0 01-5-9.84V262.74a12.21 12.21 0 0112.23-12.24H534a12.12 12.12 0 0112.12 12.24V500l138.34 100a12.22 12.22 0 012.73 17.07z"
      }
    }]
  },
  "name": "time-fill"
};
a['TimeStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M554.67 267.73a32 32 0 00-32-32h-21.34a32 32 0 00-32 32v227.42L348.37 616.1a31.79 31.79 0 000 45.22l14.94 15.15a32.21 32.21 0 0045.22 0l128-128a64 64 0 0018.14-44.59zM512 64a448 448 0 000 896 42.67 42.67 0 000-85.33A362.67 362.67 0 11874.67 512a42.67 42.67 0 0085.33 0A448 448 0 00512 64zm394.45 661.33h-95.78v-96a32 32 0 00-32-32h-21.34a32 32 0 00-32 32v96h-96a32 32 0 00-32 32v21.34a32 32 0 0032 32h96v96a32 32 0 0032 32h21.34a32 32 0 0032-32v-96h96a32 32 0 0032-32v-21.34a32 32 0 00-32.22-32z"
      }
    }]
  },
  "name": "time-stroke"
};
a['ToColorFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M836.48 415.57l-195.41-134.4L336.2 70.2a32 32 0 00-44.8 8.74l-12.16 17.92a32.64 32.64 0 008.54 45.23l78.72 54.19L96 598.4a71.47 71.47 0 0018.35 98.56L478.72 947.2A69.55 69.55 0 00576 928.43l279.04-414.3a71.47 71.47 0 00-18.56-98.56zM436.91 244.91l339.62 232.96H279.9zM865.07 674.99a336.43 336.43 0 00-26.03 38.61c-8.32 13.87-15.36 26.45-21.33 39.25A210.35 210.35 0 00791.68 832a64 64 0 0021.33 48 75.95 75.95 0 0052.48 19.84 73.39 73.39 0 0052.48-20.27 61.23 61.23 0 0021.34-48.64c.85-56.1-74.88-156.58-74.24-155.94z"
      }
    }]
  },
  "name": "to-color-fill"
};
a['ToColorStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M834.99 415.36L609.7 260.69 335.79 70.4a32 32 0 00-44.16 9.17l-12.16 18.14a32.85 32.85 0 008.53 45.22l77.65 53.34L95.36 599.25a71.68 71.68 0 0018.56 98.56l362.67 249.6a69.33 69.33 0 0039.25 12.16 70.61 70.61 0 0058.24-31.14l279.25-414.51A71.04 71.04 0 00835 415.36zm-62.08 61.23H279.25l155.95-231.9zM512 868.05L172.8 634.88l49.07-72.96H718.5zM868.9 676.05a31.79 31.79 0 00-26.66-14.72 32.85 32.85 0 00-27.52 15.36c-2.35 4.06-4.7 8.11-7.25 12.16a556.59 556.59 0 00-28.38 51.84 287.79 287.79 0 00-34.77 107.95 85.33 85.33 0 0028.37 64 101.55 101.55 0 0068.06 26.03h2.77a97.07 97.07 0 0068.9-28.38 82.35 82.35 0 0028.38-64c.85-49.92-42.24-125.01-71.9-170.24zm1.5 186.46l-1.7 1.28-1.5 1.7a34.13 34.13 0 01-24.1 9.6h-2.35a37.55 37.55 0 01-24.96-9.81 24.1 24.1 0 01-7.47-14.08 222.93 222.93 0 0126.67-79.15l1.28-2.34v-2.35c1.7-3.63 3.41-7.25 5.54-11.1a232.1 232.1 0 0133.92 88.75v2.78a18.77 18.77 0 01-5.33 14.72z"
      }
    }]
  },
  "name": "to-color-stroke"
};
a['ToolExportFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 207.36H532.05L438.2 94.72a43.37 43.37 0 00-32.86-15.36H128c-35.41 0-64 28.59-64 64v725.33c0 35.42 28.59 64 64 64h768c35.41 0 64-28.58 64-64V271.36c0-35.2-28.59-64-64-64zM679.04 569.81l-17.7 17.71a30.26 30.26 0 01-42.67 0l-64-64v206.5c0 17.71-14.3 32-32 32h-21.34c-17.7 0-32-14.29-32-32V523.74l-64 64a30.26 30.26 0 01-42.66 0l-17.71-17.7a30.26 30.26 0 010-42.67l136.1-135.9A42.46 42.46 0 01496 381.24c.21 0 .43-.22.64-.22 2.35-.85 4.7-1.7 7.25-2.13 1.5-.21 2.99-.43 4.7-.43 1.28 0 2.34-.42 3.62-.42 2.78 0 5.76.21 8.54.85.21 0 .42.21.64.21 7.68 1.71 15.14 5.34 21.12 11.52l136.74 136.54a30.46 30.46 0 01-.21 42.66z"
      }
    }]
  },
  "name": "tool-export-fill"
};
a['ToolExportStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 207.36H532.05L438.2 94.72a43.37 43.37 0 00-32.86-15.36H128c-35.41 0-64 28.59-64 64v725.33c0 35.42 28.59 64 64 64h768c35.41 0 64-28.58 64-64V271.36c0-35.2-28.59-64-64-64zm-21.33 640H149.33V164.69h235.95l93.87 112.64A42.34 42.34 0 00512 292.7h362.67v554.67zM512 378.03c-1.28 0-2.35.21-3.63.42-1.49.22-2.98.22-4.69.43-2.56.43-4.9 1.28-7.25 2.13-.22 0-.43.22-.64.22a42.46 42.46 0 00-14.94 10.24l-136.1 135.89a30.26 30.26 0 000 42.67l17.92 17.7a30.26 30.26 0 0042.66 0l64-64v206.3c0 17.7 14.3 32 32 32h21.34c17.7 0 32-14.3 32-32V523.52l64 64a30.26 30.26 0 0042.66 0l17.71-17.7a30.26 30.26 0 000-42.67L542.29 390.6a43.12 43.12 0 00-21.12-11.52c-.21 0-.42-.21-.64-.21a55.07 55.07 0 00-8.53-.85z"
      }
    }]
  },
  "name": "tool-export-stroke"
};
a['ToolFilterFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M893.87 312.75c8.53-8.54 13.44-19.84 13.44-31.36V150.4a42.86 42.86 0 00-13.44-31.15 43.99 43.99 0 00-30.51-12.58H160.64a44.88 44.88 0 00-30.72 12.37 43.63 43.63 0 00-13.23 31.36v130.99c0 14.5 6.83 27.09 17.5 35.2l245.97 236.37v263.9c0 12.37 5.33 24.1 14.3 32a42.92 42.92 0 0016 9.38l175.57 56.96c4.69 1.5 9.17 2.13 13.65 2.13 23.25 0 43.95-18.77 43.95-43.73V553.17L891.09 315.1l2.78-2.34zm-74.46-79.58l-504.1 135.47L204.8 262.19v-68.27h614.83v39.25z"
      }
    }]
  },
  "name": "tool-filter-fill"
};
a['ToolFilterStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M863.36 104.32H160.64a44.02 44.02 0 00-43.95 43.95v131.62c0 14.51 6.83 27.31 17.5 35.42l245.97 237.86v265.39a44 44 0 0030.3 41.81l175.57 57.39c4.69 1.5 9.17 2.13 13.65 2.13 23.25 0 43.95-18.98 43.95-43.94V553.6l247.46-239.57 2.56-2.35c8.54-8.53 13.44-20.05 13.44-31.57V148.27c.22-24.32-19.62-43.95-43.73-43.95zm-43.95 156.8L624.85 449.49l-68.9 66.78v298.88l-87.9-28.59V515.63l-68.69-66.56-194.77-188.59v-68.27H819.4v68.91z"
      }
    }]
  },
  "name": "tool-filter-stroke"
};
a['ToolGroupFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M848.67 443.67a57.31 57.31 0 0155.82 70.37l-73.4 312.75A57.33 57.33 0 01775.25 871h-525.5a57.33 57.33 0 01-55.83-44.21l-73.4-312.74a57.3 57.3 0 0142.72-68.87 57.38 57.38 0 0113.1-1.51h672.32zm-63.03-144.84a50.15 50.15 0 0150.16 50.14V380a19.1 19.1 0 01-19.1 19.1H208.31a19.1 19.1 0 01-19.1-19.1v-31.03a50.15 50.15 0 0150.16-50.14h546.25zM682.9 154a50.15 50.15 0 0150.17 50.13v31.04a19.1 19.1 0 01-19.11 19.1H311.04a19.1 19.1 0 01-19.1-19.1v-31.04A50.15 50.15 0 01342.1 154h340.81z"
      }
    }]
  },
  "name": "tool-group-fill"
};
a['ToolGroupStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M829.25 419h-634.5c-33.51.08-60.65 22.55-60.75 50.29l74.72 346.42c.1 27.74 27.24 50.2 60.75 50.29h488.1c33.52-.08 60.66-22.55 60.76-50.29L890 469.3c-.1-27.74-27.24-50.2-60.75-50.29zm-72.22 390.91l-35.96.09H195.1l70.44-.09L195 476.1l634-.09-71.97 333.91zM299.06 219.75h425.88c16.6 0 30.06-13.6 30.06-30.38 0-16.77-13.46-30.37-30.06-30.37H299.06c-16.6 0-30.06 13.6-30.06 30.38 0 16.77 13.46 30.37 30.06 30.37zm-56.72 130h539.32A30.36 30.36 0 00812 319.37 30.36 30.36 0 00781.66 289H242.34A30.36 30.36 0 00212 319.38a30.36 30.36 0 0030.34 30.37z"
      }
    }]
  },
  "name": "tool-group-stroke"
};
a['ToolImportFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 207.36H532.05L438.2 94.72a43.37 43.37 0 00-32.86-15.36H128c-35.41 0-64 28.59-64 64v725.33c0 35.42 28.59 64 64 64h768c35.41 0 64-28.58 64-64V271.36c0-35.2-28.59-64-64-64zM679.04 612.69l-136.1 135.9A42.46 42.46 0 01528 758.83c-.21 0-.43.21-.64.21-2.35.85-4.7 1.7-7.04 2.13-1.5.22-2.99.43-4.7.43-1.27 0-2.34.43-3.4.43-2.78 0-5.77-.22-8.54-.86-.21 0-.43-.21-.64-.21-7.68-1.7-15.15-5.33-21.12-11.52L345.17 612.91a30.26 30.26 0 010-42.67l17.5-17.5a30.26 30.26 0 0142.66 0l64 64v-206.5c0-17.7 14.3-32 32-32h21.34c17.7 0 32 14.3 32 32v206.3l64-64a30.26 30.26 0 0142.66 0l17.71 17.7a30 30 0 010 42.45z"
      }
    }]
  },
  "name": "tool-import-fill"
};
a['ToolImportStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 207.36H532.05L438.2 94.72a43.37 43.37 0 00-32.86-15.36H128c-35.41 0-64 28.59-64 64v725.33c0 35.42 28.59 64 64 64h768c35.41 0 64-28.58 64-64V271.36c0-35.2-28.59-64-64-64zm-21.33 640H149.33V164.69h235.95l93.87 112.64A42.34 42.34 0 00512 292.7h362.67v554.67zM469.33 410.03v206.5l-64-64a30.26 30.26 0 00-42.66 0l-17.71 17.71a30.26 30.26 0 000 42.67l136.75 136.53a43.12 43.12 0 0021.12 11.52c.21 0 .42.21.64.21 2.77.64 5.54.86 8.53.86 1.28 0 2.35-.22 3.63-.43 1.49-.21 2.98-.21 4.69-.43 2.56-.42 4.9-1.28 7.25-2.13.22 0 .43-.21.64-.21a42.46 42.46 0 0014.94-10.24l136.1-135.9a30.26 30.26 0 000-42.66l-17.92-17.5a30.26 30.26 0 00-42.66 0l-64 64V410.24c0-17.7-14.3-32-32-32h-21.34c-17.7-.21-32 14.3-32 31.79z"
      }
    }]
  },
  "name": "tool-import-stroke"
};
a['ToolSortFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M767.36 544.85H256.64c-36.48 0-56.53 41.82-33.5 69.55l255.37 308.7c8.53 10.23 21.12 15.57 33.49 15.57s24.96-5.34 33.5-15.79L800.84 614.4c23.04-27.95 2.99-69.55-33.49-69.55zM512 85.33a43.26 43.26 0 00-33.5 15.79L223.16 409.6c-23.04 27.95-2.99 69.55 33.49 69.55h510.5c36.49 0 56.54-41.82 33.5-69.55L545.49 101.12A43.26 43.26 0 00512 85.33z"
      }
    }]
  },
  "name": "tool-sort-fill"
};
a['ToolSortStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M767.36 526.08H256.64c-36.48 0-56.53 41.81-33.5 69.55l255.37 308.69c8.74 10.45 21.12 15.79 33.49 15.79s24.96-5.34 33.5-15.79l255.35-308.7c23.04-27.73 2.99-69.54-33.49-69.54zM512 811.09L346.88 611.63h330.24L512 811.09zM256.64 460.6h510.5c36.49 0 56.54-41.82 33.5-69.55L545.49 82.56c-8.53-10.67-21.12-15.79-33.49-15.79s-24.96 5.34-33.5 15.79L223.16 391.04c-23.04 27.95-2.99 69.55 33.49 69.55zM512 175.79l165.12 199.46H346.88L512 175.8z"
      }
    }]
  },
  "name": "tool-sort-stroke"
};
a['ToolStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M936.53 277.33l-73.38 73.39a202.03 202.03 0 01-201.18 213.33 202.67 202.67 0 01-95.78-24.1l-62.3 62.08-252.37 251.3-82.35-81.49 251.74-251.73 62.29-62.3a202.24 202.24 0 01178.13-298.24h10.88a183.68 183.68 0 0124.54 2.78 183.68 183.68 0 00-24.54-2.78L548.48 283.31a64 64 0 000 90.45l100.48 100.48a64 64 0 0045.23 18.77 72.96 72.96 0 009.6 0 64 64 0 0035.62-17.92l123.74-123.73a203.52 203.52 0 00-27.95-92.59L694.19 399.8l-70.4-70.4L764.8 188.37a196.7 196.7 0 00-44.37-19.62 196.7 196.7 0 0144.37 19.62l30.93-30.93 4.27-4.48a30.72 30.72 0 007.47-21.33 31.79 31.79 0 00-12.59-24.96l-9.81-4.27a309.33 309.33 0 00-38.4-15.57l-37.76 36.69 37.76-36.7a291.2 291.2 0 00-85.34-12.58A287.36 287.36 0 00384 436.91L93.65 726.6a64 64 0 000 90.46L206.3 929.7a64 64 0 0090.46 0L586.67 640a295.47 295.47 0 0074.66 10.03 287.79 287.79 0 00275.2-372.7z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M936.53 277.33a283.1 283.1 0 00-16-40.32c-1.28-2.77-2.98-5.54-4.26-8.32a32.21 32.21 0 00-25.82-13.01 31.15 31.15 0 00-21.33 7.47l-4.05 4.05-30.94 30.93a203.52 203.52 0 0127.95 92.59z"
      }
    }]
  },
  "name": "tool-stroke"
};
a['TrademarkCircleStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 152.32a362.67 362.67 0 11-362.67 362.67A362.67 362.67 0 01512 152.32m0-85.33a448 448 0 10448 448 448 448 0 00-448-448z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M564.48 366.72a46.08 46.08 0 0120.05 87.47l-9.6 4.69H445.65v-92.16h118.83m0-85.33h-161.5a42.67 42.67 0 00-42.66 42.66v392.32a32 32 0 0032 32h21.33a32 32 0 0032-32V544.21h97.28l87.26 184.54a31.57 31.57 0 0028.8 18.56h14.72a32 32 0 0032-32A30.72 30.72 0 00704 704l-81.5-172.16a131.41 131.41 0 0074.03-118.19 131.41 131.41 0 00-131.41-131.41z"
      }
    }]
  },
  "name": "trademark-circle-stroke"
};
a['TrigonBackwardFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M498.26 195.69L152.55 494.13c-10 8.54-10 25 0 33.56l345.71 298.55c12.87 11.07 31.74 1.09 31.74-16.84v-597c0-17.8-18.89-27.9-31.76-16.72zm384.92 0L537.47 494.13a22.76 22.76 0 000 33.68l345.71 298.55c12.87 11.07 31.76 1.09 31.76-16.84V212.41c0-17.8-18.89-27.9-31.76-16.72z"
      }
    }]
  },
  "name": "trigon-backward-fill"
};
a['TrigonBottomFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M486.4 663.47l-192-266.67c-10.67-14.93-6.4-34.13 6.4-44.8 6.4-4.27 12.8-6.4 19.2-6.4h384c17.07 0 32 14.93 32 32 0 6.4-2.13 12.8-6.4 19.2l-192 266.67c-10.67 14.93-29.87 17.06-44.8 6.4-2.13 0-4.27-4.27-6.4-6.4z"
      }
    }]
  },
  "name": "trigon-bottom-fill"
};
a['TrigonCircleRightFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 96C282.25 96 96 282.25 96 512s186.25 416 416 416 416-186.25 416-416S741.75 96 512 96zm137.07 422.48L547 592.5l-98.3 71.29a8 8 0 01-12.7-6.47V366.68a8 8 0 0112.7-6.47L547 431.5l102.07 74a8 8 0 010 12.98z"
      }
    }]
  },
  "name": "trigon-circle-right-fill"
};
a['TrigonCircleRightStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 96c229.75 0 416 186.25 416 416S741.75 928 512 928 96 741.75 96 512 282.25 96 512 96zm0 64c-194.4 0-352 157.6-352 352s157.6 352 352 352 352-157.6 352-352-157.6-352-352-352zm113.07 204.73a7.25 7.25 0 017.62.79l155.3 134.4a16 16 0 011.63 1.63 16 16 0 01-1.63 22.57l-155.22 134.3a7.23 7.23 0 01-11.7-5.7v-102.7H245a8 8 0 01-8-8v-60a8 8 0 018-8h376v-102.8a7.25 7.25 0 014.07-6.49z"
      }
    }]
  },
  "name": "trigon-circle-right-stroke"
};
a['TrigonCircleTopStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M172 537a338.76 338.76 0 1126.69 132.32A337.8 337.8 0 01172 537m-76 0c0 229.75 186.25 416 416 416s416-186.25 416-416-186.25-416-416-416S96 307.25 96 537zm409.52-133.07a8 8 0 0113 0L592.5 506l71.29 98.3a8 8 0 01-6.47 12.7H366.68a8 8 0 01-6.47-12.7L431.5 506z"
      }
    }]
  },
  "name": "trigon-circle-top-stroke"
};
a['TrigonFastBackwardFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M917.33 222.5a42.67 42.67 0 00-25.81 8.75L572.37 475.31a42.67 42.67 0 000 67.62L891.1 787a42.67 42.67 0 0026.24 8.74A42.67 42.67 0 00960 753.07v-487.9a42.67 42.67 0 00-42.67-42.66z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M512 222.5a42.67 42.67 0 00-25.81 8.75l-320 244.06a42.67 42.67 0 000 67.84l320 243.84a42.67 42.67 0 0025.81 8.96 42.67 42.67 0 0042.67-42.67v-488.1A42.67 42.67 0 00512 222.5z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M117.55 170.67H96.2a32 32 0 00-32.21 32v618.66a32 32 0 0032.21 32h21.34a32 32 0 0031.78-32V202.67a32 32 0 00-31.78-32z"
      }
    }]
  },
  "name": "trigon-fast-backward-fill"
};
a['TrigonFastForwardFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M106.67 228.27A42.67 42.67 0 0064 270.93v487.9a42.67 42.67 0 0042.67 42.66 42.67 42.67 0 0025.81-8.74l319.15-244.06a42.67 42.67 0 000-67.62L132.9 237a42.67 42.67 0 00-26.24-8.74z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M512 228.05a42.67 42.67 0 00-42.67 42.67v488.1a42.67 42.67 0 0068.48 33.93l320-244.06a42.67 42.67 0 000-67.84l-320-243.84a42.67 42.67 0 00-25.81-8.96z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M927.79 170.67h-21.34a32 32 0 00-31.78 32v618.66a32 32 0 0032 32H928a32 32 0 0032-32V202.67a32 32 0 00-32.21-32z"
      }
    }]
  },
  "name": "trigon-fast-forward-fill"
};
a['TrigonForwardFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M500.27 542.5L128 904.33a42.67 42.67 0 01-71.9-29.65V150.4a42.67 42.67 0 0171.9-30.72l371.63 362.67a42.67 42.67 0 01.64 60.16z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M948.27 542.5L576 904.33a42.67 42.67 0 01-71.9-29.65V150.4a42.67 42.67 0 0171.9-30.72l371.63 362.67a42.67 42.67 0 01.64 60.16z"
      }
    }]
  },
  "name": "trigon-forward-fill"
};
a['TrigonLeftFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M358.4 488.53l266.67-192c14.93-10.66 34.13-6.4 44.8 6.4 4.26 6.4 6.4 12.8 6.4 19.2v384c0 17.07-14.94 32-32 32-6.4 0-12.8-2.13-19.2-6.4l-266.67-192c-14.93-10.66-17.07-29.86-6.4-44.8l6.4-6.4z"
      }
    }]
  },
  "name": "trigon-left-fill"
};
a['TrigonRetractFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M756.62 130.84c75.4 0 136.54 61.13 136.54 136.54v489.24c0 75.4-61.13 136.54-136.54 136.54H267.38c-75.4 0-136.54-61.13-136.54-136.54V267.38c0-75.4 61.13-136.54 136.54-136.54h489.24zM493.57 536.7h-229.7l-.3.03a1.14 1.14 0 00-.83 1.1l.04.3a1.14 1.14 0 00.3.51L339 614.55 224.2 729.33a2.84 2.84 0 000 4.02l73.85 73.85a2.84 2.84 0 004.02 0L416.85 692.4l75.92 75.92.3.22a1.14 1.14 0 001.65-1.03v-229.7l-.04-.3a1.14 1.14 0 00-1.1-.83zm232.39-312.5a2.84 2.84 0 00-4.02 0L607.15 338.99l-75.92-75.91-.3-.22a1.14 1.14 0 00-1.65 1.02v229.7l.04.3a1.14 1.14 0 001.1.84h229.7l.3-.04a1.14 1.14 0 00.84-1.1l-.04-.3a1.14 1.14 0 00-.3-.51L685 416.84l114.8-114.78a2.84 2.84 0 000-4.02z"
      }
    }]
  },
  "name": "trigon-retract-fill"
};
a['TrigonRightFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M663.47 537.6l-266.67 192c-14.93 10.67-34.13 6.4-44.8-6.4-4.27-6.4-6.4-12.8-6.4-19.2V320c0-17.07 14.93-32 32-32 6.4 0 12.8 2.13 19.2 6.4l266.67 192c14.93 10.67 17.06 29.87 6.4 44.8 0 2.13-4.27 4.27-6.4 6.4z"
      }
    }]
  },
  "name": "trigon-right-fill"
};
a['TrigonRightStore'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M570 317l390 195-390 195V552H64v-77h506V317z"
      }
    }]
  },
  "name": "trigon-right-store"
};
a['TrigonSpreadStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M509.89 454.78a32 32 0 010-45.24l134.27-134.21-82.75-82.82a12.8 12.8 0 01-3.33-5.76l-.45-3.26c0-7.04 5.76-12.8 12.8-12.8h270.08c7.04 0 12.8 5.76 12.8 12.8v270.08a12.8 12.8 0 01-21.82 9.02l-82.75-82.69-134.28 134.21a32 32 0 01-45.24 0l-59.33-59.33zm4.22 124.36a32 32 0 010 45.24L379.84 758.6l82.75 82.82a12.8 12.8 0 013.33 5.76l.45 3.33a12.8 12.8 0 01-12.8 12.8H183.49a12.8 12.8 0 01-12.8-12.8V580.42a12.8 12.8 0 0121.82-9.1l82.75 82.7L409.54 519.8a32 32 0 0145.24 0l59.33 59.33z"
      }
    }]
  },
  "name": "trigon-spread-stroke"
};
a['TrigonTopFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M537.6 362.67l192 266.66c10.67 14.94 6.4 34.14-6.4 44.8-6.4 4.27-12.8 6.4-19.2 6.4H320c-17.07 0-32-14.93-32-32 0-6.4 2.13-12.8 6.4-19.2l192-266.66c10.67-14.94 29.87-17.07 44.8-6.4l6.4 6.4z"
      }
    }]
  },
  "name": "trigon-top-fill"
};
a['TrigonUnfoldFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M756.62 130.84c75.4 0 136.54 61.13 136.54 136.54v489.24c0 75.4-61.13 136.54-136.54 136.54H267.38c-75.4 0-136.54-61.13-136.54-136.54V267.38c0-75.4 61.13-136.54 136.54-136.54h489.24zM454.56 503a2.84 2.84 0 00-4.02 0L335.76 617.77l-75.92-75.92-.3-.21a1.14 1.14 0 00-1.65 1.02v229.7l.04.3a1.14 1.14 0 001.1.84h229.7l.31-.04a1.14 1.14 0 00.84-1.1l-.04-.3a1.14 1.14 0 00-.3-.5l-75.92-75.92 114.79-114.78a2.84 2.84 0 000-4.02zm310.4-245.1h-229.7l-.3.04a1.14 1.14 0 00-.84 1.1l.04.3a1.14 1.14 0 00.3.51l75.92 75.92-114.79 114.78a2.84 2.84 0 000 4.02l73.85 73.85a2.84 2.84 0 004.02 0l114.78-114.78 75.92 75.91.3.22a1.14 1.14 0 001.65-1.02v-229.7l-.04-.3a1.14 1.14 0 00-1.1-.85z"
      }
    }]
  },
  "name": "trigon-unfold-fill"
};
a['TrophyStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 120.75h-85.33a64 64 0 00-64-64H277.33a64 64 0 00-64 64H128a64 64 0 00-64 64v149.33a170.67 170.67 0 00152.53 170.67 297.17 297.17 0 00252.8 252.16V867.2h-224a32 32 0 00-32 32v21.33a32 32 0 0032 32h533.34a32 32 0 0032-32V899.2a32 32 0 00-32-32h-224V756.9a297.39 297.39 0 00253.01-253.22A170.67 170.67 0 00960 334.08V184.75a64 64 0 00-64-64zM213.33 416.64a85.33 85.33 0 01-64-82.56v-128h64zM513.5 674.77h-2.98a213.33 213.33 0 01-211.84-211.84V141.44h426.66v322.77A212.05 212.05 0 01513.5 674.77zm361.18-340.69a85.33 85.33 0 01-64 82.56V206.08h64z"
      }
    }]
  },
  "name": "trophy-stroke"
};
a['UnlinkStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M507.73 290.13L576 221.87c61.87-61.87 164.27-68.27 228.27-8.54 66.13 61.87 66.13 166.4 4.26 230.4L736 516.27c-12.8 12.8-12.8 32 0 44.8L750.93 576c12.8 12.8 32 12.8 44.8 0l72.54-72.53c98.13-93.87 100.26-249.6 6.4-347.74S622.93 57.6 524.8 151.47l-6.4 6.4-72.53 72.53c-12.8 12.8-12.8 32 0 44.8l14.93 14.93c12.8 12.8 34.13 12.8 46.93 0zm8.54 443.74L448 802.13c-61.87 61.87-164.27 68.27-228.27 8.54-66.13-61.87-66.13-166.4-4.26-230.4L288 507.73c12.8-12.8 12.8-32 0-44.8L273.07 448c-12.8-12.8-32-12.8-44.8 0l-72.54 72.53c-96 91.74-98.13 247.47-4.26 345.6s249.6 100.27 347.73 6.4l6.4-6.4 72.53-72.53c12.8-12.8 12.8-32 0-44.8l-14.93-14.93c-12.8-12.8-34.13-12.8-46.93 0zM241.07 179.2L844.8 782.93c12.8 12.8 12.8 32 0 44.8l-14.93 14.94c-12.8 12.8-32 12.8-44.8 0L179.2 241.07c-12.8-12.8-12.8-32 0-44.8l14.93-14.94c12.8-12.8 34.14-12.8 46.94-2.13z"
      }
    }]
  },
  "name": "unlink-stroke"
};
a['UnlockFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M897.92 429.01H298.67V277.33a128 128 0 01128-128h168.96a128 128 0 01121.81 89.18 22.83 22.83 0 0021.33 15.36h41.39a23.04 23.04 0 0021.33-27.95A213.33 213.33 0 00595.41 64H426.67a213.33 213.33 0 00-213.34 213.33v152.11h-87.25a64 64 0 00-64 64V896a64 64 0 0064 64h771.84a64 64 0 0064-64V492.8a64 64 0 00-64-63.79zM428.59 644.48a80.85 80.85 0 11121.38 69.76v69.33a30.3 30.3 0 01-30.29 30.3h-20.27a30.08 30.08 0 01-30.08-30.3v-69.33a81.07 81.07 0 01-39.89-69.76z"
      }
    }]
  },
  "name": "unlock-fill"
};
a['UnlockStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M510.3 563.63a80.64 80.64 0 00-40.97 150.61v69.33a30.08 30.08 0 0030.3 30.3h20.26a30.3 30.3 0 0030.3-30.3v-69.33a80.64 80.64 0 00-40.54-150.61z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M897.92 429.01H298.67V277.33a128 128 0 01128-128h168.96a128 128 0 01121.81 89.18 22.83 22.83 0 0021.33 15.36h41.39a23.04 23.04 0 0021.33-27.95A213.33 213.33 0 00595.41 64H426.67a213.33 213.33 0 00-213.34 213.33v152.11h-87.25a64 64 0 00-64 64V896a64 64 0 0064 64h771.84a64 64 0 0064-64V492.8a64 64 0 00-64-63.79zm-21.55 445.66H147.63V514.35h728.74z"
      }
    }]
  },
  "name": "unlock-stroke"
};
a['UploadStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64a32 32 0 00-22.61 9.39l-15.15 15.14-271.79 272.22a31.79 31.79 0 000 45.01l15.15 15.36a32 32 0 0022.61 9.39 32.43 32.43 0 0022.62-9.39L470.4 213.33V758.2a32 32 0 0032 32h21.33a32 32 0 0032-32V215.25L761.4 421.12a32 32 0 0022.61 9.39 32.85 32.85 0 0022.61-9.39l14.94-15.15a32 32 0 000-45.01l-34.14-34.13L549.76 88.96l-15.15-15.15A32 32 0 00512 64zm384 810.67H128a32 32 0 00-32 32V928a32 32 0 0032 32h768a32 32 0 0032-32v-21.33a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "upload-stroke"
};
a['UsbStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M896 926.3V469.32a64 64 0 00-64-64h-56.96V128a64 64 0 00-64-64H305.71a64 64 0 00-64 64v277.33H192a64 64 0 00-64 64V928a32 32 0 0031.79 32h21.33a32 32 0 0032.21-32V490.67h597.34V925a12.59 12.59 0 000 2.99 32 32 0 0032 32H864a32 32 0 0032-32v-1.7zM327.04 149.32h362.67v256H327.04z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M401.91999999999996 209.5h42.67q21.33 0 21.33 21.33v42.66q0 21.34-21.33 21.34h-42.67q-21.33 0-21.33-21.34v-42.66q0-21.34 21.33-21.34zM572.59 210.35h42.66q21.34 0 21.34 21.33v42.67q0 21.33-21.34 21.33H572.6q-21.34 0-21.34-21.33v-42.67q0-21.33 21.34-21.33z"
      }
    }]
  },
  "name": "usb-stroke"
};
a['UserAddFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M900.9 725.33h-96v-96c0-17.7-14.29-32-32-32h-21.33c-17.7 0-32 14.3-32 32v96h-96c-17.7 0-32 14.3-32 32v21.34c0 17.7 14.3 32 32 32h96v96c0 17.7 14.3 32 32 32h21.34c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32v-21.34c0-17.7-14.3-32-32-32zM277.34 298.67a213.33 213.33 0 10426.67 0 213.33 213.33 0 10-426.67 0zm246.83 214.4c-86.19-5.34-175.57 16.21-257.28 66.13C155.52 647.25 91.09 770.77 91.09 900.7v16.2c0 23.47 19.2 42.46 42.67 42.46l388.9-.43c17.71 0 32-14.29 32-31.78V545.07c0-17.07-13.43-30.94-30.5-32z"
      }
    }]
  },
  "name": "user-add-fill"
};
a['UserAddStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M884 727H777V620a8 8 0 00-8-8h-56a8 8 0 00-8 8v107H597a8 8 0 00-8 8v56a8 8 0 008 8h108v107a8 8 0 008 8h56a8 8 0 008-8V799h107a8 8 0 008-8v-56a8 8 0 00-8-8zM680.66 184.34c-96.46-96.46-252.86-96.46-349.32 0-96.46 96.46-96.46 252.86 0 349.32a250.58 250.58 0 0033.33 28A373.73 373.73 0 00132 908h72c0-166.79 135.21-302 302-302a247 247 0 00174.66-421.66zM506 534c-96.5 0-175-78.5-175-175s78.5-175 175-175 175 78.5 175 175-78.5 175-175 175z"
      }
    }]
  },
  "name": "user-add-stroke"
};
a['UserAinvitationStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M784 341.33a277.33 277.33 0 10-439.9 224.43A426.67 426.67 0 0081.29 925.23 32.43 32.43 0 00113.49 960h21.34a32 32 0 0031.78-29.23 341.33 341.33 0 01340.06-312.1A277.33 277.33 0 00784 341.33zm-277.33 192a192 192 0 11192-192 192 192 0 01-192 192z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M942.72 733.65a112 112 0 00-189.87-80.42 111.79 111.79 0 00-158.29 157.44l113.28 113.28 21.33 21.33 2.99 2.99a32.21 32.21 0 0021.33 7.89 32 32 0 0021.34-7.47l3.62-3.84 21.34-21.33 111.78-111.57 1.28-1.28a112 112 0 0029.87-77.02zm-294.4-39.89l3.2-1.7a64 64 0 018.75-3.85l4.9-1.28h4.48a50.13 50.13 0 0111.31 0 43.95 43.95 0 0121.33 8.32 51.84 51.84 0 015.34 4.27l3.84 3.84 9.38 9.39 31.79 31.78 32.21-32 10.88-10.88 3.42-2.98a45.01 45.01 0 014.9-4.06l2.35-1.28a44.59 44.59 0 016.19-3.41 47.79 47.79 0 0158.02 69.55v1.7a53.76 53.76 0 01-4.48 5.34c-1.06 0-1.92 2.34-3.2 3.41l-42.66 42.67-27.1 27.09-40.53 40.53-40.32-40.32-27.1-29.22L641.29 768a15.57 15.57 0 01-1.7-1.92l-4.27-5.12a47.15 47.15 0 01-3.84-7.25 48 48 0 01-3.2-11.74v-3.84a49.5 49.5 0 010-7.89 43.95 43.95 0 010-5.55 76.59 76.59 0 012.56-7.46 67.84 67.84 0 013.41-6.83 50.35 50.35 0 015.55-7.68 46.3 46.3 0 017.68-6.83z"
      }
    }]
  },
  "name": "user-ainvitation-stroke"
};
a['UserCircleFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 64C264.53 64 64 264.53 64 512s200.53 448 448 448 448-200.53 448-448S759.47 64 512 64zm200.53 661.33H691.2c-10.67 0-19.2-8.53-21.33-19.2-6.4-76.8-66.14-136.53-142.94-142.93H509.87c-78.94 2.13-145.07 61.87-153.6 142.93 0 10.67-10.67 19.2-21.34 19.2H313.6c-12.8 0-21.33-8.53-21.33-21.33v-2.13c6.4-78.94 53.33-145.07 119.46-179.2-32-27.74-51.2-68.27-51.2-113.07C360.53 326.4 428.8 256 512 256s151.47 68.27 153.6 151.47c0 44.8-19.2 85.33-51.2 113.06 66.13 34.14 113.07 100.27 119.47 179.2v2.14c0 12.8-10.67 23.46-21.34 23.46z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M512 320c-49.07 0-87.47 40.53-89.6 87.47 0 49.06 40.53 87.46 89.6 87.46 49.07 0 87.47-40.53 87.47-87.46C601.6 360.53 561.07 320 512 320z"
      }
    }]
  },
  "name": "user-circle-fill"
};
a['UserFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 149.33a192 192 0 11-192 192 192 192 0 01192-192M512 64a277.33 277.33 0 10277.33 277.33A277.33 277.33 0 00512 64zM121.6 896a36.48 36.48 0 00-10.88 1.92 34.99 34.99 0 00-10.67-1.92 32 32 0 100 64 34.99 34.99 0 0010.67-1.92A36.48 36.48 0 00121.6 960a32 32 0 100-64zm802.35 0a34.99 34.99 0 00-10.67 1.92 36.27 36.27 0 00-10.67-1.92 32 32 0 000 64 36.27 36.27 0 0010.67-1.92 34.99 34.99 0 0010.67 1.92 32 32 0 000-64z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M898.13 926.93h4.48V960h21.34v-32l31.36-5.12a448 448 0 00-886.83 2.35l31.57 2.77v32h21.34v-32l31.78 4.9a362.67 362.67 0 01717.44 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M110.72 960h802.56l-42.67-176.64-168.1-164.48-59.52-26.45-40.75-31.58 65.5-36.26 51.2-81.5L732.8 320l-4.9-52.9-60.17-87.9-113.06-57.39-122.46 11.74-120.32 86.18-15.78 96.64 2.56 83.84 64.64 109.23 68.9 54.83-110.72 54.61-101.54 84.48-74.24 94.93-34.99 101.98V960z"
      }
    }]
  },
  "name": "user-fill"
};
a['UserGapStampStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M783.57 334.93A277.33 277.33 0 10343.9 559.36 426.67 426.67 0 0081.07 918.83a32.21 32.21 0 0032 34.77h21.33a31.57 31.57 0 0031.57-29.23 341.33 341.33 0 01340.27-312.1 277.33 277.33 0 00277.33-277.34zm-277.33 192a192 192 0 11192-192 192 192 0 01-192 192zM878.93 798.08v91.52h-256v-91.52h256m21.34-64H601.6a42.67 42.67 0 00-42.67 42.67v134.18a42.67 42.67 0 0042.67 42.67h298.67a42.67 42.67 0 0042.66-42.67V776.75a42.67 42.67 0 00-42.66-42.67z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M789.33 685.65v48.64H711.9v-48.64h77.44m21.34-64H690.56a42.67 42.67 0 00-42.67 42.67v91.3a42.67 42.67 0 0042.67 42.67h120.1a42.67 42.67 0 0042.67-42.66v-91.31a42.67 42.67 0 00-42.66-42.67z"
      }
    }]
  },
  "name": "user-gap-stamp-stroke"
};
a['UserGapStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M674.35 565.76a277.33 277.33 0 10-324.7 0A426.67 426.67 0 0086.83 925.23a32.21 32.21 0 0032 34.77h21.33a32 32 0 0031.79-29.23 341.33 341.33 0 01680.1 0A32 32 0 00883.84 960h21.33a32.43 32.43 0 0032.22-34.77 426.67 426.67 0 00-263.04-359.47zM512 149.33a192 192 0 11-192 192 192 192 0 01192-192z"
      }
    }]
  },
  "name": "user-gap-stroke"
};
a['UserGapWaitStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M929.28 683.95L914.13 669a31.79 31.79 0 00-45.22 0L706.77 832l-88.1-89.81a31.79 31.79 0 00-45.23 0l-15.15 14.93a32 32 0 000 45.44l126.94 126.72a31.79 31.79 0 0045.22 0l199.9-199.9a32 32 0 00-1.07-45.43zM789.33 341.33a277.33 277.33 0 10-439.68 224.43A426.67 426.67 0 0086.83 925.23a32.21 32.21 0 0032 34.77h21.33a32 32 0 0031.79-29.23A341.33 341.33 0 01512 618.67a277.33 277.33 0 00277.33-277.34zM512 533.33a192 192 0 11192-192 192 192 0 01-192 192z"
      }
    }]
  },
  "name": "user-gap-wait-stroke"
};
a['UserRemoveStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M912.21 857.17l-68.05-67.84 68.05-67.84a32.43 32.43 0 000-45.44l-15.14-14.93a31.79 31.79 0 00-45.23 0L784 728.96l-68.05-67.63a31.79 31.79 0 00-45.23 0l-14.93 14.94a32 32 0 000 45.44l67.84 67.62-67.84 67.84a31.79 31.79 0 000 45.23l14.93 15.15a32.21 32.21 0 0045.23 0L784 849.7l67.84 67.62a32.21 32.21 0 0045.23 0l15.14-15.14a32.21 32.21 0 000-45.02zM805.12 341.33a277.33 277.33 0 10-439.68 224.43 426.67 426.67 0 00-262.83 359.47 32.21 32.21 0 0032 34.77h21.34a31.79 31.79 0 0031.78-29.23 341.33 341.33 0 01340.06-312.1 277.33 277.33 0 00277.33-277.34zm-277.33 192a192 192 0 11192-192 192 192 0 01-192 192z"
      }
    }]
  },
  "name": "user-remove-stroke"
};
a['UserStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 149.33a192 192 0 11-192 192 192 192 0 01192-192M512 64a277.33 277.33 0 10277.33 277.33A277.33 277.33 0 00512 64zM121.6 896a36.48 36.48 0 00-10.88 1.92 34.99 34.99 0 00-10.67-1.92 32 32 0 100 64 34.99 34.99 0 0010.67-1.92A36.48 36.48 0 00121.6 960a32 32 0 100-64zm802.35 0a34.99 34.99 0 00-10.67 1.92 36.27 36.27 0 00-10.67-1.92 32 32 0 000 64 36.27 36.27 0 0010.67-1.92 34.99 34.99 0 0010.67 1.92 32 32 0 000-64z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M898.13 926.93h4.48V960h21.34v-32l31.36-5.12a448 448 0 00-886.83 2.35l31.57 2.77v32h21.34v-32l31.78 4.9a362.67 362.67 0 01717.44 0z"
      }
    }]
  },
  "name": "user-stroke"
};
a['UserSyncStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M804.27 341.33C804.27 187.73 680.53 64 526.93 64S249.6 187.73 249.6 341.33c0 89.6 42.67 172.8 115.2 226.14C217.6 629.33 115.2 768 102.4 925.87c-2.13 17.06 12.8 34.13 29.87 34.13h23.46c17.07 0 29.87-12.8 32-29.87 14.94-174.93 162.14-311.46 339.2-311.46 153.6 0 277.34-123.74 277.34-277.34zm-277.34 192c-106.66 0-192-85.33-192-192s85.34-192 192-192 192 85.34 192 192-85.33 192-192 192zM870.4 793.6H650.67c-23.47 0-42.67-19.2-42.67-42.67s19.2-42.66 42.67-42.66H870.4c23.47 0 42.67 19.2 42.67 42.66s-19.2 42.67-42.67 42.67zm6.4 134.4H657.07c-23.47 0-42.67-19.2-42.67-42.67s19.2-42.66 42.67-42.66H876.8c23.47 0 42.67 19.2 42.67 42.66S900.27 928 876.8 928z"
      }
    }]
  },
  "name": "user-sync-stroke"
};
a['UserWaitStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M659.25 720h220q8 0 8 8v44q0 8-8 8h-220q-8 0-8-8v-44q0-8 8-8zm0 111h220q8 0 8 8v44q0 8-8 8h-220q-8 0-8-8v-44q0-8 8-8zm102.5-214.6a371.67 371.67 0 00-103.7-65.8c-.4-.2-.8-.3-1.2-.5A248.07 248.07 0 00759.35 349c0-137-110.8-248-247.5-248s-247.4 111-247.4 248a247.89 247.89 0 00102.6 201.1c-.4.2-.8.3-1.2.5a375.78 375.78 0 00-229.1 338.2 8 8 0 008 8.2H588v-72H221.21A299.36 299.36 0 01670 642.1a8.09 8.09 0 008.1.3 171.45 171.45 0 0181.4-20.4h.1a3.21 3.21 0 002.15-5.6zM512 521a171.91 171.91 0 11121.4-50.4A170.6 170.6 0 01512 521z"
      }
    }]
  },
  "name": "user-wait-stroke"
};
a['VerificationFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M879.79 180.27L524.16 55.04c-7.9-2.35-16-2.35-23.9 0L144.22 180.27a42.5 42.5 0 00-30.72 40.96v212.9a562.28 562.28 0 00385.07 534.19c4.48 1.5 8.96 2.13 13.44 2.13s9.17-.64 13.44-2.13a562.56 562.56 0 00385.07-534.19V221.01a42.43 42.43 0 00-30.72-40.74zM728.32 431.36l-222.3 222.3c-12.58 12.58-32.85 12.58-45.22 0L337.5 530.34a31.79 31.79 0 010-45.23l15.14-15.15a31.79 31.79 0 0145.23 0l85.54 85.55 184.54-184.53a31.79 31.79 0 0145.22 0l15.15 15.14c12.37 12.59 12.37 32.86 0 45.23z"
      }
    }]
  },
  "name": "verification-fill"
};
a['VerificationStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M397.87 469.97a31.79 31.79 0 00-45.23 0l-15.15 15.15a31.79 31.79 0 000 45.23l123.31 123.3c12.59 12.59 32.85 12.59 45.23 0L728.1 431.57c12.58-12.58 12.58-32.85 0-45.22l-15.15-15.15a31.79 31.79 0 00-45.23 0L483.2 555.73l-85.33-85.76zm481.92-289.7L524.16 55.04c-7.9-2.35-16-2.35-23.9 0L144.22 180.27a42.5 42.5 0 00-30.72 40.96v212.9a562.28 562.28 0 00385.07 534.19c4.48 1.5 8.96 2.13 13.44 2.13s9.17-.64 13.44-2.13a562.56 562.56 0 00385.07-534.19V221.01a42.43 42.43 0 00-30.72-40.74zm-54.62 254.08A477 477 0 01512 882.77a477.01 477.01 0 01-313.17-448.42V253.44L512.2 140.59l312.96 112.85v180.9z"
      }
    }]
  },
  "name": "verification-stroke"
};
a['VideoCameraStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M717.01 206.93H128a59.52 59.52 0 00-64 53.98v502.18a59.52 59.52 0 0064 53.98h589.01a59.52 59.52 0 0064-53.98v-78.08L912 760.75a31.57 31.57 0 0016 4.26 32 32 0 0032-32V338.35a32 32 0 00-32-32 31.57 31.57 0 00-16 4.26l-130.99 75.52V260.91a59.52 59.52 0 00-64-53.98zM149.33 745.17V278.83h546.35V510.5l-2.77 1.49 2.77 1.5v231.67zM874.67 640L781 586.67V484.69l93.66-53.97V640z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M374.61 344.53H267.95a32 32 0 00-32 32v21.34a32 32 0 0032 32H374.6a32 32 0 0032-32v-21.34a32.21 32.21 0 00-32-32z"
      }
    }]
  },
  "name": "video-camera-stroke"
};
a['ViewFormFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 128c70.7 0 128 57.3 128 128v512c0 70.7-57.3 128-128 128H256c-70.7 0-128-57.3-128-128V256c0-70.7 57.3-128 128-128h512zm0 528H256a32 32 0 00-32 32v80a32 32 0 0032 32h512a32 32 0 0032-32v-80a32 32 0 00-32-32zm-328-96H256a32 32 0 000 64h184a32 32 0 000-64zm328-240H256a32 32 0 00-32 32v80a32 32 0 0032 32h512a32 32 0 0032-32v-80a32 32 0 00-32-32zm-328-96H256a32 32 0 000 64h184a32 32 0 000-64z"
      }
    }]
  },
  "name": "view-form-fill"
};
a['ViewKanbanFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 128c70.7 0 128 57.3 128 128v512c0 70.7-57.3 128-128 128H256c-70.7 0-128-57.3-128-128V256c0-70.7 57.3-128 128-128h512zm-216 96h-80a32 32 0 00-32 32v512a32 32 0 0032 32h80a32 32 0 0032-32V256a32 32 0 00-32-32zm216 0h-80a32 32 0 00-32 32v384a32 32 0 0032 32h80a32 32 0 0032-32V256a32 32 0 00-32-32zm-432 0h-80a32 32 0 00-32 32v288a32 32 0 0032 32h80a32 32 0 0032-32V256a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "view-kanban-fill"
};
a['ViewTableFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 128c70.7 0 128 57.3 128 128v512c0 70.7-57.3 128-128 128H256c-70.7 0-128-57.3-128-128V256c0-70.7 57.3-128 128-128h512zM320 656h-64a32 32 0 00-32 32v80a32 32 0 0032 32h64a32 32 0 0032-32v-80a32 32 0 00-32-32zm448 0H432a32 32 0 00-32 32v80a32 32 0 0032 32h336a32 32 0 0032-32v-80a32 32 0 00-32-32zM320 440h-64a32 32 0 00-32 32v80a32 32 0 0032 32h64a32 32 0 0032-32v-80a32 32 0 00-32-32zm448 0H432a32 32 0 00-32 32v80a32 32 0 0032 32h336a32 32 0 0032-32v-80a32 32 0 00-32-32zM320 224h-64a32 32 0 00-32 32v64a32 32 0 0032 32h64a32 32 0 0032-32v-64a32 32 0 00-32-32zm448 0H432a32 32 0 00-32 32v64a32 32 0 0032 32h336a32 32 0 0032-32v-64a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "view-table-fill"
};
a['ViewTimelineFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M768 128c70.7 0 128 57.3 128 128v512c0 70.7-57.3 128-128 128H256c-70.7 0-128-57.3-128-128V256c0-70.7 57.3-128 128-128h512zm0 528H432a32 32 0 00-32 32v80a32 32 0 0032 32h336a32 32 0 0032-32v-80a32 32 0 00-32-32zM650.07 440H256a32 32 0 00-32 32v80a32 32 0 0032 32h394.07a32 32 0 0032-32v-80a32 32 0 00-32-32zM768 224H432a32 32 0 00-32 32v64a32 32 0 0032 32h336a32 32 0 0032-32v-64a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "view-timeline-fill"
};
a['WalletStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M595 512a40 40 0 1040-40 40 40 0 00-40 40zm229 312H200V200h624v184H511a32 32 0 00-32 32v192a32 32 0 0032 32h313zm0-248H543V448h281zm40-448H160a32 32 0 00-32 32v704a32 32 0 0032 32h704a32 32 0 0032-32V160a32 32 0 00-32-32z"
      }
    }]
  },
  "name": "wallet-stroke"
};
a['WarningFill'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M487 735.57a55.47 55.47 0 1042.5-102.48 55.47 55.47 0 00-42.5 102.4zm27.3-638.55a30.72 30.72 0 0126.71 15.36l400.81 693.76a30.8 30.8 0 01-26.7 46.17H113.57a30.8 30.8 0 01-26.71-46.17l400.72-693.76a30.72 30.72 0 0126.71-15.36zm37.8 277.42h-79.87a7.68 7.68 0 00-7.68 7.68v177.33a7.65 7.65 0 007.68 7.68h79.88a7.65 7.65 0 007.68-7.68V382.29a7.68 7.68 0 00-7.68-7.68z"
      }
    }]
  },
  "name": "warning-fill"
};
a['WarningStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512 249.17l322.99 557.44H189L512 249.17m0-106.45c-21.55 0-43.1 10.67-55.47 32L96.64 795.95c-24.75 42.66 5.97 96 55.47 96h720c49.28 0 80-53.34 55.46-96l-360.1-621.23c-12.38-21.33-33.92-32-55.47-32zm.43 625.28h-1.92a52.21 52.21 0 01-52.27-52.27v-1.92a52.21 52.21 0 0152.27-52.26h1.92a52.21 52.21 0 0152.26 52.26v1.92A52.35 52.35 0 01512.43 768zm16-144.21h-34.99a24.54 24.54 0 01-24.53-24.54V408.53A24.54 24.54 0 01493.44 384h34.99a24.54 24.54 0 0124.53 24.53v190.72a24.54 24.54 0 01-24.53 24.54z"
      }
    }]
  },
  "name": "warning-stroke"
};
a['WidthAdaptiveStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M199.36 823.13V200.44a7.58 7.58 0 00-7.53-7.59h-56.51a7.58 7.58 0 00-7.53 7.59v622.69a7.59 7.59 0 007.53 7.6h56.51a7.59 7.59 0 007.53-7.6zm696.85 0V200.44a7.58 7.58 0 00-7.53-7.59h-56.51a7.58 7.58 0 00-7.53 7.59v622.69a7.59 7.59 0 007.53 7.6h56.51a7.59 7.59 0 007.53-7.6zM645.7 604.84a6.83 6.83 0 0011 5.36l120.17-94.93a6.71 6.71 0 000-10.64L656.72 409.7a6.81 6.81 0 00-11 5.37v62.81H393.3v-59.14a6.84 6.84 0 00-11-5.37L262.21 508.3a6.71 6.71 0 000 10.64l120.07 94.94a6.82 6.82 0 0011-5.37v-62.82H645.7z"
      }
    }]
  },
  "name": "width-adaptive-stroke"
};
a['WifiStroke'] = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M874.45 367.15a32 32 0 1064 0 32 32 0 10-64 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M888.32 350.3a32 32 0 1064 0 32 32 0 10-64 0zM85.55 366.93a32 32 0 1064 0 32 32 0 10-64 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M71.68 350.08a32 32 0 1064 0 32 32 0 10-64 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M920.32 350.3l20.05-24.75a725.33 725.33 0 00-856.96 0l21.34 24.53-24.54 21.33 14.3 17.07 1.28-2.35 23.04-18.34 18.77 25.6a638.5 638.5 0 01751.36 0l18.56-26.03 24.75 19.84 13.44-16zM636.59 651.95a32 32 0 1064 0 32 32 0 10-64 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M650.45 635.1a32 32 0 1064 0 32 32 0 10-64 0zM309.33 635.1a32 32 0 1064 0 32 32 0 10-64 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M323.41 651.73a32 32 0 1064 0 32 32 0 10-64 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M668.59 651.73l24.32 21.34L707.2 656l-24.53-20.9L701 609.27a320 320 0 00-378.45 0h1.07l17.7 25.81-24.32 21.34 13.44 16 24.96-19.84 18.99 25.81a234.67 234.67 0 01274.99 0zM191.57 494.3a32 32 0 1064 0 32 32 0 10-64 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M205.87 510.93a32 32 0 1064 0 32 32 0 10-64 0zM753.92 510.93a32 32 0 1064 0 32 32 0 10-64 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M768.21 494.08a32 32 0 1064 0 32 32 0 10-64 0z"
      }
    }, {
      "tag": "path",
      "attrs": {
        "d": "M785.92 512l24.75 19.2 14.29-17.07-24.75-20.05 19.2-24.96a512 512 0 00-614.18.21l18.34 25.82-23.89 21.33 14.72 17.7 23.47-21.33 18.13 23.9a425.6 425.6 0 01512 1.28zM448 774.61a64 64 0 10128 0 64 64 0 10-128 0z"
      }
    }]
  },
  "name": "wifi-stroke"
};
module.exports = a;
exports["default"] = a;